// InstagramTemplateEditor.jsx
import React, { Component } from "react";
import ReactDOM from "react-dom";
import $ from 'jquery';
// import "./InstagramTemplateEditor.css";
import axios from 'axios';
import http from '../modules/api';

import RCSlider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import Slider from '@mui/material/Slider';

import button_list from '../../resources/img/button_list.png';

import ToggleButton from '../modules/common/ToggleButton';
import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from "../modules/common/SelectBoxV2";
import Pagination from "react-js-pagination";

import ContentEditable from "react-contenteditable";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {TextEditor} from "../modules/textEditor/TextEditor_v2";
import {initSelectionOnMouseDown} from "../modules/textEditor/TextEditor";
import textEditorFont from "../modules/textEditor/textEditorFont";
import ContentState from "draft-js/lib/ContentState";
import htmlToDraft from "html-to-draftjs";
import { SketchPicker } from 'react-color'

import TagButton from '../modules/common/TagButton';
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import icn_filter from '../../resources/img/icn_filter.svg';
import icn_refresh_2 from '../../resources/img/icn_refresh_2.svg';

import SearchProductPopup from '../modules/popup/SearchProductPopup';
import DetailImgCropPopup from '../autoEvent/component/DetailImgCropPopup';
import RoboImageStudioTabs from '../autoEvent/component/RoboImageStudioTabs';
import RoboMDAICopywriterModal from './component/RoboMDAICopywriterModal';
import AiImageStudioWorkflowClass from "../modules/common/AiImageStudioWorkflowClass";
import UploadYoutubeLinkPopup from '../modules/popup/UploadYoutubeLinkPopup';

import PopupFrameV2 from "../modules/popup/PopupFrameV2";
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import BasicDialogV2 from "../modules/dialogs/BasicDialogV2";
import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';
import InputDialogV2 from '../modules/dialogs/InputDialogV2';

import DownloadManager from '../modules/CommonDownloadManager';
import * as CommonDownloadManager from '../modules/CommonDownloadManager';
import FileDownload from 'js-file-download';

const scollSettingBtnRef = React.createRef(); // 배너 버튼 설정으로 가기
const DESIGN_EDITOR_TUTORIAL_EVENT = "instagram-tutorial:design-editor-action";

let button_info_input_timer = {}; // 버튼정보 입력 작업시 여러번 요청 보내는 것을 방지
let title_input_timer = {}; // 제목 입력 작업시 여러번 요청 보내는 것을 방지(배너 이름, 큰제목, 작은제목)

let txt_scale_value = 0;

const transparent_image = "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/robo_banner/2023/04/07/367/74ce6536-7b78-47f7-a813-6030b2534e70.png";

const presetColors = [
    "rgb(227,227,227)",
    "rgb(208,2,27)",
    "rgb(245,166,35)",
    "rgb(248,231,28)",
    "rgb(139,87,42)",
    "rgb(126,211,33)",
    "rgb(67,117,5)",
    "rgb(189,16,224)",
    "rgb(144,19,254)",
    "rgb(74,144,226)",
    "rgb(80,227,194)",
    "rgb(184,233,134)",
    "rgb(0,0,0)",
    "rgb(74,74,74)",
    "rgb(155,155,155)",
    "rgb(255,255,255)",
];

var color_title_num_p = 0;
var color_title_num_m = 0;

var dateString = new Date().getFullYear() + ("0" + parseInt(new Date().getMonth()+1)).slice(-2) + ("0" + parseInt(new Date().getDate())).slice(-2) + ("0" + parseInt(new Date().getHours())).slice(-2) + ("0" + parseInt(new Date().getSeconds())).slice(-2)

var first_lodded_cafe24_item = false;
var first_lodded_sub_titie = false;
var first_lodded_pc_banner = false;
var first_lodded_mobile_banner = false;

// 배너 변경으로 누끼를 중복으로 따는것을 방지
var w_nukki_action_state = true;
var h_nukki_action_state = true;

// 배너 변경으로 누끼를 중복으로 따는것을 방지
var w_nukki_action_state = true;
var h_nukki_action_state = true;

var is_banner_color_init = false;
var is_mobile_banner_color_init = false;

var isTmp = false; // 배너 업테이트 할지 여부

// 이미지 컬럼 순서별 이름
const youtube_order_text = ["youtube", "youtube_detail", "youtube_third","youtube_fourth"];
const img_order_text = ["img", "img_detail", "img_third","img_fourth"];

var object_domain = document.domain.indexOf("robomd.io") > -1 ? "https://script.robomd.io" : "https://"+document.domain;
var object_port = window.location.port;
if (document.domain.indexOf("127.0.0.1") >= 0 && object_port == "3000") {
    object_domain = "http://127.0.0.1:8092"
} else if (object_port != '') {
    object_domain = object_domain + ":" + object_port
}

let is_test_use = "";
if (document.domain.indexOf("127.0.0.1") >= 0 || document.domain.indexOf("otdeal.me") >= 0) {
    is_test_use = "&is_test_use=Y"
}

let fontArray = [];
let mainPlainText = "";
let subPlainText = "";
let mainContent = ContentState.createFromText(mainPlainText);
let subContent = ContentState.createFromText(subPlainText);
let keydownTimeout;
let font_family_list = [];

var nukki_action_state_cnt = 0;

// var is_banner_ratio_loaded = false;

// checkNukkiState를 페이지 로드시에는 실행하지 않도록 하기 위해 사용
// (이미지 주소가 접근 불가능해진 경우 실행하면 누끼 템플릿의 경우 실제 배너와 미리보기가 달라질 수 있기때문)
var getBannerRatioCnt = 0;

function randomStr(len = 8) {
  return Math.random().toString(36).substring(2, 2 + len);
}

class InstagramTemplateEditor extends Component {
  scrollContainerRef = null;
  eventTmpCancelSource = null; // 미리보기 axios source
  resizeRaf = null;
  instagramDesignTutorialSnapshot = null;
  
  constructor(props) {
    super(props);


    this.state = {
      canvasWidth: 0,

      user_seq: "",
      shop_no: "",

      iframe_page_id : "robomd_instagram_page",
      iframe_html_id : "-1",

      solution_type_cd : "", // 비연동 서비스 구분자 : 09900

      is_detail_image_use: false,

      select_item_list : [],
      item_list : [],
      keyword_list : [],

      product_name: "",

      background: '#ffffff',
      background2: '#ffffff',
      background3: '#ffffff',
      background4: '#ffffff',

      event_seq:"",
      lang_type: "",
      none_title: window.location.href.indexOf("/instagram") >= 0 ? "인스타그램_템플릿_디자인_"+randomStr(4) : "",
      title: "",
      sub_title: "",
      foreign_title: "",
      org_title: "",
      event_type_cd: "",
      event_type_name: "",
      event_type_img: "",
      event_pc_banner_name: "",
      event_pc_tag_cd_list: [],
      event_pc_tag_name_list: [],
      event_mobile_type_cd: "",
      event_mobile_type_name: "",
      event_mobile_type_img:"",
      event_mobile_banner_name: "",
      event_mobile_tag_cd_list: [],
      event_mobile_tag_name_list: [],
      title_sentence_cd: "",
      content_sentence_cd: "",
      sentence: "",
      eng_sentence: "",
      display_yn:"N" ,
      sentence_cd:"",

      keyword_cd: "",
      keyword: "",
      image: "",
      product_no: "",
      event_price : 0,

      /* 진열 기간 설정 start */
      start_date: "",
      start_hour: "",
      start_minute: "",

      end_date: "",
      end_hour: "",
      end_minute: "",
      
      start_date_format: "",
      end_date_format: "",
      /* 진열 기간 설정 end */

      // 모달 & 패널
      isModalOpen: true,
    //   activePanel: "template",
      activePanel: this.props.event_type_cd ? "image" : "template",
      isTemplatePanelCollapsed: false,
      mobileTemplatePopupOpen: false,

      isHistoryPanelCollapsed: false,

      // AI 카피라이터 팝업
      isCopywriterModalOpen: false,
      copywriterApplyTarget: '', // main | sub

      // 탭
      currentTab: "image", // image | text | color

      // 템플릿 & 이미지
      selectedTemplateType: "single", // single|double|triple|grid
      images: [
        {
          index: 1,
          src: null,
          x: 10, // %
          y: 10, // %
          w: 80, // %
          h: 60, // %
          unit: "percent",
        },
        {
          index: 2,
          src: null,
          x: 10, // %
          y: 10, // %
          w: 80, // %
          h: 60, // %
          unit: "percent",
        },
      ],
      selectedImageIndex: 1,
      currentUnit: "percent", // 이미지 이동 기준 단위 (step 크기 및 표시용)

      // 업로드 팝업
      isUploadPopupOpen: false,
      currentUploadIndex: 1,

      // 텍스트
      mainText: "BEST ITEM\n한정 수량 특가",
      subText: "Premium Collection\n최대 70% 할인 이벤트",

      mainPos: { x: 10, y: 85, w: 80, h: 20 },
      subPos: { x: 10, y: 70, w: 80, h: 20 },

      textUnitMode: "percent", // 텍스트 이동 단위
      mainSizePercent: 100,
      subSizePercent: 100,

      mainFontFamily: "'Noto Sans KR', sans-serif",
      subFontFamily: "'Noto Sans KR', sans-serif",

      mainBold: false,
      mainItalic: false,
      mainUnderline: false,
      subBold: false,
      subItalic: false,
      subUnderline: false,

      mainColor: "#ffffff",
      subColor: "#ffffff",

      // 컬러
      canvasMainColor: "#764ba2",
      canvasSubColor: "#667eea",
      canvasPointColor: "#f093fb",
      canvasBgColor: "#ffffff",
      extractedColors: [],

      // AI 옵션
      bgRemoveEnabled: false,
      w_bgRemoveStrength_1: 2,
      w_bgRemoveStrength_2: 2,
      w_bgRemoveStrength_3: 2,
      w_bgRemoveStrength_4: 2,
      h_bgRemoveStrength_1: 2,
      h_bgRemoveStrength_2: 2,
      h_bgRemoveStrength_3: 2,
      h_bgRemoveStrength_4: 2,  
      contourCorrection: false,
      faceAuto: false,

      event_type_cd : "",
      event_pc_banner_name : "",
      event_mobile_type_cd : "",
      event_mobile_banner_name : "",

      bannerTypeList : [],
      mobileBannerTypeList : [],

      pc_banner_type_paging : {
          activePage: 1,
          totalCnt: 0,
          startIdx: 0,
          rowcnt:15,
      },
      
      mobile_banner_type_paging : {
          activePage: 1,
          totalCnt: 0,
          startIdx: 0,
          rowcnt:12,
      },

      pc_banner_ratio_list: [],
      mobile_banner_ratio_list: [{
        "org_banner_width": 1024,
        "org_banner_height": 1024,
        "org_event_type": "p",
        "org_width_height": 1,
        "banner_width": 1024,
        "banner_height": 1024
      }],
      selected_pc_banner_ratio : {},
      selected_mobile_banner_ratio : {
        "org_banner_width": 1024,
        "org_banner_height": 1024,
        "org_event_type": "p",
        "org_width_height": 1,
        "banner_width": 1024,
        "banner_height": 1024
      },

      // 비연동형 : 배너 사이즈 입력값
      event_banner_pc_width : 1024,
      event_banner_pc_height : 1024,
      event_banner_mobile_width : 1024,
      event_banner_mobile_height : 1024,

      /* 이미지 포지션 배너에 적용되지 않는 값 */
      w_img_position_left_1: 0,
      w_img_position_right_1: 0,
      w_img_position_top_1: 0,
      w_img_position_bottom_1: 0,

      w_img_position_left_2: 0,
      w_img_position_right_2: 0,
      w_img_position_top_2: 0,
      w_img_position_bottom_2: 0,

      w_img_position_left_3: 0,
      w_img_position_right_3: 0,
      w_img_position_top_3: 0,
      w_img_position_bottom_3: 0,

      w_img_position_left_4: 0,
      w_img_position_right_4: 0,
      w_img_position_top_4: 0,
      w_img_position_bottom_4: 0,

      h_img_position_left_1: 0,
      h_img_position_right_1: 0,
      h_img_position_top_1: 0,
      h_img_position_bottom_1: 0,

      h_img_position_left_2: 0,
      h_img_position_right_2: 0,
      h_img_position_top_2: 0,
      h_img_position_bottom_2: 0,

      h_img_position_left_3: 0,
      h_img_position_right_3: 0,
      h_img_position_top_3: 0,
      h_img_position_bottom_3: 0,

      h_img_position_left_4: 0,
      h_img_position_right_4: 0,
      h_img_position_top_4: 0,
      h_img_position_bottom_4: 0,

      h_img_position_x_1: 0,
      h_img_position_y_1: 0,
      h_img_position_x_2: 0,
      h_img_position_y_2: 0,
      h_img_position_x_3: 0,
      h_img_position_y_3: 0,
      h_img_position_x_4: 0,
      h_img_position_y_4: 0,

      w_main_txt_position_x : 0,
      w_main_txt_position_y : 0,
      h_main_txt_position_x : 0,
      h_main_txt_position_y : 0,

      w_sub_txt_position_x : 0,
      w_sub_txt_position_y : 0,
      h_sub_txt_position_x : 0,
      h_sub_txt_position_y : 0,

      w_img_position_name : [],
      h_img_position_name : [],

      mainEditorState: EditorState.createWithContent(mainContent),
      subEditorState: EditorState.createWithContent(subContent),

      /* 링크 입력형 이미지 리스트 : 배너별 이미지 포지션이 변경되어도 위치에 맞게 상태가 유지되도록 하기 위해 사용
      * 포함 정보 : 링크 이미지 타입(업로드 or 링크형), 이미지 seq(파일형), 이미지 이름, 이미지 주소, 이미지 유효성(현재는 링크형 전용), 누끼 이미지 링크
      */
      w_user_img_list : [
                          {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                          {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                          {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                          {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false}
                      ],
      h_user_img_list : [
                          {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                          {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                          {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                          {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false}
                      ],

      /* 누끼 해제 요청 상태 : 사용자가 직접 원본 이미지 사용을 클릭한 경우(상태를 유지) */
      w_non_nukki_state: [false, false, false, false],
      h_non_nukki_state: [false, false, false, false],

      pc_banner_type_paging : {
          activePage: 1,
          totalCnt: 0,
          startIdx: 0,
          rowcnt:12,
      },
      
      mobile_banner_type_paging : {
          activePage: 1,
          totalCnt: 0,
          startIdx: 0,
          rowcnt:12,
      },

      pc_history_paging : {
          activePage: 1,
          totalCnt: 0,
          startIdx: 0,
          rowcnt:12,
      },
      
      mobile_history_paging : {
          activePage: 1,
          totalCnt: 0,
          startIdx: 0,
          rowcnt:12,
      },

      template_tag_list: [{}],        // 템플릿 태그 리스트
      w_template_all_tag_list: {    // 가로 템플릿 카테고리별 태그 리스트
          bsn: [],
          usg: [],
          lyt: [],
          sty: [],
      },
      h_template_all_tag_list: {    // 세로 템플릿 카테고리별 태그 리스트
          bsn: [],
          usg: [],
          lyt: [],
          sty: [],
      },
      w_selected_tags: {             // 가로 템플릿 카테고리별 선택된 태그 리스트
          bsn: [],
          usg: [],
          lyt: [],
          sty: [],
      },
      h_selected_tags: {             // 세로 템플릿 카테고리별 선택된 태그 리스트
          bsn: [],
          usg: [],
          lyt: [],
          sty: [],
      },
      w_all_selected: {              // 가로 템플릿 카테고리별 전체 선택 여부
          bsn: false,
          usg: false,
          lyt: false,
          sty: false,
      },
      h_all_selected: {              // 세로 템플릿 카테고리별 전체 선택 여부
          bsn: false,
          usg: false,
          lyt: false,
          sty: false,
      },
      w_all_tag_selected: true,                     // 가로 템플릿 필터 전체 태그 버튼 선택 여부
      h_all_tag_selected: true,                     // 세로 템플릿 필터 전체 태그 버튼 선택 여부
      show_template_filter_popup: false,            // 템플릿 필터 팝업
      show_template_filter_popup_type: "03000",     // 템플릿 필터 팝업 가로/세로 타입 구분

      button_list : [{
          button_text : "버튼명",
          link : "",
          order_no : 1,
          event_seq : dateString,
      }],

      /* 상세 이미지 업로드 */
      w_crop_img_info_list : [{},{},{},{}],
      h_crop_img_info_list : [{},{},{},{}],

      /* 분할된 상세 이미지 선택 팝업 */
      select_detail_crop_img_popup_show : false,

      /* 링크 입력형 이미지 리스트 : 배너별 이미지 포지션이 변경되어도 위치에 맞게 상태가 유지되도록 하기 위해 사용
      * 포함 정보 : 링크 이미지 타입(업로드 or 링크형), 이미지 seq(파일형), 이미지 이름, 이미지 주소, 이미지 유효성(현재는 링크형 전용), 누끼 이미지 링크
      */
      w_user_img_list : [
                        {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                        {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                        {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                        {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false}
                    ],
      h_user_img_list : [
                        {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                        {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                        {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false},
                        {link_type : "49001", org_img_seq : "", org_img_name : "", img_link : "", img_link_able : false}
                    ],

        /** 이미지 누끼 타입 */
        w_nukki_version_list : [3,3,3,3],
        h_nukki_version_list : [3,3,3,3],

        // AI 인물 위치 자동 이동 가능 여부
        w_is_full_background_img_use : "N",
        h_is_full_background_img_use : "N",

        // 유튜브 링크 사용 가능 여부
        w_is_youtube_link_use : "N",
        h_is_youtube_link_use : "N",

        template_sample_values: {},
        template_sample_user_image_fields: {},
        template_sample_user_text_changed: false,
        template_sample_user_date_changed: false,
    };

    this.fileInput = null; // 업로드용 임시 input
  }

  getOpenedFrom = () => {
    return this.props.opened_from || this.props.openedFrom || "";
  }

  isOpenedFromAiDesignStarter = () => {
    return this.getOpenedFrom() === "AI_DESIGN_STARTER";
  }

  getUrlParams() {
        var params = {};
        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
        return params;
    }

  componentDidMount() {
    window.addEventListener(DESIGN_EDITOR_TUTORIAL_EVENT, this.handleInstagramDesignTutorialAction);
    /* 초기화 */
    dateString = new Date().getFullYear() + ("0" + parseInt(new Date().getMonth()+1)).slice(-2) + ("0" + parseInt(new Date().getDate())).slice(-2) + ("0" + parseInt(new Date().getHours())).slice(-2) + ("0" + parseInt(new Date().getSeconds())).slice(-2)
    first_lodded_cafe24_item = false;
    first_lodded_sub_titie = false;
    first_lodded_pc_banner = false;
    first_lodded_mobile_banner = false;
    // 배너 변경으로 누끼를 중복으로 따는것을 방지
    w_nukki_action_state = true;
    h_nukki_action_state = true;
    // 배너 변경으로 누끼를 중복으로 따는것을 방지
    w_nukki_action_state = true;
    h_nukki_action_state = true;
    is_banner_color_init = false;
    is_mobile_banner_color_init = false;
    isTmp = false; // 배너 업테이트 할지 여부

    fontArray = [];
    mainPlainText = "";
    subPlainText = "";
    mainContent = ContentState.createFromText(mainPlainText);
    subContent = ContentState.createFromText(subPlainText);
    font_family_list = [];
    nukki_action_state_cnt = 0;

    getBannerRatioCnt = 0;

    console.log("this.props.event_seq", this.props.event_seq);

    // 1. 비율 파싱 및 규격 계산 (기존과 동일)
    // const ratioStr = this.props.ratio || "1:1";
    const initialEventTypeCd = this.getInitialEventTypeCd();
    const ratioStr =
        this.props.ratio
        || this.getRatioByEventTypeCd(initialEventTypeCd)
        || "1:1";
    if (initialEventTypeCd) {
        this.setState({
            activePanel: "image"
        });
    }    
    const [wRatio, hRatio] = ratioStr.split(':').map(Number);
    const baseSize = 1024;
    const calculatedHeight = Math.round((baseSize / wRatio) * hRatio);

    const newBannerData = {
        "org_banner_width": baseSize,
        "org_banner_height": calculatedHeight,
        "org_event_type": "p",
        "org_width_height": wRatio / hRatio,
        "banner_width": baseSize,
        "banner_height": calculatedHeight,
        "ratio_string": ratioStr
    };

    // 2. 가로/세로 비율에 따른 타겟 결정
    const isLandscape = wRatio > hRatio; 
    const targetListKey = isLandscape ? 'pc_banner_ratio_list' : 'mobile_banner_ratio_list';
    const targetSelectedKey = isLandscape ? 'selected_pc_banner_ratio' : 'selected_mobile_banner_ratio';

    console.log("isLandscape", isLandscape);
    console.log("targetListKey", targetListKey);
    console.log("targetSelectedKey", targetSelectedKey);

    // 3. 상태 업데이트
    this.setState(prevState => {
        // 중복 검사: ratio_string이 같은 데이터가 이미 있는지 확인
        const isDuplicate = prevState[targetListKey].some(item => item.ratio_string === ratioStr);

        return {
            // 중복이 아닐 때만 리스트에 추가, 중복이면 기존 리스트 유지
            [targetListKey]: isDuplicate 
                ? prevState[targetListKey] 
                : [...prevState[targetListKey], newBannerData],
            
            // 선택된 상태값은 중복 여부와 상관없이 최신으로 업데이트 (클릭 시 변경 목적)
            [targetSelectedKey]: newBannerData,

            // 가로형 사이즈, 세로형 사이즈 업데이트
            event_banner_pc_width: baseSize,
            event_banner_pc_height: calculatedHeight,
            event_banner_mobile_width: baseSize,
            event_banner_mobile_height: calculatedHeight
        };
    }, () => {
        this.updateCanvasWidth();
        window.addEventListener("resize", this.updateCanvasWidth);
        
        // API 호출 (가로/세로 구분)
        const typeCode =
            this.props.upper_code_cd
            || this.getUpperCodeCdByEventTypeCd(initialEventTypeCd)
            || (isLandscape ? "03000" : "07000");

        this.getBannerDesignTemplateUserFavoritePaging(typeCode);
        this.loadeventHistory(typeCode);
    });

    // is_banner_ratio_loaded = true;
    this.getBannerDesignTemplateFilter();          // 배너 템플릿 필터 조회
    this.getCafe24Code("23000", "language_code_list"); // 대제목 언어 선택 코드 조회
    // this.loadCommonCode("BANNER_TYPE", "INSTAGRAM");

    const event_seq = this.getEventSeq();
    if (event_seq) {
      this.loadEventDetail(event_seq);
    } else {
        /* 버튼 초기화 */
        // dateString을 쓰기 때문에 다시 초기화 한다.
        this.setState({
            button_list : [{
                button_text : "버튼명",
                link : "",
                order_no : 1,
                event_seq : dateString,
            }],
        }, () => {
            this.insertEventTmp('preview'); //처음 로드 시 미리보기 동작하도록 변경함.
        })
    }

    // iOS 에디터 폰트 리스트
    textEditorFont.map((obj) => {
        fontArray.push(obj.name);
    });

    const handleOutsideClick = (e) => {
        // 1. 클릭된 요소가 각 에디터 영역(Wrapper) 내부에 있는지 확인
        const color_picker_1 = e.target.closest("#color_picker_1");
        const color_picker_2 = e.target.closest("#color_picker_2");
        const color_picker_3 = e.target.closest("#color_picker_3");
        const color_picker_4 = e.target.closest("#color_picker_4");
        const color_picker_w_color_etc = e.target.closest("#color_picker_w_color_etc");
        const color_picker_h_color_etc = e.target.closest("#color_picker_h_color_etc");

        const color_picker_1_wrapper = e.target.closest("#color_picker_1_wrapper");
        const color_picker_2_wrapper = e.target.closest("#color_picker_2_wrapper");
        const color_picker_3_wrapper = e.target.closest("#color_picker_3_wrapper");
        const color_picker_4_wrapper = e.target.closest("#color_picker_4_wrapper");
        const color_picker_w_color_etc_wrapper = e.target.closest("#color_picker_w_color_etc_wrapper");
        const color_picker_h_color_etc_wrapper = e.target.closest("#color_picker_h_color_etc_wrapper");

        // 2. 만약 클릭된 곳이 위 영역들 중 어느 곳도 아니라면 (즉, 완전한 외부라면) 닫기
        if (!color_picker_1 && !color_picker_1_wrapper) {
            this.onCloseRactangleColorButton("is_expand_color1")
        }
        if (!color_picker_2 && !color_picker_2_wrapper) {
            this.onCloseRactangleColorButton("is_expand_color2")
        }
        if (!color_picker_3 && !color_picker_3_wrapper) {
            this.onCloseRactangleColorButton("is_expand_color3")
        }
        if (!color_picker_4 && !color_picker_4_wrapper) {
            this.onCloseRactangleColorButton("is_expand_color4")
        }
        if (!color_picker_w_color_etc && !color_picker_w_color_etc_wrapper) {
            this.onCloseRactangleColorButton("is_expand_w_color_etc")
        }
        if (!color_picker_h_color_etc && !color_picker_h_color_etc_wrapper) {
            this.onCloseRactangleColorButton("is_expand_h_color_etc")
        }
    };

    document.addEventListener("mousedown", handleOutsideClick);
  }

  componentDidUpdate(prevProps) {
    console.log("componentDidUpdate", isTmp);

    // 화면 스크롤 고정
    if( this.state.save_dialog_show_state
        || this.state.warning_dialog_show_state
        || this.state.input_dialog_show_state
        || this.state.basic_dialog_show_state
        || this.state.show_robo_img_popup
        || this.state.select_detail_crop_img_popup_show
        || this.state.showUploadYoutubeLinkPopup
        || this.state.isCopywriterModalOpen) {
        document.body.style.overflow = 'hidden'; // 스크롤 고정
    } else {
        document.body.style.overflow = 'auto'; // 스크롤 고정 해제
    }

    // if (isTmp && this.state.mirror_banner_state == "on") {
    if (isTmp) {
        this.insertEventTmp('preview'); //미리보기 버튼 클릭시 동작 하도록 변경함.
        isTmp = false;
        // this.setHeight();
    } else {
        isTmp = false;
    }

    // 상품 카테고리 영역 동적 높이 할당
    $(".item_content_box_category_area_body").css("max-height", $(".item_content_box_item_area_body").height());
    $(".item_content_box_category_area_body").css("overflow", "auto");

    // if (is_banner_ratio_loaded && this.state.iframe_html_id && this.state.iframe_page_id) {
        // this.getBannerRatio();
        // this.setHeight();
        // is_banner_ratio_loaded = false;
    // }

    // 에디터에 적용된 폰트 추출
    document.querySelectorAll(".text_editor_title font").forEach((element) => {
        if(element.getAttribute("face") != null && element.getAttribute("face") != ""){
            font_family_list.push(element.getAttribute("face"));
            font_family_list = [...new Set(font_family_list)];
        }
    });

    // 에디터에 적용된 폰트 추출
    document.querySelectorAll(".text_editor_title span").forEach((element) => {
        let fontFamily = window.getComputedStyle(element).fontFamily;
        if(fontFamily != null && fontFamily != ""){
            font_family_list.push(fontFamily.replaceAll('\"', ''));
            font_family_list = [...new Set(font_family_list)];
        }
    });

    // 에디터에 적용된 폰트 추출(iOS)
    document.querySelectorAll(".main_editor_wysiwyg span").forEach((element) => {
        let fontFamily = window.getComputedStyle(element).fontFamily;
        if(fontFamily != null && fontFamily != ""){
            font_family_list.push(fontFamily.replaceAll('\"', ''));
            font_family_list = [...new Set(font_family_list)];
        }
    });

    // 에디터에 적용된 폰트 추출(iOS)
    document.querySelectorAll(".sub_editor_wysiwyg span").forEach((element) => {
        let fontFamily = window.getComputedStyle(element).fontFamily;
        if(fontFamily != null && fontFamily != ""){
            font_family_list.push(fontFamily.replaceAll('\"', ''));
            font_family_list = [...new Set(font_family_list)];
        }
    });
  }

  componentWillUnmount() {
    window.removeEventListener(DESIGN_EDITOR_TUTORIAL_EVENT, this.handleInstagramDesignTutorialAction);
    this.instagramDesignTutorialSnapshot = null;
    window.removeEventListener("resize", this.updateCanvasWidth);
    if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
  }
  captureInstagramDesignTutorialSnapshot = () => {
    if (this.instagramDesignTutorialSnapshot) return;
    this.instagramDesignTutorialSnapshot = {
      activePanel: this.state.activePanel,
      isTemplatePanelCollapsed: this.state.isTemplatePanelCollapsed,
      isHistoryPanelCollapsed: this.state.isHistoryPanelCollapsed,
      isUploadPopupOpen: this.state.isUploadPopupOpen,
      currentUploadIndex: this.state.currentUploadIndex,
      selectedImageIndex: this.state.selectedImageIndex,
    };
  };

  handleInstagramDesignTutorialAction = (event) => {
    const action = event && event.detail ? event.detail.action : "";
    if (!action) return;

    if (action === "RESTORE") {
      if (!this.instagramDesignTutorialSnapshot) return;
      const snapshot = this.instagramDesignTutorialSnapshot;
      this.instagramDesignTutorialSnapshot = null;
      this.setState(snapshot);
      return;
    }

    this.captureInstagramDesignTutorialSnapshot();
    if (action === "SNAPSHOT") return;

    const commonPatch = { isUploadPopupOpen: false };

    if (action === "SHOW_TEMPLATE") {
      this.setState({ ...commonPatch, activePanel: "template", isTemplatePanelCollapsed: false });
      return;
    }
    if (action === "SHOW_IMAGE") {
      this.setState({ ...commonPatch, activePanel: "image" });
      return;
    }
    if (action === "SHOW_IMAGE_SOURCE") {
      this.setState({
        activePanel: "image",
        isUploadPopupOpen: true,
        currentUploadIndex: this.state.selectedImageIndex || 1,
      });
      return;
    }
    if (action === "SHOW_TEXT") {
      this.setState({ ...commonPatch, activePanel: "text" });
      return;
    }
    if (action === "SHOW_COLOR") {
      this.setState({ ...commonPatch, activePanel: "color" });
      return;
    }
    if (action === "SHOW_HISTORY") {
      this.setState({ ...commonPatch, activePanel: "history", isHistoryPanelCollapsed: false });
    }
  };


    getInitialEventTypeCd = () => {
        return String(this.props.event_type_cd || "").trim();
    }

    getEventSeq = () => {
        return this.getUrlParams()["event_seq"] || this.props.event_seq || "";
    }

    getInitialTemplateBanner = (upperCodeCd, selectedBanner) => {
        const initialEventTypeCd = this.getInitialEventTypeCd();
        if (!initialEventTypeCd) {
            return null;
        }

        if (selectedBanner) {
            return selectedBanner;
        }

        const isMobile = upperCodeCd == "07000";
        return {
            code_cd: initialEventTypeCd,
            val1: isMobile
                ? (this.props.event_mobile_type_name || this.props.event_type_name || "")
                : (this.props.event_type_name || ""),
            val2: isMobile
                ? (this.props.event_mobile_type_img || this.props.event_type_img || "")
                : (this.props.event_type_img || ""),
            banner_name: isMobile
                ? (this.props.event_mobile_banner_name || this.props.event_pc_banner_name || "")
                : (this.props.event_pc_banner_name || ""),
            tag_name_list: "",
        };
    }

    getUpperCodeCdByEventTypeCd = (eventTypeCd) => {
        if (String(eventTypeCd || "").startsWith("07")) return "07000";
        if (String(eventTypeCd || "").startsWith("03")) return "03000";
        return "";
    }

    getRatioByEventTypeCd = (eventTypeCd) => {
        if (String(eventTypeCd || "").startsWith("07")) return "4:5";
        if (String(eventTypeCd || "").startsWith("03")) return "16:9";
        return "";
    }

  setStateAsync(state) {
      return new Promise((resolve) => {
          this.setState(state, resolve);
      });
  }

  getTemplateImageFieldName = (type, idx, state = this.state) => {
      const defaultColumnList = [
          "img_link",
          "img_detail_link",
          "img_third_link",
          "img_fourth_link",
      ];
      const positionList = state[type + "_img_position_name"] || [];
      const position = positionList[idx] || {};
      const imgColumnName = position.img_column_name || defaultColumnList[idx] || "";

      if (!imgColumnName) {
          return "";
      }

      return type === "h" ? "h_" + imgColumnName : imgColumnName;
  }

  getUserImageChangedStatePatch = (type, idx, state = this.state) => {
      const fieldName = this.getTemplateImageFieldName(type, idx, state);

      if (!fieldName) {
          return {};
      }

      return {
          template_sample_user_image_fields: {
              ...(state.template_sample_user_image_fields || {}),
              [fieldName]: true,
          },
      };
  }

  getUserTextChangedStatePatch = () => {
      return {
          template_sample_user_text_changed: true,
      };
  }

  isTemplateSampleUserTextChanged = () => {
      return this.state.template_sample_user_text_changed === true;
  }

  getUserDateChangedStatePatch = () => {
      return {
          template_sample_user_date_changed: true,
      };
  }

  isTemplateSampleUserDateChanged = () => {
      return this.state.template_sample_user_date_changed === true;
  }

  getTemplateImageClearStatePatch = (type, idx, state = this.state) => {
      const fieldName = this.getTemplateImageFieldName(type, idx, state);
      const positionList = state[type + "_img_position_name"] || [];
      const position = positionList[idx] || {};
      const positionName = position.position_name || img_order_text[idx] || "";
      const patch = {
          ...this.getUserImageChangedStatePatch(type, idx, state),
      };

      if (fieldName) {
          patch[fieldName] = "";
      }

      if (positionName) {
          patch[type + "_" + positionName + "_nukki_yn"] = "N";
          patch[type + "_nukki_" + positionName + "_link"] = "";
          patch[type + "_" + positionName + "_49002_link"] = "";
          patch[type + "_" + positionName + "_49004_link"] = "";
          patch[type + "_" + positionName + "_49006_link"] = "";
          patch[type === "h" ? "h_robo_banner_org_" + positionName + "_link_seq" : "robo_banner_org_" + positionName + "_link_seq"] = "";
      }

      return patch;
  }

  getTemplateImageClearPreviewNukkiInfo = (type, idx, state = this.state) => {
      const positionList = state[type + "_img_position_name"] || [];
      const position = positionList[idx] || {};
      const positionName = position.position_name || img_order_text[idx] || "";

      if (!positionName) {
          return { change_N_list: [] };
      }

      return {
          change_N_list: [
              { key: type + "_" + positionName + "_nukki_yn", value: "N" },
              { key: type + "_nukki_" + positionName + "_link", value: "" },
              { key: type + "_" + positionName + "_49002_link", value: "" },
              { key: type + "_" + positionName + "_49004_link", value: "" },
              { key: type + "_" + positionName + "_49006_link", value: "" },
          ],
      };
  }

  getTemplateBaseColorPatch = (source = {}) => {
      const isBlank = (value) => {
          return value == null || String(value).trim() === "" || String(value) === "null";
      };
      const getColor = (stateFieldName, colorCodeFieldName, fallback) => {
          if (!isBlank(source[stateFieldName])) return source[stateFieldName];
          if (!isBlank(source[colorCodeFieldName])) return source[colorCodeFieldName];
          return fallback;
      };

      return {
          background: getColor("background", "color_code_1", "#ffffff"),
          background2: getColor("background2", "color_code_2", "#ffffff"),
          background3: getColor("background3", "color_code_3", "#ffffff"),
          background4: getColor("background4", "color_code_4", "#ffffff"),

          color_value_1: isBlank(source.color_value_1) ? "" : source.color_value_1,
          color_value_2: isBlank(source.color_value_2) ? "" : source.color_value_2,
          color_value_3: isBlank(source.color_value_3) ? "" : source.color_value_3,
          color_value_4: isBlank(source.color_value_4) ? "" : source.color_value_4,

          color_lmnst_1: isBlank(source.color_lmnst_1) ? "" : source.color_lmnst_1,
          color_lmnst_2: isBlank(source.color_lmnst_2) ? "" : source.color_lmnst_2,
          color_lmnst_3: isBlank(source.color_lmnst_3) ? "" : source.color_lmnst_3,
          color_lmnst_4: isBlank(source.color_lmnst_4) ? "" : source.color_lmnst_4,

          color_strtn_1: isBlank(source.color_strtn_1) ? "" : source.color_strtn_1,
          color_strtn_2: isBlank(source.color_strtn_2) ? "" : source.color_strtn_2,
          color_strtn_3: isBlank(source.color_strtn_3) ? "" : source.color_strtn_3,
          color_strtn_4: isBlank(source.color_strtn_4) ? "" : source.color_strtn_4,

          color_hue_1: isBlank(source.color_hue_1) ? "" : source.color_hue_1,
          color_hue_2: isBlank(source.color_hue_2) ? "" : source.color_hue_2,
          color_hue_3: isBlank(source.color_hue_3) ? "" : source.color_hue_3,
          color_hue_4: isBlank(source.color_hue_4) ? "" : source.color_hue_4,
      };
  }


  handleHistoryPageChange(pageNumber) {
      const { pc_history_paging } = this.state;
      pc_history_paging["activePage"] = pageNumber;
      pc_history_paging["startIdx"] = ((pageNumber * Number(pc_history_paging["rowcnt"])) - pc_history_paging["rowcnt"]);
      this.setState({pc_history_paging : pc_history_paging});

      this.loadeventHistory("03000");
  }

  handleMobileHistoryPageChange(pageNumber) {
      const { mobile_history_paging } = this.state;
      mobile_history_paging["activePage"] = pageNumber;
      mobile_history_paging["startIdx"] = ((pageNumber * Number(mobile_history_paging["rowcnt"])) - mobile_history_paging["rowcnt"]);
      this.setState({mobile_history_paging : mobile_history_paging});

      this.loadeventHistory("07000");
  } 

 loadeventHistory(upper_code_cd) {   
   const width_ratio =
        upper_code_cd == "03000"
            ? this.state.selected_pc_banner_ratio.banner_height / this.state.selected_pc_banner_ratio.banner_width
            : this.state.selected_mobile_banner_ratio.banner_height / this.state.selected_mobile_banner_ratio.banner_width;

    this.setState({
        event_history_list: [],
    }, () => {
        http.get("/rest/shop/instagram/InstagramTemplateEventHistory"
            +"?start="+(upper_code_cd == "03000" ? this.state.pc_history_paging["startIdx"] : this.state.mobile_history_paging["startIdx"])
            +"&row_cnt="+(upper_code_cd == "03000" ? this.state.pc_history_paging["rowcnt"] : this.state.mobile_history_paging["rowcnt"])
            +"&upper_code_cd="+upper_code_cd
            +"&width_ratio="+width_ratio // 백엔드 쿼리에서, 07000 템플릿 중에서도 정사각형인지 세로로 긴건지 구분해서 출력하도록 하기 위한 구분자
        )
          .then(res => {
            const data = res.data;
    
            if (upper_code_cd == "03000") {
                const {pc_history_paging} = this.state;
                pc_history_paging["totalCnt"] = data.totalCnt;
                this.setState({pc_history_paging : pc_history_paging});
            } else if (upper_code_cd == "07000") {
                const {mobile_history_paging} = this.state;
                mobile_history_paging["totalCnt"] = data.totalCnt;
                this.setState({mobile_history_paging : mobile_history_paging});
            }
    
            this.setState({
                event_history_list: data.list,
            });
          })
          .catch(err => {
            console.error("이벤트 상세 조회 실패:", err);
            alert("이벤트 상세 조회 중 오류가 발생했습니다.");
          });
    });        

  }

  loadEventDetail(event_seq) {
    http.get("/rest/common/admin/event/detail?event_seq="+event_seq)
      .then(res => {
        if (res.data.err_code == 401) {
          window.location.href = "/logout";
        } else if (res.data.err_code == 404) {
          alert("접근할 수 없는 배너입니다.");
        //   window.location.href = "/shop/cafe24/event/list";
        } else {
          var event = res.data["event"];
          let timeFormater = function(time){
              if (Number(time) < 10) {
                  if(time == "00") {
                      return "0";
                  } else {
                      return time.replace("0", "");
                  }
              } else{
                  return time;
              }
          };

          if(event) {
            var start_date = new Date(event.start_date);
            var end_date = new Date(event.end_date);
            var start_hour = timeFormater(event.start_hour);
            var start_minute = timeFormater(event.start_minute);
            var end_hour = timeFormater(event.end_hour);
            var end_minute = timeFormater(event.end_minute);
            var start_date_format = start_date.getFullYear() + "-"+ ("0" + parseInt(start_date.getMonth()+1)).slice(-2) +"-"+("0" + parseInt(start_date.getDate())).slice(-2)+" "+start_hour+":"+start_minute+":00";
            var end_date_format = end_date.getFullYear() + "-"+ ("0" + parseInt(end_date.getMonth()+1)).slice(-2) +"-"+("0" + parseInt(end_date.getDate())).slice(-2)+" "+end_hour+":"+end_minute+":59";

            let is_detail_image_use = false;
            if (event.image_type_cd == "46002") {
                is_detail_image_use = true
            }

            let w_img_position_name = this.addBannerDesignPositionText(res.data.w_banner_design_position_img_list);
            let h_img_position_name = this.addBannerDesignPositionText(res.data.h_banner_design_position_img_list);

            // iOS 텍스트 에디터의 경우 font 태그 대신 span 태그를 사용하므로 변환
            // let mainEditorText = this.convertFontTagToSpan(event.title);
            // let subEditorText = this.convertFontTagToSpan(event.foreign_title);

            let extractedColors = [];
            if (event.ai_colorhunt_1 && event.ai_colorhunt_1 != "") {
                extractedColors.push(event.ai_colorhunt_1);
            }
            if (event.ai_colorhunt_2 && event.ai_colorhunt_2 != "") {
                extractedColors.push(event.ai_colorhunt_2);
            }
            if (event.ai_colorhunt_3 && event.ai_colorhunt_3 != "") {
                extractedColors.push(event.ai_colorhunt_3);
            }
            if (event.ai_colorhunt_4 && event.ai_colorhunt_4 != "") {
                extractedColors.push(event.ai_colorhunt_4);
            }

            // 버튼내 event_seq를 tmp_event_seq로 초기화
            const button_list = (event.button_list || []).map(btn => ({
                ...btn,
                event_seq: dateString
            }));

            // 폰트 리스트 호출
            const loadedFontFamilyList = event.font_family_list
            ? [...new Set(String(event.font_family_list).split(",").map(v => v.trim()).filter(Boolean))]
            : [];

            font_family_list = loadedFontFamilyList;

            this.setState({
                event_seq: event.event_seq,
                pre_iframe_html_id: event.pre_iframe_html_id,
                start_date: start_date,
                start_hour: start_hour,
                start_minute: start_minute,
                start_date_format: start_date_format,
                end_date: end_date,
                end_hour: end_hour,
                end_minute: end_minute,
                end_date_format: end_date_format,
                simple_date_cd: event.simple_date_cd,

                start_date_format_calendar: start_date.getFullYear() + "-"+ ("0" + parseInt(start_date.getMonth()+1)).slice(-2) +"-"+("0" + parseInt(start_date.getDate())).slice(-2)
                            +" "+event.start_hour+":"+event.start_minute+":00.000+0900",
                end_date_format_calendar: end_date.getFullYear() + "-"+ ("0" + parseInt(end_date.getMonth()+1)).slice(-2) +"-"+("0" + parseInt(end_date.getDate())).slice(-2)
                            +" "+event.end_hour+":"+event.end_minute+":59.000+0900",
                book_yn : new Date(start_date_format) > new Date() ? "Y" : "N",
                lang_type: event.lang_type,
                none_title: !event.none_title ? "" : event.none_title,
                auto_title: event.title && event.title.replaceAll("font-size: 15px;", ""),
                non_auto_title: event.title && event.title.replaceAll("font-size: 15px;", ""),
                title: event.title && event.title.replaceAll("font-size: 15px;", ""),
                sub_title: event.foreign_title && event.foreign_title.replaceAll("font-size: 15px;", ""),
                foreign_title: event.foreign_title && event.foreign_title.replaceAll("font-size: 15px;", ""),
                org_title: event.org_title,
                event_type_cd: event.event_type_cd,
                event_mobile_type_cd: event.event_mobile_type_cd,
                event_type_name: event.event_type_name,
                event_type_img: event.event_type_img,
                event_mobile_type_name: event.event_mobile_type_name,
                event_mobile_type_img: event.event_mobile_type_img,
                event_pc_banner_name: event.event_pc_banner_name,
                event_mobile_banner_name: event.event_mobile_banner_name,
                event_pc_tag_cd_list: (event.event_pc_tag_cd_list || "").toString().split(","),
                event_pc_tag_name_list: (event.event_pc_tag_name_list || "").toString().split(","),
                event_mobile_tag_cd_list: (event.event_mobile_tag_cd_list || "").toString().split(","),
                event_mobile_tag_name_list: (event.event_mobile_tag_name_list || "").toString().split(","),
                keyword_cd: event.keyword_cd,
                keyword: event.keyword,
                image: event.img_link,
                image_type_cd: event.image_type_cd,
                is_soldout_display : event.is_soldout_display,
                gpt_main_keyword : event.gpt_main_keyword,
                event_price : event.event_price,

                user_seq: event.user_seq,
                shop_no: event.shop_no,
                display_yn: event.display_yn,
                title_sentence_cd: event.title_sentence_cd,
                content_sentence_cd: event.content_sentence_cd,
                sentence: event.sentence,
                eng_sentence: event.eng_sentence,
                reg_user_seq: event.reg_user_seq,
                reg_date: event.reg_date,
                mod_date: event.mod_date,
                dominant_color: event.dominant_color, // 현재 사용여부 알수없음
                is_product_change: event.is_product_change,
                w_color1_is_use: event.w_color1_is_use,
                w_color2_is_use: event.w_color2_is_use,
                w_color3_is_use: event.w_color3_is_use,
                w_color4_is_use: event.w_color4_is_use,
                h_color1_is_use: event.h_color1_is_use,
                h_color2_is_use: event.h_color2_is_use,
                h_color3_is_use: event.h_color3_is_use,
                h_color4_is_use: event.h_color4_is_use,
                w_color_etc_is_use: event.w_color_etc_is_use,
                h_color_etc_is_use: event.h_color_etc_is_use,
                w_img1_is_use: event.w_img1_is_use,
                w_img2_is_use: event.w_img2_is_use,
                w_img3_is_use: event.w_img3_is_use,
                w_img4_is_use: event.w_img4_is_use,
                h_img1_is_use: event.h_img1_is_use,
                h_img2_is_use: event.h_img2_is_use,
                h_img3_is_use: event.h_img3_is_use,
                h_img4_is_use: event.h_img4_is_use,
                background: event.color_code_1,
                background2: event.color_code_2,
                background3: event.color_code_3,
                background4: event.color_code_4,

                color_value_1 : event.color_value_1,
                color_value_2 : event.color_value_2,
                color_value_3 : event.color_value_3,
                color_value_4 : event.color_value_4,

                color_lmnst_1 : event.color_lmnst_1,
                color_lmnst_2 : event.color_lmnst_2,
                color_lmnst_3 : event.color_lmnst_3,
                color_lmnst_4 : event.color_lmnst_4,

                color_strtn_1 : event.color_strtn_1, 
                color_strtn_2 : event.color_strtn_2,
                color_strtn_3 : event.color_strtn_3,
                color_strtn_4 : event.color_strtn_4,

                color_hue_1 : event.color_hue_1, 
                color_hue_2 : event.color_hue_2,
                color_hue_3 : event.color_hue_3,
                color_hue_4 : event.color_hue_4,

                link_url: event.link_url,
                is_link_url : event.link_url ? "Y" : "N",
                facial_x_start: event.facial_x_start,
                facial_y_start: event.facial_y_start,
                facial_width: event.facial_width,
                facial_height: event.facial_height,
                facial_yn: event.facial_yn,
                origin_img_width: event.origin_img_width,
                origin_img_height: event.origin_img_height,

                // 기존에는 px를 사용하는것만 존재했기 때문에 null값이라면 px(50001)로 설정
                img_position_1_type : event.img_position_1_type ?? "50001",
                img_position_2_type : event.img_position_2_type ?? "50001",
                img_position_3_type : event.img_position_3_type ?? "50001",
                img_position_4_type : event.img_position_4_type ?? "50001",
                h_img_position_1_type : event.h_img_position_1_type ?? "50001",
                h_img_position_2_type : event.h_img_position_2_type ?? "50001",
                h_img_position_3_type : event.h_img_position_3_type ?? "50001",
                h_img_position_4_type : event.h_img_position_4_type ?? "50001",

                w_large_text_color : event.w_large_text_color,
                h_large_text_color : event.h_large_text_color,
                w_small_text_color : event.w_small_text_color,
                h_small_text_color : event.h_small_text_color,
                w_color_etc: event.w_color_etc,
                h_color_etc: event.h_color_etc,

                img_link: event.img_link == "null" ? "" : event.img_link,
                img_detail_link: event.img_detail_link == "null" ? "" : event.img_detail_link,
                img_third_link: event.img_third_link == "null" ? "" : event.img_third_link,
                img_fourth_link: event.img_fourth_link == "null" ? "" : event.img_fourth_link,
                h_img_link: event.h_img_link == "null" ? "" : event.h_img_link,
                h_img_detail_link: event.h_img_detail_link == "null" ? "" : event.h_img_detail_link,
                h_img_third_link: event.h_img_third_link == "null" ? "" : event.h_img_third_link,
                h_img_fourth_link: event.h_img_fourth_link == "null" ? "" : event.h_img_fourth_link,

                robo_banner_org_img_link_seq : event.robo_banner_org_img_link_seq,
                robo_banner_org_img_detail_link_seq: event.robo_banner_org_img_detail_link_seq,
                robo_banner_org_img_third_link_seq: event.robo_banner_org_img_third_link_seq,
                robo_banner_org_img_fourth_link_seq: event.robo_banner_org_img_fourth_link_seq,
                h_robo_banner_org_img_link_seq : event.h_robo_banner_org_img_link_seq,
                h_robo_banner_org_img_detail_link_seq: event.h_robo_banner_org_img_detail_link_seq,
                h_robo_banner_org_img_third_link_seq: event.h_robo_banner_org_img_third_link_seq,
                h_robo_banner_org_img_fourth_link_seq: event.h_robo_banner_org_img_fourth_link_seq,

                w_crop_img_info_list : res.data.w_crop_img_info_list,
                h_crop_img_info_list : res.data.h_crop_img_info_list,

                is_detail_image_use: is_detail_image_use,

                w_img_nukki_yn : event.w_img_nukki_yn,
                h_img_nukki_yn : event.h_img_nukki_yn,
                w_img_detail_nukki_yn : event.w_img_detail_nukki_yn,
                h_img_detail_nukki_yn : event.h_img_detail_nukki_yn,
                w_img_third_nukki_yn : event.w_img_third_nukki_yn,
                h_img_third_nukki_yn : event.h_img_third_nukki_yn,
                w_img_fourth_nukki_yn : event.w_img_fourth_nukki_yn,
                h_img_fourth_nukki_yn : event.h_img_fourth_nukki_yn,

                w_img_nukki_ppm_yn : event.w_img_nukki_ppm_yn,
                w_img_detail_nukki_ppm_yn : event.w_img_detail_nukki_ppm_yn,
                w_img_third_nukki_ppm_yn : event.w_img_third_nukki_ppm_yn,
                w_img_fourth_nukki_ppm_yn : event.w_img_fourth_nukki_ppm_yn,
                h_img_nukki_ppm_yn : event.h_img_nukki_ppm_yn,
                h_img_detail_nukki_ppm_yn : event.h_img_detail_nukki_ppm_yn,
                h_img_third_nukki_ppm_yn : event.h_img_third_nukki_ppm_yn,
                h_img_fourth_nukki_ppm_yn :event.h_img_fourth_nukki_ppm_yn,

                w_img_nukki_version : event.w_img_nukki_version,
                w_img_detail_nukki_version : event.w_img_detail_nukki_version,
                w_img_third_nukki_version : event.w_img_third_nukki_version,
                w_img_fourth_nukki_version : event.w_img_fourth_nukki_version,
                h_img_nukki_version : event.h_img_nukki_version,
                h_img_detail_nukki_version : event.h_img_detail_nukki_version,
                h_img_third_nukki_version : event.h_img_third_nukki_version,
                h_img_fourth_nukki_version : event.h_img_fourth_nukki_version,

                w_nukki_img_link : (!event.w_nukki_img_link || event.w_nukki_img_link == "undefined") ? "" : event.w_nukki_img_link,
                w_nukki_img_detail_link : (!event.w_nukki_img_detail_link || event.w_nukki_img_detail_link == "undefined") ? "" : event.w_nukki_img_detail_link,
                w_nukki_img_third_link : (!event.w_nukki_img_third_link || event.w_nukki_img_third_link == "undefined") ? "" : event.w_nukki_img_third_link,
                w_nukki_img_fourth_link : (!event.w_nukki_img_fourth_link || event.w_nukki_img_fourth_link == "undefined") ? "" : event.w_nukki_img_fourth_link,
                h_nukki_img_link : (!event.h_nukki_img_link || event.h_nukki_img_link == "undefined") ? "" : event.h_nukki_img_link,
                h_nukki_img_detail_link : (!event.h_nukki_img_detail_link || event.h_nukki_img_detail_link == "undefined") ? "" : event.h_nukki_img_detail_link,
                h_nukki_img_third_link : (!event.h_nukki_img_third_link || event.h_nukki_img_third_link == "undefined") ? "" : event.h_nukki_img_third_link,
                h_nukki_img_fourth_link : (!event.h_nukki_img_fourth_link || event.h_nukki_img_fourth_link == "undefined") ? "" : event.h_nukki_img_fourth_link,

                w_img_link_type : event.w_img_link_type,
                w_img_detail_link_type : event.w_img_detail_link_type,
                w_img_third_link_type : event.w_img_third_link_type,
                w_img_fourth_link_type : event.w_img_fourth_link_type,
                h_img_link_type : event.h_img_link_type,
                h_img_detail_link_type : event.h_img_detail_link_type,
                h_img_third_link_type : event.h_img_third_link_type,
                h_img_fourth_link_type : event.h_img_fourth_link_type,

                w_img_49002_link : (!event.w_img_49002_link || event.w_img_49002_link == "undefined") ? "" : event.w_img_49002_link,
                w_img_detail_49002_link : (!event.w_img_detail_49002_link || event.w_img_detail_49002_link == "undefined") ? "" : event.w_img_detail_49002_link,
                w_img_third_49002_link : (!event.w_img_third_49002_link || event.w_img_third_49002_link == "undefined") ? "" : event.w_img_third_49002_link,
                w_img_fourth_49002_link : (!event.w_img_fourth_49002_link || event.w_img_fourth_49002_link == "undefined") ? "" : event.w_img_fourth_49002_link,
                h_img_49002_link : (!event.h_img_49002_link || event.h_img_49002_link == "undefined") ? "" : event.h_img_49002_link,
                h_img_detail_49002_link : (!event.h_img_detail_49002_link || event.h_img_detail_49002_link == "undefined") ? "" : event.h_img_detail_49002_link,
                h_img_third_49002_link : (!event.h_img_third_49002_link || event.h_img_third_49002_link == "undefined") ? "" : event.h_img_third_49002_link,
                h_img_fourth_49002_link : (!event.h_img_fourth_49002_link || event.h_img_fourth_49002_link == "undefined") ? "" : event.h_img_fourth_49002_link,

                w_img_49004_link: event.w_img_49004_link,
                w_img_detail_49004_link: event.w_img_detail_49004_link,
                w_img_third_49004_link: event.w_img_third_49004_link,
                w_img_fourth_49004_link: event.w_img_fourth_49004_link,
                h_img_49004_link: event.h_img_49004_link,
                h_img_detail_49004_link: event.h_img_detail_49004_link,
                h_img_third_49004_link: event.h_img_third_49004_link,
                h_img_fourth_49004_link: event.h_img_fourth_49004_link,
                
                w_img_49006_link: event.w_img_49006_link,
                w_img_detail_49006_link: event.w_img_detail_49006_link,
                w_img_third_49006_link: event.w_img_third_49006_link,
                w_img_fourth_49006_link: event.w_img_fourth_49006_link,
                h_img_49006_link: event.h_img_49006_link,
                h_img_detail_49006_link: event.h_img_detail_49006_link,
                h_img_third_49006_link: event.h_img_third_49006_link,
                h_img_fourth_49006_link: event.h_img_fourth_49006_link,

                youtube_link : event.youtube_link,
                youtube_detail_link : event.youtube_detail_link,
                youtube_third_link : event.youtube_third_link,
                youtube_fourth_link : event.youtube_fourth_link,
                h_youtube_link : event.h_youtube_link,
                h_youtube_detail_link : event.h_youtube_detail_link,
                h_youtube_third_link : event.h_youtube_third_link,
                h_youtube_fourth_link : event.h_youtube_fourth_link,
                youtube_thumbnail : event.youtube_thumbnail,
                youtube_detail_thumbnail : event.youtube_detail_thumbnail,
                youtube_third_thumbnail : event.youtube_third_thumbnail,
                youtube_fourth_thumbnail : event.youtube_fourth_thumbnail,
                h_youtube_thumbnail : event.h_youtube_thumbnail,
                h_youtube_detail_thumbnail : event.h_youtube_detail_thumbnail,
                h_youtube_third_thumbnail : event.h_youtube_third_thumbnail,
                h_youtube_fourth_thumbnail : event.h_youtube_fourth_thumbnail,
                w_is_youtube_use: event.w_is_youtube_use,
                w_is_youtube_detail_use: event.w_is_youtube_detail_use,
                w_is_youtube_third_use: event.w_is_youtube_third_use,
                w_is_youtube_fourth_use: event.w_is_youtube_fourth_use,
                h_is_youtube_use: event.h_is_youtube_use,
                h_is_youtube_detail_use: event.h_is_youtube_detail_use,
                h_is_youtube_third_use: event.h_is_youtube_third_use,
                h_is_youtube_fourth_use: event.h_is_youtube_fourth_use,

                event_type_cd_use_yn : event.event_type_cd_use_yn,
                event_mobile_cd_use_yn : event.event_mobile_cd_use_yn,

                w_img_position_name : w_img_position_name,
                h_img_position_name : h_img_position_name,
                w_essential_img_nukki_yn : res.data.w_essential_img_nukki_yn,
                h_essential_img_nukki_yn : res.data.h_essential_img_nukki_yn,
                w_is_nukki_ppm_yn : res.data.w_is_nukki_ppm_yn,
                h_is_nukki_ppm_yn : res.data.h_is_nukki_ppm_yn,
                w_is_nukki_multi_use_yn : res.data.w_is_nukki_multi_use_yn,
                h_is_nukki_multi_use_yn : res.data.h_is_nukki_multi_use_yn,
                w_is_nukki_crop_yn : res.data.w_is_nukki_crop_yn,
                h_is_nukki_crop_yn : res.data.h_is_nukki_crop_yn,
                w_is_date_use : res.data.w_is_date_use,
                h_is_date_use : res.data.h_is_date_use,
                w_is_price_use : res.data.w_is_price_use,
                h_is_price_use : res.data.h_is_price_use,
                w_is_button_use : res.data.w_is_button_use,
                h_is_button_use : res.data.h_is_button_use,
                w_is_youtube_link_use : res.data.w_is_youtube_link_use,
                h_is_youtube_link_use : res.data.h_is_youtube_link_use,

                // 미리보기 사이즈 입력값
                event_banner_pc_width : event.event_banner_pc_width == "0" ? "" : event.event_banner_pc_width,
                event_banner_pc_height : event.event_banner_pc_height  == "0" ? "" : event.event_banner_pc_height,
                event_banner_mobile_width : event.event_banner_mobile_width  == "0" ? "" : event.event_banner_mobile_width,
                event_banner_mobile_height : event.event_banner_mobile_height  == "0" ? "" : event.event_banner_mobile_height,
                    
                // 버튼 리스트
                button_list : button_list,

                // 텍스트 위치 이동
                w_main_txt_position_x : event.w_main_txt_position_x,
                w_main_txt_position_y : event.w_main_txt_position_y,
                h_main_txt_position_x : event.h_main_txt_position_x,
                h_main_txt_position_y : event.h_main_txt_position_y,
                w_sub_txt_position_x : event.w_sub_txt_position_x,
                w_sub_txt_position_y : event.w_sub_txt_position_y,
                h_sub_txt_position_x : event.h_sub_txt_position_x,
                h_sub_txt_position_y : event.h_sub_txt_position_y,

                // 이미지 크기 조절
                w_img_1_scale : event.w_img_1_scale,
                w_img_2_scale : event.w_img_2_scale,
                w_img_3_scale : event.w_img_3_scale,
                w_img_4_scale : event.w_img_4_scale,
                h_img_1_scale : event.h_img_1_scale,
                h_img_2_scale : event.h_img_2_scale,
                h_img_3_scale : event.h_img_3_scale,
                h_img_4_scale : event.h_img_4_scale,

                // 텍스트 크기 조절
                w_main_txt_scale : event.w_main_txt_scale,
                h_main_txt_scale : event.h_main_txt_scale,
                w_sub_txt_scale : event.w_sub_txt_scale,
                h_sub_txt_scale : event.h_sub_txt_scale,

                // iOS 텍스트 에디터
                // mainEditorState: this.htmlToEditor(mainEditorText),
                // subEditorState: this.htmlToEditor(subEditorText),

                selected_target_view_list : event.target_view_list,

                extractedColors,

                font_family_list: loadedFontFamilyList,
            }, () => {
                this.getisUsePallete({ preserveEventColor: true });

                let w_nukki_ppm_state = [false, false, false, false];
                let h_nukki_ppm_state = [false, false, false, false];
                let w_nukki_version_list = [1,1,1,1];
                let h_nukki_version_list = [1,1,1,1];
                let {w_user_img_list, h_user_img_list} = this.state;
                
                // 업로드 이미지, 링크형 이미지, pmm 상태 데이터 담는 작업
                /** 가로형 */
                for(var i=0;i<this.state.w_img_position_name.length;i++){
                    w_user_img_list[i].link_type = this.state["w_"+this.state.w_img_position_name[i].position_name+"_link_type"];
                    if(this.state["robo_banner_org_"+this.state.w_img_position_name[i].position_name+"_link_seq"]){
                        this.searchOrgImg(this.state["robo_banner_org_"+this.state.w_img_position_name[i].position_name+"_link_seq"], i, "w", true); // 첨부 이미지 조회
                    }
                    if(w_user_img_list[i].link_type == "49002"){
                        const img_link = this.state["w_"+this.state.w_img_position_name[i].position_name+"_49002_link"];
                        const idx = i;
                        this.checkImgLinkUseAble(img_link, () => {
                            var {w_user_img_list} = this.state;
                            w_user_img_list[idx].img_link_able = true;
                            this.setState({w_user_img_list : w_user_img_list,});
                        });

                        w_user_img_list[i].img_link = img_link;
                        w_user_img_list[i].org_img_name = img_link;
                    }
                    if(w_user_img_list[i].link_type == "49003"){
                        let crop_img_info = this.state.w_crop_img_info_list[i];
                        let img_link = crop_img_info.crop_img_link_list ? crop_img_info.crop_img_link_list[crop_img_info.crop_img_seleted_no] : "";
                        w_user_img_list[i].img_link = img_link;
                        w_user_img_list[i].org_img_name = img_link;
                    }
                    if(w_user_img_list[i].link_type == "49004"){
                        const img_link = this.state["w_"+this.state.w_img_position_name[i].position_name+"_49004_link"];
                        const idx = i;
                        this.checkImgLinkUseAble(img_link, () => {
                            var {w_user_img_list} = this.state;
                            w_user_img_list[idx].img_link_able = true;
                            this.setState({w_user_img_list : w_user_img_list,});
                        });

                        w_user_img_list[i].img_link = img_link;
                        w_user_img_list[i].org_img_name = img_link;
                    }
                    if(w_user_img_list[i].link_type == "49005"){
                        const video_link = this.state[this.state.w_img_position_name[i].youtube_position_name+"_link"];
                        const thumbnail = this.state[this.state.w_img_position_name[i].youtube_position_name+"_thumbnail"];

                        w_user_img_list[i].img_link = thumbnail;
                        w_user_img_list[i].video_link = video_link;
                        w_user_img_list[i].org_img_name = video_link;
                    }
                    if(this.state["w_"+this.state.w_img_position_name[i].position_name+"_nukki_ppm_yn"] == "Y"){ // ppm 상태값 조회
                        w_nukki_ppm_state[i] = true;
                    }
                    w_nukki_version_list[i] = this.state["w_"+this.state.w_img_position_name[i].position_name+"_nukki_version"] ?? 1;
                }

                /** 세로형 */
                for(var i=0;i<this.state.h_img_position_name.length;i++){
                    h_user_img_list[i].link_type = this.state["h_"+this.state.h_img_position_name[i].position_name+"_link_type"];
                    if(this.state["h_robo_banner_org_"+this.state.h_img_position_name[i].position_name+"_link_seq"]){
                        this.searchOrgImg(this.state["h_robo_banner_org_"+this.state.h_img_position_name[i].position_name+"_link_seq"], i, "h", true); // 첨부 이미지 조회
                    }
                    if(h_user_img_list[i].link_type == "49002"){
                        const img_link = this.state["h_"+this.state.h_img_position_name[i].position_name+"_49002_link"];
                        const idx = i;
                        this.checkImgLinkUseAble(img_link, () => {
                            var {h_user_img_list} = this.state;
                            h_user_img_list[idx].img_link_able = true;
                            this.setState({h_user_img_list : h_user_img_list,});
                        });

                        h_user_img_list[i].img_link = img_link;
                        h_user_img_list[i].org_img_name = img_link;
                    }
                    if(h_user_img_list[i].link_type == "49003"){
                        let crop_img_info = this.state.h_crop_img_info_list[i];
                        let img_link = crop_img_info.crop_img_link_list ? crop_img_info.crop_img_link_list[crop_img_info.crop_img_seleted_no] : "";
                        h_user_img_list[i].img_link = img_link;
                        h_user_img_list[i].org_img_name = img_link;
                    }
                    if(h_user_img_list[i].link_type == "49004"){
                        const img_link = this.state["h_"+this.state.h_img_position_name[i].position_name+"_49004_link"];
                        const idx = i;
                        this.checkImgLinkUseAble(img_link, () => {
                            var {h_user_img_list} = this.state;
                            h_user_img_list[idx].img_link_able = true;
                            this.setState({h_user_img_list : h_user_img_list,});
                        });

                        h_user_img_list[i].img_link = img_link;
                        h_user_img_list[i].org_img_name = img_link;
                    }
                    if(h_user_img_list[i].link_type == "49005"){
                        const video_link = this.state["h_"+this.state.h_img_position_name[i].youtube_position_name+"_link"];
                        const thumbnail = this.state["h_"+this.state.h_img_position_name[i].youtube_position_name+"_thumbnail"];

                        h_user_img_list[i].img_link = thumbnail;
                        h_user_img_list[i].video_link = video_link;
                    }
                    if(h_user_img_list[i].link_type == "49006"){
                        const img_link = this.state["h_"+this.state.h_img_position_name[i].position_name+"_49006_link"];
                        const idx = i;
                        this.checkImgLinkUseAble(img_link, () => {
                            var {h_user_img_list} = this.state;
                            h_user_img_list[idx].img_link_able = true;
                            this.setState({h_user_img_list : h_user_img_list,});
                        });

                        h_user_img_list[i].img_link = img_link;
                        h_user_img_list[i].org_img_name = img_link;
                    }
                    if(this.state["h_"+this.state.h_img_position_name[i].position_name+"_nukki_ppm_yn"] == "Y"){
                        h_nukki_ppm_state[i] = true;
                    }
                    h_nukki_version_list[i] = this.state["h_"+this.state.h_img_position_name[i].position_name+"_nukki_version"] ?? 1;
                }

                // 저장된 데이터를 불러왔을때 이미지가 사용되지 않는 영역의 누끼 이미지를 초기화
                let non_use_w_position_name = JSON.parse(JSON.stringify(img_order_text));
                let non_use_h_position_name = JSON.parse(JSON.stringify(img_order_text));
                for(var i=0;i<4;i++){
                    if(this.state["w_img"+(i+1)+"_is_use"] == "Y"){
                        non_use_w_position_name.splice(non_use_w_position_name.indexOf(this.state.w_img_position_name[i].position_name),1);
                    }
                    if(this.state["h_img"+(i+1)+"_is_use"] == "Y"){
                        non_use_h_position_name.splice(non_use_h_position_name.indexOf(this.state.h_img_position_name[i].position_name),1);
                    }
                }
                for(var i=0;i<non_use_w_position_name.length;i++){
                    this.setState({["w_nukki_"+non_use_w_position_name[i]+"_link"] : ""});
                }
                for(var i=0;i<non_use_h_position_name.length;i++){
                    this.setState({["h_nukki_"+non_use_h_position_name[i]+"_link"] : ""});
                }
                this.setState({
                    w_nukki_ppm_state: w_nukki_ppm_state,
                    h_nukki_ppm_state: h_nukki_ppm_state,
                    w_nukki_version_list : w_nukki_version_list,
                    h_nukki_version_list : h_nukki_version_list,
                    w_user_img_list : w_user_img_list,
                    h_user_img_list : h_user_img_list,
                }, () => {
                    var event_seq = this.getUrlParams()["event_seq"];
                    // this.loadEventDetailProduct(event_seq);
                });

                if (this.getUrlParams()["sample_yn"] != "Y") {
                    // 샘플 배너 일 때, DB 저장값 null이라서 사용 하지 않음. 디폴트값으로 대체.
                    this.setState({
                        item_user_type: event.item_user_type,
                        iframe_page_id: event.iframe_page_id,
                        iframe_html_id: event.iframe_html_id,
                    });

                    // 자동 배너 설정 불러오기
                    // this.getAutoEventSetting(event.iframe_page_id, event.iframe_html_id).then(r => {});
                    // 파일명 규칙 설정 불러오기
                    // this.getFileNameSettingList(event.iframe_page_id, event.iframe_html_id).then(r => {});
                }

                // is_banner_ratio_loaded = true;

                // 사용자 멀티샵 서비스 무료체험, 결제여부 확인
                this.fn_shopServiceOperated("01009");   // 01009 : 타겟뷰 서비스
            });


            for(var i=1;i<=4;i++){
                /* 가로형 이미지 가로 위치 */
                if (event["img_position_x_"+i]) {
                    if (event["img_position_x_"+i] > 0) {
                        this.setState({
                            ["w_img_position_left_"+i]: 0,
                            ["w_img_position_right_"+i]: Number(event["img_position_x_"+i]),
                            ["w_img_position_x_"+i]: Number(event["img_position_x_"+i]),
                        })
                    } else {
                        this.setState({
                            ["w_img_position_left_"+i]: -1 * Number(event["img_position_x_"+i]),
                            ["w_img_position_right_"+i]: 0,
                            ["w_img_position_x_"+i]: Number(event["img_position_x_"+i]),
                        })
                    }
                }
                /* 가로형 이미지 세로 위치 */
                if (event["img_position_y_"+i]) {
                    if (event["img_position_y_"+i] > 0) {
                        this.setState({
                            ["w_img_position_bottom_"+i]: Number(event["img_position_y_"+i]),
                            ["w_img_position_top_"+i]: 0,
                            ["w_img_position_y_"+i]: -1 * Number(event["img_position_y_"+i]),
                        })
                    } else {
                        this.setState({
                            ["w_img_position_bottom_"+i]: 0,
                            ["w_img_position_top_"+i]: -1 * Number(event["img_position_y_"+i]),
                            ["w_img_position_y_"+i]: Number(event["img_position_y_"+i]),
                        })
                    }
                }
                /* 세로형 이미지 가로 위치 */
                if (event["h_img_position_x_"+i]) {
                    if (event["h_img_position_x_"+i] > 0) {
                        this.setState({
                            ["h_img_position_left_"+i]: 0,
                            ["h_img_position_right_"+i]: Number(event["h_img_position_x_"+i]),
                            ["h_img_position_x_"+i]: Number(event["h_img_position_x_"+i]),
                        })
                    } else {
                        this.setState({
                            ["h_img_position_left_"+i]: -1 * Number(event["h_img_position_x_"+i]),
                            ["h_img_position_right_"+i]: 0,
                            ["h_img_position_x_"+i]: Number(event["h_img_position_x_"+i]),
                        })
                    }
                }
                /* 세로형 이미지 세로 위치 */
                if (event["h_img_position_y_"+i]) {
                    if (event["h_img_position_y_"+i] > 0) {
                        this.setState({
                            ["h_img_position_bottom_"+i]: Number(event["h_img_position_y_"+i]),
                            ["h_img_position_top_"+i]: 0,
                            ["h_img_position_y_"+i]: -1 * Number(event["h_img_position_y_"+i]),
                        })
                    } else {
                        this.setState({
                            ["h_img_position_bottom_"+i]: 0,
                            ["h_img_position_top_"+i]: -1 * Number(event["h_img_position_y_"+i]),
                            ["h_img_position_y_"+i]: Number(event["h_img_position_y_"+i]),
                        })
                    }
                }
            }

            if (event.simple_date_cd && event.simple_date_cd == "17001") {
                this.state.disabledStartDate = false;
                this.state.disabledEndDate = false; 
            } else {
                this.state.disabledStartDate = true;
                this.state.disabledEndDate = true;
            }

            // 페이지 로드시 배너 설정값 미리보기 테이블에 덮어쓰기
            const nukki_info = { page_load : true, };
            this.insertEventTmp('preview', nukki_info, true);

            // 텍스트 위치 이동
            if(event.w_main_txt_position_x == undefined || event.w_main_txt_position_x == null){
                event.w_main_txt_position_x = 0;
            }
            if(event.w_main_txt_position_y == undefined || event.w_main_txt_position_y == null){
                event.w_main_txt_position_y = 0;
            }
            if(event.h_main_txt_position_x == undefined || event.h_main_txt_position_x == null){
                event.h_main_txt_position_x = 0;
            }
            if(event.h_main_txt_position_y == undefined || event.h_main_txt_position_y == null){
                event.h_main_txt_position_y = 0;
            }
            if(event.w_sub_txt_position_x == undefined || event.w_sub_txt_position_x == null){
                event.w_sub_txt_position_x = 0;
            }
            if(event.w_sub_txt_position_y == undefined || event.w_sub_txt_position_y == null){
                event.w_sub_txt_position_y = 0;
            }
            if(event.h_sub_txt_position_x == undefined || event.h_sub_txt_position_x == null){
                event.h_sub_txt_position_x = 0;
            }
            if(event.h_sub_txt_position_y == undefined || event.h_sub_txt_position_y == null){
                event.h_sub_txt_position_y = 0;
            }

            if(Number(event.w_main_txt_position_x) < 0){
                this.setState({ w_main_txt_position_left : Math.abs(Number(event.w_main_txt_position_x))});
            }else{
                this.setState({ w_main_txt_position_right : Math.abs(Number(event.w_main_txt_position_x))});
            }
            if(Number(event.w_main_txt_position_y) < 0){
                this.setState({ w_main_txt_position_bottom : Math.abs(Number(event.w_main_txt_position_y))});
            }else{
                this.setState({ w_main_txt_position_top : Math.abs(Number(event.w_main_txt_position_y))});
            }
            if(Number(event.h_main_txt_position_x) < 0){
                this.setState({ h_main_txt_position_left : Math.abs(Number(event.h_main_txt_position_x))});
            }else{
                this.setState({ h_main_txt_position_right : Math.abs(Number(event.h_main_txt_position_x))});
            }
            if(Number(event.h_main_txt_position_y) < 0){
                this.setState({ h_main_txt_position_bottom : Math.abs(Number(event.h_main_txt_position_y))});
            }else{
                this.setState({ h_main_txt_position_top : Math.abs(Number(event.h_main_txt_position_y))});
            }

            if(Number(event.w_sub_txt_position_x) < 0){
                this.setState({ w_sub_txt_position_left : Math.abs(Number(event.w_sub_txt_position_x))});
            }else{
                this.setState({ w_sub_txt_position_right : Math.abs(Number(event.w_sub_txt_position_x))});
            }
            if(Number(event.w_sub_txt_position_y) < 0){
                this.setState({ w_sub_txt_position_bottom : Math.abs(Number(event.w_sub_txt_position_y))});
            }else{
                this.setState({ w_sub_txt_position_top : Math.abs(Number(event.w_sub_txt_position_y))});
            }
            if(Number(event.h_sub_txt_position_x) < 0){
                this.setState({ h_sub_txt_position_left : Math.abs(Number(event.h_sub_txt_position_x))});
            }else{
                this.setState({ h_sub_txt_position_right : Math.abs(Number(event.h_sub_txt_position_x))});
            }
            if(Number(event.h_sub_txt_position_y) < 0){
                this.setState({ h_sub_txt_position_bottom : Math.abs(Number(event.h_sub_txt_position_y))});
            }else{
                this.setState({ h_sub_txt_position_top : Math.abs(Number(event.h_sub_txt_position_y))});
            }
        }

        this.loadCafe24Item();
        this.loadProductCategory(this.state.parentCategory);
        this.getFullCalendarEventList("", ""); // 달력용 기획전 목록 조회

        if(event.iframe_page_id) {
            this.getBannerHtmlList(event.iframe_page_id);
        }
      }
  })
  .catch(error => {
  // console.log ("===== error =====");
  // console.log (error);
  // console.log ("===== error request =====");
  // console.log(error.request);
  });
}

// 사용자 멀티샵 서비스 무료체험, 결제여부 확인
fn_shopServiceOperated = (service_type, callback=()=>{}) => {
    http.get("/rest/shop/serviceOperated/"+service_type)
    .then(res => {
        if(res.data.code == "0000"){
            if(service_type == "01009" 
                && (
                        res.data.shopServiceOperated_map.is_finish == "0" 
                        || res.data.shopServiceOperated_map.is_finish == "1"        //타겟뷰 서비스 : 무료체험 구분 없음
                        || res.data.shopServiceOperated_map.is_payment == "1"
                    )
            ){
                this.setState({is_use_target_view_service : "Y"});
            } else{
                this.setState({
                    is_use_target_view_service : "N",       // is_finish : -1 미신청시 해당 팝업 출력
                });
            }
        }
        return res;
    })
    .then((res) => {
        callback(res);
    })
    .catch(error => {
      console.log (error);
    });
}

  getBannerRatio (changeBannerArea, inputType){
    // 페이지 로드시 사이즈 입력값이 모두 비어있다면, 설정에 있는 사이즈 값을 사용 중이던 배너이므로 설정값 사이즈를 사용한다.
    const loadInputAddSetting = getBannerRatioCnt==0 && !this.state.event_banner_pc_width && !this.state.event_banner_pc_height && !this.state.event_banner_mobile_width && !this.state.event_banner_mobile_height;
    var sendForm = {
        user_seq: this.state.user_seq,
        shop_no: "1",
        iframe_page_id: this.state.iframe_page_id,
        iframe_html_id: this.state.iframe_html_id,

        // 배너 영역을 변경하여 비율을 새로 받아오거나, 로보 배너 등록을 새로하는 경우에만 설정 비율로 응답받음
        store_connected_yn : ( changeBannerArea || loadInputAddSetting) ? "Y" : "N",

        /* 비연동형 사이즈 입력값 전달 */
        event_banner_pc_width : this.state.event_banner_pc_width,
        event_banner_pc_height : this.state.event_banner_pc_height,
        event_banner_mobile_width : this.state.event_banner_mobile_width,
        event_banner_mobile_height : this.state.event_banner_mobile_height,
    }

    if(sendForm.store_connected_yn == "Y" && !(this.state.iframe_page_id && this.state.iframe_html_id)){
        return false;
    }

    http.get("/rest/common/banner/ratio", {params:sendForm})
    .then(res => {
        let single_size = this.state.single_size;
        //this.loadTargetViewList(); // 타겟뷰 목록 조회
        
        let org_event_banner_pc_width = res.data.org_event_banner_pc_width;
        let org_event_banner_pc_height = res.data.org_event_banner_pc_height;
        let org_event_banner_mobile_width = res.data.org_event_banner_mobile_width;
        let org_event_banner_mobile_height = res.data.org_event_banner_mobile_height;
        let event_banner_pc_width_height = res.data.event_banner_pc_width_height;
        let event_banner_mobile_width_height = res.data.event_banner_mobile_width_height;

        let pc_banner_ratio_list = [];
        let mobile_banner_ratio_list = [];
        let selected_pc_banner_ratio = {};
        let selected_mobile_banner_ratio = {};
        let pc_mobile_same_ratio = false; // pc/mobile형 비율 사이즈가 정확하게 일치하면 true, 셀렉트박스에 하나의 설정만 들어가도록 한다. 

        if(org_event_banner_pc_width == org_event_banner_mobile_width && org_event_banner_pc_height == org_event_banner_mobile_height){
            pc_mobile_same_ratio = true;
            if(sendForm.store_connected_yn == "Y" || getBannerRatioCnt == 0){
                single_size = true;
            }
        }

        //배너 영역을 변경하여 비율을 새로 받아오거나, 로보 배너 등록을 새로하는 경우
        if(loadInputAddSetting || changeBannerArea){
            if(!pc_mobile_same_ratio){
                single_size = false;
            }
            /* 사이즈 입력란에 설정 사이즈 적용 */
            this.setState({
                event_banner_pc_width : org_event_banner_pc_width ?? "",
                event_banner_pc_height : org_event_banner_pc_height ?? "",
                event_banner_mobile_width : org_event_banner_mobile_width ?? "",
                event_banner_mobile_height : org_event_banner_mobile_height ?? "",
            });
        } else if(single_size){
            this.setState({
                event_banner_pc_width : org_event_banner_pc_width ?? "",
                event_banner_pc_height : org_event_banner_pc_height ?? "",
                event_banner_mobile_width : org_event_banner_pc_width ?? "",
                event_banner_mobile_height : org_event_banner_pc_height ?? "",
            });
        }

        var pc_org_obj = {
            "org_banner_width":   org_event_banner_pc_width,
            "org_banner_height": org_event_banner_pc_height,
            "org_event_type" : "p",
            "org_width_height" : event_banner_pc_width_height,
        };
        if (event_banner_pc_width_height && event_banner_pc_width_height > 1) {
            pc_org_obj = this.getCaptureSize("pc",pc_org_obj);
            // 원본 pc 비율이 1보다 큰 경우
            pc_banner_ratio_list.push(pc_org_obj);
            selected_pc_banner_ratio = pc_org_obj;
        } else if (event_banner_pc_width_height && event_banner_pc_width_height <= 1){
            pc_org_obj = this.getCaptureSize("mobile",pc_org_obj);
            // 원본 pc 비율이 1보다 작거나 같은 경우
            mobile_banner_ratio_list.push(pc_org_obj);
            selected_mobile_banner_ratio = pc_org_obj;
        }

        if(!pc_mobile_same_ratio && !single_size){
            var mobile_org_obj = {
                "org_banner_width": org_event_banner_mobile_width,
                "org_banner_height": org_event_banner_mobile_height,
                "org_event_type" : "m",
                "org_width_height" : event_banner_mobile_width_height,
            };
            if (event_banner_mobile_width_height && event_banner_mobile_width_height <= 1){
                mobile_org_obj = this.getCaptureSize("mobile",mobile_org_obj);
                // 원본 모바일 비율이 1보다 작거나 같은 경우
                mobile_banner_ratio_list.push(mobile_org_obj);
                
                // 비연동형에서 입력값이 모바일이였다면, 해당 비율을 선택값으로 설정
                if(!selected_mobile_banner_ratio.org_banner_width || inputType == "mobile"){
                    selected_mobile_banner_ratio = mobile_org_obj;
                }
            } else if (event_banner_mobile_width_height && event_banner_mobile_width_height > 1) {
                mobile_org_obj = this.getCaptureSize("pc",mobile_org_obj);
                // 원본 모바일 비율이 1보다 큰 경우
                pc_banner_ratio_list.push(mobile_org_obj);

                // 비연동형에서 입력값이 모바일이였다면, 해당 비율을 선택값으로 설정
                if(!selected_pc_banner_ratio.org_banner_width || inputType == "mobile"){
                    selected_pc_banner_ratio = mobile_org_obj;
                }
            }
        }

        this.setState({
            pc_banner_ratio_list: pc_banner_ratio_list,
            mobile_banner_ratio_list: mobile_banner_ratio_list,
            selected_pc_banner_ratio : selected_pc_banner_ratio,
            selected_mobile_banner_ratio : selected_mobile_banner_ratio,
            single_size : single_size,
        }, () => {
            if(getBannerRatioCnt > 0 || !this.getUrlParams()["event_seq"]){
                // 페이지 로드할때 실행하고 자동배너를 변경할떄마다 실행
                this.checkNukkiState();
            } else{
                this.insertEventTmp('preview');
            }
            getBannerRatioCnt++;
        });

        // banner_ratio_list가 존재하는지로 가로형 또는 세로형이 보여지는 여부 판별
        this.setState({
            is_show_pc_banner_area: pc_banner_ratio_list.length > 0 ? true : false,
            is_show_mobile_banner_area: mobile_banner_ratio_list.length > 0 ? true : false,
        });

        this.setHeight();
    })
}

  /** 누끼 필수 템플릿이 누끼가 따져있는지 확인하고 배경 제거를 진행하는 함수
   * 1. getBannerRatio (iframe_html_id가 변경되는 함수 실행시)
  */
  checkNukkiState(){
      let nukki_info_Y_list = [];
      for(var i=0;i<4;i++){
          // 이미지가 사용되는 영역에 이미지가 있는데, 누끼 필수 영역임에도 누끼를 안땄다면 배경제거 실행
          if(this.state.w_essential_img_nukki_yn == "Y" && this.state["w_img"+(i+1)+"_is_use"] == "Y" && !this.state.w_non_nukki_state[i] && this.state["w_"+this.state.w_img_position_name[i].position_name+"_nukki_yn"] == "N"){
              if(this.positionImgCheck("w", i)){
                  const nukki_info_Y = {
                      type : "w",
                      position : i+1,
                      action : "Y",
                  };
                  nukki_info_Y_list.push(nukki_info_Y);
              } else{
                  this.setState({["w_"+this.state.w_img_position_name[i].position_name+"nukki_yn"] : "N"});
              }
          }

          // 이미지가 사용되는 영역에 이미지가 있는데, 누끼 필수 영역임에도 누끼를 안땄다면 배경제거 실행
          if(this.state.h_essential_img_nukki_yn == "Y" && this.state["h_img"+(i+1)+"_is_use"] == "Y" && !this.state.h_non_nukki_state[i] && this.state["h_"+this.state.h_img_position_name[i].position_name+"_nukki_yn"] == "N"){
              if(this.positionImgCheck("h", i)){
                  const nukki_info_Y = {
                      type : "h",
                      position : i+1,
                      action : "Y",
                  };
                  nukki_info_Y_list.push(nukki_info_Y);
              } else{
                  this.setState({["h_"+this.state.h_img_position_name[i].position_name+"nukki_yn"] : "N"});
              }
          }
      }
      if(nukki_info_Y_list.length == 0){
          this.insertEventTmp('preview');
          
          this.setState({ save_dialog_show_state: false });
          return false;
      }

      const nukki_info = {
          change_N_list : [],
          nukki_info_Y_list : nukki_info_Y_list,
      };
      this.insertEventTmp('preview', nukki_info);
  }

  isAppleMobile() {
    const ua = navigator.userAgent || "";
    const isIphoneIpod = /iPhone|iPod/.test(ua);

    // iPad는 예전엔 ua에 iPad가 있었고,
    // iPadOS 13+는 Mac처럼 보이기도 해서 아래 보정
    const isIpadByUA = /iPad/.test(ua);
    const isIpadOS13Plus = (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    return isIphoneIpod || isIpadByUA || isIpadOS13Plus;
  }

  onChangeDesignTitle = (designTitle) => {
    this.setState({ designTitle });
  }
  
  onDownloadImage = () => {
    alert("디자인 이미지를 다운로드합니다. (추후 구현)");
  }

  onSaveDesign = () => {
    alert("디자인을 저장합니다. (추후 구현)");
  }

  /* ========== API 호출 ========== */
  //공통코드 조회
  getCafe24Code(upper_code_cd, name) {
      http.get( "/rest/common/cafe24Code?upper_code_cd="+upper_code_cd)
      .then(res => {        
          if(res.data.length > 0) {
              this.setState({[name] : res.data});
          }
      }).catch(e => {

      })
  };
  loadCommonCode(upper_code_cd, banner_type) {
    http.get("/rest/common/cafe24Code?upper_code_cd="+upper_code_cd)
    .then(res => {
          console.log(res.data);
          for(var idx in res.data) {
              if(res.data[idx].code_cd === banner_type) {
                  this.setState({"lang_type": res.data[idx].val3});
              }
          }
      })
  }

  getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list) {
      var startidx = 0
      var rowcnt = 10

      const initialEventTypeCd = this.getInitialEventTypeCd();
      const initialUpperCodeCd = this.getUpperCodeCdByEventTypeCd(initialEventTypeCd);
      const hasEventSeq = !!this.getEventSeq();
      const hasInitialTemplate =
          initialEventTypeCd && initialUpperCodeCd == upper_code_cd;
      if (upper_code_cd == "03000") {
          startidx = this.state.pc_banner_type_paging.startIdx;
          rowcnt = this.state.pc_banner_type_paging.rowcnt;
      } else if (upper_code_cd == "07000") {
          startidx = this.state.mobile_banner_type_paging.startIdx;
          rowcnt = this.state.mobile_banner_type_paging.rowcnt;
      }

      let tag_list = [];

      if(selected_tag_list != null && selected_tag_list != undefined && selected_tag_list.length > 0){
          tag_list = selected_tag_list;
      }

      http.get("/rest/common/bannerDesignTemplateUserFavorite/paging"
              +"?upper_code_cd="+upper_code_cd
              +"&startidx="+startidx
              +"&rowcnt="+rowcnt
              +"&is_instagram_use=Y"
            //   +is_test_use // 테스트용
              +"&tag_list="+tag_list
              )
      .then(res => {
          if (upper_code_cd == "03000") {
              const {pc_banner_type_paging} = this.state;
              pc_banner_type_paging["totalCnt"] = res.data.totalCnt;

              this.setState({bannerTypeList : res.data.list
                              , pc_banner_type_paging : pc_banner_type_paging});

              if (!hasEventSeq && !first_lodded_pc_banner) {
                const selectedBanner =
                    hasInitialTemplate
                        ? res.data.list.find(item => item.code_cd == initialEventTypeCd)
                        : null;

                const targetBanner = hasInitialTemplate
                    ? this.getInitialTemplateBanner(upper_code_cd, selectedBanner)
                    : res.data.list[0];

                if (targetBanner) {
                    this.onClickBannerTypeRadioButton(
                        targetBanner,
                        "event_type_cd",
                        "event_pc_banner_name",
                        true
                    );
                }

                first_lodded_pc_banner = true;
            } 

          } else if (upper_code_cd == "07000") {
              const{mobile_banner_type_paging} = this.state;
              mobile_banner_type_paging["totalCnt"] = res.data.totalCnt;

              this.setState({mobileBannerTypeList : res.data.list
                              , mobile_banner_type_paging : mobile_banner_type_paging});
              if (!hasEventSeq && !first_lodded_mobile_banner) {
                const selectedBanner =
                    hasInitialTemplate
                        ? res.data.list.find(item => item.code_cd == initialEventTypeCd)
                        : null;

                const targetBanner = hasInitialTemplate
                    ? this.getInitialTemplateBanner(upper_code_cd, selectedBanner)
                    : res.data.list[0];

                if (targetBanner) {
                    this.onClickBannerTypeRadioButton(
                        targetBanner,
                        "event_mobile_type_cd",
                        "event_mobile_banner_name",
                        true
                    );
                }

                first_lodded_mobile_banner = true;
            }
          }
      }).catch(e => {
          console.log("### [ERROR] getBannerDesignTemplateUserFavoritePaging ###");
      })
  }

  // 배너 템플릿 필터 조회
  getBannerDesignTemplateFilter() {
      http.get("/rest/common/bannerDesignTemplateFilter?instagram_display_yn=Y")
          .then(res => {
              let tagLists = {};
              let categoryList = [];

              res.data.ctg_list.map(obj => {
                  categoryList.push(obj.tag_cd.substr(0, 3).toLowerCase());
              });

              for (const category of categoryList) {
                  tagLists[category] = res.data[category + "_tag_list"].map((tag) => ({
                      ctg_cd: tag.ctg_cd,
                      ctg_sorting: tag.ctg_sorting,
                      ctg_sorting_inside: tag.ctg_sorting_inside,
                      display_yn: tag.display_yn,
                      tag_cd: tag.tag_cd,
                      tag_name: tag.tag_name,
                      tag_sorting: tag.tag_sorting,
                      isSelected: false,
                  }));
              }

              this.setState({
                  template_ctg_list: res.data.ctg_list,
                  template_tag_list: res.data.tag_list,
                  w_template_all_tag_list: tagLists,
                  h_template_all_tag_list: tagLists,
              });

          }).catch(e => {
          console.log("### [ERROR] getBannerDesignTemplateFilter ###", e);
      })
  }

  // 배너 라디오 버튼 클릭
  onClickBannerTypeRadioButton = async (banner, name, banner_name, is_first) => {
     try {
        // 선택한 배너가 이미 선택되어있는 배너라면 동작하지 않는다
        if(this.state.event_type_cd == banner.code_cd || this.state.event_mobile_type_cd == banner.code_cd){
            return false;
        }
        // if (!is_first && !window.confirm("선택한 템플릿으로 디자인을 변경하시겠어요?")) {
        //     return false;
        // }
        if (!is_first) {
          const result = await this.openConfirmDialog({
            title: "선택한 템플릿으로 디자인을 변경하시겠어요?",
          });
  
          if (!result) {
              return false;
          }
        }

        this.nukkiBlockPageClick();

        var name2 = name.replace("_cd", "") + "_name";
        var name3 = name.replace("_cd", "") + "_img";
        var name4 = banner_name; // event_pc_banner_name or event_mobile_banner_name
        var name5 = banner_name.replace("_banner_name", "_tag_name_list"); // event_mobile_tag_name_list or event_mobile_tag_name_list
        this.setState({[name] : banner.code_cd,
            [name2] : banner.val1,
            [name3] : banner.val2,
            [name4] : banner.banner_name,
            [name5] : (banner.tag_name_list || "").toString().split(","),
            img_position_idx_list: this.state.img_position_idx_list,
        }, async () => {
            
            // this.setHeight();
            if (name.indexOf("mobile") > 0) {
                // 누끼 관련 설정 초기화
                h_nukki_action_state = false;
    
                for (var idx=1; idx<=4; idx++) {
                    if (idx == 4) {
                        is_mobile_banner_color_init = true;
                    }
                    await this.setStateAsync({
                        ["h_img_position_left_"+idx]:0,
                        ["h_img_position_right_"+idx]:0,
                        ["h_img_position_top_"+idx]:0,
                        ["h_img_position_bottom_"+idx]:0,
                        
                        ["h_img_position_x_"+idx]:0,
                        ["h_img_position_y_"+idx]:0,
    
                        ["h_img_position_"+(idx)+"_type"] : "50002",
                        ["h_img_"+idx+"_auto_move_yn"]: "N",
                    });
                }
                
                await this.setStateAsync({
                    event_mobile_cd_use_yn : "Y",
                })
    
                let mainText;
                let subText;
    
                if(document.querySelector(".mainTextEditor")) {
                    mainText = document.querySelector(".mainTextEditor").innerHTML.replace(/(<([^>]+)>)/ig,"");
                    await this.setStateAsync({
                        title: mainText,
                        auto_title: mainText,
                    });
                }
                if(document.querySelector(".subTextEditor")) {
                    subText = document.querySelector(".subTextEditor").innerHTML.replace(/(<([^>]+)>)/ig,"");
                    await this.setStateAsync({
                        sub_title: subText,
                        sentence: subText,
                        eng_sentence: subText,
                        foreign_title: subText,
                    });
                }

                // 이미지 영역 포지션 초기화
                this.setState({
                    selectedImageIndex : 1,
                });
    
                // 이미지 크기 조절 초기화
                await this.resetImgScale("h", "1");
                await this.resetImgScale("h", "2");
                await this.resetImgScale("h", "3");
                await this.resetImgScale("h", "4");
    
                // 텍스트 위치 이동 초기화
                await this.moveTextPositionResetOnClick(null, "h", "main", true);
                await this.moveTextPositionResetOnClick(null, "h", "sub", true);
    
                // 텍스트 크기 조절 초기화
                await this.handleTxtScaleResetOnClick(null, "h", "main", true);
                await this.handleTxtScaleResetOnClick(null, "h", "sub", true);
    
            } else {
                // 누끼 관련 설정 초기화
                w_nukki_action_state = false;
    
                for (var idx=1; idx<=4; idx++) {
                    if (idx == 4) {
                        is_banner_color_init = true;
                    }
                    await this.setStateAsync({
                        ["w_img_position_left_"+idx]:0,
                        ["w_img_position_right_"+idx]:0,
                        ["w_img_position_top_"+idx]:0,
                        ["w_img_position_bottom_"+idx]:0,
    
                        ["w_img_position_x_"+idx]:0,
                        ["w_img_position_y_"+idx]:0,
    
                        ["img_position_"+(idx)+"_type"] : "50002",
                        ["w_img_"+idx+"_auto_move_yn"]: "N",
                    });
                }
    
                await this.setStateAsync({
                    event_type_cd_use_yn : "Y",
                });
    
                let mainText;
                let subText;
    
                if(document.querySelector(".mainTextEditor")) {
                    mainText = document.querySelector(".mainTextEditor").innerHTML.replace(/(<([^>]+)>)/ig,"");
                    await this.setStateAsync({
                        title: mainText,
                        auto_title: mainText,
                    });
                }
    
                if(document.querySelector(".subTextEditor")) {
                    subText = document.querySelector(".subTextEditor").innerHTML.replace(/(<([^>]+)>)/ig,"");
                    await this.setStateAsync({
                        sub_title: subText,
                        sentence: subText,
                        eng_sentence: subText,
                        foreign_title: subText,
                    });
                }

                // 이미지 영역 포지션 초기화
                this.setState({
                    selectedImageIndex : 1,
                });
    
                // 이미지 크기 조절 초기화
                await this.resetImgScale("w", "1");
                await this.resetImgScale("w", "2");
                await this.resetImgScale("w", "3");
                await this.resetImgScale("w", "4");
    
                // 텍스트 위치 이동 초기화
                await this.moveTextPositionResetOnClick(null, "w", "main", true);
                await this.moveTextPositionResetOnClick(null, "w", "sub", true);
    
                // 텍스트 크기 조절 초기화
                await this.handleTxtScaleResetOnClick(null, "w", "main", true);
                await this.handleTxtScaleResetOnClick(null, "w", "sub", true);
            }

            await this.setStateAsync(this.getTemplateBaseColorPatch(banner));

            const upperCodeCd = name.indexOf("mobile") > 0 ? "07000" : "03000";
            const sampleData = await this.fetchTemplateSampleData(banner.code_cd, upperCodeCd);
            const hasSampleNukki =
                sampleData
                && sampleData.nukki
                && Object.keys(sampleData.nukki).length > 0;
            const didInsertEventTmp = await this.getisUsePallete({
                skipAutoNukkiRun: hasSampleNukki,
                sampleColorPatch: this.getTemplateSampleColorPatch(sampleData),
            });
            const sampleApplied = await this.applyTemplateSampleData(sampleData, {
                refreshPreview: true,
            });

            if (!sampleApplied && !didInsertEventTmp) {
                this.insertEventTmp("preview", null, true);
            }
        });

      } catch (e) {
          console.log("### onClickBannerTypeRadioButton error: " , e);
      }
  }

  // 사용 예:
// const didInsert = await this.getisUsePallete();
// console.log(didInsert); // true / false

  fetchTemplateSampleData = async (templateCd, upperCodeCd) => {
    try {
      const res = await http.get("/rest/shop/instagram/template/sample", {
        params: {
          template_cd: templateCd || "-1",
          upper_code_cd: upperCodeCd || "",
        },
      });

      return this.normalizeTemplateSampleData(res.data || {});
    } catch (e) {
      console.log("### [ERROR] fetchTemplateSampleData ###", e);
      return null;
    }
  }

  normalizeTemplateSampleData = (sampleData) => {
    const getValue = (row, key) => {
      if (!row || !key) return null;
      if (row[key] != null) return row[key];

      const upperKey = key.toUpperCase();
      if (row[upperKey] != null) return row[upperKey];

      const camelKey = key.replace(/_([a-z])/g, (match, ch) => ch.toUpperCase());
      if (row[camelKey] != null) return row[camelKey];

      return null;
    };

    const isBlank = (value) => {
      return value == null || String(value).trim() === "" || String(value) === "null";
    };

    const normalized = {
      ...sampleData,
      sample: {
        ...(sampleData.sample || {}),
      },
      nukki: {
        ...(sampleData.nukki || {}),
      },
      link_type: {
        ...(sampleData.link_type || {}),
      },
    };

    (sampleData.list || []).forEach((row) => {
      const fieldName = getValue(row, "field_name");
      if (isBlank(fieldName)) return;

      const sampleUrl = getValue(row, "sample_url");
      const sampleValue = getValue(row, "sample_value");
      normalized.sample[fieldName] = !isBlank(sampleUrl) ? sampleUrl : sampleValue;

      const sampleNukkiUrl = getValue(row, "sample_nukki_url");
      if (!isBlank(sampleNukkiUrl)) {
        normalized.nukki[fieldName] = sampleNukkiUrl;
      }

      const linkTypeCd = getValue(row, "link_type_cd");
      if (!isBlank(linkTypeCd)) {
        normalized.link_type[fieldName] = linkTypeCd;
      }
    });

    return normalized;
  }

  getTemplateSampleColorPatch = (sampleData) => {
    if (!sampleData) {
      return {};
    }

    const isBlank = (value) => {
      return value == null || String(value).trim() === "" || String(value) === "null";
    };

    const normalizeFieldName = (fieldName) => {
      return String(fieldName || "").trim();
    };

    const getValue = (row, key) => {
      if (!row || !key) return null;
      if (row[key] != null) return row[key];

      const upperKey = key.toUpperCase();
      if (row[upperKey] != null) return row[upperKey];

      const camelKey = key.replace(/_([a-z])/g, (match, ch) => ch.toUpperCase());
      if (row[camelKey] != null) return row[camelKey];

      return null;
    };

    const sampleMap = {};
    Object.keys(sampleData.sample || {}).forEach((fieldName) => {
      sampleMap[normalizeFieldName(fieldName)] = sampleData.sample[fieldName];
    });

    (sampleData.list || []).forEach((row) => {
      const fieldName = normalizeFieldName(getValue(row, "field_name"));
      if (isBlank(fieldName)) return;

      const sampleValue = getValue(row, "sample_value");
      if (!isBlank(sampleValue)) {
        sampleMap[fieldName] = sampleValue;
      }
    });

    const patch = {};
    [
      "background",
      "background2",
      "background3",
      "background4",
      "w_large_text_color",
      "h_large_text_color",
      "w_small_text_color",
      "h_small_text_color",
      "w_color_etc",
      "h_color_etc",
    ].forEach((fieldName) => {
      if (!isBlank(sampleMap[fieldName])) {
        patch[fieldName] = sampleMap[fieldName];
      }
    });

    [
      { colorField: "background", index: "1" },
      { colorField: "background2", index: "2" },
      { colorField: "background3", index: "3" },
      { colorField: "background4", index: "4" },
    ].forEach(({ colorField, index }) => {
      if (!isBlank(sampleMap[colorField])) {
        patch["color_value_" + index] = "";
        patch["color_lmnst_" + index] = "";
        patch["color_strtn_" + index] = "";
        patch["color_hue_" + index] = "";
      }
    });

    return patch;
  }

  applyTemplateSampleData = async (sampleData, options = {}) => {
    if (!sampleData || !sampleData.sample) {
      return false;
    }

    const sample = sampleData.sample || {};
    const nukki = sampleData.nukki || {};
    const linkType = sampleData.link_type || {};
    const previousSampleValues = this.state.template_sample_values || {};
    const userImageChangedFields = this.state.template_sample_user_image_fields || {};
    const userTextChanged = this.isTemplateSampleUserTextChanged();
    const userDateChanged = this.isTemplateSampleUserDateChanged();
    let applied = false;

    const isBlank = (value) => {
      return value == null || String(value).trim() === "" || String(value) === "null";
    };

    const statePatch = {};
    const nextSampleValues = {
      ...previousSampleValues,
    };
    const nextUserImageChangedFields = {
      ...userImageChangedFields,
    };

    const normalizeSampleFieldName = (fieldName) => {
      return String(fieldName || "").trim();
    };

    const getRowValue = (row, key) => {
      if (!row || !key) return null;
      if (row[key] != null) return row[key];

      const upperKey = key.toUpperCase();
      if (row[upperKey] != null) return row[upperKey];

      const camelKey = key.replace(/_([a-z])/g, (match, ch) => ch.toUpperCase());
      if (row[camelKey] != null) return row[camelKey];

      return null;
    };

    const sampleRowMap = {};
    (sampleData.list || []).forEach((row) => {
      const fieldName = normalizeSampleFieldName(getRowValue(row, "field_name"));
      if (isBlank(fieldName)) return;

      const sampleUrl = getRowValue(row, "sample_url");
      const sampleValue = getRowValue(row, "sample_value");
      sampleRowMap[fieldName] = !isBlank(sampleUrl) ? sampleUrl : sampleValue;
    });

    const sampleMap = {};
    Object.keys(sample || {}).forEach((fieldName) => {
      sampleMap[normalizeSampleFieldName(fieldName)] = sample[fieldName];
    });

    const hasSampleField = (fieldName) => {
      const normalizedFieldName = normalizeSampleFieldName(fieldName);
      return Object.prototype.hasOwnProperty.call(sampleMap, normalizedFieldName)
        || Object.prototype.hasOwnProperty.call(sampleRowMap, normalizedFieldName);
    };

    const getSampleField = (fieldName) => {
      const normalizedFieldName = normalizeSampleFieldName(fieldName);
      if (Object.prototype.hasOwnProperty.call(sampleMap, normalizedFieldName)) {
        return sampleMap[normalizedFieldName];
      }
      return sampleRowMap[normalizedFieldName];
    };

    const setSampleField = (fieldName, nextValue, sampleFieldName) => {
      const sourceFieldName = sampleFieldName || fieldName;
      if (!hasSampleField(sourceFieldName) || isBlank(nextValue)) {
        return;
      }
      statePatch[fieldName] = nextValue;
      nextSampleValues[fieldName] = nextValue;
      applied = true;
    };

    if (!userTextChanged) {
      setSampleField("title", getSampleField("title"));
      setSampleField("auto_title", getSampleField("title"), "title");
      setSampleField("non_auto_title", getSampleField("title"), "title");
      setSampleField("foreign_title", getSampleField("foreign_title"));
      setSampleField("sub_title", getSampleField("foreign_title"), "foreign_title");
      setSampleField("sentence", getSampleField("foreign_title"), "foreign_title");
      setSampleField("eng_sentence", getSampleField("foreign_title"), "foreign_title");
      setSampleField("event_price", getSampleField("event_price"));
    }

    const setSampleDateField = (dateType, sampleFieldNameList) => {
      if (userDateChanged || !this.isDateAreaUseTemplate()) {
        return;
      }

      const fieldNameList = Array.isArray(sampleFieldNameList)
        ? sampleFieldNameList
        : [sampleFieldNameList];

      const matchedFieldName = fieldNameList.find((fieldName) => {
        return hasSampleField(fieldName) && !isBlank(getSampleField(fieldName));
      });

      if (!matchedFieldName) {
        return;
      }

      const sampleDateValue = getSampleField(matchedFieldName);
      const datePatch = this.getTemplateDateStatePatch(dateType, sampleDateValue);
      Object.assign(statePatch, datePatch);

      const sampleValueKey = dateType === "start" ? "start_date" : "end_date";
      nextSampleValues[sampleValueKey] = sampleDateValue;
      applied = true;
    };

    if (!userDateChanged && this.isDateAreaUseTemplate()) {
      setSampleDateField("start", ["start_date", "start_date_format"]);
      setSampleDateField("end", ["end_date", "end_date_format"]);

      const sampleSimpleDateCd = getSampleField("simple_date_cd");
      if (hasSampleField("simple_date_cd") && !isBlank(sampleSimpleDateCd)) {
        statePatch.simple_date_cd = sampleSimpleDateCd;
        nextSampleValues.simple_date_cd = sampleSimpleDateCd;
        applied = true;
      }
    }

    [
      "background",
      "background2",
      "background3",
      "background4",
      "w_large_text_color",
      "h_large_text_color",
      "w_small_text_color",
      "h_small_text_color",
      "w_color_etc",
      "h_color_etc",
    ].forEach((fieldName) => {
      setSampleField(fieldName, getSampleField(fieldName));
    });

    [
      { colorField: "background", index: "1" },
      { colorField: "background2", index: "2" },
      { colorField: "background3", index: "3" },
      { colorField: "background4", index: "4" },
    ].forEach(({ colorField, index }) => {
      if (hasSampleField(colorField) && !isBlank(getSampleField(colorField))) {
        statePatch["color_value_" + index] = "";
        statePatch["color_lmnst_" + index] = "";
        statePatch["color_strtn_" + index] = "";
        statePatch["color_hue_" + index] = "";
      }
    });

    const buttonText = getSampleField("button_text");
    if (!userTextChanged && hasSampleField("button_text") && !isBlank(buttonText)) {
      const buttonList = (this.state.button_list && this.state.button_list.length > 0)
        ? [...this.state.button_list]
        : [{
          button_text: "버튼명",
          link: "",
          order_no: 1,
          event_seq: dateString,
        }];

      buttonList[0] = {
        ...buttonList[0],
        button_text: buttonText,
      };
      statePatch.button_list = buttonList;
      nextSampleValues.button_text = buttonText;
      applied = true;
    }

    const applyImageSamples = (type) => {
      const positionList = this.state[type + "_img_position_name"] || [];
      const userListKey = type + "_user_img_list";
      const userList = [...(this.state[userListKey] || [])];
      const essentialNukkiYn = this.state[type + "_essential_img_nukki_yn"];
      const cropYn = this.state[type + "_is_nukki_crop_yn"];
      const versionList = this.state[type + "_nukki_version_list"] || [];
      const ppmState = this.state[type + "_nukki_ppm_state"] || [];

      for (let i = 0; i < positionList.length; i++) {
        const position = positionList[i];
        const fieldName = this.getTemplateImageFieldName(type, i);
        const sampleImage = getSampleField(fieldName);
        const hasUserSelectedImage = userImageChangedFields[fieldName] === true;

        if (!hasSampleField(fieldName) || isBlank(sampleImage)) {
          continue;
        }

        if (hasUserSelectedImage) {
          if (isBlank(userList[i] && userList[i].img_link)) {
            const positionName = position && position.position_name;
            statePatch[fieldName] = "";
            if (positionName) {
              statePatch[type + "_" + positionName + "_nukki_yn"] = "N";
              statePatch[type + "_nukki_" + positionName + "_link"] = "";
              statePatch[type + "_" + positionName + "_49002_link"] = "";
              statePatch[type + "_" + positionName + "_49004_link"] = "";
              statePatch[type + "_" + positionName + "_49006_link"] = "";
            }
          }
          continue;
        }

        const imageLinkType = linkType[fieldName] || "49004";
        userList[i] = {
          ...(userList[i] || {}),
          link_type: imageLinkType,
          org_img_seq: "",
          org_img_name: sampleImage,
          img_link: sampleImage,
          img_link_able: true,
        };

        statePatch[fieldName] = sampleImage;
        nextSampleValues[fieldName] = sampleImage;
        delete nextUserImageChangedFields[fieldName];
        applied = true;

        const sampleNukkiImage = nukki[fieldName];
        if (essentialNukkiYn === "Y" && !isBlank(sampleNukkiImage)) {
          const positionName = position.position_name;
          const ppmYn = ppmState[i] ? "Y" : "N";
          const cropValue = cropYn || "N";
          const version = versionList[i] || 2;

          userList[i]["img_ppm_" + ppmYn + "_crop_" + cropValue + "_version_" + version] = sampleNukkiImage;
          statePatch[type + "_" + positionName + "_nukki_yn"] = "Y";
          statePatch[type + "_nukki_" + positionName + "_link"] = sampleNukkiImage;
        }
      }

      statePatch[userListKey] = userList;
    };

    applyImageSamples("w");
    applyImageSamples("h");

    if (!applied) {
      return false;
    }

    statePatch.template_sample_values = nextSampleValues;
    statePatch.template_sample_user_image_fields = nextUserImageChangedFields;
    await this.setStateAsync(statePatch);
    if (options.refreshPreview) {
      this.insertEventTmp("preview", null, true);
    }
    return true;
  }

async getisUsePallete(options = {}) {
  let didInsertEventTmp = false; // ✅ insertEventTmp 실행 여부 누적
  const skipAutoNukkiRun = options.skipAutoNukkiRun;
  const preserveEventColor = options.preserveEventColor === true;
  const sampleColorPatch = options.sampleColorPatch || {};

  if (!(this.state.event_type_cd || this.state.event_mobile_type_cd)) {
    return false;
  }

  try {
    const res = await http.get(
      "/rest/common/banner/isUsePallete?event_type_cd=" +
        this.state.event_type_cd +
        "&event_mobile_type_cd=" +
        this.state.event_mobile_type_cd
    );

    if (!res.data) return false;

    const templateBaseColorPatch = preserveEventColor
      ? {}
      : this.getTemplateBaseColorPatch(res.data);

    // 기존 초기 색상 세팅
    let paletteColorPatch = {};
    if (is_banner_color_init === true) {
      paletteColorPatch = {
        w_large_text_color: res.data.w_large_text_color,
        w_small_text_color: res.data.w_small_text_color,
        w_color_etc: res.data.w_color_etc,
      };
      is_banner_color_init = false;
    } else if (is_mobile_banner_color_init === true) {
      paletteColorPatch = {
        h_large_text_color: res.data.h_large_text_color,
        h_small_text_color: res.data.h_small_text_color,
        h_color_etc: res.data.h_color_etc,
      };
      is_mobile_banner_color_init = false;
    }

    let w_img_position_name = this.addBannerDesignPositionText(
      res.data.w_banner_design_position_img_list
    );
    let h_img_position_name = this.addBannerDesignPositionText(
      res.data.h_banner_design_position_img_list
    );

    // 동영상 링크 타입(49005) 초기화 로직
    for (var i = 0; i < w_img_position_name.length; i++) {
      if (this.state.w_user_img_list[i].link_type === "49005") {
        this.setState({
          [w_img_position_name[i].img_column_name]:
            this.state.is_detail_image_use === true &&
            this.state.select_item_list[0].detail_image
              ? this.state.select_item_list[0].detail_image
              : this.state.select_item_list[0].image
              ? this.state.select_item_list[0].image
              : "",
        });
      }
    }

    for (var i = 0; i < h_img_position_name.length; i++) {
      if (this.state.h_user_img_list[i].link_type === "49005") {
        this.setState({
          ["h_" + h_img_position_name[i].img_column_name]:
            this.state.is_detail_image_use === true &&
            this.state.select_item_list[0].detail_image
              ? this.state.select_item_list[0].detail_image
              : this.state.select_item_list[0].image
              ? this.state.select_item_list[0].image
              : "",
        });
      }
    }

    // ✅ 핵심: setState 완료까지 기다리기 위해 Promise로 감싸서 await
    await new Promise((resolve) => {
      this.setState(
        {
          ...templateBaseColorPatch,
          ...paletteColorPatch,
          ...sampleColorPatch,

          w_color1_is_use: res.data.w_color1_is_use,
          w_color2_is_use: res.data.w_color2_is_use,
          w_color3_is_use: res.data.w_color3_is_use,
          w_color4_is_use: res.data.w_color4_is_use,
          h_color1_is_use: res.data.h_color1_is_use,
          h_color2_is_use: res.data.h_color2_is_use,
          h_color3_is_use: res.data.h_color3_is_use,
          h_color4_is_use: res.data.h_color4_is_use,
          w_color_etc_is_use: res.data.w_color_etc_is_use,
          h_color_etc_is_use: res.data.h_color_etc_is_use,

          w_img1_is_use: res.data.w_img1_is_use,
          w_img2_is_use: res.data.w_img2_is_use,
          w_img3_is_use: res.data.w_img3_is_use,
          w_img4_is_use: res.data.w_img4_is_use,
          h_img1_is_use: res.data.h_img1_is_use,
          h_img2_is_use: res.data.h_img2_is_use,
          h_img3_is_use: res.data.h_img3_is_use,
          h_img4_is_use: res.data.h_img4_is_use,

          w_essential_img_nukki_yn: res.data.w_img_nukki_yn,
          h_essential_img_nukki_yn: res.data.h_img_nukki_yn,

          w_is_nukki_ppm_yn: res.data.w_is_nukki_ppm_yn,
          h_is_nukki_ppm_yn: res.data.h_is_nukki_ppm_yn,

          w_is_nukki_multi_use_yn: res.data.w_is_nukki_multi_use_yn,
          h_is_nukki_multi_use_yn: res.data.h_is_nukki_multi_use_yn,

          w_is_nukki_crop_yn: res.data.w_is_nukki_crop_yn,
          h_is_nukki_crop_yn: res.data.h_is_nukki_crop_yn,

          w_is_date_use: res.data.w_is_date_use,
          h_is_date_use: res.data.h_is_date_use,

          w_is_price_use: res.data.w_is_price_use,
          h_is_price_use: res.data.h_is_price_use,

          w_img_position_name: w_img_position_name,
          h_img_position_name: h_img_position_name,

          w_is_button_use: res.data.w_is_button_use,
          h_is_button_use: res.data.h_is_button_use,

          w_is_full_background_img_use: res.data.w_is_full_background_img_use,
          h_is_full_background_img_use: res.data.h_is_full_background_img_use,

          w_is_fashionplus_face_banner_use:
            res.data.w_is_fashionplus_face_banner_use,
          h_is_fashionplus_face_banner_use:
            res.data.h_is_fashionplus_face_banner_use,

          w_is_youtube_link_use: res.data.w_is_youtube_link_use,
          h_is_youtube_link_use: res.data.h_is_youtube_link_use,
        },
        async () => {
          // ✅ w 누끼 처리
          if (!w_nukki_action_state) {
            let w_nukki_ppm_state = false;

            await new Promise((r) => {
              this.setState(
                {
                  w_nukki_ppm_state: [
                    w_nukki_ppm_state,
                    w_nukki_ppm_state,
                    w_nukki_ppm_state,
                    w_nukki_ppm_state,
                  ],
                  w_nukki_version_list: [2, 2, 2, 2],
                },
                () => r()
              );
            });

            if (
              !skipAutoNukkiRun &&
              this.state.page_load_tmp_state &&
              this.state.w_essential_img_nukki_yn === "N"
            ) {
              this.setState({
                w_img_nukki_yn: "N",
                w_img_detail_nukki_yn: "N",
                w_img_third_nukki_yn: "N",
                w_img_fourth_nukki_yn: "N",
              });

              let change_N_list = [];
              for (var i = 0; i < 4; i++) {
                change_N_list.push({
                  key: "w_" + img_order_text[i] + "_nukki_yn",
                  value: "N",
                });
                change_N_list.push({
                  key: "w_nukki_" + img_order_text[i] + "_link",
                  value: "",
                });
              }

              const nukki_info = { change_N_list };
              this.insertEventTmp("preview", nukki_info);
              didInsertEventTmp = true; // ✅ 실행됨
            } else if (
              !skipAutoNukkiRun &&
              this.state.page_load_tmp_state &&
              this.state.w_essential_img_nukki_yn === "Y"
            ) {
              let nukki_info_Y_list = [];

              for (var i = 0; i < this.state.w_img_position_name.length; i++) {
                if (
                  this.state["w_img" + (i + 1) + "_is_use"] === "Y" &&
                  !this.state.w_non_nukki_state[i] &&
                  !this.state["w_non_nukki_state"][i]
                ) {
                  if (this.positionImgCheck("w", i)) {
                    nukki_info_Y_list.push({
                      type: "w",
                      position: i + 1,
                      action: "Y",
                    });
                  }
                }
              }

              const nukki_info = {
                change_N_list: [],
                nukki_info_Y_list,
              };
              this.insertEventTmp("preview", nukki_info);
              didInsertEventTmp = true; // ✅ 실행됨
            }

            w_nukki_action_state = true;
          }

          // ✅ h 누끼 처리
          if (!h_nukki_action_state) {
            let h_nukki_ppm_state = false;

            await new Promise((r) => {
              this.setState(
                {
                  h_nukki_ppm_state: [
                    h_nukki_ppm_state,
                    h_nukki_ppm_state,
                    h_nukki_ppm_state,
                    h_nukki_ppm_state,
                  ],
                  h_nukki_version_list: [2, 2, 2, 2],
                },
                () => r()
              );
            });

            if (
              !skipAutoNukkiRun &&
              this.state.page_load_tmp_state &&
              this.state.h_essential_img_nukki_yn === "N"
            ) {
              this.setState({
                h_img_nukki_yn: "N",
                h_img_detail_nukki_yn: "N",
                h_img_third_nukki_yn: "N",
                h_img_fourth_nukki_yn: "N",
              });

              let change_N_list = [];
              for (var i = 0; i < 4; i++) {
                change_N_list.push({
                  key: "h_" + img_order_text[i] + "_nukki_yn",
                  value: "N",
                });
                change_N_list.push({
                  key: "h_nukki_" + img_order_text[i] + "_link",
                  value: "",
                });
              }

              const nukki_info = { change_N_list };
              this.insertEventTmp("preview", nukki_info);
              didInsertEventTmp = true; // ✅ 실행됨
            } else if (
              !skipAutoNukkiRun &&
              this.state.page_load_tmp_state &&
              this.state.h_essential_img_nukki_yn === "Y"
            ) {
              let nukki_info_Y_list = [];

              for (var i = 0; i < this.state.h_img_position_name.length; i++) {
                if (
                  this.state["h_img" + (i + 1) + "_is_use"] === "Y" &&
                  !this.state.h_non_nukki_state[i] &&
                  !this.state["h_non_nukki_state"][i]
                ) {
                  if (this.positionImgCheck("h", i)) {
                    nukki_info_Y_list.push({
                      type: "h",
                      position: i + 1,
                      action: "Y",
                    });
                  }
                }
              }

              const nukki_info = {
                change_N_list: [],
                nukki_info_Y_list,
              };
              this.insertEventTmp("preview", nukki_info);
              didInsertEventTmp = true; // ✅ 실행됨
            }

            h_nukki_action_state = true;
          }

          resolve(); // ✅ 바깥 setState Promise 완료
        }
      );
    });

    return didInsertEventTmp;
  } catch (e) {
    console.log(e);
    return false;
  }
}

  insertEventTmp(call_cls, nukki_info, button_update) {
    if(!this.getUrlParams()["event_seq"]) {
        if ((Object.keys(this.state.selected_pc_banner_ratio ?? {}).length) && !this.state.event_type_cd) {
            if ((Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length) && !this.state.event_mobile_type_cd) {
                return false;
            }
        }
    }
    const {is_recommendation_small_title} = this.state;

    // 배너 문구 replace
    let replaceText = function(text){
        return String(text).replace(/(?:\r\n|\r|\n)/g, '<br />');
    };

    // 폰트 리스트 호출
    const saveFontFamilyList = [...new Set(font_family_list)];
    this.updateFontList(saveFontFamilyList);

    let body = {
        event_seq : this.getUrlParams()["event_seq"] ? this.state.event_seq : dateString,
        insert_type : "N", // insert_type은 무조건 N으로 사용중, 페이지 시작때 db에 미리보기를 넣는것으로 대체 가능
        nukki_run_yn : "N", // Y인 경우 누끼 따는 작업 실행

        start_date : this.state.start_date_format,
        end_date : this.state.end_date_format,
        title : replaceText(this.state.title),
        title_sentence_cd : this.state.title_sentence_cd,

        // 작은 글자 추천 여부에 따라 적용
        foreign_title : is_recommendation_small_title == "on" ? replaceText(this.state.robomd_on_foreign_title) : replaceText(this.state.foreign_title),
        content_sentence_cd : is_recommendation_small_title == "on" ? this.state.robomd_on_sentence_cd : this.state.content_sentence_cd,
        sentence : is_recommendation_small_title == "on" ? replaceText(this.state.robomd_on_sentence) : replaceText(this.state.sentence),
        eng_sentence : is_recommendation_small_title == "on" ? replaceText(this.state.robomd_on_eng_sentence) : replaceText(this.state.eng_sentence),

        display_yn : this.state.display_yn,
        event_type_cd : this.state.event_type_cd,
        event_mobile_type_cd : this.state.event_mobile_type_cd,
        event_type_name : this.state.event_type_name,
        event_mobile_type_name : this.state.event_mobile_type_name,
        event_pc_banner_name: this.state.event_pc_banner_name,
        event_mobile_banner_name: this.state.event_mobile_banner_name,
        keyword_cd : this.state.keyword,
        event_price : this.state.event_price,

        img_link : this.state.img_link,
        img_detail_link : this.state.img_detail_link,
        img_third_link : this.state.img_third_link,
        img_fourth_link : this.state.img_fourth_link,
        h_img_link : this.state.h_img_link,
        h_img_detail_link : this.state.h_img_detail_link,
        h_img_third_link : this.state.h_img_third_link,
        h_img_fourth_link : this.state.h_img_fourth_link,

        color_code_1 : this.state.background,
        color_code_2 : this.state.background2,
        color_code_3 : this.state.background3,
        color_code_4 : this.state.background4,

        color_value_1 : this.state.color_value_1,
        color_value_2 : this.state.color_value_2,
        color_value_3 : this.state.color_value_3,
        color_value_4 : this.state.color_value_4,

        color_lmnst_1 : this.state.color_lmnst_1,
        color_lmnst_2 : this.state.color_lmnst_2,
        color_lmnst_3 : this.state.color_lmnst_3,
        color_lmnst_4 : this.state.color_lmnst_4,

        color_strtn_1 : this.state.color_strtn_1,
        color_strtn_2 : this.state.color_strtn_2,
        color_strtn_3 : this.state.color_strtn_3,
        color_strtn_4 : this.state.color_strtn_4,

        color_hue_1 : this.state.color_hue_1,
        color_hue_2 : this.state.color_hue_2,
        color_hue_3 : this.state.color_hue_3,
        color_hue_4 : this.state.color_hue_4,
        
        user_seq : this.state.user_seq,
        shop_no : "1",
        product_no : this.state.product_no,
        reg_user_seq : this.state.reg_user_seq,
        reg_date : this.state.reg_date,

        facial_x_start : this.state.facial_x_start,
        facial_y_start : this.state.facial_y_start,
        facial_width: this.state.facial_width,
        facial_height : this.state.facial_height,
        facial_yn : this.state.facial_yn,
        origin_img_width : this.state.origin_img_width,
        origin_img_height : this.state.origin_img_height,
        call_cls : call_cls,   //호출 구분 : 미리보기 호출시 이력 테이블 저장

        /* 이미지 위치 조절 값 */
        img_position_1_type : this.state.img_position_1_type,
        img_position_2_type : this.state.img_position_2_type,
        img_position_3_type : this.state.img_position_3_type,
        img_position_4_type : this.state.img_position_4_type,
        h_img_position_1_type : this.state.h_img_position_1_type,
        h_img_position_2_type : this.state.h_img_position_2_type,
        h_img_position_3_type : this.state.h_img_position_3_type,
        h_img_position_4_type : this.state.h_img_position_4_type,

        /* 텍스트 컬러 */
        w_large_text_color : this.state.w_large_text_color,
        h_large_text_color : this.state.h_large_text_color,
        w_small_text_color : this.state.w_small_text_color,
        h_small_text_color :this.state.h_small_text_color,
        /* 텍스트 외 요소 색상 */
        w_color_etc : this.state.w_color_etc,
        h_color_etc : this.state.h_color_etc,
        /* 버튼 리스트 */
        button_list : this.state.button_list,
        button_clear_yn : button_update || !this.state.page_load_tmp_state ? "Y" : "N", // 버튼 수정 여부

        /* 텍스트 위치 이동 */
        w_main_txt_position_x : Number(this.state.w_main_txt_position_right) - Number(this.state.w_main_txt_position_left),
        w_main_txt_position_y : Number(this.state.w_main_txt_position_top) - Number(this.state.w_main_txt_position_bottom),
        h_main_txt_position_x : Number(this.state.h_main_txt_position_right) - Number(this.state.h_main_txt_position_left),
        h_main_txt_position_y : Number(this.state.h_main_txt_position_top) - Number(this.state.h_main_txt_position_bottom),
        w_sub_txt_position_x : Number(this.state.w_sub_txt_position_right) - Number(this.state.w_sub_txt_position_left),
        w_sub_txt_position_y : Number(this.state.w_sub_txt_position_top) - Number(this.state.w_sub_txt_position_bottom),
        h_sub_txt_position_x : Number(this.state.h_sub_txt_position_right) - Number(this.state.h_sub_txt_position_left),
        h_sub_txt_position_y : Number(this.state.h_sub_txt_position_top) - Number(this.state.h_sub_txt_position_bottom),

        /* 이미지 크기 조절 */
        w_img_1_scale : this.state.w_img_1_scale,
        w_img_2_scale : this.state.w_img_2_scale,
        w_img_3_scale : this.state.w_img_3_scale,
        w_img_4_scale : this.state.w_img_4_scale,
        h_img_1_scale : this.state.h_img_1_scale,
        h_img_2_scale : this.state.h_img_2_scale,
        h_img_3_scale : this.state.h_img_3_scale,
        h_img_4_scale : this.state.h_img_4_scale,

        /* 텍스트 크기 조절 */
        w_main_txt_scale : this.state.w_main_txt_scale,
        h_main_txt_scale : this.state.h_main_txt_scale,
        w_sub_txt_scale : this.state.w_sub_txt_scale,
        h_sub_txt_scale : this.state.h_sub_txt_scale,

        /* 폰트 리스트 */
        font_family_list : saveFontFamilyList,
    };

    console.log("tmp h_main_txt_position_right", this.state.h_main_txt_position_right);
    console.log("tmp h_main_txt_position_left", this.state.h_main_txt_position_left);
    console.log("tmp h_main_txt_position_top", this.state.h_main_txt_position_top);
    console.log("tmp h_main_txt_position_bottom", this.state.h_main_txt_position_bottom);

    // 4개의 이미지 영역 초기화
    // 삭제된 이미지는 body에 필드가 빠지면 서버 tmp 값이 유지될 수 있으므로,
    // 이미지/누끼/링크형 컬럼은 먼저 빈 값으로 내려보내고 아래에서 사용 중인 값만 다시 채운다.
    for(var i=0;i<4;i++){
        body["w_nukki_"+img_order_text[i]+"_link"] = "";
        body["h_nukki_"+img_order_text[i]+"_link"] = "";
        body["w_"+img_order_text[i]+"_49002_link"] = "";
        body["h_"+img_order_text[i]+"_49002_link"] = "";
        body["w_"+img_order_text[i]+"_49004_link"] = "";
        body["h_"+img_order_text[i]+"_49004_link"] = "";
        body["w_"+img_order_text[i]+"_49006_link"] = "";
        body["h_"+img_order_text[i]+"_49006_link"] = "";

        body[youtube_order_text[i]+"_link"] = "";
        body["h_"+youtube_order_text[i]+"_link"] = "";
        body[youtube_order_text[i]+"_thumbnail"] = "";
        body["h_"+youtube_order_text[i]+"_thumbnail"] = "";
        body["w_is_"+youtube_order_text[i]+"_use"] = "N";
        body["h_is_"+youtube_order_text[i]+"_use"] = "N";

        body["w_"+img_order_text[i]+"_nukki_yn"] = "N";
        body["h_"+img_order_text[i]+"_nukki_yn"] = "N";
        body["w_"+img_order_text[i]+"_nukki_ppm_yn"] = "N";
        body["h_"+img_order_text[i]+"_nukki_ppm_yn"] = "N";
        body["w_"+img_order_text[i]+"_nukki_version"] = "1";
        body["h_"+img_order_text[i]+"_nukki_version"] = "1";
    }

    for(var i=0;i<this.state.w_img_position_name.length;i++){
        const positionName = this.state.w_img_position_name[i].position_name;
        const useWNukki = this.state.w_essential_img_nukki_yn === "Y";
        body["w_"+positionName+"_nukki_yn"] = useWNukki ? (this.state["w_"+positionName+"_nukki_yn"] || "N") : "N";
        body["w_"+positionName+"_nukki_ppm_yn"] = this.state.w_nukki_ppm_state[i] ? "Y" : "N";
        body["w_"+positionName+"_nukki_version"] = this.state.w_nukki_version_list[i] || "1";
        body["w_"+positionName+"_link_type"] = this.state.w_user_img_list[i].link_type;
        if(useWNukki && this.state["w_"+positionName+"_nukki_yn"] == "Y"){
            body["w_nukki_"+positionName+"_link"] = this.state["w_nukki_"+positionName+"_link"];
        }
        if(this.state.w_user_img_list[i].link_type == "49002"){
            body["w_"+positionName+"_49002_link"] = this.state.w_user_img_list[i].img_link || "";
        }
        if(this.state.w_user_img_list[i].link_type == "49006"){
            body["w_"+positionName+"_49006_link"] = this.state.w_user_img_list[i].img_link || "";
        }

        // 업로드 이미지가 사용되는 경우
        if(this.state["w_img"+(i+1)+"_is_use"] == "Y" && this.state.w_user_img_list[i].img_link){
            // 링크 타입이 동영상 주소가 아닌 경우에만 추가
            if(this.state.w_user_img_list[i].link_type != "49005"){
                body[this.state.w_img_position_name[i].img_column_name] = this.state.w_user_img_list[i].img_link;
            }
            if(this.state.w_user_img_list[i].link_type == "49004"){
                body["w_"+positionName+"_49004_link"] = this.state.w_user_img_list[i].img_link;
            }
            body[youtube_order_text[i]+"_link"] = (this.state.w_is_youtube_link_use == "Y" && this.state.w_user_img_list[i].video_link) ? this.state.w_user_img_list[i].video_link : "";
            body[youtube_order_text[i]+"_thumbnail"] = (this.state.w_is_youtube_link_use == "Y" && this.state.w_user_img_list[i].video_link) ? this.state.w_user_img_list[i].img_link : "";
            body["w_is_"+youtube_order_text[i]+"_use"] = (this.state.w_is_youtube_link_use == "Y" && this.state.w_user_img_list[i].video_link) ? "Y" : "N";
        }
    }
    for(var i=0;i<this.state.h_img_position_name.length;i++){
        const positionName = this.state.h_img_position_name[i].position_name;
        const useHNukki = this.state.h_essential_img_nukki_yn === "Y";
        body["h_"+positionName+"_nukki_yn"] = useHNukki ? (this.state["h_"+positionName+"_nukki_yn"] || "N") : "N";
        body["h_"+positionName+"_nukki_ppm_yn"] = this.state.h_nukki_ppm_state[i] ? "Y" : "N";
        body["h_"+positionName+"_nukki_version"] = this.state.h_nukki_version_list[i] || "1";
        body["h_"+positionName+"_link_type"] = this.state.h_user_img_list[i].link_type;
        if(useHNukki && this.state["h_"+positionName+"_nukki_yn"] == "Y"){
            body["h_nukki_"+positionName+"_link"] = this.state["h_nukki_"+positionName+"_link"];
        }
        if(this.state.h_user_img_list[i].link_type == "49002"){
            body["h_"+positionName+"_49002_link"] = this.state.h_user_img_list[i].img_link || "";
        }
        if(this.state.h_user_img_list[i].link_type == "49006"){
            body["h_"+positionName+"_49006_link"] = this.state.h_user_img_list[i].img_link || "";
        }

        // 업로드 이미지가 사용되는 경우
        if(this.state["h_img"+(i+1)+"_is_use"] == "Y" && this.state.h_user_img_list[i].img_link){
            // 링크 타입이 동영상 주소가 아닌 경우에만 추가
            if(this.state.h_user_img_list[i].link_type != "49005"){
                body["h_"+this.state.h_img_position_name[i].img_column_name] = this.state.h_user_img_list[i].img_link;
            }
            if(this.state.h_user_img_list[i].link_type == "49004"){
                body["h_"+positionName+"_49004_link"] = this.state.h_user_img_list[i].img_link;
            }
            body["h_"+youtube_order_text[i]+"_link"] = (this.state.h_is_youtube_link_use == "Y" && this.state.h_user_img_list[i].video_link) ? this.state.h_user_img_list[i].video_link : "";
            body["h_"+youtube_order_text[i]+"_thumbnail"] = (this.state.h_is_youtube_link_use == "Y" && this.state.h_user_img_list[i].video_link) ? this.state.h_user_img_list[i].img_link : "";
            body["h_is_"+youtube_order_text[i]+"_use"] = (this.state.h_is_youtube_link_use == "Y" && this.state.h_user_img_list[i].video_link) ? "Y" : "N";
        }
    }
    
    /* 이미지 위치 조절 값 */
    for(var img_position_idx = 1; img_position_idx <= 4; img_position_idx ++) {
        // 위쪽, 왼쪽으로 이동시 음수로 보낸다
        /* 가로형 */
        body["img_position_x_"+img_position_idx] = Number(this.state["w_img_position_left_"+img_position_idx]) != 0 ? Number(this.state["w_img_position_left_"+img_position_idx])*-1 : Number(this.state["w_img_position_right_"+img_position_idx]);
        body["img_position_y_"+img_position_idx] = Number(this.state["w_img_position_top_"+img_position_idx]) != 0 ? Number(this.state["w_img_position_top_"+img_position_idx])*-1 : Number(this.state["w_img_position_bottom_"+img_position_idx]);
        /* 세로형 */
        body["h_img_position_x_"+img_position_idx] = Number(this.state["h_img_position_left_"+img_position_idx]) != 0 ? Number(this.state["h_img_position_left_"+img_position_idx])*-1 : Number(this.state["h_img_position_right_"+img_position_idx]);
        body["h_img_position_y_"+img_position_idx] = Number(this.state["h_img_position_top_"+img_position_idx]) != 0 ? Number(this.state["h_img_position_top_"+img_position_idx])*-1 : Number(this.state["h_img_position_bottom_"+img_position_idx]);
    }

    /**
     * 현재 미리보기 기능은 백엔드에서 해당 이미지의 img_nukki_yn 값이 Y로 되어있으면, 누끼 따는 요청을 보내도 누끼를 안따고 넘겨준다.
     * 누끼따는 템플릿으로 누끼가 따여져있는 경우 이미 img_nukki_yn값이 Y로 되어있을때,
     * 이미지를 변경하게 되면 곧바로 변경된 이미지의 누끼를 따서 적용하면 되지만 img_nukki_yn값이 Y로 되어있어서 새로운 이미지 링크여도 누끼를 안따고 넘겨준다.
     * 그래서 img_nukki_yn값을 현재는 N으로 변경한 후 누끼를 따는 방식으로 진행중이지만 이미지 링크만으로도 누끼를 따는 api가 생겨서 추후에 기능 수정 예정.
     * 
     * /shop/removeBackground
     * 위 api를 통해 이미지의 누끼를 따고 미리보기 api를 태워서 새로운 누끼 이미지를 미리보기 DB에 적용한다.
     * 혹시 모르니 img_nukki_yn 값도 함께 적용
     */
    let nukki_idx;
    var nukkiLink; // 이미 존재하는 누끼 링크
    if(nukki_info){
        nukki_idx = nukki_info.position ? Number(nukki_info.position)-1: "";
        /* 이미지 누끼 관련 정보를 미리보기 테이블에 덮어씌우는 부분
          * event_seq가 존재하는 페이지에 진입했을때 실행 */
        if(nukki_info.page_load){
            body['w_img_nukki_yn'] = this.state.w_img_nukki_yn;
            body['h_img_nukki_yn'] = this.state.h_img_nukki_yn;
            body['w_img_detail_nukki_yn'] = this.state.w_img_detail_nukki_yn;
            body['h_img_detail_nukki_yn'] = this.state.h_img_detail_nukki_yn;
            body['w_img_third_nukki_yn'] = this.state.w_img_third_nukki_yn;
            body['h_img_third_nukki_yn'] = this.state.h_img_third_nukki_yn;
            body['w_img_fourth_nukki_yn'] = this.state.w_img_fourth_nukki_yn;
            body['h_img_fourth_nukki_yn'] = this.state.h_img_fourth_nukki_yn;

            body['w_img_nukki_ppm_yn'] = this.state.w_img_nukki_ppm_yn;
            body['w_img_detail_nukki_ppm_yn'] = this.state.w_img_detail_nukki_ppm_yn;
            body['w_img_third_nukki_ppm_yn'] = this.state.w_img_third_nukki_ppm_yn;
            body['w_img_fourth_nukki_ppm_yn'] = this.state.w_img_fourth_nukki_ppm_yn;
            body['h_img_nukki_ppm_yn'] = this.state.h_img_nukki_ppm_yn;
            body['h_img_detail_nukki_ppm_yn'] = this.state.h_img_detail_nukki_ppm_yn;
            body['h_img_third_nukki_ppm_yn'] = this.state.h_img_third_nukki_ppm_yn;
            body['h_img_fourth_nukki_ppm_yn'] = this.state.h_img_fourth_nukki_ppm_yn;

            body['w_nukki_img_link'] = this.state.w_nukki_img_link;
            body['w_nukki_img_detail_link'] = this.state.w_nukki_img_detail_link;
            body['w_nukki_img_third_link'] = this.state.w_nukki_img_third_link;
            body['w_nukki_img_fourth_link'] = this.state.w_nukki_img_fourth_link;
            body['h_nukki_img_link'] = this.state.h_nukki_img_link;
            body['h_nukki_img_detail_link'] = this.state.h_nukki_img_detail_link;
            body['h_nukki_img_third_link'] = this.state.h_nukki_img_third_link;
            body['h_nukki_img_fourth_link'] = this.state.h_nukki_img_fourth_link;

            $("#blockPageClick").hide();
        }

        /* 이미지 배경 제거 요청 */
        if(nukki_info.action){
            const ppm_yn = this.state[nukki_info.type+"_nukki_ppm_state"][nukki_idx] ? "Y" : "N";
            const version = this.state[nukki_info.type+"_nukki_version_list"][nukki_idx];
            body[nukki_info.type+'_nukki_ppm_yn'] = ppm_yn;
            body[nukki_info.type+'_nukki_version'] = version;

            nukkiLink = this.checkTypeNukkiRunImage(nukki_info.type, Number(nukki_info.position)-1);
            if(nukkiLink){
                body[nukki_info.type+"_nukki_"+this.state[nukki_info.type+"_img_position_name"][nukki_idx].position_name+'_link'] =nukkiLink;
                body[nukki_info.type+'_'+this.state[nukki_info.type+"_img_position_name"][nukki_idx].position_name+'_nukki_yn'] = "Y";
            } else{
                body['nukki_run_yn'] = "Y";
                body[nukki_info.type+'_nukki_yn'] = nukki_info.action;
                body[nukki_info.type+'_nukki_position'] = nukki_info.position;

                let save_dialog_content = "AI 원본 배경 제거중 입니다.";
                this.setState({
                    save_dialog_show_state: true,
                    save_dialog_content: save_dialog_content,
                    save_dialog_button_list: [
                        {
                            title: "확인",
                            type: "1",
                            display_yn:"N",
                        }
                    ]
                }, () => {
                    $("#blockPageClick").hide();
                });
            }
            
            $(".mirror_banner_v2_pc_banner_area").css({opacity : "0"});
            $(".mirror_banner_v2_mobile_banner_area").css({opacity : "0"});
        }

        /** 누끼 상태값 및 누끼 링크 변경
         * nukki_info_Y_list가 있으면, api 응답후 배경 제거 작업을 이어서 실행
        */
        if(nukki_info.change_N_list){
            let N_list = nukki_info.change_N_list ? nukki_info.change_N_list : [];
            for(var i=0;i<N_list.length;i++){
                body[N_list[i].key] = N_list[i].value;
            }
        }
    }

    // 이전 요청이 남아있으면 취소
    if (this.eventTmpCancelSource) {
      this.eventTmpCancelSource.cancel("Canceled because a new insertEventTmp request started.");
    }

    // 새 cancel token 생성
    this.eventTmpCancelSource = axios.CancelToken.source();

    const config = {
        headers: {
            'Content-Type': 'application/json',
            },
        cancelToken: this.eventTmpCancelSource.token,
    };

    http.post("/rest/common/insert/event/tmp", body, config)
    .then(res =>
          {
            this.eventTmpCancelSource = null;
            this.setState({page_load_tmp_state : true,})
            let event_seq = this.getUrlParams()["event_seq"] ? this.state.event_seq : dateString;
            // $(".mirror_banner_v2_pc_banner").html('<object class="robomd_banner_m" type="text/html" data="'+object_domain+'/admin_banner.html?event_seq='+event_seq+'&platform_type=p&mirror_type=18001" type="text/html" style="width:100%;height:100%; background: #FFF;"></object>');
            // $(".mirror_banner_v2_mobile_banner").html('<object class="robomd_banner_p" type="text/html" data="'+object_domain+'/admin_banner.html?event_seq='+event_seq+'&platform_type=m&mirror_type=18001" type="text/html" style="width:100%;height:100%; background: #FFF;"></object>');
            const previewTs = Date.now();
            
            const $object_p = $(".robomd_banner_p");
            $object_p.attr('data', object_domain+"/admin_banner.html?event_seq="+event_seq+"&platform_type=p&mirror_type=18001&is_instagram=Y&preview_ts="+previewTs);

            const $object_m = $(".robomd_banner_m");
            $object_m.attr('data', object_domain+"/admin_banner.html?event_seq="+event_seq+"&platform_type=m&mirror_type=18001&is_instagram=Y&preview_ts="+previewTs);
            
            if(nukki_info){
                if(nukki_info.action == "Y"){
                    if(nukki_action_state_cnt > 0){
                        nukki_action_state_cnt --;
                    }
                    if(res.data.nukki_response_code == "200"){
                        const position_name = this.state[nukki_info.type+"_img_position_name"][nukki_idx].position_name;
                        const nukki_img_link = res.data[nukki_info.type+"_nukki_"+position_name+"_link"];

                        this.setState({
                            [nukki_info.type+"_"+position_name+"_nukki_yn"] : "Y",
                            [nukki_info.type+"_nukki_"+position_name+"_link"] : nukki_img_link,
                        });
                        // 상품 이미지라면
                        if(!this.positionLinkTypeImgCheck(nukki_info.type,nukki_idx)){
                            var robo_nukki_img = {
                                org_img_link : body[nukki_info.type == "w" ? this.state[nukki_info.type+"_img_position_name"][nukki_idx].img_column_name : "h_"+this.state[nukki_info.type+"_img_position_name"][nukki_idx].img_column_name],
                                ppm_yn : this.state[nukki_info.type+"_nukki_ppm_state"][nukki_idx] ? "Y" : "N",
                                crop_yn : nukki_info.type == "w" ? this.state.w_is_nukki_crop_yn : this.state.h_is_nukki_crop_yn,
                                version : this.state[nukki_info.type+"_nukki_version_list"][nukki_idx],
                                nukki_img_link : nukki_img_link,
                            };
                            var robo_nukki_img_list = !sessionStorage.getItem("robo_nukki_img_list") ? []: JSON.parse(sessionStorage.getItem("robo_nukki_img_list"));
                            robo_nukki_img_list.push(robo_nukki_img);
                            sessionStorage.setItem("robo_nukki_img_list",JSON.stringify(robo_nukki_img_list));
                        } else{
                            // 사용자가 직접 올린 이미지라면
                            let user_img_list = this.state[nukki_info.type+"_user_img_list"];
                            let ppm_yn = this.state[nukki_info.type+"_nukki_ppm_state"][nukki_idx] ? "Y" : "N";
                            let crop_yn = nukki_info.type == "w" ? this.state.w_is_nukki_crop_yn : this.state.h_is_nukki_crop_yn;
                            let version = this.state[nukki_info.type+"_nukki_version_list"][nukki_idx];
                            user_img_list[nukki_idx]["img_ppm_"+ppm_yn+"_crop_"+crop_yn+"_version_"+version] = nukki_img_link;

                            this.setState({[nukki_info.type+"_user_img_list"]: user_img_list,});
                        }
                        
                    } else if(nukkiLink){
                        this.setState({
                            [nukki_info.type+"_"+this.state[nukki_info.type+"_img_position_name"][nukki_idx].position_name+"_nukki_yn"] : "Y",
                            [nukki_info.type+"_nukki_"+this.state[nukki_info.type+"_img_position_name"][nukki_idx].position_name+"_link"] : nukkiLink,
                        });
                    } else{
                        alert("배경 제거에 실패하였습니다.");
                    }

                    if(nukki_action_state_cnt == 0){
                        this.setState({ save_dialog_show_state: false });
                        $(".mirror_banner_v2_pc_banner_area").css({opacity : "1"});
                        $(".mirror_banner_v2_mobile_banner_area").css({opacity : "1"});
                        $("#blockPageClick").hide();
                    }
                    return false;
                }

                if(nukki_info.change_N_list){
                    // 누끼를 이어서 따야하는 경우
                    if(nukki_info.nukki_info_Y_list && nukki_info.nukki_info_Y_list.length > 0){
                        let action_y_num = 0;

                        for(var i=0;i<nukki_info.nukki_info_Y_list.length;i++){
                            this.insertEventTmp('preview', nukki_info.nukki_info_Y_list[i]);
                            action_y_num ++;
                        }

                        // 배경 제거를 하나라도 실행하면 미리보기 막기
                        if(action_y_num != 0){
                            nukki_action_state_cnt = action_y_num;

                            $(".mirror_banner_v2_pc_banner_area").css({opacity : "0"});
                            $(".mirror_banner_v2_mobile_banner_area").css({opacity : "0"});
                            return false;
                        }
                    }
                    this.setState({ save_dialog_show_state: false });
                }

                if(nukki_info.page_load){
                    this.insertEventTmp('preview');
                }
            }
            $(".mirror_banner_v2_pc_banner_area").css({opacity : "1"});
            $(".mirror_banner_v2_mobile_banner_area").css({opacity : "1"});
            $("#blockPageClick").hide();
        })
        .catch(error => {
            // ✅ 취소된 요청이면 에러처럼 처리하지 않고 종료
            if (axios.isCancel && axios.isCancel(error)) {
              return;
            }

            if(nukki_info && nukki_info.action == "Y"){
                alert("배경 제거에 실패하였습니다.");
            }
            this.setState({
                page_load_tmp_state : true,
                save_dialog_show_state: false,
            })
            $(".mirror_banner_v2_pc_banner_area").css({opacity : "1"});
            $(".mirror_banner_v2_mobile_banner_area").css({opacity : "1"});
            $("#blockPageClick").hide();
      });
  }

  saveEvent =  e => {
      if (!this.state.iframe_page_id){
          alert("적용 범위 - 페이지를 선택해 주세요.");
          $("#iframe_page_id_select").focus();
          return false;
      }
      if (!this.state.iframe_html_id){
          alert("적용 범위 - 배너를 선택해 주세요.");
          $("#iframe_html_id_select").focus();
          return false;
      }
      // if (!this.state.item_user_type){
      //     alert("적용 범위 - 누구에게 노출할지 선택해 주세요.");
      //     $("#item_user_type").focus();
      //     return false;
      // }
      // if(this.state.item_user_type == "T" && this.state.is_use_target_view_service == "Y" && this.state.selected_target_view_list.length == 0){
      //     alert("타겟을 선택해 주세요.")
      // }
      // if (!this.state.title) {
      //     if (!this.state.none_title) {
      //         alert("큰 글자 제목이 없습니다. 대신 배너 이름을 입력해 주세요.");
      //         $("#none_title").focus();
      //         return false;
      //     }
      // }

      if (!this.state.none_title) {
          // alert("디자인 제목을 입력해 주세요.");
          // $("#none_title").focus();
          // return false;
          this.setState({
            none_title : crypto.randomUUID()
          })
      }

      // if (this.state.solution_type_cd != "09900" && !this.state.product_no){
      //     alert("상품을 선택해 주세요.");
      //     $("#search_product").focus();
      //     return false;
      // }
      // if (this.state.solution_type_cd != "09900" && !this.state.is_soldout_display){
      //     alert("선택된 상품 품절 시 종료 여부를 선택해 주세요.");
      //     return false;
      // }

      if(!this.state.selected_pc_banner_ratio.org_width_height && !this.state.selected_mobile_banner_ratio.org_width_height){
          alert("배너 사이즈를 입력해주세요.");
          if(!this.state.event_banner_pc_width || this.state.event_banner_pc_width == "0"){
              $("#input_event_banner_pc_width").focus();
              return false;
          }
          if(!this.state.event_banner_pc_height || this.state.event_banner_pc_height == "0"){
              $("#input_event_banner_pc_height").focus();
              return false;
          }
      }

      // if (!this.state.start_hour) {
      //     alert("시작 일시를 지정해주세요.")
      //     $("#start_hour").focus();
      //     return false;
      // }
      // if (!this.state.start_minute) {
      //     alert("시작 일시를 지정해주세요.")
      //     $("#start_minute").focus();
      //     return false;
      // }

      // if (!this.state.end_hour) {
      //     alert("종료 일시를 지정해주세요.")
      //     $("#end_hour").focus();
      //     return false;
      // }
      // if (!this.state.end_minute) {
      //     alert("종료 일시를 지정해주세요.")
      //     $("#end_minute").focus();
      //     return false;
      // }

      // 비연동인 경우에 가격을 사용하는 템플릿이 있다면 체크
      // if(this.state.solution_type_cd == "09900" && ((Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_is_price_use == "Y") || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_is_price_use == "Y"))){
      //     if (this.state.event_price !== 0 && (this.state.event_price == null || this.state.event_price == "")) {
      //         alert("가격 텍스트를 작성해 주세요.")
      //         $("#input_event_price_text").focus();
      //         return false;
      //     }
      // }

      if (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length) {
        if (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && !this.state.event_type_cd){
            alert("가로형 배너 디자인을 선택해주세요.")
            return false;
        }
        if(Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.event_type_cd_use_yn == "N"){
            alert("사용 가능한 가로형 배너 디자인을 선택해주세요.")
            return false;
        }
      } else {
          if (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && !this.state.event_mobile_type_cd){
              alert("세로형 배너 디자인을 선택해주세요.")
              return false;
          }
          if(Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.event_mobile_cd_use_yn == "N"){
              alert("사용 가능한 세로형 배너 디자인을 선택해주세요.")
              return false;
          }
      }
      if (!this.state.background){
          alert("색상을 선택해주세요.")
          return false;
      }
      // if (this.state.title == null || this.state.title == ""){
      //     alert("큰 글자 제목을 입력해주세요.")
      //     return false;
      // }
      // if (this.state.sub_title == null || this.state.sub_title == ""){
      //     alert("작은 글자 제목을 입력해주세요.")
      //     return false;
      // }
      // if (this.state.lang_type == "eng" && (!this.state.foreign_title || this.state.foreign_title == "undefined")) {
      //     alert("영문 배너 제목을 입력해주세요.")
      //     return false;
      // }

      // if(new Date(this.state.start_date_format) > new Date(this.state.end_date_format)) {
      //     alert("시작일시가 종료일시 보다 미래 일 수 없습니다.\n다시 설정해 주세요.");
      //     $("#start_date").focus();
      //     return false;
      // } else if(new Date(this.state.start_date_format).valueOf() == new Date(this.state.end_date_format).valueOf()) {
      //     alert("종료 일시는 시작 일시와 다르게 선택해 주세요. ");
      //     $("#start_date").focus();
      //     return false;
      // }

      if((Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_is_button_use == "Y") || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_is_button_use == "Y")){
          for(var i=0;i<this.state.button_list.length;i++){
              if(!this.state.button_list[i].button_text){
                  alert("버튼 텍스트를 입력해주세요.");
                  $("#button_text_input_"+(i+1)).focus();
                  return false;
              }
              // if(!this.state.button_list[i].link){
              //     alert("버튼 링크를 입력해주세요.");
              //     $("#button_link_input_"+(i+1)).focus();
              //     return false;
              // }
          }
      }

      this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "저장 중 입니다...",
          save_dialog_button_list: [
              {
                  title: "확인",
                  type: "1",
                  display_yn:"N",
              }
          ]
      });

      // this.stroeOrSettingCnt()

      const {is_recommendation_small_title} = this.state;
      // 배너 문구 replace
      let replaceText = function(text){
          return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
      };
      // let item_img = (this.state.is_detail_image_use == true && this.state.select_item_list[0].detail_image) ? this.state.select_item_list[0].detail_image : this.state.select_item_list[0].image ? this.state.select_item_list[0].image : "";

      // 폰트 리스트 호출
      const saveFontFamilyList = [...new Set(font_family_list)];
      this.updateFontList(saveFontFamilyList);

      let event_banner_pc_width, event_banner_pc_height, event_banner_mobile_width, event_banner_mobile_height;
      if((this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width) > 0 && Number(this.state.event_banner_pc_height) > 0) && !(this.state.event_banner_mobile_width && this.state.event_banner_mobile_height && Number(this.state.event_banner_mobile_width) > 0 && Number(this.state.event_banner_mobile_height) > 0)){
          event_banner_pc_width = this.state.event_banner_pc_width;
          event_banner_pc_height = this.state.event_banner_pc_height;
          event_banner_mobile_width = this.state.event_banner_pc_width;
          event_banner_mobile_height = this.state.event_banner_pc_height;
      } else if(!(this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width) > 0 && Number(this.state.event_banner_pc_height) > 0) && (this.state.event_banner_mobile_width && this.state.event_banner_mobile_height && Number(this.state.event_banner_mobile_width) > 0 && Number(this.state.event_banner_mobile_height) > 0)){
          event_banner_pc_width = this.state.event_banner_mobile_width;
          event_banner_pc_height = this.state.event_banner_mobile_height;
          event_banner_mobile_width = this.state.event_banner_mobile_width;
          event_banner_mobile_height = this.state.event_banner_mobile_height;
      } else if(this.state.single_size) {
          event_banner_pc_width = this.state.event_banner_pc_width;
          event_banner_pc_height = this.state.event_banner_pc_height;
          event_banner_mobile_width = this.state.event_banner_pc_width;
          event_banner_mobile_height = this.state.event_banner_pc_height;
      } else {
          event_banner_pc_width = this.state.event_banner_pc_width;
          event_banner_pc_height = this.state.event_banner_pc_height;
          event_banner_mobile_width = this.state.event_banner_mobile_width;
          event_banner_mobile_height = this.state.event_banner_mobile_height;
      }
      console.log("saveEvent event_banner_pc_width:", event_banner_pc_width);
      console.log("saveEvent event_banner_pc_height:", event_banner_pc_height);
      console.log("saveEvent event_banner_mobile_width:", event_banner_mobile_width);
      console.log("saveEvent event_banner_mobile_height:", event_banner_mobile_height);

      let body = {
          event_seq : window.location.href.indexOf("/instagram") >= 0 ? "" : this.state.event_seq, // 인스타그램 디자인 편집인 경우에는 매번 새로운 event_seq 생성
          user_seq : this.state.user_seq,
          shop_no : "1",
          iframe_page_id : window.location.href.indexOf("/instagram") >= 0 ? "robomd_instagram_page" : this.state.iframe_page_id,
          iframe_html_id : window.location.href.indexOf("/instagram") >= 0 ? "-1" : this.state.iframe_html_id,
          is_instagram : window.location.href.indexOf("/instagram") >= 0 ? "Y" : "N",
          
          pre_iframe_html_id : this.state.pre_iframe_html_id,
          item_user_type : this.state.item_user_type,
          // target_view_seq_list : this.state.selected_target_view_list.length != 0 ? this.state.selected_target_view_list.map(obj => obj.target_view_seq) : null,

          event_type_cd : this.state.event_type_cd,
          event_mobile_type_cd : this.state.event_mobile_type_cd,

          
          none_title : replaceText(this.state.none_title),
          title : replaceText(this.state.title),
          content : replaceText(this.state.title),
          // 작은 글자 추천 여부에 따라 적용
          foreign_title : is_recommendation_small_title == "on" ? replaceText(this.state.robomd_on_foreign_title) : replaceText(this.state.foreign_title),
          sentence : is_recommendation_small_title == "on" ? replaceText(this.state.robomd_on_sentence) : replaceText(this.state.sentence),
          eng_sentence : is_recommendation_small_title == "on" ? replaceText(this.state.robomd_on_eng_sentence) : replaceText(this.state.eng_sentence),
          
          // img_link : item_img,
          // img_detail_link : item_img,
          // img_third_link : item_img,
          // img_fourth_link : item_img,
          // h_img_link : item_img,
          // h_img_detail_link : item_img,
          // h_img_third_link : item_img,
          // h_img_fourth_link : item_img,

          img_link : this.state.img_link,
          img_detail_link : this.state.img_detail_link,
          img_third_link : this.state.img_third_link,
          img_fourth_link : this.state.img_fourth_link,
          h_img_link : this.state.h_img_link,
          h_img_detail_link : this.state.h_img_detail_link,
          h_img_third_link : this.state.h_img_third_link,
          h_img_fourth_link : this.state.h_img_fourth_link,

          w_crop_img_info_list : this.state.w_crop_img_info_list,
          h_crop_img_info_list : this.state.h_crop_img_info_list,

          image_type_cd : this.state.image_type_cd,
          
          color_code_1 : this.state.background,
          color_code_2 : this.state.background2,
          color_code_3 : this.state.background3,
          color_code_4 : this.state.background4,
          
          color_value_1 : this.state.color_value_1,
          color_value_2 : this.state.color_value_2,
          color_value_3 : this.state.color_value_3,
          color_value_4 : this.state.color_value_4,
          
          color_lmnst_1 : this.state.color_lmnst_1,
          color_lmnst_2 : this.state.color_lmnst_2,
          color_lmnst_3 : this.state.color_lmnst_3,
          color_lmnst_4 : this.state.color_lmnst_4,
          
          color_strtn_1 : this.state.color_strtn_1,
          color_strtn_2 : this.state.color_strtn_2,
          color_strtn_3 : this.state.color_strtn_3,
          color_strtn_4 : this.state.color_strtn_4,
          
          color_hue_1 : this.state.color_hue_1,
          color_hue_2 : this.state.color_hue_2,
          color_hue_3 : this.state.color_hue_3,
          color_hue_4 : this.state.color_hue_4,
          
          start_date : this.state.start_date_format,
          end_date : this.state.end_date_format,
          product_no : this.state.product_no,
          display_yn : this.state.display_yn,
          reg_user_seq : this.state.reg_user_seq,
          reg_date : this.state.reg_date,
          is_soldout_display : this.state.solution_type_cd == "09900" ? "Y" : this.state.is_soldout_display,
          simple_date_cd : this.state.simple_date_cd,
          link_url : this.state.link_url && this.state.is_link_url == "Y" ? this.state.link_url : null,
          gpt_main_keyword : this.state.gpt_main_keyword,
          event_price : this.state.event_price,

          facial_x_start : this.state.facial_x_start,
          facial_y_start : this.state.facial_y_start,
          facial_width: this.state.facial_width,
          facial_height : this.state.facial_height,
          facial_yn : this.state.facial_yn,
          origin_img_width : this.state.origin_img_width,
          origin_img_height : this.state.origin_img_height,
          
          /* 텍스트 컬러 */
          w_large_text_color : this.state.w_large_text_color,
          h_large_text_color : this.state.h_large_text_color,
          w_small_text_color : this.state.w_small_text_color,
          h_small_text_color :this.state.h_small_text_color,
          /* 텍스트 외 요소 색상 */
          w_color_etc : this.state.w_color_etc,
          h_color_etc : this.state.h_color_etc,
          /* 번역 */
          translated_yn : this.state.translated_yn,
          language_code : this.state.language_code,

          // 미리보기 사이즈 입력값
          event_banner_pc_width : event_banner_pc_width,
          event_banner_pc_height : event_banner_pc_height,
          event_banner_mobile_width : event_banner_mobile_width,
          event_banner_mobile_height : event_banner_mobile_height,
              
          /* 버튼 리스트 */
          button_list : this.state.button_list,

          /* 텍스트 위치 이동 */
          w_main_txt_position_x : Number(this.state.w_main_txt_position_right) - Number(this.state.w_main_txt_position_left),
          w_main_txt_position_y : Number(this.state.w_main_txt_position_top) - Number(this.state.w_main_txt_position_bottom),
          h_main_txt_position_x : Number(this.state.h_main_txt_position_right) - Number(this.state.h_main_txt_position_left),
          h_main_txt_position_y : Number(this.state.h_main_txt_position_top) - Number(this.state.h_main_txt_position_bottom),
          w_sub_txt_position_x : Number(this.state.w_sub_txt_position_right) - Number(this.state.w_sub_txt_position_left),
          w_sub_txt_position_y : Number(this.state.w_sub_txt_position_top) - Number(this.state.w_sub_txt_position_bottom),
          h_sub_txt_position_x : Number(this.state.h_sub_txt_position_right) - Number(this.state.h_sub_txt_position_left),
          h_sub_txt_position_y : Number(this.state.h_sub_txt_position_top) - Number(this.state.h_sub_txt_position_bottom),

          /* 이미지 크기 조절 */
          w_img_1_scale: this.state.w_img_1_scale,
          w_img_2_scale: this.state.w_img_2_scale,
          w_img_3_scale: this.state.w_img_3_scale,
          w_img_4_scale: this.state.w_img_4_scale,
          h_img_1_scale: this.state.h_img_1_scale,
          h_img_2_scale: this.state.h_img_2_scale,
          h_img_3_scale: this.state.h_img_3_scale,
          h_img_4_scale: this.state.h_img_4_scale,

          /* 텍스트 크기 조절 */
          w_main_txt_scale: this.state.w_main_txt_scale,
          h_main_txt_scale: this.state.h_main_txt_scale,
          w_sub_txt_scale: this.state.w_sub_txt_scale,
          h_sub_txt_scale: this.state.h_sub_txt_scale,

          /* 폰트 리스트 */
          font_family_list: saveFontFamilyList,

          /* 추출된 색상 */
          ...(
            Array.isArray(this.state.extractedColors) && this.state.extractedColors.length > 0
              ? {
                  ai_colorhunt_1: this.state.extractedColors?.[0] ?? null,
                  ai_colorhunt_2: this.state.extractedColors?.[1] ?? null,
                  ai_colorhunt_3: this.state.extractedColors?.[2] ?? null,
                  ai_colorhunt_4: this.state.extractedColors?.[3] ?? null,
                }
              : {}
          ),
      };

      // 이미지가 사용되는 영역의 이미지 처리
      for(var i=0;i<this.state.w_img_position_name.length;i++){
          body[this.state.w_img_position_name[i].img_column_name] = this.state[this.state.w_img_position_name[i].img_column_name];
          // 업로드 이미지 관련 처리
          if(this.state.w_user_img_list[i].img_link){
              // 동영상 주소 타입인데, 유튜브를 사용하지 않는 템플릿인 경우 업로드 img_link(썸네일)을 적용하지 않음
              if(!(this.state.w_is_youtube_link_use != "Y" && this.state.w_user_img_list[i].link_type == "49005")){
                  body[this.state.w_img_position_name[i].img_column_name] = this.state.w_user_img_list[i].img_link;
              }
              // 파일 업로드의 경우 img_seq도 저장
              if(this.state.w_user_img_list[i].link_type == "49001"){
                  body["robo_banner_org_"+this.state.w_img_position_name[i].img_column_name+"_seq"] = this.state.w_user_img_list[i].org_img_seq;
              }
          }
      }
      // 이미지가 사용되는 영역의 이미지 처리
      for(var i=0;i<this.state.h_img_position_name.length;i++){
          body["h_"+this.state.h_img_position_name[i].img_column_name] = this.state["h_"+this.state.h_img_position_name[i].img_column_name];
          // 업로드 이미지 관련 처리
          if(this.state.h_user_img_list[i].img_link){
              // 동영상 주소 타입인데, 유튜브를 사용하지 않는 템플릿인 경우 업로드 img_link(썸네일)을 적용하지 않음
              if(!(this.state.h_is_youtube_link_use != "Y" && this.state.h_user_img_list[i].link_type == "49005")){
                  body["h_"+this.state.h_img_position_name[i].img_column_name] = this.state.h_user_img_list[i].img_link;
              }
              // 파일 업로드의 경우 img_seq도 저장
              if(this.state.h_user_img_list[i].link_type == "49001"){
                  body["h_robo_banner_org_"+this.state.h_img_position_name[i].img_column_name+"_seq"] = this.state.h_user_img_list[i].org_img_seq;
              }

          }
      }

      for(var img_position_idx = 1; img_position_idx <= 4; img_position_idx ++) {
          // 위쪽, 왼쪽으로 이동시 음수로 보낸다
          /* 가로형 */
          body["img_position_x_"+img_position_idx] = Number(this.state["w_img_position_left_"+img_position_idx]) != 0 ? Number(this.state["w_img_position_left_"+img_position_idx])*-1 : Number(this.state["w_img_position_right_"+img_position_idx]);
          body["img_position_y_"+img_position_idx] = Number(this.state["w_img_position_top_"+img_position_idx]) != 0 ? Number(this.state["w_img_position_top_"+img_position_idx])*-1 : Number(this.state["w_img_position_bottom_"+img_position_idx]);
          /* 세로형 */
          body["h_img_position_x_"+img_position_idx] = Number(this.state["h_img_position_left_"+img_position_idx]) != 0 ? Number(this.state["h_img_position_left_"+img_position_idx])*-1 : Number(this.state["h_img_position_right_"+img_position_idx]);
          body["h_img_position_y_"+img_position_idx] = Number(this.state["h_img_position_top_"+img_position_idx]) != 0 ? Number(this.state["h_img_position_top_"+img_position_idx])*-1 : Number(this.state["h_img_position_bottom_"+img_position_idx]);
      }

      // 4개의 이미지 영역중 배너 타입에 따라 쓰지 않게된 부분의 초기화를 위한 설정
      for(var i=0;i<4;i++){
          /* 이미지 위치 조절 값 : 50002*/
          body["img_position_"+(i+1)+"_type"] = "50002";
          body["h_img_position_"+(i+1)+"_type"] = "50002";
          
          // 이미지 누끼딴 여부(yn)
          body["w_"+img_order_text[i]+"_nukki_yn"] = "N";
          body["h_"+img_order_text[i]+"_nukki_yn"] = "N";

          // 이미지 ppm 상태 : 밑에서 Y로 사용중인 것만 체크하여 값 변경
          body["w_"+img_order_text[i]+"_nukki_ppm_yn"] = "N";
          body["h_"+img_order_text[i]+"_nukki_ppm_yn"] = "N";
          
          // 배경제거 버전
          body["w_"+img_order_text[i]+"_nukki_version"] = "1";
          body["h_"+img_order_text[i]+"_nukki_version"] = "1";

          // 이미지 타입 초기화 (49001 : 업로드 / 49002 : 링크 / 49004 : 로보이미지)
          body["w_"+img_order_text[i]+"_link_type"] = "49001";
          body["h_"+img_order_text[i]+"_link_type"] = "49001";
          body["w_"+img_order_text[i]+"_49002_link"] = null;
          body["h_"+img_order_text[i]+"_49002_link"] = null;
          body["w_"+img_order_text[i]+"_49004_link"] = null;
          body["h_"+img_order_text[i]+"_49004_link"] = null;
          body["w_"+img_order_text[i]+"_49006_link"] = null;
          body["h_"+img_order_text[i]+"_49006_link"] = null;

          // 누끼 이미지 링크
          // 누끼 해제/삭제된 영역은 서버에 명시적으로 null을 내려 기존 저장값을 제거한다.
          body["w_nukki_"+img_order_text[i]+"_link"] = null;
          body["h_nukki_"+img_order_text[i]+"_link"] = null;
          if(this.state["w_"+img_order_text[i]+"_nukki_yn"] == "Y"){
              body["w_nukki_"+img_order_text[i]+"_link"] = this.state["w_nukki_"+img_order_text[i]+"_link"];
          }
          if(this.state["h_"+img_order_text[i]+"_nukki_yn"] == "Y"){
              body["h_nukki_"+img_order_text[i]+"_link"] = this.state["h_nukki_"+img_order_text[i]+"_link"];
          }

          body[youtube_order_text[i]+"_link"] = "";
          body["h_"+youtube_order_text[i]+"_link"] = "";
          body[youtube_order_text[i]+"_thumbnail"] = "";
          body["h_"+youtube_order_text[i]+"_thumbnail"] = "";
          body["w_is_"+youtube_order_text[i]+"_use"] = "N";
          body["h_is_"+youtube_order_text[i]+"_use"] = "N";
      }

      for(var i=0;i<this.state.w_img_position_name.length;i++){
          body["img_position_"+(i+1)+"_type"] = this.state["img_position_"+(i+1)+"_type"] ? this.state["img_position_"+(i+1)+"_type"] : "50001";
          body["w_"+this.state.w_img_position_name[i].position_name+"_nukki_yn"] = this.state["w_"+this.state.w_img_position_name[i].position_name+"_nukki_yn"];
          body["w_"+this.state.w_img_position_name[i].position_name+"_nukki_ppm_yn"] = this.state.w_nukki_ppm_state[i] ? "Y" : "N";
          body["w_"+this.state.w_img_position_name[i].position_name+"_nukki_version"] = this.state.w_nukki_version_list[i];
          body["w_"+this.state.w_img_position_name[i].position_name+"_link_type"] = this.state.w_user_img_list[i].link_type;
          if(this.state.w_user_img_list[i].link_type == "49002"){
              body["w_"+this.state.w_img_position_name[i].position_name+"_49002_link"] = this.state.w_user_img_list[i].img_link;
          }
          if(this.state.w_user_img_list[i].link_type == "49004"){
              body["w_"+this.state.w_img_position_name[i].position_name+"_49004_link"] = this.state.w_user_img_list[i].img_link;
          }
          if(this.state.w_user_img_list[i].link_type == "49006"){
              body["w_"+this.state.w_img_position_name[i].position_name+"_49006_link"] = this.state.w_user_img_list[i].img_link;
          }
          if(this.state.w_is_youtube_link_use == "Y" && this.state.w_user_img_list[i].link_type == "49005" && this.state.w_user_img_list[i].video_link){
              let video_link = this.state.w_user_img_list[i].video_link;
              // 입력값에 https://가 들어있으면 그대로 사용, 없다면 https://를 붙여서 사용
              if(!video_link.includes("https://")){
                  video_link = video_link.includes("youtube.com") ? ("https://www.youtube.com" + video_link.split("youtube.com")[1]) : ("https://www.youtu.be" + video_link.split("youtu.be")[1]);
              }
              body[youtube_order_text[i]+"_link"] = video_link;
              body[youtube_order_text[i]+"_thumbnail"] = this.state.w_user_img_list[i].img_link;
              body["w_is_"+youtube_order_text[i]+"_use"] = this.state.w_user_img_list[i].video_link ? "Y" : "N";
          }
      }
      for(var i=0;i<this.state.h_img_position_name.length;i++){
          body["h_img_position_"+(i+1)+"_type"] = this.state["h_img_position_"+(i+1)+"_type"] ? this.state["h_img_position_"+(i+1)+"_type"] : "50001";
          body["h_"+this.state.h_img_position_name[i].position_name+"_nukki_yn"] = this.state["h_"+this.state.h_img_position_name[i].position_name+"_nukki_yn"];
          body["h_"+this.state.h_img_position_name[i].position_name+"_nukki_ppm_yn"] = this.state.h_nukki_ppm_state[i] ? "Y" : "N";
          body["h_"+this.state.h_img_position_name[i].position_name+"_nukki_version"] = this.state.h_nukki_version_list[i];
          body["h_"+this.state.h_img_position_name[i].position_name+"_link_type"] = this.state.h_user_img_list[i].link_type;
          if(this.state.h_user_img_list[i].link_type == "49002"){
              body["h_"+this.state.h_img_position_name[i].position_name+"_49002_link"] = this.state.h_user_img_list[i].img_link;
          }
          if(this.state.h_user_img_list[i].link_type == "49004"){
              body["h_"+this.state.h_img_position_name[i].position_name+"_49004_link"] = this.state.h_user_img_list[i].img_link;
          }
          if(this.state.h_user_img_list[i].link_type == "49006"){
              body["h_"+this.state.h_img_position_name[i].position_name+"_49006_link"] = this.state.h_user_img_list[i].img_link;
          }
          if(this.state.h_is_youtube_link_use == "Y" && this.state.h_user_img_list[i].link_type == "49005" && this.state.h_user_img_list[i].video_link){
              let video_link = this.state.h_user_img_list[i].video_link;
              // 입력값에 https://가 들어있으면 그대로 사용, 없다면 https://를 붙여서 사용
              if(!video_link.includes("https://")){
                  video_link = video_link.includes("youtube.com") ? ("https://www.youtube.com" + video_link.split("youtube.com")[1]) : ("https://www.youtu.be" + video_link.split("youtu.be")[1]);
              }
              body["h_"+youtube_order_text[i]+"_link"] = video_link;
              body["h_"+youtube_order_text[i]+"_thumbnail"] = this.state.h_user_img_list[i].img_link;
              body["h_is_"+youtube_order_text[i]+"_use"] = this.state.h_user_img_list[i].video_link ? "Y" : "N";
          }
      }

      const config = {
          headers: {
              'Content-Type': 'application/json',
          },
      }
  http.post("/rest/common/event/save", body, config)
  .then( async res => {
          if (res.data.err_msg) {
              // alert(res.data.err_msg);
              if (res.data.err_code == 401) {
                  window.location.href = "/logout";
              }
          } else {
              // let save_notice = "";
              // if (this.state.solution_type_cd != "09900" && this.getUrlParams()["sample_yn"] && this.getUrlParams()["sample_yn"] == "Y") {
              //     save_notice = "저장되었습니다. 이제부터 배너 목록에서 '샘플 배너'가 아니라 '로보 배너'로 표기됩니다.";
              // } else {
                  // save_notice = "저장되었습니다.";
              // }
              // if(res.data.is_change_order_no){
              //     let save_page_name = this.state.page_list.find((obj) => obj.code_name == this.state.iframe_page_id)["val1"];
              //     let save_html_name = this.state.html_list.find((obj) => obj.iframe_html_id == this.state.iframe_html_id)["iframe_html_name"];
              //     save_notice += "\n이 배너는 ["+save_page_name+"]의 ["+save_html_name+"] 영역의 1번째 순서로 변경되었습니다.";
              // }
              // alert(save_notice);
              // if (this.getUrlParams()["event_seq"]) {
              //     window.location.href = window.location.href.replace('&sample_yn=Y', "");
              // } else {


                  // window.location.href="/shop/instagram/InstagramTemplateEditor?event_seq="+res.data.event_seq;

                  // 캡처요청 상태 조회
                  let limit_count = 0;
                  await this.setStateAsync({
                      event_seq: res.data.event_seq,
                      save_dialog_show_state: true,
                      save_dialog_content: "이미지 변환 작업을 진행중입니다.<br/>잠시만 기다려 주세요.",
                      save_dialog_button_list: [
                          {
                              title: "확인",
                              type: "1",
                              display_yn:"N",
                          }
                      ]
                  });
                  await this.fn_captureStateChecker(res.data.capture_obj.req_seq, "N", "", "is_capture_done", limit_count, false);
                  await this.setStateAsync({
                      save_dialog_show_state: false,
                  });
              // }
          }
  })
  .catch(error => {
    // console.log ("===== error =====");
    // console.log (error);
    // console.log ("===== error request =====");
    // console.log(error.request);
    });
  }

  /** 누끼 링크 조회 */
  checkTypeNukkiRunImage(type, idx){
      const user_img_list = this.state[type+"_user_img_list"];
      let ppm_yn = this.state[type+"_nukki_ppm_state"][idx] ? "Y" : "N";
      let crop_yn = this.state[type+"_is_nukki_crop_yn"];
      let version = this.state[type+"_nukki_version_list"][idx];

      // 업로드 이미지가 있는 경우
      if(this.state[type+"_user_img_list"][idx].link_type != "49005" && this.state[type+"_user_img_list"][idx].img_link){
          return user_img_list[idx]["img_ppm_"+ppm_yn+"_crop_"+crop_yn+"_version_"+version];
      }

      // 비연동형 : 이미지가 없는 경우
      if(this.state.solution_type_cd == "09900"){
          return transparent_image;
      }
      // 상품 이미지가 있는 경우
      let link = this.state[(type == "h" ? "h_" : "") + this.state[type+"_img_position_name"][idx].img_column_name];
      if(link) {
          var robo_nukki_img_list = !sessionStorage.getItem("robo_nukki_img_list") ? []: JSON.parse(sessionStorage.getItem("robo_nukki_img_list"))
          var resultLink = false;
          
          if(robo_nukki_img_list.length > 0){
              for(var i=0;i<robo_nukki_img_list.length;i++){
                  if(robo_nukki_img_list[i].org_img_link == link && robo_nukki_img_list[i].ppm_yn == ppm_yn && robo_nukki_img_list[i].crop_yn == crop_yn && robo_nukki_img_list[i].version == version){
                      resultLink = robo_nukki_img_list[i].nukki_img_link;
                  }
              }
              return resultLink;
          }
      }
      return false;
  }

  handleBannerPageChange(pageNumber) {
      const { pc_banner_type_paging, w_selected_tags } = this.state;
      pc_banner_type_paging["activePage"] = pageNumber;
      pc_banner_type_paging["startIdx"] = ((pageNumber * Number(pc_banner_type_paging["rowcnt"])) - pc_banner_type_paging["rowcnt"]);
      this.setState({pc_banner_type_paging : pc_banner_type_paging});

      const selected_tag_list = [];
      for(const category in w_selected_tags){
          if(w_selected_tags.hasOwnProperty(category)){
              w_selected_tags[category].map((obj => {
                  selected_tag_list.push(obj)
              }));
          }
      }
      this.getBannerDesignTemplateUserFavoritePaging("03000", selected_tag_list);
  }


  handleMobileBannerPageChange(pageNumber) {
      const { mobile_banner_type_paging, h_selected_tags } = this.state;
      mobile_banner_type_paging["activePage"] = pageNumber;
      mobile_banner_type_paging["startIdx"] = ((pageNumber * Number(mobile_banner_type_paging["rowcnt"])) - mobile_banner_type_paging["rowcnt"]);
      this.setState({mobile_banner_type_paging : mobile_banner_type_paging});

      const selected_tag_list = [];
      for(const category in h_selected_tags){
          if(h_selected_tags.hasOwnProperty(category)){
              h_selected_tags[category].map((obj => {
                  selected_tag_list.push(obj)
              }));
          }
      }
      this.getBannerDesignTemplateUserFavoritePaging("07000", selected_tag_list);
  }  

  // 템플릿 필터 버튼 클릭
  handleTemplateFilterBtnClick = (upper_code_cd) => {
      this.setState({
          show_template_filter_popup_type: upper_code_cd,
          show_template_filter_popup: true,
      })
  }

  // 템플릿 필터 팝업 닫기(x) 버튼 클릭
  closeTemplateFilterPopupBtnClick = () => {
      this.resetTemplateFilterBtnClick("03000", "w");     // 템플릿 필터 초기화
      this.resetTemplateFilterBtnClick("07000", "h");     // 템플릿 필터 초기화
      this.setState({
          show_template_filter_popup: false,
      });
  }

  // 태그 버튼 클릭
  tagBtnClick = (category, tagCd, isSelected, upper_code_cd, template_type) => {
    if (this.state.dragging) {
        return false;
    }

    const selected_tag_list = [];

    this.setState((prevState) => {
        const updatedList = prevState[`${template_type}_template_all_tag_list`][category].map((tag) => {
            if (tag.tag_cd === tagCd) {
                return {
                    ...tag,
                    isSelected: isSelected,
                };
            }
            return tag;
        });

        const allSelected = this.checkAllSelected(category, updatedList);

        const updatedSelectedTags = {
            ...prevState[`${template_type}_selected_tags`],
            [category]: updatedList.filter((tag) => tag.isSelected).map((tag) => tag.tag_cd),
        };

        for(const category in updatedSelectedTags){
            if(updatedSelectedTags.hasOwnProperty(category)){
                updatedSelectedTags[category].map((obj => {
                    selected_tag_list.push(obj)
                }));
            }
        }
        // console.log(selected_tag_list)

        if(updatedSelectedTags == null || updatedSelectedTags == undefined || updatedSelectedTags.length == 0){
            return {
                [template_type + "_all_tag_selected"]: true,
            }
        }else{
            return {
                selected: prevState.selected !== tagCd ? tagCd : "",
                [template_type + "_template_all_tag_list"]: {
                    ...prevState[`${template_type}_template_all_tag_list`],
                    [category]: updatedList,
                },
                [template_type + "_selected_tags"]: updatedSelectedTags,
                [template_type + "_all_selected"]: {
                    ...prevState[`${template_type}_all_selected`],
                    [category]: allSelected,
                },
                [template_type + "_all_tag_selected"]: false,
            }
        }
    }, () => {
        if(template_type == "w"){
            this.setState({
                pc_banner_type_paging : {   // 페이징 초기화
                    activePage: 1,
                    totalCnt: 0,
                    startIdx: 0,
                    rowcnt:15,
                }
            }, () => {
                this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list);
            })
        }else {
            this.setState({
                mobile_banner_type_paging : {   // 페이징 초기화
                    activePage: 1,
                    totalCnt: 0,
                    startIdx: 0,
                    rowcnt:12,
                },
            }, () => {
                this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list);
            })
        }
    });
  }

  // 필터 팝업 내부 태그 버튼 클릭
  handleTagBtnClick = (category, tagCd, isSelected, template_type) => {
      this.setState((prevState) => {
          const updatedList = prevState[`${template_type}_template_all_tag_list`][category].map((tag) => {
              if (tag.tag_cd === tagCd) {
                  return {
                      ...tag,
                      isSelected: isSelected,
                  };
              }
              return tag;
          });

          const allSelected = this.checkAllSelected(category, updatedList);

          const updatedSelectedTags = {
              ...prevState[`${template_type}_selected_tags`],
              [category]: updatedList.filter((tag) => tag.isSelected).map((tag) => tag.tag_cd),
          };

          if(updatedSelectedTags == null || updatedSelectedTags == undefined || updatedSelectedTags.length == 0) {
              return {
                  [template_type + "_all_tag_selected"]: true,
              }
          }else{
              return {
                  [template_type + "_template_all_tag_list"]: {
                      ...prevState[`${template_type}_template_all_tag_list`],
                      [category]: updatedList,
                  },
                  [template_type + "_selected_tags"]: updatedSelectedTags,
                  [template_type + "_all_selected"]: {
                      ...prevState[`${template_type}_all_selected`],
                      [category]: allSelected,
                  },
                  [template_type + "_all_tag_selected"]: false,
              };
          }
      });
  };

  // 필터 팝업 밖 전체 태그 버튼 클릭
  allTagBtnClick = (upper_code_cd, template_type) => {
      this.setState((prevState) => ({
          [template_type + "_all_tag_selected"]: !prevState[`${template_type}_all_tag_selected`],
      }), () => {
          if(this.state[template_type + "_all_tag_selected"]){
              this.resetTemplateFilterBtnClick(upper_code_cd, template_type);
          }
      });
  }

  // 필터 팝업 내부 전체 태그 버튼 클릭
  handleAllTagBtnClick = (category, template_type) => {
      this.setState((prevState) => {
          const allSelected = !prevState[`${template_type}_all_selected`][category];

          const updatedList = prevState[`${template_type}_template_all_tag_list`][category].map((tag) => ({
              ...tag,
              isSelected: allSelected,
          }));

          const updatedSelectedTags = {
              ...prevState[`${template_type}_selected_tags`],
              [category]: allSelected ? updatedList.map((tag) => tag.tag_cd) : [],
          };

          return {
              [template_type + "_template_all_tag_list"]: {
                  ...prevState[`${template_type}_template_all_tag_list`],
                  [category]: updatedList,
              },
              [template_type + "_selected_tags"]: updatedSelectedTags,
              [template_type + "_all_selected"]: {
                  ...prevState[`${template_type}_all_selected`],
                  [category]: allSelected,
              },
          };
      });
  };

  checkAllSelected = (category, updatedList) => {
      return updatedList.every((tag) => tag.isSelected) && updatedList.length > 0;
  };

  // 템플릿 필터 팝업 초기화 버튼 클릭
  resetTemplateFilterBtnClick = (upper_code_cd, template_type) => {
      this.setState((prevState) => {
          const updatedTagLists = {};
          const updatedAllSelected = {};

          Object.keys(prevState[`${template_type}_template_all_tag_list`]).forEach((category) => {
              updatedTagLists[category] = prevState[`${template_type}_template_all_tag_list`][category].map((tag) => ({
                  ...tag,
                  isSelected: false,
              }));
              updatedAllSelected[category] = false;
          });

          return {
              [template_type + "_template_all_tag_list"]: {
                  ...prevState[`${template_type}_template_all_tag_list`],
                  ...updatedTagLists,
              },
              [template_type + "_all_selected"]: {
                  ...prevState[`${template_type}_all_selected`],
                  ...updatedAllSelected,
              },
              [template_type + "_selected_tags"]: {
                  bsn: [],
                  usg: [],
                  lyt: [],
                  sty: [],
              },
              [template_type + "_all_tag_selected"]: true,
          };
      }, () => {
          if(template_type == "w"){
              this.setState({
                  pc_banner_type_paging : {   // 페이징 초기화
                      activePage: 1,
                      totalCnt: 0,
                      startIdx: 0,
                      rowcnt:15,
                  }
              }, () => {
                  this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd);
              });

          }else {
              this.setState({
                  mobile_banner_type_paging : {   // 페이징 초기화
                      activePage: 1,
                      totalCnt: 0,
                      startIdx: 0,
                      rowcnt:12,
                  },
              }, () => {
                  this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd);
              });
          }
      });
  }

  // 템플릿 필터 팝업 적용 버튼 클릭
  applyTemplateFilterBtnClick = (upper_code_cd, template_type) => {
    const selected_tag_list = [];

    for(const category in this.state[template_type + "_selected_tags"]){
        if(this.state[template_type + "_selected_tags"].hasOwnProperty(category)){
            this.state[template_type + "_selected_tags"][category].map((obj => {
                selected_tag_list.push(obj)
            }));
        }
    }
    // console.log(selected_tag_list)

    if(template_type == "w"){
        this.setState({
            show_template_filter_popup: false,
            pc_banner_type_paging : {   // 페이징 초기화
                activePage: 1,
                totalCnt: 0,
                startIdx: 0,
                rowcnt:15,
            }
        }, () => {
            this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list);
        });

    }else {
        this.setState({
            show_template_filter_popup: false,
            mobile_banner_type_paging : {   // 페이징 초기화
                activePage: 1,
                totalCnt: 0,
                startIdx: 0,
                rowcnt:12,
            },
        }, () => {
            this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list);
        });
    }
}

  /** 누끼 작업중 화면 클릭 막기 */
  nukkiBlockPageClick(){
    if(this.state.w_essential_img_nukki_yn == "Y" || this.state.h_essential_img_nukki_yn == "Y"){
        $("#blockPageClick").show();
    }
  }

  // 이미지 크기 조절 초기화
  resetImgScale(type, idx) {
    this.setState({
        [type + "_img_" + idx + "_scale"] : 1,
    });
  }

  handleTxtScaleResetOnClick = (e, type1, type2, isNotTmp) => {
      if(e){e.stopPropagation()}
      isTmp = isNotTmp ? false : true;

      this.setState({
          [type1 + '_' + type2 + '_txt_scale'] : 1
      });
  }

  /* 텍스트 위치 이동 초기화 버튼 클릭 */
  moveTextPositionResetOnClick = (e, type1, type2, isNotTmp) => {
      isTmp = isNotTmp ? false : true;
      this.setState({
          [type1 + "_" + type2 + "_txt_position_left"] : 0,
          [type1 + "_" + type2 + "_txt_position_right"] : 0,
          [type1 + "_" + type2 + "_txt_position_top"] : 0,
          [type1 + "_" + type2 + "_txt_position_bottom"] : 0,
          [type1 + "_" + type2 + "_txt_position_x"] : 0,
          [type1 + "_" + type2 + "_txt_position_y"] : 0,
      });
  }

  /* 배너 템플릿 이미지 컬럼명의 _link값을 제외한 정보 추가 */
  addBannerDesignPositionText(obj){
      for(var i=0;i<obj.length;i++){
          obj[i]["position_name"] = obj[i].img_column_name.replace("_link","");
          obj[i]["youtube_position_name"] = "youtube"+obj[i].img_column_name.replace("_link","").replace("img","");
      }
      return obj;
  }

  editorToHtml = (editorState) => {
      let convertHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      convertHtml = convertHtml.replace(/<(\/)?[Pp](\/)?>/g,"");
      return convertHtml;
  }

  onMainEditorStateChange = (mainEditorState) => {
    const currentContentState = this.state.mainEditorState.getCurrentContent();
    const newContentState = mainEditorState.getCurrentContent();

    this.setState({
        mainEditorState: mainEditorState,
        auto_title: this.editorToHtml(mainEditorState),
        title: this.editorToHtml(mainEditorState),
        org_title: this.editorToHtml(mainEditorState),
        template_sample_user_text_changed: true,

    }, () => {
        if(currentContentState !== newContentState) {
            this.checkKeydown(this);
        }
    });
  }

  onSubEditorStateChange = (subEditorState) => {
    const currentContentState = this.state.subEditorState.getCurrentContent();
    const newContentState = subEditorState.getCurrentContent();

    this.setState({
        subEditorState: subEditorState,
        sub_title: this.editorToHtml(subEditorState),
        foreign_title: this.editorToHtml(subEditorState),
        sentence: this.editorToHtml(subEditorState),
        eng_sentence: this.editorToHtml(subEditorState),
        template_sample_user_text_changed: true,

    }, () => {
        if(currentContentState !== newContentState) {
            this.checkKeydown(this);
        }
    });
  }

  checkKeydown = function(thisComponent){
    clearTimeout(keydownTimeout);
    keydownTimeout = setTimeout(function(){
        thisComponent.insertEventTmp('preview');
    }, 1000);
  }

  updateFontList = (font_family_list) => {
    font_family_list = [...new Set(font_family_list)];
    this.setState({font_family_list: font_family_list});
  }

  /* 이미지가 존재하는지 체크 (상품 이미지 or 업로드 or 링크) */
  positionImgCheck(type, idx, nonNukkiStateCheck){
      const link_type = this.state[type+"_user_img_list"][idx].link_type; // 49001: 파일 업로드, 49002: 이미지 주소, 49003: 상세페이지, 49004: 로보이미지, 49005: 동영상 주소
      let upload_img = this.state[type+"_user_img_list"][idx].img_link; // link_type에 맞는 이미지

    //   console.log('positionImgCheck', type, idx, nonNukkiStateCheck, link_type, upload_img);
      if (!upload_img) {
          return false;
      }

      if(!nonNukkiStateCheck && (link_type == "49002" || link_type == "49004") && upload_img && !this.state[type+"_user_img_list"][idx].img_link_able){
          return false;
      }
      // 상품 이미지 또는 자동 생성시 들어간 상품 두번째 이미지 등
      let link = this.state[(type == "h" ? "h_" : "") + this.state[type+"_img_position_name"][idx].img_column_name];
      if(this.state[type+"_img"+(Number(idx)+1)+"_is_use"] == "Y"){
          switch (link_type){
              case "49002":
              case "49004":
                  return (upload_img && (this.state[type+"_user_img_list"][idx].img_link_able || nonNukkiStateCheck)) ? upload_img : link;
              case "49005":
                  if(this.state[type+"_is_youtube_link_use"] == "Y"){
                      return false;
                  } else{
                      upload_img = link;
                  }
              default : // 49001, 49003, 49004 등..
              return upload_img ? upload_img : link;
          }
      }
  }

  /* 링크 타입 관련 이미지가 존재하는지 체크 (업로드 or 링크) */
  positionLinkTypeImgCheck(type, idx){
      const link_type = this.state[type+"_user_img_list"][idx].link_type;
      const upload_img = this.state[type+"_user_img_list"][idx].img_link;

      // position 정보가 없다면 체크 불가능
      if(this.state[type+"_img_position_name"].length == 0){
          return false;
      }

      switch (link_type){
          case "49002":
          case "49004":
              return (upload_img && this.state[type+"_user_img_list"][idx].img_link_able) ? upload_img : false;
          case "49005":
              return false;
          default : // 49001, 49003, 49004 등..
              return upload_img ? upload_img : false;
      }
  }

  // 이미지 링크로 배경 제거
  removeBackgroundLinkImg = (img_path, ppm) => {
      http.get("/rest/removeBackground?img_path="+img_path+"&ppm_yn="+ppm)
      .then(res => {
          console.log(res.data);
          
      })
  }

/* ========== 드래그 스크롤 ========== */
handleDrag = ({ scrollContainer }) => (ev) => {
  if (scrollContainer && scrollContainer.current) {
    this.scrollContainerRef = scrollContainer.current; // 한 번만 기억
  }

  this.handleDragMove(ev, (posDiff) => {
      if (scrollContainer && scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
      }
  });
};

handleMouseOnWheel = (apiObj, ev) => {
    const isTouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isTouchpad) {
        ev.stopPropagation();
        return;
    }

    if (ev.deltaY < 0) {
        apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
        apiObj.scrollPrev();
    }
};

handleDragStart = (ev) => {
    // console.log("handleDragStart");
    this.setState({
        position: ev.clientX,
        clicked: true,
    });

    // 드래그 시작 시 전역 리스너 등록
    window.addEventListener("mousemove", this.handleWindowMouseMove);
    window.addEventListener("mouseup", this.handleWindowMouseUp);
};

handleDragStop = () => {
    // console.log("handleDragStop");
    window.requestAnimationFrame(() => {
        this.setState({
            dragging: false,
            clicked: false,
        });
    });

    // 드래그 종료 시 전역 리스너 제거
    window.removeEventListener("mousemove", this.handleWindowMouseMove);
    window.removeEventListener("mouseup", this.handleWindowMouseUp);
};

handleDragMove = (ev, cb) => {
    const newDiff = this.state.position - ev.clientX;
    const movedEnough = Math.abs(newDiff) > 5;

    if (this.state.clicked && movedEnough) {
        this.setState({
            dragging: true,
        });
    }

    if (this.state.dragging && movedEnough) {
        this.setState(
            {
                position: ev.clientX,
            },
            () => cb(newDiff)
        );
    }
};

handleWindowMouseMove = (ev) => {
  // console.log("handleWindowMouseMove", ev);
  this.handleDragMove(ev, (posDiff) => {
    if (this.scrollContainerRef) {
      this.scrollContainerRef.scrollLeft += posDiff;
    }
  });
};

handleWindowMouseUp = (ev) => {
  this.handleDragStop();
};

checkImgFileExtension = (file) => {
    let reg = /(.*?)\.(jpg|jpeg|png|gif|bmp|svg)$/i;

    if(String(file.name).match(reg)) {
        return true;
    }else{
        return false;
    }
}

uploadCallback = (file) => {
    return new Promise(
        (resolve, reject) => {
            if(!this.checkImgFileExtension(file)){
                alert("이미지 파일만 첨부할 수 있습니다.");
                resolve();
                return;
            }

            const formData = new FormData();
            formData.append('files', file);

            axios({
                url: '/rest/shop/roboBanner/save/orgImg',
                method: 'POST',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(response => {
                    resolve({ data: { link: response.data.org_img_path_uri_encode } });
                })
                .catch(error => {
                    console.error(error);
                });
        }
    );
  }

  /**
   * 이미지 링크가 사용 가능한 링크인지 확인 : onload, onerror 작업이 끝난 후 action 함수 실행
   * @param {*} link 이미지 링크
   * @function loadAction 이미지 링크가 로드되었을때 실행할 함수
   * @function errorAction 이미지 링크가 에러떴을때 실행할 함수
   */
  checkImgLinkUseAble = (link, loadAction, errorAction) => {
      var img = new Image();
      img.src = link;
      if(loadAction){
          img.onload = () => { // 링크 상태 유효함
              loadAction();
          };
      }
      if(errorAction){
          img.onerror = () => {
              errorAction();
          };
      }
  }

  onChangeTitle = (e, name) => {
    let text_value = e.target.value.replace("font-size: 15px;", "");
    const checkInputTimer = function(this_component, value){
        // title_input_timer 동작을 취소한다 (시간이 100 만큼 지나기 전에 입력이 또 있었다면, 이전의 timeout동작은 실행되지 않을것이다)
        clearTimeout(title_input_timer[value]);
        title_input_timer[value] = setTimeout(() => {
            // 미리보기 데이터 저장
            this_component.insertEventTmp('preview');
        },500);
    };

    if (name == "none_title") {
        this.setState({none_title: e.target.value});
    } else if (name == "auto_title") {
        this.setState({[name]: e.target.value,
                        title: e.target.value,
                        org_title: e.target.value,
                        template_sample_user_text_changed: true
                    }, () =>{checkInputTimer(this, name)});
    } else {
        this.setState({[name]: text_value,
            foreign_title: text_value,
            sentence: text_value,
            eng_sentence: text_value,
            template_sample_user_text_changed: true,
        }, () =>{checkInputTimer(this, name)});
    }
    // this.getTextLength (name+"_length", e.target.value);
  }

  // ContentEditable 붙여넣기 시 외부 HTML/CSS 스타일 제거
  escapeContentEditablePasteHtml = (value = "") => {
      return String(value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
  }

  convertPlainTextPasteToHtml = (value = "") => {
      return this.escapeContentEditablePasteHtml(value)
          .replace(/\r\n/g, "\n")
          .replace(/\r/g, "\n")
          .replace(/\n/g, "<br>");
  }

  handleContentEditablePaste = (e, name) => {
      e.preventDefault();

      const clipboardData = e.clipboardData || window.clipboardData;
      if (!clipboardData) {
          return;
      }

      const plainText = clipboardData.getData("text/plain");
      const pasteHtml = this.convertPlainTextPasteToHtml(plainText);
      const markerId = "paste_marker_" + Date.now() + "_" + Math.random().toString(36).substring(2);
      const startMarkerId = markerId + "_start";
      const endMarkerId = markerId + "_end";

      // 외부 HTML/CSS는 버리고, 텍스트와 줄바꿈만 삽입
      document.execCommand(
          "insertHTML",
          false,
          '<span id="' + startMarkerId + '"></span>' + pasteHtml + '<span id="' + endMarkerId + '"></span>'
      );

      const startMarker = document.getElementById(startMarkerId);
      const endMarker = document.getElementById(endMarkerId);
      const selection = window.getSelection();

      if (startMarker && endMarker && selection) {
          const pastedRange = document.createRange();
          pastedRange.setStartAfter(startMarker);
          pastedRange.setEndBefore(endMarker);

          selection.removeAllRanges();
          selection.addRange(pastedRange);

          // 현재 커서 위치 주변의 font/span 스타일을 물려받는 경우까지 제거
          document.execCommand("removeFormat", false, null);

          const afterPasteRange = document.createRange();
          afterPasteRange.setStartAfter(endMarker);
          afterPasteRange.collapse(true);

          selection.removeAllRanges();
          selection.addRange(afterPasteRange);

          startMarker.remove();
          endMarker.remove();
      }

      this.onChangeTitle({
          target: {
              value: e.currentTarget.innerHTML,
          },
      }, name);
  }

  handleTitleBlur = e => {
      // console.log(e);
      // 자동배너 수정 - 배너제목
      // ReactGA.event({
      //     category: "자동배너 수정",
      //     action: (e.target.id == "foreign_title" ? "(영문)" : "") + "배너제목 : " + e.target.value,
      //     label: ga_label
      // });
  };

  /* ========== 공통 유틸 ========== */

  getUrlParams() {
    var params = {};
    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
    return params;
  }

  getSelectedImage = () => {
    const { images, selectedImageIndex } = this.state;
    return images.find((img) => img.index === selectedImageIndex) || null;
  };

  updateImageByIndex = (index, updater) => {
    this.setState((prev) => ({
      images: prev.images.map((img) =>
        img.index === index ? { ...img, ...updater(img) } : img
      ),
    }));
  };

  /* ========== 모달/패널/탭 ========== */

  openTemplateEditor = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    if (this.props.onClose != null) {
      this.props.onClose();
    }
    else {
      this.setState({ isModalOpen: false, mobileTemplatePopupOpen: false });
    }
  };

  toggleTemplatePanel = () => {
    this.setState((prev) => ({
      isTemplatePanelCollapsed: !prev.isTemplatePanelCollapsed,
    }));
  };

  toggleHistoryPanel = () => {
    this.setState((prev) => ({
        isHistoryPanelCollapsed: !prev.isHistoryPanelCollapsed,
    }));
  };

  switchTab = (tab) => {
    this.setState({ currentTab: tab });
  };

  /* ========== 모바일 템플릿 팝업 ========== */

  openMobileTemplatePopup = () => {
    this.setState({ mobileTemplatePopupOpen: true });
  };

  closeMobileTemplatePopup = () => {
    this.setState({ mobileTemplatePopupOpen: false });
  };

  selectMobileTemplate = (type) => {
    this.applyTemplateLayout(type);
    this.setState({ mobileTemplatePopupOpen: false });
  };

  /* ========== 템플릿 레이아웃 ========== */

  applyTemplateLayout = (type) => {
    let images = [];
    if (type === "single") {
      images = [
        { index: 1, src: null, x: 10, y: 10, w: 80, h: 60, unit: "percent" },
      ];
    } else if (type === "double") {
      images = [
        { index: 1, src: null, x: 5, y: 5, w: 42, h: 60, unit: "percent" },
        { index: 2, src: null, x: 53, y: 5, w: 42, h: 60, unit: "percent" },
      ];
    } else if (type === "triple") {
      images = [
        { index: 1, src: null, x: 5, y: 5, w: 90, h: 40, unit: "percent" },
        { index: 2, src: null, x: 5, y: 50, w: 42, h: 30, unit: "percent" },
        { index: 3, src: null, x: 53, y: 50, w: 42, h: 30, unit: "percent" },
      ];
    } else if (type === "grid") {
      images = [
        { index: 1, src: null, x: 5, y: 5, w: 42, h: 42, unit: "percent" },
        { index: 2, src: null, x: 53, y: 5, w: 42, h: 42, unit: "percent" },
        { index: 3, src: null, x: 5, y: 53, w: 42, h: 42, unit: "percent" },
        { index: 4, src: null, x: 53, y: 53, w: 42, h: 42, unit: "percent" },
      ];
    }

    this.setState({
      selectedTemplateType: type,
      images,
      selectedImageIndex: images[0]?.index || 1,
    });
  };

  selectTemplateCard = (type) => {
    this.applyTemplateLayout(type);
  };

  /* ========== 업로드 팝업 & 이미지 업로드 ========== */

  showUploadPopup = (index) => {
    this.setState({
      isUploadPopupOpen: true,
      currentUploadIndex: index,
      selectedImageIndex: index,
    });
  };

  closeUploadPopup = () => {
    this.setState({ isUploadPopupOpen: false });
  };

  // uploadOption = (type) => {
  //   if (type === "file") {
  //     // 임시 input 생성
  //     const input = document.createElement("input");
  //     input.type = "file";
  //     input.accept = "image/*";
  //     input.onchange = (e) => {
  //       const file = e.target.files[0];
  //       if (!file) return;
  //       const reader = new FileReader();
  //       reader.onload = (ev) => {
  //         const src = ev.target.result;
  //         const idx = this.state.currentUploadIndex;
  //         this.updateImageByIndex(idx, () => ({ src }));
  //       };
  //       reader.readAsDataURL(file);
  //     };
  //     input.click();
  //   } else if (type === "product") {
  //     alert("상품 이미지 선택 기능 (추후 구현)");
  //   } else if (type === "crop") {
  //     alert("상세페이지 자르기 기능 (추후 구현)");
  //   } else if (type === "ai") {
  //     const prompt = window.prompt("AI 이미지 생성 프롬프트를 입력하세요:");
  //     if (prompt) {
  //       alert("AI 이미지 생성 중... (실제 연동 필요)");
  //     }
  //   }

  //   this.closeUploadPopup();
  // };

  uploadOption = (type) => {
    // 필요하면 state에 넣어둔 업로드 타입(w/h)을 쓰세요.
    // (없으면 기본 w로 처리)
    const bannerType = Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ? "w" : "h";
    const idx = (this.state.currentUploadIndex - 1); 

    if (type === "file") {
      // Object.keys(this.state.selected_pc_banner_ratio ?? {}).length

      const link_type = "49001"; // 파일 업로드

      // 임시 input 생성 (label+input 방식과 동일하게 동작시키기)
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.multiple = false;

      // 화면에 보이지 않도록 설정
      input.style.position = "fixed";
      input.style.left = "-9999px";
      input.style.width = "1px";
      input.style.height = "1px";
      input.style.opacity = "0";

      // 같은 파일을 다시 선택해도 change가 타도록(기존 value="" 역할)
      input.value = "";

      input.onchange = (e) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        // 기존 기능과 동일: 누끼 작업중 클릭 막기
        // this.nukkiBlockPageClick();

        // 기존 기능과 동일: 확장자 체크 + 업로드 프리뷰/다이얼로그 + _handleSubmit 호출
        // attachImage는 FileList를 받으므로 그대로 넘기면 됩니다.
        this.attachImage(files, idx, bannerType, link_type);

        // cleanup
        input.remove();
      };

      document.body.appendChild(input);
      input.click();

      // 기존 uploadOption 동작 유지: 옵션 선택 후 팝업 닫기
      this.closeUploadPopup();
      return;
    }

    else if (type === "url") {
      this.closeUploadPopup();
      const link_type = "49002"; // 이미지 주소
      this.openImgLinkUrlPopup(bannerType, idx, link_type);

    }

    else if (type === "product") {
      this.setState({ show_add_product_popup: true,  }, () => {
        this.closeUploadPopup();
      });
    }
    else if (type === "crop") {
      this.setState({
          select_detail_crop_img_popup_show: true,
      });
    }
    else if (type === "ai") {
      this.setState({
          show_robo_img_popup: true,
      });
   }
   else if (type === "youtube") {
      this.setState({
          showUploadYoutubeLinkPopup: true,
      });
   }

    this.closeUploadPopup();
  };

  /**
   * 업로드된 이미지 Preview
   * @param {*} acceptedFiles 파일정보
   * @param {*} idx 배너 이미지 순서 번호
   * @param {*} type w or h
   * @param {*} link_type 49001(파일 업로드) or 49003(상세 이미지)
   */
  attachImage(acceptedFiles, idx, type, link_type) {
    if (acceptedFiles) {

        if(!this.checkFileExtension(acceptedFiles)){
            alert("이미지 파일만 첨부할 수 있습니다.");
            return;
        }

        /* Get files in array form */
        const files = Array.from(acceptedFiles);
        //const { getRootProps, getInputProps, isDragActive } = useDropzone({ files });
        /* Map each file to a promise that resolves to an array of image URI's */ 
        Promise.all(files.map(file => {
            return (new Promise((resolve,reject) => {
                const reader = new FileReader();
                reader.addEventListener('load', (ev) => {
                    resolve(ev.target.result);
                });
                reader.addEventListener('error', reject);
                reader.readAsDataURL(file);
            }));
        }))
        .then(images => {
            /* Once all promises are resolved, update state with image URI array */
            console.log(images);
            console.log(files);

            this.setState({
                save_dialog_show_state: true,
                save_dialog_content: "이미지 업로드중 입니다.",
                save_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        display_yn:"N",
                    }
                ]
            }, () => {
                $("#blockPageClick").hide();
            });

            this._handleSubmit(idx, type, files[0], link_type);
        }, error => {        
            console.error(error);
            this.setState({ save_dialog_show_state: false });
        });
    }
  }

  checkFileExtension = (file) => {
    let reg = /(.*?)\.(jpg|jpeg|png|gif|bmp)$/i;

    if(String(file[0].name).match(reg)) {
        return true;
    }else{
        return false;
    }
  }

  // 이미지 업로드 팝업 : 저장 이벤트
  _handleSubmit = (idx, type, file, link_type) => {
      const config = {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }
      let url = '/rest/shop/roboBanner/save/orgImg';
      if (link_type == "49003") {
          url = '/rest/shop/roboBanner/save/nooResizeOrgImg'
      }
      const formData = new FormData();
      formData.append("files", file);
      // forEach((file) => formData.append("files", file));
      
      http.post(url, formData, config)
      .then(
          res => {
              // 조회
              this.searchOrgImg(res.data.robo_banner_org_img_seq, idx, type, null, link_type);
          })
      .catch(
          error => {
              alert(error+"\n관리자에게 문의해 주세요.");
              this.setState({ save_dialog_show_state: false });
          }
      );
  };

  /**
   * 
   * @param {*} robo_banner_org_img_seq 이미지 seq
   * @param {*} idx 배너 이미지 순서 번호
   * @param {*} type w or h
   * @param {*} non_nukki_action 누끼를 따지 않는 경우(화면 로드시 기존 이미지 조회때 사용)
   * @param {*} link_type 49001(파일 업로드) or 49003(상세 이미지)
   */
  searchOrgImg(robo_banner_org_img_seq, idx, type, non_nukki_action, link_type) {
      if(link_type != "49003"){
          $(".mirror_banner_v2_pc_banner_area").css({opacity : "0"});
          $(".mirror_banner_v2_mobile_banner_area").css({opacity : "0"});
      }

      http.get("/rest/shop/roboBanner/search/orgImg?robo_banner_org_img_seq="+robo_banner_org_img_seq+"&user_seq="+this.state.user_seq)
      .then(res => {
                  let upload_img = res.data["list"][0];

                  let user_img_list = this.state[type+"_user_img_list"];
                  user_img_list[idx].org_img_seq = upload_img.robo_banner_org_img_seq;
                  user_img_list[idx].org_img_name = upload_img.org_img_name;
                  user_img_list[idx].img_link = upload_img.org_img_path;
                  user_img_list[idx].video_link = "";
                  if(!non_nukki_action){
                      user_img_list[idx].link_type = link_type;
                  }

                  this.setState({
                      [type+"_user_img_list"] : user_img_list,
                  }, () => {
                      if(non_nukki_action){
                          this.setState({ save_dialog_show_state: false });
                          $(".mirror_banner_v2_pc_banner_area").css({opacity : "1"});
                          $(".mirror_banner_v2_mobile_banner_area").css({opacity : "1"});
                      } else{
                          this.eventChangeOneProductImageOfNukki(type, idx);
                      }
                  });
      })
      .catch(error => {
          alert(error+"\n관리자에게 문의해 주세요.");

          this.setState({ save_dialog_show_state: false });
          $(".mirror_banner_v2_pc_banner_area").css({opacity : "1"});
          $(".mirror_banner_v2_mobile_banner_area").css({opacity : "1"});
      });
  }

  onClickAddProductbtn(selected_product_list){
    const idx = (this.state.currentUploadIndex - 1); 
    const bannerType = Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ? "w" : "h";
    const link_type = "49006"; // 49001: 파일 업로드, 49002: 이미지 주소, 49003: 상세페이지, 49004: 로보이미지, 49005: 동영상 주소

    let user_img_list = this.state[bannerType+"_user_img_list"];
    user_img_list[idx].img_link = selected_product_list[0].image_url;
    user_img_list[idx].video_link = "";
    // if(!non_nukki_action){
        user_img_list[idx].link_type = link_type;
    // }

    const product_no = selected_product_list[0].product_no;

    this.setState({
        show_add_product_popup:false,
        [bannerType+"_user_img_list"] : user_img_list,
        product_no,
    }, () => {
        // if(non_nukki_action){
        //     this.setState({ save_dialog_show_state: false });
        //     $(".mirror_banner_v2_pc_banner_area").css({opacity : "1"});
        //     $(".mirror_banner_v2_mobile_banner_area").css({opacity : "1"});
        // } else{
            this.eventChangeOneProductImageOfNukki(bannerType, idx);
        // }
    });
  }

  /** 상품 이미지가 하나가 수정되는 경우 이벤트(누끼 관련 설정)
   *  1. 이미지 업로드/링크 변경
   *  2. 업로드/링크 이미지 x 버튼 클릭
  */
  eventChangeOneProductImageOfNukki(type, idx){
      let user_img_list = this.state[type+"_user_img_list"];

      user_img_list[idx].img_link_able = true;

      // version 3의 경우 ppm Y 상태가 없다
      user_img_list[idx]["img_ppm_N_crop_N_version_1"] = "";
      user_img_list[idx]["img_ppm_N_crop_N_version_2"] = "";
      user_img_list[idx]["img_ppm_N_crop_N_version_3"] = "";

      user_img_list[idx]["img_ppm_N_crop_Y_version_1"] = "";
      user_img_list[idx]["img_ppm_N_crop_Y_version_2"] = "";
      user_img_list[idx]["img_ppm_N_crop_Y_version_3"] = "";

      user_img_list[idx]["img_ppm_Y_crop_N_version_1"] = "";
      user_img_list[idx]["img_ppm_Y_crop_N_version_2"] = "";
      user_img_list[idx]["img_ppm_Y_crop_N_version_3"] = "";
      
      user_img_list[idx]["img_ppm_Y_crop_Y_version_1"] = "";
      user_img_list[idx]["img_ppm_Y_crop_Y_version_2"] = "";
      user_img_list[idx]["img_ppm_Y_crop_Y_version_3"] = "";

      // 상세이미지를 쓰지 않는 경우, 상세이미지 데이터를 초기화한다
      let crop_img_info_list = this.state[type+"_crop_img_info_list"];
      if(!(user_img_list[idx].link_type == "49003" && user_img_list[idx].img_link)){
          crop_img_info_list[idx] = {};
      }

      // AI 얼굴 위치 자동 이동을 실행한 경우 위치이동 초기화
      if(this.state[type+"_img_"+(idx+1)+"_auto_move_yn"]=="Y"){
          this.setState({
              [type+"_img_"+(idx+1)+"_auto_move_yn"] : "N",
              [type+"_img_"+(idx+1)+"_scale"] : 1,
              [type+"_img_position_left_"+(idx+1)] : 0,
              [type+"_img_position_right_"+(idx+1)] : 0,
              [type+"_img_position_top_"+(idx+1)] : 0,
              [type+"_img_position_bottom_"+(idx+1)] : 0,
          });
      }

      this.setState({
          select_detail_img_type_popup_show : false, // 이미지 업로드 팝업 닫기
          [type+"_user_img_list"] : user_img_list,
          [type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn"] : "N",
          [type+"_crop_img_info_list"] : crop_img_info_list,
          ...(user_img_list[idx].img_link ? this.getUserImageChangedStatePatch(type, idx) : this.getTemplateImageClearStatePatch(type, idx)),
      }, () => {
          let change_N_list = [];
          let nukki_info_Y_list = [];
          if(this.state[type+"_essential_img_nukki_yn"] == "Y" && !this.state[type+"_non_nukki_state"][idx] && this.positionImgCheck(type, idx)){
              nukki_info_Y_list.push({
                  type : type,
                  position : idx+1,
                  action : "Y",
              });
          }
          change_N_list.push({
              key : type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn",
              value : "N"
          });
          change_N_list.push({
              key : type+"_nukki_"+this.state[type+"_img_position_name"][idx].position_name+"_link",
              value : ""
          });
  
          const nukki_info = {
              type : type,
              change_N_list : change_N_list,
              nukki_info_Y_list : nukki_info_Y_list,
          };

          this.insertEventTmp('preview', nukki_info);
      });
  }

  handleSelectCarouselImage = (index) => {
    this.setState({ selectedImageIndex: index });
  };

  addNewImage = () => {
    this.setState((prev) => {
      const nextIndex =
        prev.images.length === 0
          ? 1
          : Math.max(...prev.images.map((i) => i.index)) + 1;
      const newImage = {
        index: nextIndex,
        src: null,
        x: 10,
        y: 10,
        w: 80,
        h: 60,
        unit: "percent",
      };
      return {
        images: [...prev.images, newImage],
        selectedImageIndex: nextIndex,
      };
    });
  };

  /* ========== 이미지 위치/사이즈 ========== */

  setUnit = (unit) => {
    this.setState({ currentUnit: unit });
  };

  moveImage = (direction) => {
    const { currentUnit, selectedImageIndex } = this.state;
    const step = currentUnit === "percent" ? 5 : 20;

    this.updateImageByIndex(selectedImageIndex, (img) => {
      let x = img.x;
      let y = img.y;

      if (direction === "left") x -= step;
      if (direction === "right") x += step;
      if (direction === "up") y -= step;
      if (direction === "down") y += step;

      return { x, y, unit: currentUnit };
    });
  };

  handleImagePosChange = (field, value) => {
    const num = parseInt(value, 10) || 0;
    const { selectedImageIndex, currentUnit } = this.state;
    this.updateImageByIndex(selectedImageIndex, (img) => {
      const next = { ...img, unit: currentUnit };
      if (field === "x") next.x = num;
      if (field === "y") next.y = num;
      if (field === "w") next.w = num;
      if (field === "h") next.h = num;
      return next;
    });
  };

  /* 이미지 링크 입력 팝업 열기 */
  openImgLinkUrlPopup(type, idx, link_type){
      this.setState({
          input_dialog_show_state: true,
          input_dialog_title: "배너에 사용될 이미지 주소를 입력해주세요.",
          input_dialog_content: "",
          input_dialog_input_value: this.state[`${type}_user_img_list`][idx].link_type == "49002" && this.state[`${type}_user_img_list`][idx].img_link,
          input_dialog_input_placeholder : "",
          input_dialog_button_list: [
              {
                  title: "적용",
                  type: "1",
                  event_method: (e) => {
                      $("#blockPageClick").show();
                      this.setState({input_dialog_show_state: false});

                      const link = e.target.value.replaceAll("&quot;","").replaceAll("&quot","");

                      this.checkImgLinkUseAble(link,
                          () => {
                              this.onChangeImgLinkUrl(type, idx, link, link_type);
                          },
                          () => {
                              alert("허용하지 않는 이미지 주소입니다.");
                              $("#blockPageClick").hide();
                          }
                      );
                  }
              },
              {
                  title: "취소",
                  type: "0",
                  event_method: () => {
                      this.setState({input_dialog_show_state: false});
                  }
              }
          ]
      });
  }

  /* 링크 입력형 이미지 주소 입력 */
  onChangeImgLinkUrl(type, idx, link, link_type){
      let user_img_list = this.state[type+"_user_img_list"];
      // 이전과 같은 이미지 링크를 입력한 경우
      if(link == user_img_list[idx].img_link){
          // 이미지 업로드 팝업 닫기
          $("#blockPageClick").hide();
          return false;
      }
      // 입력된 이미지 주소 적용
      user_img_list[idx].link_type = link_type;
      user_img_list[idx].img_link = link;
      user_img_list[idx].org_img_name = link;
      user_img_list[idx].org_img_seq = "";
      user_img_list[idx].video_link = "";

      this.setState({
          [type+"_user_img_list"] : user_img_list,
      }, () => {
          this.eventChangeOneProductImageOfNukki(type, idx);
      });
  }

  /* ========== 텍스트 관련 ========== */

  updateMainText = (e) => {
    this.setState({ mainText: e.target.value });
  };

  getAIText = (type) => {
    const target = type === 'sub' ? 'sub' : 'main';
    this.setState({
      isCopywriterModalOpen: true,
      copywriterApplyTarget: target,
    });
  };

  closeCopywriterModal = () => {
    this.setState({
      isCopywriterModalOpen: false,
      copywriterApplyTarget: '',
    });
  };

  stripHtmlToPlainText = (value = '') => {
    const div = document.createElement('div');
    div.innerHTML = String(value || '')
      .replace(/<br\s*\/?>(?!$)/gi, '\n')
      .replace(/<\/p>/gi, '\n');
    return String(div.textContent || div.innerText || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  };

  getCopywriterInitialCommand = () => {
    const target = this.state.copywriterApplyTarget;
    const mainText = this.stripHtmlToPlainText(this.state.title);
    const subText = this.stripHtmlToPlainText(this.state.sub_title);

    if (target === 'sub') {
      const contextList = [];
      if (mainText) contextList.push(`메인 텍스트: ${mainText}`);
      if (subText) contextList.push(`현재 서브 텍스트: ${subText}`);
      return contextList.length > 0
        ? `현재 디자인 문구를 참고해서 더 좋은 서브 텍스트를 만들어줘.\n${contextList.join('\n')}`
        : '';
    }

    return mainText
      ? `현재 메인 텍스트를 참고해서 더 좋은 메인 텍스트를 만들어줘.\n현재 메인 텍스트: ${mainText}`
      : '';
  };

  getCopywriterGenerationInstruction = () => {
    if (this.state.copywriterApplyTarget === 'sub') {
      return [
        '인스타그램 디자인 이미지 안에 들어갈 서브 텍스트 후보를 작성한다.',
        '완성형 피드 본문이 아니라 메인 텍스트를 보완하는 짧은 보조 문구여야 한다.',
        '각 추천 문구는 1~2줄로 작성하고, 한 줄이 지나치게 길지 않게 한다.',
        '해시태그, 긴 설명, 문단형 본문, 불필요한 인사말은 제외한다.',
      ].join('\n');
    }

    return [
      '인스타그램 디자인 이미지 안에 들어갈 메인 텍스트 후보를 작성한다.',
      '완성형 피드 본문이 아니라 시선을 끄는 짧은 헤드라인이어야 한다.',
      '각 추천 문구는 1~2줄로 작성하고, 핵심 메시지를 간결하게 전달한다.',
      '해시태그, 긴 설명, 문단형 본문, 불필요한 인사말은 제외한다.',
    ].join('\n');
  };

  getCopywriterGenerationContext = () => {
    const bannerType = Object.keys(this.state.selected_pc_banner_ratio || {}).length ? 'w' : 'h';
    const imageList = (this.state[`${bannerType}_user_img_list`] || [])
      .map((item) => item && item.img_link)
      .filter(Boolean);

    const productNameList = [
      this.state.product_name,
      ...(this.state.select_item_list || []).map((item) =>
        item && (item.product_name || item.product_name_ko || item.item_name || item.name)
      ),
    ].filter(Boolean);

    return {
      product_name_list: Array.from(new Set(productNameList.map((item) => String(item).trim()).filter(Boolean))),
      image_list: Array.from(new Set(imageList.map((item) => String(item).trim()).filter(Boolean))),
    };
  };

  applyCopywriterText = async (mergedText) => {
    const target = this.state.copywriterApplyTarget;
    const plainText = String(mergedText || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim();

    if (!target || !plainText) {
      return false;
    }

    const htmlText = this.convertPlainTextPasteToHtml(plainText);
    const contentState = ContentState.createFromText(plainText);

    if (target === 'sub') {
      this.setState({
        subText: plainText,
        sub_title: htmlText,
        foreign_title: htmlText,
        sentence: htmlText,
        eng_sentence: htmlText,
        subEditorState: EditorState.createWithContent(contentState),
        template_sample_user_text_changed: true,
      }, () => {
        this.insertEventTmp('preview', null, true);
      });
      return true;
    }

    this.setState({
      mainText: plainText,
      auto_title: htmlText,
      title: htmlText,
      org_title: htmlText,
      mainEditorState: EditorState.createWithContent(contentState),
      template_sample_user_text_changed: true,
    }, () => {
      this.insertEventTmp('preview', null, true);
    });
    return true;
  };

  changeFont = (type, font) => {
    if (type === "main") {
      this.setState({ mainFontFamily: font });
    } else {
      this.setState({ subFontFamily: font });
    }
  };

  toggleStyle = (type, style) => {
    const keyMap = {
      main: {
        bold: "mainBold",
        italic: "mainItalic",
        underline: "mainUnderline",
      },
      sub: {
        bold: "subBold",
        italic: "subItalic",
        underline: "subUnderline",
      },
    };
    const key = keyMap[type][style];
    this.setState((prev) => ({ [key]: !prev[key] }));
  };

  resizeText = (type, value) => {
    const num = parseInt(value, 10) || 100;
    if (type === "main") {
      this.setState({ mainSizePercent: num });
    } else {
      this.setState({ subSizePercent: num });
    }
  };

  updateTextColor = (type, color) => {
    if (type === "main") {
      this.setState({ mainColor: color });
    } else {
      this.setState({ subColor: color });
    }
  };

  setTextUnit = (unit) => {
    this.setState({ textUnitMode: unit });
  };

  moveTextElement = (type, direction) => {
    const { textUnitMode } = this.state;
    const step = textUnitMode === "percent" ? 5 : 20;

    this.setState((prev) => {
      const target = type === "main" ? prev.mainPos : prev.subPos;
      let { x, y } = target;

      if (direction === "left") x -= step;
      if (direction === "right") x += step;
      if (direction === "up") y -= step;
      if (direction === "down") y += step;

      x = Math.max(0, Math.min(x, 100));
      y = Math.max(0, Math.min(y, 100));

      const next = { ...target, x, y };
      return type === "main" ? { mainPos: next } : { subPos: next };
    });
  };

  updateTextPositionField = (type, field, value) => {
    const num = parseInt(value, 10) || 0;
    this.setState((prev) => {
      const target = type === "main" ? prev.mainPos : prev.subPos;
      const next = { ...target };
      if (field === "x") next.x = num;
      if (field === "y") next.y = num;
      if (field === "w") next.w = num;
      if (field === "h") next.h = num;
      return type === "main" ? { mainPos: next } : { subPos: next };
    });
  };

  /* ========== 컬러 / AI 색상 추출 ========== */

  updateTemplateColor = (kind, color, complete) => {
    if(complete){
      isTmp = true;
    }
    
    if (kind == "1") {
      // this.setState({ canvasBgColor: color });
       this.setState({ 
            // background: color.hex + Math.round(color.rgb.a * 255).toString(16)
            background: color,
            color_value_1 : "",
            color_lmnst_1 : "",
            color_strtn_1 : "",
        });
    } else if (kind == "2") {
      // this.setState({ canvasMainColor: color });
      this.setState({ 
            // background2: color.hex + Math.round(color.rgb.a * 255).toString(16)
            background2: color,
            color_value_2 : "",
            color_lmnst_2 : "",
            color_strtn_2 : "",
        });
    } else if (kind == "3") {
      // this.setState({ canvasSubColor: color });
      this.setState({ 
            // background3: color.hex + Math.round(color.rgb.a * 255).toString(16)
            background3: color,
            color_value_3 : "",
            color_lmnst_3 : "",
            color_strtn_3 : "",
        });
    } else if (kind == "4") {
      // this.setState({ canvasPointColor: color });
        this.setState({ 
            // background4: color.hex + Math.round(color.rgb.a * 255).toString(16)
            background4: color,
            color_value_4 : "",
            color_lmnst_4 : "",
            color_strtn_4 : "",
        });
    }
  };

  handleChange = (color, complete) => {
      if(complete){
          isTmp = true;
      }
      this.setState({ 
          // background: color.hex + Math.round(color.rgb.a * 255).toString(16)
          background: color.hex,
          color_value_1 : "",
          color_lmnst_1 : "",
          color_strtn_1 : "",
      });

      $("#image_2_0").css("background-color", "rgb("+color.hex + Math.round(color.rgb.a * 255).toString(16)+")");

      // 자동배너 수정 - 배경색상1
      // ReactGA.event({
      //     category: "자동배너 수정",
      //     action: "배경색상1 : " + color.hex,
      //     label: ga_label
      // });

      console.log("##### color: "+color.hex + Math.round(color.rgb.a * 255).toString(16));

  };

  handleChange2 = (color, complete) => {
      if(complete){
          isTmp = true;
      }
      this.setState({ 
          // background2: color.hex + Math.round(color.rgb.a * 255).toString(16)
          background2: color.hex,
          color_value_2 : "",
          color_lmnst_2 : "",
          color_strtn_2 : "",
      });

      // 자동배너 수정 - 배경색상2
      // ReactGA.event({
      //     category: "자동배너 수정",
      //     action: "배경색상2 : " + color.hex,
      //     label: ga_label
      // });

      console.log("##### color: "+color.hex + Math.round(color.rgb.a * 255).toString(16));
  };

  handleChange3 = (color, complete) => {
      if(complete){
          isTmp = true;
      }
      this.setState({ 
          // background3: color.hex + Math.round(color.rgb.a * 255).toString(16)
          background3: color.hex,
          color_value_3 : "",
          color_lmnst_3 : "",
          color_strtn_3 : "",
      });

      // 자동배너 수정 - 배경색상3
      // ReactGA.event({
      //     category: "자동배너 수정",
      //     action: "배경색상3 : " + color.hex,
      //     label: ga_label
      // });

      console.log("##### color: "+color.hex + Math.round(color.rgb.a * 255).toString(16));

  };

  handleChange4 = (color, complete) => {
      if(complete){
          isTmp = true;
      }
      this.setState({ 
          // background4: color.hex + Math.round(color.rgb.a * 255).toString(16)
          background4: color.hex,
          color_value_4 : "",
          color_lmnst_4 : "",
          color_strtn_4 : "",
      });

      // 자동배너 수정 - 배경색상4
      // ReactGA.event({
      //     category: "자동배너 수정",
      //     action: "배경색상4 : " + color.hex,
      //     label: ga_label
      // });

      console.log("##### color: "+color.hex + Math.round(color.rgb.a * 255).toString(16));

  };

  handleChangeTextColor = (color, name, complete) => {

      this.setState({ 
          [name]: color.hex
      }, () => {
          if(complete){
              this.insertEventTmp('preview');
          }
      });

      // 자동배너 수정 - 배경색상4
      // ReactGA.event({
      //     category: "자동배너 수정",
      //     action: name+" : " + color.hex,
      //     label: ga_label
      // });

      console.log("##### color: "+color.hex + Math.round(color.rgb.a * 255).toString(16));
  };

  getCanvasBackgroundStyle = () => {
    const {
      canvasMainColor,
      canvasSubColor,
      canvasBgColor,
    } = this.state;
    // 메인/서브 그라디언트 + 배경색 조합
    return {
      background: `linear-gradient(135deg, ${canvasMainColor}, ${canvasSubColor})`,
      backgroundColor: canvasBgColor,
      height: this.state.canvasWidth,
    };
  };

  updateCanvasWidth = () => {
    if (this.resizeRaf) return;

    this.resizeRaf = requestAnimationFrame(() => {
      this.resizeRaf = null;

      const el = document.getElementById("canvasFrame");
      if (!el) return;

      if (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length) {
        el.style.maxWidth = "960px"
      }

      console.log("Object.keys(this.state.selected_pc_banner_ratio ?? {}).length", Object.keys(this.state.selected_pc_banner_ratio ?? {}).length);

      const width = 
        Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
        ? el.getBoundingClientRect().width * (this.state.selected_pc_banner_ratio.banner_height / this.state.selected_pc_banner_ratio.banner_width)
        : el.getBoundingClientRect().width * (this.state.selected_mobile_banner_ratio.banner_height / this.state.selected_mobile_banner_ratio.banner_width);

      if (this.state.canvasWidth !== width) {
        this.setState({ canvasWidth: width });
      }
    });
  };

  extractColors = () => {
    // 탭 이동 후 AI 추출
    this.setState({ currentTab: "color" }, this.aiExtractColors);
  };

  aiExtractColors = () => {
    const colors = ["#8b5cf6", "#a78bfa", "#fbbf24", "#60a5fa", "#34d399"];

    this.setState({
      extractedColors: colors,
      canvasMainColor: colors[0],
      canvasSubColor: colors[1],
      canvasPointColor: colors[2],
      canvasBgColor: "#ffffff",
    });

    alert("AI가 색상을 추출했습니다!");
  };

async onSelectImgLinkColor(type, idx){
      const hasNoImgLink = this.state[type+"_user_img_list"].every(
        item => !item.img_link || item.img_link.trim() === ""
      );

      if (hasNoImgLink) {
        // alert("색상을 추출할 이미지를 먼저 업로드해 주세요.");
        const result = await this.openBasicDialog({
            content: "색상을 추출할 이미지를 먼저 등록해 주세요.",
        });
        if (result) {
            this.setState({ activePanel: "image" });
        }
        return;
      }

      $(".mirror_banner_v2_pc_banner_area").css({opacity : "0"});
      $(".mirror_banner_v2_mobile_banner_area").css({opacity : "0"});

      this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "AI 배경색 추출중 입니다.",
          save_dialog_button_list: [
              {
                  title: "확인",
                  type: "1",
                  display_yn:"N",
              }
          ]
      }, () => {
          $("#blockPageClick").hide();
      });

      if (!this.positionImgCheck(type, idx, true)) {
        for (let index in this.state[type+"_img_position_name"]) {
          if (this.positionImgCheck(type, index, true)) {
            idx = index;
            break;
          }
        }
      } 

      let link = this.state[(type == "h" ? "h_" : "") + this.state[type+"_img_position_name"][idx].img_column_name];

      // 업로드 이미지가 있는 경우
      if(!(this.state[type+"_is_youtube_link_use"] == "N" && this.state[type+"_user_img_list"][idx].link_type == "49005") && this.state[type+"_user_img_list"][idx].img_link){
          link = this.state[type+"_user_img_list"][idx].img_link;
      }
      // let link = "https://vrthumb.imagetoday.co.kr/2018/02/08/tip250t012568.jpg"; // 테스트용 임시 이미지

      let event_type_cd_param_name = type == "h" ? "event_mobile_type_cd" : "event_type_cd";
      let event_type_cd = type == "h" ? this.state.event_mobile_type_cd : this.state.event_type_cd;

      http.get("/rest/shop/linkImg/ColorDetector?img_link="+link+"&"+event_type_cd_param_name+"="+event_type_cd)
      .then(res => {
          let event_color = res.data["color"]["event"];
          
          this.setState({
              background : event_color.color_code_1,
              background2 : event_color.color_code_2,
              background3 : event_color.color_code_3,
              background4 : event_color.color_code_4,
              color_value_1 : event_color.color_value_1,
              color_value_2 : event_color.color_value_2,
              color_value_3 : event_color.color_value_3,
              color_value_4 : event_color.color_value_4,
              color_lmnst_1 : event_color.color_lmnst_1,
              color_lmnst_2 : event_color.color_lmnst_2,
              color_lmnst_3 : event_color.color_lmnst_3,
              color_lmnst_4 : event_color.color_lmnst_4,
              color_strtn_1 : event_color.color_strtn_1,
              color_strtn_2 : event_color.color_strtn_2,
              color_strtn_3 : event_color.color_strtn_3,
              color_strtn_4 : event_color.color_strtn_4,
              color_hue_1 : event_color.color_hue_1,
              color_hue_2 : event_color.color_hue_2,
              color_hue_3 : event_color.color_hue_3,
              color_hue_4 : event_color.color_hue_4,
              extractedColors : [
                  event_color.color_code_1,
                  event_color.color_code_2,
                  event_color.color_code_3,
                  event_color.color_code_4,
              ],
          }, () => {
              this.insertEventTmp('preview');

              this.setState({ save_dialog_show_state: false });
              $(".mirror_banner_v2_pc_banner_area").css({opacity : "1"});
              $(".mirror_banner_v2_mobile_banner_area").css({opacity : "1"});
              $("#blockPageClick").hide();
          });
      })
      .catch(error => {
          alert("AI 배경색 추출에 실패하였습니다.");

          this.setState({ save_dialog_show_state: false });
          $(".mirror_banner_v2_pc_banner_area").css({opacity : "1"});
          $(".mirror_banner_v2_mobile_banner_area").css({opacity : "1"});
          $("#blockPageClick").hide();
      });
  }

  applyColorPreset = (preset) => {
    let colors = {};
    switch (preset) {
      case "warm":
        colors = {
          main: "#ef4444",
          sub: "#f97316",
          point: "#fbbf24",
          bg: "#fff7ed",
        };
        break;
      case "cool":
        colors = {
          main: "#3b82f6",
          sub: "#06b6d4",
          point: "#14b8a6",
          bg: "#f0f9ff",
        };
        break;
      case "pastel":
        colors = {
          main: "#fda4af",
          sub: "#c7d2fe",
          point: "#fde047",
          bg: "#ffffff",
        };
        break;
      case "mono":
        colors = {
          main: "#374151",
          sub: "#6b7280",
          point: "#9ca3af",
          bg: "#f9fafb",
        };
        break;
      default:
        return;
    }

    this.setState({
      canvasMainColor: colors.main,
      canvasSubColor: colors.sub,
      canvasPointColor: colors.point,
      canvasBgColor: colors.bg,
    });
  };

  applyExtractedColor = (color) => {
    this.setState({ canvasMainColor: color });
  };
  copyToClipboard = async (text) => {
    // 최신 방식
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (e) {}
    }

    // fallback
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);

    return ok;
  };

  showToast = (message) => {
    // 연속 클릭 대응
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    this.setState(
      {
        showToast: true,
        toastMsg: message,
      },
      () => {
        this.timer = setTimeout(() => {
          this.setState({ showToast: false });
        }, 3000);
      }
    );
  };

  handleCopyExtractedColor = async (color) => {
    const ok = await this.copyToClipboard(color);

    if (ok) {
      this.showToast("복사 되었습니다 : " + color);
    }
  };

  /* ========== 배경 제거 옵션 ========== */

  toggleBgRemove = () => {
    this.setState((prev) => ({
      bgRemoveEnabled: !prev.bgRemoveEnabled,
    }));
  };

  setBgType = (type) => {
    this.setState({ bgRemoveStrength: type });
  };

  toggleContourCorrection = () => {
    this.setState((prev) => ({
      contourCorrection: !prev.contourCorrection,
    }));
  };

  toggleFaceAuto = () => {
    this.setState((prev) => ({ faceAuto: !prev.faceAuto }));
  };

  /* ========== 텍스트 크기 조절 ========== */
  getTxtScaleValueText = (value) => {
      txt_scale_value = value;
      return `${value}`;
  }

  handleTxtScaleOnChange = (e, type1, type2) => {
      e.stopPropagation();

      this.setState({
          [type1 + '_' + type2 + '_txt_scale'] : e.target.value
      });
  }

  /* ========== 텍스트 위치 이동 ========== */
  movePositionOnBlur = (e, position, opposite) => {
    isTmp = true;

    if(e.target.value == "" || e.target.value == -0 || isNaN(e.target.value)){
        this.setState({[position] : 0})
        return;
    }

    if(e.target.value != 0 && e.target.value != -0){
        this.setState({
            [position] : Math.abs(Number(e.target.value)),
            [opposite] : 0,
        });
    }
}

  movePositionOnBlurV2 = (value, position, opposite) => {
    isTmp = true;

    if(value == "" || value == -0 || isNaN(value)){
        this.setState({[position] : 0})
        return;
    }

    if(value != 0 && value != -0){
        this.setState({
            [position] : Math.abs(Number(value)),
            [opposite] : 0,
        });
    }
}

  /* ========== 텍스트 추천 ========== */
  getAutoTitle(keyword, name) {
      if(!keyword){
          if (name == "title") {
            alert("메인 텍스트를 입력해주세요.\n(인공지능이 입력한 내용을 분석해 어울리는 문장을 추천합니다.)");
          } else if (name == "sub_title") {
            alert("서브 텍스트를 입력해주세요.\n(인공지능이 입력한 내용을 분석해 어울리는 문장을 추천합니다.)");
          } else {
            alert("키워드를 입력해 주세요.");
          }
          return false;
      }

      this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "AI 문구 추천중 입니다.",
          save_dialog_button_list: [
              {
                  title: "확인",
                  type: "1",
                  display_yn:"N",
              }
          ]
      });

      /* html 태그 제거 */
      const div = document.createElement("div");
      div.innerHTML = keyword;
      keyword = div.textContent || div.innerText || ""; 
      
      http.get("/rest/shop/event/gpt/sentence?user_seq="+this.state.user_seq+"&keyword="+encodeURI(keyword))
      .then(res => {
          if(res.data.res_txt) {
              const content = ContentState.createFromText(res.data.res_txt);
              isTmp = true;
              if (name == "title") {
                  this.setState({[name]: res.data.res_txt,
                      title: res.data.res_txt,
                      org_title: res.data.res_txt,
                      save_dialog_show_state: false,
                      template_sample_user_text_changed: true,
                  });
              } else {
                  this.setState({[name]: res.data.res_txt,
                      foreign_title: res.data.res_txt,
                      sentence: res.data.res_txt,
                      eng_sentence: res.data.res_txt,
                      save_dialog_show_state: false,
                      template_sample_user_text_changed: true,
                  });
              }
          } else{
              alert("문구 추천에 실패하였습니다.");
              this.setState({ save_dialog_show_state: false });
          }
      }).catch(e => {
          alert("문구 추천에 실패하였습니다.");
          this.setState({ save_dialog_show_state: false });
      })
    };


  isDateAreaUseTemplate = () => {
      return (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length > 0 && this.state.w_is_date_use == "Y")
        || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length > 0 && this.state.h_is_date_use == "Y");
  }

  padDatePart = (value) => {
      return String(value || "").padStart(2, "0");
  }

  normalizeTimePart = (value, fallbackValue) => {
      if (value == null || String(value).trim() === "" || String(value) === "null" || String(value) === "undefined") {
          return String(fallbackValue);
      }

      return String(value);
  }

  normalizeTimePartForCalendar = (value, fallbackValue) => {
      return this.padDatePart(this.normalizeTimePart(value, fallbackValue));
  }

  toDateInputValue = (value) => {
      if (value == null || String(value).trim() === "" || String(value) === "null" || String(value) === "undefined") {
          return "";
      }

      if (value instanceof Date && !isNaN(value.getTime())) {
          return value.getFullYear()
              + "-"
              + this.padDatePart(value.getMonth() + 1)
              + "-"
              + this.padDatePart(value.getDate());
      }

      const rawValue = String(value).trim();
      const separatedDate = rawValue.match(/^(\d{4})[-./](\d{1,2})[-./](\d{1,2})/);
      if (separatedDate) {
          return separatedDate[1]
              + "-"
              + this.padDatePart(separatedDate[2])
              + "-"
              + this.padDatePart(separatedDate[3]);
      }

      const onlyNumberDate = rawValue.replace(/[^\d]/g, "");
      if (onlyNumberDate.length >= 8) {
          return onlyNumberDate.substring(0, 4)
              + "-"
              + onlyNumberDate.substring(4, 6)
              + "-"
              + onlyNumberDate.substring(6, 8);
      }

      return "";
  }

  getTemplateDateInputValue = (dateType) => {
      const formatKey = dateType === "start" ? "start_date_format" : "end_date_format";
      const dateKey = dateType === "start" ? "start_date" : "end_date";

      return this.toDateInputValue(this.state[formatKey]) || this.toDateInputValue(this.state[dateKey]);
  }

  getTemplateDateStatePatch = (dateType, dateValue) => {
      const inputValue = this.toDateInputValue(dateValue);

      if (!inputValue) {
          if (dateType === "start") {
              return {
                  start_date: "",
                  start_date_format: "",
                  start_date_format_calendar: "",
                  disabledStartDate: false,
                  simple_date_cd: "17001",
              };
          }

          return {
              end_date: "",
              end_date_format: "",
              end_date_format_calendar: "",
              disabledEndDate: false,
              simple_date_cd: "17001",
          };
      }

      const dateParts = inputValue.split("-").map(Number);
      const dateObject = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

      if (dateType === "start") {
          const startHour = this.normalizeTimePart(this.state.start_hour, "0");
          const startMinute = this.normalizeTimePart(this.state.start_minute, "0");
          const startHourCalendar = this.normalizeTimePartForCalendar(this.state.start_hour, "0");
          const startMinuteCalendar = this.normalizeTimePartForCalendar(this.state.start_minute, "0");

          return {
              start_date: dateObject,
              start_hour: startHour,
              start_minute: startMinute,
              start_date_format: inputValue + " " + startHour + ":" + startMinute + ":00",
              start_date_format_calendar: inputValue + " " + startHourCalendar + ":" + startMinuteCalendar + ":00.000+0900",
              disabledStartDate: false,
              simple_date_cd: "17001",
          };
      }

      const endHour = this.normalizeTimePart(this.state.end_hour, "23");
      const endMinute = this.normalizeTimePart(this.state.end_minute, "59");
      const endHourCalendar = this.normalizeTimePartForCalendar(this.state.end_hour, "23");
      const endMinuteCalendar = this.normalizeTimePartForCalendar(this.state.end_minute, "59");

      return {
          end_date: dateObject,
          end_hour: endHour,
          end_minute: endMinute,
          end_date_format: inputValue + " " + endHour + ":" + endMinute + ":59",
          end_date_format_calendar: inputValue + " " + endHourCalendar + ":" + endMinuteCalendar + ":59.000+0900",
          disabledEndDate: false,
          simple_date_cd: "17001",
      };
  }

  onChangeTemplateDate = (dateType, e) => {
      const dateValue = e && e.target ? e.target.value : e;

      this.setState({
          ...this.getTemplateDateStatePatch(dateType, dateValue),
          ...this.getUserDateChangedStatePatch(),
      }, () => {
          clearTimeout(title_input_timer["template_date_" + dateType]);
          title_input_timer["template_date_" + dateType] = setTimeout(() => {
              this.insertEventTmp('preview', null, true);
          }, 200);
      });
  }

  onClickClearTemplateDate = (dateType) => {
      this.setState({
          ...this.getTemplateDateStatePatch(dateType, ""),
          ...this.getUserDateChangedStatePatch(),
      }, () => {
          this.insertEventTmp('preview', null, true);
      });
  }

  isPriceAreaUseTemplate = () => {
      return (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length > 0 && this.state.w_is_price_use == "Y")
        || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length > 0 && this.state.h_is_price_use == "Y");
  }

  getEventPriceInputValue = () => {
      const eventPrice = this.state.event_price;

      if (eventPrice == null || String(eventPrice) === "null") {
          return "";
      }

      if (String(eventPrice) === "0") {
          return "";
      }

      return eventPrice;
  }

  onChangeEventPrice = (e) => {
      const event_price = e.target.value;

      this.setState({
          event_price,
          template_sample_user_text_changed: true,
      }, () => {
          clearTimeout(title_input_timer["event_price"]);
          title_input_timer["event_price"] = setTimeout(() => {
              this.insertEventTmp('preview', null, true);
          }, 200);
      });
  }

  /* ========== 버튼 ========== */

  /** 버튼 텍스트/링크 입력 */
  onChangeButtonSetting(e, idx, type){
      let {button_list} = this.state;
      button_list[idx][type] = e.target.value;
      this.setState({
          button_list : button_list,
          ...(type === "button_text" ? this.getUserTextChangedStatePatch() : {}),
      }, () => {
          // button_info_input_timer의 동작을 취소한다 (시간이 200 만큼 지나기 전에 입력이 또 있었다면, 이전의 timeout동작은 실행되지 않을것이다)
          clearTimeout(button_info_input_timer[type+"/"+idx]);
          button_info_input_timer[type+"/"+idx] = setTimeout(() => {
              // 미리보기 데이터 저장
              this.insertEventTmp('preview', null, true);
          },200);
      });
  }

  /** 버튼 추가 */
  onClickAddButton(){
      let {button_list} = this.state;
      button_list.push({
          event_seq : this.getUrlParams()["event_seq"] ? this.state.event_seq : dateString,
          button_text : "",
          link : "",
      });
      for(var i=0;i<button_list.length;i++){
          button_list[i].order_no = i+1; 
      }
      this.setState({
          button_list : button_list,
          ...this.getUserTextChangedStatePatch(),
      }, () => {
          this.insertEventTmp('preview', null, true);
      });
  }

  /** 버튼 삭제 */
  onClickDelButton(idx){
      let {button_list} = this.state;
      button_list.splice(idx,1);
      for(var i=0;i<button_list.length;i++){
          button_list[i].order_no = i+1; 
      }
      this.setState({
          button_list : button_list,
          ...this.getUserTextChangedStatePatch(),
      }, () => {
          this.insertEventTmp('preview', null, true);
      });
  }

  /* ========== 번역 ========== */
  // 번역 선택
  handleLanguageChange = (type, value, text) => {
      if (!(type == "mainTextEditor"
                ? this.state.title
                : this.state.sub_title)) {
        // alert("번역할 문장을 입력해주세요.");
        return false;
      }
      // if (e.target.value && this.state.auto_title) {
      if (value) {
          this.setState({language_code : value});
          var language =  text;
          
          let data = {
              text : 
                type == "mainTextEditor"
                ? this.state.title
                : this.state.sub_title
                ,
              target : language
          }
          http.post("/rest/common/translate/google", data)
          .then(res => {
              if (res.data.resCode == "200") {
                  const blocksFromHTML = htmlToDraft(res.data.translated_text);
                  const state = ContentState.createFromBlockArray(
                      blocksFromHTML.contentBlocks,
                      blocksFromHTML.entityMap,
                  );
                  isTmp = true;
                  if(type == "mainTextEditor") {
                      const mainText = res.data.translated_text;
                      this.setState({
                          title: mainText,
                          auto_title: mainText,
                          mainEditorState: EditorState.createWithContent(state),
                          language_code : "",
                          template_sample_user_text_changed: true,
                      });
                  }
                  if(type == "subTextEditor") {
                      const subText = res.data.translated_text;
                      this.setState({
                          sub_title: subText,
                          sentence: subText,
                          eng_sentence: subText,
                          foreign_title: subText,
                          subEditorState: EditorState.createWithContent(state),
                          language_code : "",
                          template_sample_user_text_changed: true,
                      });
                  }
              } else {
                  alert("번역 서비스 점검중 입니다.\n관리자에게 문의해 주세요. (1599-3518)")
              }
          })
          .catch(error => {
              alert("번역 서비스 오류가 발생했습니다.\n관리자에게 문의해 주세요. (1599-3518)")
          });
      }
  }

  /* ========== 배경제거 ========== */
  // AI 원본 배경 제거 버튼 클릭
  onClickRemoveBackground(e, type, img_position_idx){
      /** 누끼따주는 API를 실행하면 누끼 따진 이미지가 프론트로 return 될것
       * 해당 이미지를 누끼 상태가 Y인 경우에만 저장으로 넘겨야한다.
      */
      let idx = Number(img_position_idx) - 1;
      if (e){ // 클릭 이벤트가 있는 경우에만 처리
        let action = e.target.checked ? "Y" : "N";
        // 이미지가 존재하는 경우와, 누끼 해제하는데 링크 입력형 이미지가 유효하지 않은 경우는(이미지가 비어있는 상태로 보이도록) 통과
        if(this.positionImgCheck(type, idx)
        || (action == "N" && (this.state[type+"_user_img_list"][idx].link_type == "49002" || this.state[type+"_user_img_list"][idx].link_type == "49004") && this.state[type+"_user_img_list"][idx].img_link && !this.state[type+"_user_img_list"][idx].img_link_able)){
            let non_nukki_state = this.state[type+"_non_nukki_state"];
            non_nukki_state[idx] = (action == "N") ? true : false;
            console.log("### 누끼 ###", type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn");
            this.setState({
                [type+"_non_nukki_state"] : non_nukki_state,
            }, () => {
                let nukki_info;
                if(action == "Y"){
                    nukki_info = {
                        type : type,
                        position : Number(img_position_idx),
                        action : "Y",
                    };
                } else{
                    let change_N_list= [];
                    change_N_list.push({
                        key : type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn",
                        value : "N"
                    });
                    change_N_list.push({
                        key : type+"_nukki_"+this.state[type+"_img_position_name"][idx].position_name+"_link",
                        value : ""
                    });
                    nukki_info = {
                        change_N_list : change_N_list,
                    };
                    this.setState({[type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn"] : "N"});
                }
                this.insertEventTmp('preview', nukki_info);
            });
        } 
      } else { // 클릭 없이 누끼 해제 하는 경우 (예: 해당 영역의 이미지 제거 등) - non_nukki_state 값은 변경하지 않는다.
        let nukki_info;
        let change_N_list= [];
        change_N_list.push({
            key : type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn",
            value : "N"
        });
        change_N_list.push({
            key : type+"_nukki_"+this.state[type+"_img_position_name"][idx].position_name+"_link",
            value : ""
        });
        nukki_info = {
            change_N_list : change_N_list,
        };
        this.setState({[type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn"] : "N"});
        this.insertEventTmp('preview', nukki_info);
      }
  }
  /** 배경제거 버전 슬라이더 변경 */
  onChangeVersionSlider = (value, type, img_position_idx, afterChange) => {
      console.log("### onChangeVersionSlider ###", value, type, img_position_idx, afterChange);
      const idx = Number(img_position_idx) - 1;
      let nukki_version_list = this.state[type+"_nukki_version_list"];
      nukki_version_list[idx] = value;

      let nukki_ppm_state = this.state[type+"_nukki_ppm_state"];
      if(afterChange && value == "2"){
          nukki_ppm_state[idx] = false;
      }
      this.setState({
          [type+"_nukki_version_list"] : nukki_version_list,
          [type+"_nukki_ppm_state"] : nukki_ppm_state,
          [type+"_bgRemoveStrength_"+img_position_idx] : value,
      }, () => {
          if(!afterChange){
              return false;
          }

          let nukki_info_Y_list = [];
          nukki_info_Y_list.push({
              type : type,
              position : Number(img_position_idx),
              action : "Y",
          });

          const nukki_info = {
              type : type,
              change_N_list : [],
              nukki_info_Y_list : nukki_info_Y_list,
          };
          this.insertEventTmp('preview', nukki_info);
      });
  }

  /** 누끼 AI 윤곽 보정 상태 변경 */
  changeNukkiPPMstate(e, type, img_position_idx){
      let nukki_ppm_state = this.state[type+"_nukki_ppm_state"];
      nukki_ppm_state[Number(img_position_idx)-1] = e.target.checked;
      this.setState({[type+"_nukki_ppm_state"]: nukki_ppm_state}, () => {
          let nukki_info_Y_list = [];
          nukki_info_Y_list.push({
              type : type,
              position : Number(img_position_idx),
              action : "Y",
          });

          const nukki_info = {
              type : type,
              change_N_list : [],
              nukki_info_Y_list : nukki_info_Y_list,
          };
          this.insertEventTmp('preview', nukki_info);
      });

  }

  /* ========== AI 인물 배치 ========== */
  /**
   * 인물 위치 자동 이동
   * @param {*} type w or h
   * @param {*} idx 배너 이미지 순서 번호
   */
  modelImageShift(type, idx){
    const img_path = this.positionImgCheck(type, idx);
      if (!img_path) {
          return false;
      }

      this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "인물 위치를 추출중 입니다.",
          save_dialog_button_list: [
              {
                  title: "확인",
                  type: "1",
                  display_yn:"N",
              }
          ]
      });

      let target_width, target_height;
      if(type == "w"){
          if(this.state.selected_pc_banner_ratio.org_banner_width > 50 || this.state.selected_pc_banner_ratio.org_banner_height > 50){
              target_width = this.state.selected_pc_banner_ratio.org_banner_width;
              target_height = this.state.selected_pc_banner_ratio.org_banner_height;
          } else{
              target_width = this.state.selected_pc_banner_ratio.banner_width;
              target_height = this.state.selected_pc_banner_ratio.banner_height;
          }
      } else{
          if(this.state.selected_mobile_banner_ratio.org_banner_width > 50 || this.state.selected_mobile_banner_ratio.org_banner_height > 50){
              target_width = this.state.selected_mobile_banner_ratio.org_banner_width;
              target_height = this.state.selected_mobile_banner_ratio.org_banner_height;
          } else{
              target_width = this.state.selected_mobile_banner_ratio.banner_width;
              target_height = this.state.selected_mobile_banner_ratio.banner_height;
          }
      }

      const sendForm = {
          img_path : img_path,
          target_width : Math.round(target_width),
          target_height : Math.round(target_height),
      };
      http.get("/rest/shop/modelImageShift", {params:sendForm})
      .then(res => {
          if(res.data.person != "0" && res.data.resCode != "500"){
              const x = res.data.x;
              const y = res.data.y;
              const img_idx = idx+1;

              // 왼쪽과 위쪽 방향은 음수로 들어오기 때문에 양수로 변환후 적용
              this.setState({
                  [type+"_img_"+img_idx+"_auto_move_yn"] : "Y", // 위치 이동 실행 여부
                  [(type == "w" ? "":"h_")+"img_position_"+img_idx+"_type"] : "50002", // %로 변경
                  [type+"_img_position_left_"+img_idx] : (x && x < 0) ? -x : 0,
                  [type+"_img_position_right_"+img_idx] : (x && x > 0) ? x : 0,
                  [type+"_img_position_top_"+img_idx] : (y && y < 0) ? -y : 0,
                  [type+"_img_position_bottom_"+img_idx] : (y && y > 0) ? y : 0,

                  [type+"_img_position_x_"+img_idx] : x != null ? x : 0,
                  [type+"_img_position_y_"+img_idx] : y != null ? -y : 0,
              }, () => {
                  this.insertEventTmp('preview');
              });
              this.setState({ save_dialog_show_state: false });

              return false;
          }

          alert("인물 위치를 찾지 못했습니다.");
          this.setState({ save_dialog_show_state: false });
      })
      .catch(error => {
          alert("인물 위치를 찾지 못했습니다.");
          this.setState({ save_dialog_show_state: false });
      })
  }

  /**
   * 패션플러스 얼굴 위치 자동 이동
   * @param {*} type w or h
   * @param {*} idx 배너 이미지 순서 번호
   */
  faceImageShiftForFashionPlus(type, idx, nukki_crop_yn){
      this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "얼굴 위치를 추출중 입니다.",
          save_dialog_button_list: [
              {
                  title: "확인",
                  type: "1",
                  display_yn:"N",
              }
          ]
      });

      const config = {
          headers: {
              'Content-Type': 'application/json',
              },
      };

      let target_width, target_height;
      if(type == "w"){
          if(this.state.selected_pc_banner_ratio.org_banner_width > 50 || this.state.selected_pc_banner_ratio.org_banner_height > 50){
              target_width = this.state.selected_pc_banner_ratio.org_banner_width;
              target_height = this.state.selected_pc_banner_ratio.org_banner_height;
          } else{
              target_width = this.state.selected_pc_banner_ratio.banner_width;
              target_height = this.state.selected_pc_banner_ratio.banner_height;
          }
      } else{
          if(this.state.selected_mobile_banner_ratio.org_banner_width > 50 || this.state.selected_mobile_banner_ratio.org_banner_height > 50){
              target_width = this.state.selected_mobile_banner_ratio.org_banner_width;
              target_height = this.state.selected_mobile_banner_ratio.org_banner_height;
          } else{
              target_width = this.state.selected_mobile_banner_ratio.banner_width;
              target_height = this.state.selected_mobile_banner_ratio.banner_height;
          }
      }

      let is_nukki_img = nukki_crop_yn == "Y"? true : false;
      const body = {
          // 누끼 이미지를 사용하는 템플릿이고 누끼이미지가 존재하는 경우 누끼 이미지를 보내고 그렇지 않은 경우에는 원본 이미지를 보낸다
          img_path : is_nukki_img && this.state[type+"_essential_img_nukki_yn"] == "Y" && (this.checkTypeNukkiRunImage(type, idx) || this.state[type+"_nukki_"+this.state[type+"_img_position_name"][idx].img_column_name])
                      ? this.checkTypeNukkiRunImage(type, idx) ? this.checkTypeNukkiRunImage(type, idx) : this.state[type+"_nukki_"+this.state[type+"_img_position_name"][idx].img_column_name]
                      : this.positionImgCheck(type, idx),
          position : (idx+1),
          target_width : Math.round(target_width),
          target_height : Math.round(target_height),
          event_type_cd : (type == "w") ? this.state.event_type_cd : null,
          event_mobile_type_cd : (type == "w") ? null : this.state.event_mobile_type_cd,
      };
      http.post("/rest/shop/faceImageShift", body, config)
      .then(res => {
          if(res.data.resCode == "200"){
              const shift_pc = res.data.shift_pc;
              const scale_factor = res.data.scale_factor;
              if (shift_pc != null &&  shift_pc.length> 0 && scale_factor != null) {
                  const x = shift_pc[0];
                  const y = shift_pc[1];
                  const img_idx = idx+1;
  
                  // 왼쪽과 위쪽 방향은 음수로 들어오기 때문에 양수로 변환후 적용
                  this.setState({
                      [type+"_img_"+img_idx+"_auto_move_yn"] : "Y", // 위치 이동 실행 여부
                      [(type == "w" ? "":"h_")+"img_position_"+img_idx+"_type"] : "50002", // %로 변경
                      [type+"_img_position_left_"+img_idx] : (x && x < 0) ? -x : 0,
                      [type+"_img_position_right_"+img_idx] : (x && x > 0) ? x : 0,
                      [type+"_img_position_top_"+img_idx] : (y && y < 0) ? -y : 0,
                      [type+"_img_position_bottom_"+img_idx] : (y && y > 0) ? y : 0,

                      [type+"_img_position_x_"+img_idx] : x != null ? x : 0,
                      [type+"_img_position_y_"+img_idx] : y != null ? -y : 0,
                      
                      [type + '_img_' + img_idx + '_scale'] : (scale_factor && scale_factor > 0) ? scale_factor : 0,
                  }, () => {
                      this.insertEventTmp('preview');
                  });
              }
              this.setState({ save_dialog_show_state: false });

              return false;
          }

          alert("얼굴 위치를 찾지 못했습니다.");
          this.setState({ save_dialog_show_state: false });
      })
      .catch(error => {
          alert("얼굴 위치를 찾지 못했습니다.");
          this.setState({ save_dialog_show_state: false });
      })
  }

  handleImgScaleOnChange = (e, type, idx) => {
    e.stopPropagation();

    this.setState({
        [type + '_img_' + idx + '_scale'] : e.target.value,
    });
  }

  /** 상품 이미지가 하나가 수정되는 경우 이벤트(누끼 관련 설정)
   *  1. 이미지 업로드/링크 변경
   *  2. 업로드/링크 이미지 x 버튼 클릭
  */
  eventChangeOneProductImageOfNukki(type, idx){
      let user_img_list = this.state[type+"_user_img_list"];

      user_img_list[idx].img_link_able = true;

      // version 3의 경우 ppm Y 상태가 없다
      user_img_list[idx]["img_ppm_N_crop_N_version_1"] = "";
      user_img_list[idx]["img_ppm_N_crop_N_version_2"] = "";
      user_img_list[idx]["img_ppm_N_crop_N_version_3"] = "";

      user_img_list[idx]["img_ppm_N_crop_Y_version_1"] = "";
      user_img_list[idx]["img_ppm_N_crop_Y_version_2"] = "";
      user_img_list[idx]["img_ppm_N_crop_Y_version_3"] = "";

      user_img_list[idx]["img_ppm_Y_crop_N_version_1"] = "";
      user_img_list[idx]["img_ppm_Y_crop_N_version_2"] = "";
      user_img_list[idx]["img_ppm_Y_crop_N_version_3"] = "";
      
      user_img_list[idx]["img_ppm_Y_crop_Y_version_1"] = "";
      user_img_list[idx]["img_ppm_Y_crop_Y_version_2"] = "";
      user_img_list[idx]["img_ppm_Y_crop_Y_version_3"] = "";

      // 상세이미지를 쓰지 않는 경우, 상세이미지 데이터를 초기화한다
      let crop_img_info_list = this.state[type+"_crop_img_info_list"];
      if(!(user_img_list[idx].link_type == "49003" && user_img_list[idx].img_link)){
          crop_img_info_list[idx] = {};
      }

      // AI 얼굴 위치 자동 이동을 실행한 경우 위치이동 초기화
      if(this.state[type+"_img_"+(idx+1)+"_auto_move_yn"]=="Y"){
          this.setState({
              [type+"_img_"+(idx+1)+"_auto_move_yn"] : "N",
              [type+"_img_"+(idx+1)+"_scale"] : 1,
              [type+"_img_position_left_"+(idx+1)] : 0,
              [type+"_img_position_right_"+(idx+1)] : 0,
              [type+"_img_position_top_"+(idx+1)] : 0,
              [type+"_img_position_bottom_"+(idx+1)] : 0,
          });
      }

      this.setState({
          select_detail_img_type_popup_show : false, // 이미지 업로드 팝업 닫기
          [type+"_user_img_list"] : user_img_list,
          [type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn"] : "N",
          [type+"_crop_img_info_list"] : crop_img_info_list,
          ...(user_img_list[idx].img_link ? this.getUserImageChangedStatePatch(type, idx) : this.getTemplateImageClearStatePatch(type, idx)),
      }, () => {
          let change_N_list = [];
          let nukki_info_Y_list = [];
          if(this.state[type+"_essential_img_nukki_yn"] == "Y" && !this.state[type+"_non_nukki_state"][idx] && this.positionImgCheck(type, idx)){
              nukki_info_Y_list.push({
                  type : type,
                  position : idx+1,
                  action : "Y",
              });
          }
          change_N_list.push({
              key : type+"_"+this.state[type+"_img_position_name"][idx].position_name+"_nukki_yn",
              value : "N"
          });
          change_N_list.push({
              key : type+"_nukki_"+this.state[type+"_img_position_name"][idx].position_name+"_link",
              value : ""
          });
  
          const nukki_info = {
              type : type,
              change_N_list : change_N_list,
              nukki_info_Y_list : nukki_info_Y_list,
          };

          this.insertEventTmp('preview', nukki_info);
      });
  }

  /* ========== 다운로드 ==========  */
  /** 캡처되는 실제 사이즈 계산 */
  getCaptureSize(type, banner_ratio){
      let banner_width = 0;
      let banner_height = 0;
      
      banner_width = 1000 * banner_ratio.org_width_height;
      banner_height = 1000;

      if (banner_width > 10000 || banner_height > 10000) {
          if(type == "pc") {
                  banner_width = 10000
                  banner_height = 10000 / banner_ratio.org_width_height;
          } else {
                  banner_width = 10000 / banner_ratio.org_width_height;
                  banner_height = 10000
          }
      }
      banner_ratio["banner_width"] = banner_width;
      banner_ratio["banner_height"] = banner_height;

      return banner_ratio;
  }

  // 자동 배너 설정 조회
  async getAutoEventSetting(iframe_page_id, iframe_html_id) {
      try{
          const res = await http.get("/rest/shop/event/setting?iframe_page_id="+iframe_page_id+"&iframe_html_id="+iframe_html_id);

          if(res.data != null) {
              if (res.data.err_code == 401) {
                  alert(res.data.err_msg);
                  window.location.href = "/logout";
              }

              if(res.data.list[0] != null) {
                  this.setState({
                      auto_event_setting: res.data.list[0],
                      file_name_setting_yn: res.data.list[0].file_name_setting_yn,
                  });
              }
              return res.data;
          }
      }catch(error) {
          console.log(error);
      }
  }

  // 파일명 규칙 설정 조회
  async getFileNameSettingList(iframe_page_id, iframe_html_id) {
      try{
          const res = await http.get("/rest/shop/event/setting/file-name/setting?iframe_page_id="+iframe_page_id+"&iframe_html_id="+iframe_html_id);

          if(res.data != null) {
              if (res.data.code == 401) {
                  alert(res.data.msg);
                  window.location.href = "/logout";
              }

              if(res.data.file_name_setting_list != null && res.data.file_name_setting_list.length > 0) {
                  this.setState({
                      file_name_setting_list : res.data.file_name_setting_list,
                      w_file_name_setting_list : res.data.w_file_name_setting_list,
                      h_file_name_setting_list : res.data.h_file_name_setting_list,
                  });
              }else {
                  this.setState({
                      file_name_setting_list : [],
                      w_file_name_setting_list : [],
                      h_file_name_setting_list : [],
                  });

                  // 파일명 규칙 기본 설정 불러오기
                  await this.getFileNameDefaultSetting();
              }

              return res.data;
          }

      }catch(error) {
          console.log(error);
      }
  }

  // 파일명 규칙 기본 설정 조회
  async getFileNameDefaultSetting() {
      try{
          const res = await http.get("/rest/shop/event/setting/file-name/default");

          if(res.data != null) {
              if (res.data.code == 401) {
                  alert(res.data.msg);
                  window.location.href = "/logout";
              }

              if(res.data.file_name_default_setting_list != null && res.data.file_name_default_setting_list.length > 0) {
                  this.setState({
                      file_name_default_setting_list: res.data.file_name_default_setting_list,
                      w_file_name_default_setting_list: res.data.w_file_name_default_setting_list,
                      h_file_name_default_setting_list: res.data.h_file_name_default_setting_list,
                  });
              }
          }

      }catch(error) {
          console.log(error);
      }
  }

  getDateFormat = (date) => {
      let dateFormat = new Date(date);
      let year = dateFormat.getFullYear();
      let month = ('0' + (dateFormat.getMonth() + 1)).slice(-2);
      let day = ('0' + dateFormat.getDate()).slice(-2);
      let dateString = year + month + day;

      return dateString;
  }

  getDayOfWeek = (date) => {
      const week = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      const dayOfWeek = week[new Date(date).getDay()];

      return dayOfWeek;
  }

  getAutoNumber = (start_num, increment_value) => {
      const padded_increment_value = increment_value.toString().padStart(String(start_num).length, '0');
      const incremented_num = parseInt(start_num) + parseInt(padded_increment_value);
      const auto_num = incremented_num.toString().padStart(String(start_num).length, '0');

      return auto_num;
  }

  // 파일명 규칙 자동 번호 저장
  async updateFileNameAutoNum(type, rules_number, rules_auto_num) {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          },
      };

      let body = {
          iframe_page_id: this.state.iframe_page_id,
          iframe_html_id: this.state.iframe_html_id,
          banner_type: type,
          rules_number: rules_number,
          rules_auto_num: rules_auto_num
      }

      try{
          const res = await http.post("/rest/shop/event/setting/file-name/auto-num", body, config);

      }catch(error) {
          console.log(error);
      }
  }

  getFileName = (real_type, banner_type, rules_number, code_cd, second_code_cd, third_code_cd, rules_date, rules_name, rules_auto_num) => {
      let file_name = "";

      switch (code_cd) {
          case "61000":   // 페이지 위치
              file_name = this.state.auto_event_setting.iframe_page_id.split("_")[1];
              break;

          case "62000":   // 배너 영역명
              file_name = this.state.auto_event_setting.iframe_html_name;
              break;

          case "63000":   // 배너 사이즈
              if(second_code_cd == "63001") {  // 픽셀(가로x세로)
                  if(real_type == "pc") {
                      file_name = "픽셀(" + String(this.state.selected_pc_banner_ratio.org_banner_width) + "x" + String(this.state.selected_pc_banner_ratio.org_banner_height) + ")";
                  }else if(real_type == "mobile") {
                      file_name = "픽셀(" + String(this.state.selected_mobile_banner_ratio.org_banner_width) + "x" + String(this.state.selected_mobile_banner_ratio.org_banner_height) + ")";
                  }
              }else if(second_code_cd == "63002") {   // 비율(가로x세로)
                  if(real_type == "pc") {
                      file_name = "비율(" + String(Number(this.state.selected_pc_banner_ratio.org_width_height).toFixed(1)) + "x1)";
                  }else if(real_type == "mobile") {
                      file_name = "비율(" + String(Number(this.state.selected_mobile_banner_ratio.org_width_height).toFixed(1)) + "x1)";
                  }
              }else if(second_code_cd == "63003" || second_code_cd == "63004" || second_code_cd == "63005" || second_code_cd == "63006" || second_code_cd == "63007" || second_code_cd == "63008" || second_code_cd == "63009" || second_code_cd == "63010") {    // PC, MO, pc, m, mobile, 가로, 세로, 직접 입력
                  file_name = rules_name;
              }
              break;

          case "64000":   // 날짜
              if(second_code_cd == "64001") {     // 배너 등록일
                  if(third_code_cd == "65001") {          // YYYYMMDD
                      file_name = this.getDateFormat(this.state.reg_date);
                  }else if(third_code_cd == "65002") {    // YYMMDD
                      file_name = this.getDateFormat(this.state.reg_date).substring(2);
                  }else if(third_code_cd == "65003") {    // MMDD
                      file_name = this.getDateFormat(this.state.reg_date).substring(4);
                  }else if(third_code_cd == "65004") {    // 요일
                      file_name = this.getDayOfWeek(this.state.reg_date);
                  }

              }else if(second_code_cd == "64002") {   // 최종 수정일
                  if(third_code_cd == "65001") {          // YYYYMMDD
                      file_name = this.getDateFormat(this.state.mod_date);
                  }else if(third_code_cd == "65002") {    // YYMMDD
                      file_name = this.getDateFormat(this.state.mod_date).substring(2);
                  }else if(third_code_cd == "65003") {    // MMDD
                      file_name = this.getDateFormat(this.state.mod_date).substring(4);
                  }else if(third_code_cd == "65004") {    // 요일
                      file_name = this.getDayOfWeek(this.state.mod_date);
                  }

              }else if(second_code_cd == "64003") {   // 다운로드 날짜
                  if(third_code_cd == "65001") {          // YYYYMMDD
                      file_name = this.getDateFormat(new Date());
                  }else if(third_code_cd == "65002") {    // YYMMDD
                      file_name = this.getDateFormat(new Date()).substring(2);
                  }else if(third_code_cd == "65003") {    // MMDD
                      file_name = this.getDateFormat(new Date()).substring(4);
                  }else if(third_code_cd == "65004") {    // 요일
                      file_name = this.getDayOfWeek(new Date());
                  }

              }else if(second_code_cd == "64004") {   // 날짜 직접 선택
                  if(third_code_cd == "65001") {          // YYYYMMDD
                      file_name = this.getDateFormat(rules_date);
                  }else if(third_code_cd == "65002") {    // YYMMDD
                      file_name = this.getDateFormat(rules_date).substring(2);
                  }else if(third_code_cd == "65003") {    // MMDD
                      file_name = this.getDateFormat(rules_date).substring(4);
                  }else if(third_code_cd == "65004") {    // 요일
                      file_name = this.getDayOfWeek(rules_date);
                  }
              }
              break;

          case "66000":   // 자동 번호
              file_name = rules_auto_num;

              const updated_num = this.getAutoNumber(rules_auto_num, 1);
              this.updateFileNameAutoNum(banner_type, rules_number, updated_num).then(r => {});

              break;

          case "67000":   // 배너 이름
              if(this.state.none_title != null && this.state.none_title != ""){
                  file_name = this.state.none_title;
              }else if(this.state.org_title != null && this.state.org_title != ""){
                  file_name = this.state.org_title;
              }else if(this.state.auto_title != null && this.state.auto_title != ""){
                  file_name = this.state.auto_title;
              }else{
                  file_name = "제목없음";
              }
              break;

          case "69999":   // 직접 입력
              file_name = rules_name;
              break;

          default:
              break;

      }
      return file_name;
  }

  getBannerDownloadFileName = (file_type, real_type) => {
      let _file_name = "";

      if (this.state.event_seq != null && this.state.event_seq != "") {    // event_seq 가 존재하는 경우

          // 파일명 규칙 설정 여부
          if (this.state.file_name_setting_yn == "Y") {     // 파일명 규칙 설정이 "Y"인 경우 (파일명 규칙 설정이 "직접 설정"인 경우)

              if (this.state.file_name_setting_list != null && this.state.file_name_setting_list.length > 0) {    // 파일명 규칙 설정 목록이 존재하는 경우

                  // 저장된 파일명 규칙 설정에 맞게 다운로드. ex) 규칙1_규칙2_규칙3_규칙4.jpg
                  this.state[file_type + "_file_name_setting_list"].map((obj, idx) => {
                      _file_name += String(this.getFileName(real_type, obj.banner_type, obj.rules_number, obj.code_cd, obj.second_code_cd, obj.third_code_cd, obj.rules_date, obj.rules_name, obj.rules_auto_num));

                      if (idx + 1 < this.state[file_type + "_file_name_setting_list"].length) {
                          _file_name += "_";
                      }
                  });

              } else {    // 파일명 규칙 설정 목록이 존재하지 않는 경우

                  // 파일명 규칙 기본 설정으로 다운로드. ex) 규칙1_규칙2_규칙3_규칙4.jpg
                  if(this.state[file_type + "_file_name_default_setting_list"] != null && this.state[file_type + "_file_name_default_setting_list"].length>0){
                      this.state[file_type + "_file_name_default_setting_list"].map((obj, idx) => {
                          _file_name += String(this.getFileName(real_type, obj.banner_type, obj.rules_number, obj.code_cd, obj.second_code_cd, obj.third_code_cd, obj.rules_date, obj.rules_name, obj.rules_auto_num));

                          if(idx+1 < this.state[file_type + "_file_name_default_setting_list"].length) {
                              _file_name += "_";
                          }
                      });
                  }
              }

          }else if(this.state.file_name_setting_yn == "D") {     // 파일명 규칙 설정이 "D"인 경우

              // 로보MD_배너종류_배너번호로 다운로드
              if(this.state.reg_user_seq == -1) {
                  _file_name = "로보MD_자동배너_" + this.state.event_seq;

              }else if(this.state.mod_user_seq == -2 || this.getUrlParams()["sample_yn"] == "Y") {
                  _file_name = "로보MD_샘플배너_" + this.state.event_seq;

              }else {
                  _file_name = "로보MD_로보배너_" + this.state.event_seq;
              }

          }else if(this.state.file_name_setting_yn == "N") {      // 파일명 규칙 설정이 "N"인 경우 (파일명 규칙 설정이 "기본 설정"인 경우)
              if(this.state.none_title != null && this.state.none_title != ""){
                  _file_name = this.state.none_title;
              }else if(this.state.org_title != null && this.state.org_title != ""){
                  _file_name = this.state.org_title;
              }else if(this.state.auto_title != null && this.state.auto_title != ""){
                  _file_name = this.state.auto_title;
              }else{
                  _file_name = "제목없음";
              }
          } else {
            if(this.state.none_title != null && this.state.none_title != ""){
              _file_name = this.state.none_title;
            }else if(this.state.org_title != null && this.state.org_title != ""){
                _file_name = this.state.org_title;
            }else if(this.state.auto_title != null && this.state.auto_title != ""){
                _file_name = this.state.auto_title;
            }else{
                _file_name = "제목없음";
            }
          }
      } else {
          if(this.state.none_title != null && this.state.none_title != ""){
              _file_name = this.state.none_title;
          }else if(this.state.org_title != null && this.state.org_title != ""){
              _file_name = this.state.org_title;
          }else if(this.state.auto_title != null && this.state.auto_title != ""){
              _file_name = this.state.auto_title;
          }else{
              _file_name = "제목없음";
          }
      }

      return _file_name;
  }

  // 미리보기 안의 개별 다운로드 버튼 클릭
  downloadOneBannerBtnClick = (download_type) => {
      // 자동 배너 설정 불러오기
      if (this.state.iframe_page_id != "robomd_instagram_page") {
        this.getAutoEventSetting(this.state.iframe_page_id, this.state.iframe_html_id).then(data => {
            if(data.list[0] != null) {
                this.setState({
                    auto_event_setting: data.list[0],
                    file_name_setting_yn: data.list[0].file_name_setting_yn,
                }, () => {
  
                    // 파일명 규칙 설정 불러오기
                    this.getFileNameSettingList(this.state.iframe_page_id, this.state.iframe_html_id).then(data => {
                        this.setState({
                            file_name_setting_list: data.file_name_setting_list,
                            w_file_name_setting_list: data.w_file_name_setting_list,
                            h_file_name_setting_list: data.h_file_name_setting_list,
  
                        }, () => {
                            // 배너 다운로드
                            this.onClickBannerDownload(download_type);
                        });
                    });
                });
            }else{
                // alert('자동 배너 설정을 불러올 수 없습니다.');
            }
        });
      } else {
        // 배너 다운로드
        this.onClickBannerDownload(download_type);
      }
  }

  // 배너 다운로드
  onClickBannerDownload = (download_type) => {
      let event_seq = "";
      let file_name = this.state.org_title;
      let file_type = "";
      let real_type = "";
      let platform_type = "";
      let banner_width = 0;
      let banner_height = 0;
      let org_banner_width = 0;
      let org_banner_height = 0;
      let mirror_type = "18001";      // 18001(미리보기), 18002

      // if(this.state.event_seq == null || this.state.event_seq == "") {
      //     // event_seq = dateString;

      //     this.setState({
      //         warning_dialog_show_state : true,
      //         warning_dialog_content : "배너를 저장한 이후에<br/> 다운로드 할 수 있어요.",
      //         warning_dialog_button_list: [
      //             {
      //                 title: "확인",
      //                 type: "1",
      //                 event_method: () => {
      //                     this.setState({ warning_dialog_show_state: false });
      //                 }
      //             }
      //         ],
      //     });

      // }else{
          event_seq = this.getUrlParams()["event_seq"] ? this.state.event_seq : dateString;

          if(download_type == "is_download_w") {
              const {selected_pc_banner_ratio} = this.state;
              real_type = "pc";
              platform_type = "p";
              org_banner_width = selected_pc_banner_ratio.org_banner_width;
              org_banner_height = selected_pc_banner_ratio.org_banner_height;
              banner_width = selected_pc_banner_ratio.banner_width;
              banner_height = selected_pc_banner_ratio.banner_height;

              if(this.state.selected_pc_banner_ratio.org_event_type == "p"){
                  file_type = "w";
              }else if(this.state.selected_pc_banner_ratio.org_event_type == "m"){
                  file_type = "h";
              }

          } else {
              const {selected_mobile_banner_ratio} = this.state;
              real_type = "mobile";
              platform_type = "m";
              org_banner_width = selected_mobile_banner_ratio.org_banner_width;
              org_banner_height = selected_mobile_banner_ratio.org_banner_height;
              banner_width = selected_mobile_banner_ratio.banner_width;
              banner_height = selected_mobile_banner_ratio.banner_height;

              if(this.state.selected_mobile_banner_ratio.org_event_type == "p"){
                  file_type = "w";
              }else if(this.state.selected_mobile_banner_ratio.org_event_type == "m"){
                  file_type = "h";
              }
          }

          file_name = this.getBannerDownloadFileName(file_type, real_type);

          // 파일명 규칙 설정이 "기본 설정"일 경우 파일명 카운트 저장하기
          if(this.state.file_name_setting_yn == "N"){
              if(file_name != null && file_name != ""){
                  this.saveFileNameCnt(file_type, file_name).then(res => {
                      file_name = res;
                  });
              }
          }

          if (file_name == null || file_name == "") {
              file_name = this.state.org_title;
          }

          if (file_name == null || file_name == "") {
              file_name = this.state.auto_title;
          }

          if (file_name == null || file_name == "") {
              file_name = this.state.none_title;
          }

          if (file_name == null || file_name == "") {
              file_name = "제목없음";
          }

          let req_list = [];
          let req_map = {
              event_seq : event_seq
              , platform_type : platform_type
              , banner_width : banner_width
              , banner_height : banner_height
              , org_banner_width : org_banner_width
              , org_banner_height : org_banner_height
              , mirror_type : mirror_type
              , file_name: this.getBannerDownloadFileName(file_type, real_type)
          }
          req_list.push(req_map);
          //this.contentDownload(file_name, download_type, req_list);

          console.log(req_list)

          // 다운로드 준비상태 : 진행중
          this.setState({
              save_dialog_show_state: true,
              save_dialog_content: "디자인을 다운로드 중입니다.",
              save_dialog_button_list: [
                  {
                      title: "확인",
                      type: "1",
                      display_yn:"N",
                  }
              ]
          });
          this.setState({[download_type]:false}, () => {
              new Promise( ( resolve, reject ) => {setTimeout( resolve, 500 ); })
                  .then( () => {
                      CommonDownloadManager.fn_contentDownload(file_name, req_list, () => {
                        this.setState({ save_dialog_show_state: false });
                      },
                      "Y",
                    );
                  });
          });
      // }
  }

  // 파일명 카운트 저장하기
  async saveFileNameCnt(type, file_name) {
      let _file_name = "";
      let _file_name_num = "";

      const config = {
          headers: {
              'Content-Type': 'application/json',
          },
      };

      let body = {
          iframe_page_id: this.state.iframe_page_id,
          iframe_html_id: this.state.iframe_html_id,
          banner_type: type,
          file_name: file_name
      }

      try{
          const res = await http.post("/rest/shop/event/setting/file-name/cnt", body, config);

          if(res.data != null) {
              if(res.data.code == "200"){
                  if(res.data.file_name_cnt > 0){
                      _file_name_num = res.data.file_name_cnt;
                      _file_name = file_name + "_" + this.padWithZero(Number(_file_name_num));
                  }else {
                      _file_name = file_name;
                  }

                  return _file_name;
              }
          }
      }catch(error) {
          console.log(error);
      }
  }

  padWithZero(num) {
      if (num < 10) {
          return "0" + num;
      } else {
          return num.toString();
      }
  }

  // 이미지 다운로드
  contentDownload(file_name, download_type, req_list) {
      // 다운로드 준비상태 : 진행중
      this.setState({[download_type]:false});
      const config = {
          headers: {
              'content-type': 'application/json;'
          },
      }
      http.post("/rest/shop/cafe24/event/capture_v2", { req_list : req_list }, config )
      .then(res => {
          if (res.data.code == "200") {
              // 성공시 s3 파일 다운로드 요청
              // this.fn_s3ImageFileDownload(res.data.capture_code, file_name);
              // 캡처요청 상태 조회
              let limit_count = 0;
              this.fn_captureStateChecker(res.data.req_seq, res.data.multi_image_yn, file_name, download_type, limit_count);
          } else {
              alert(res.data.code + "\n" + res.data.msg);
          }
      })
      .catch(error => {
          //console.log (error);
          alert("배너 다운로드 요청 실패\n고객센터 : 1599-3518");
          // 다운로드 준비상태 : 완료
          this.setState({[download_type]:true});
      });
  }

  // 캡처요청 상태 조회
  async fn_captureStateChecker(req_seq, multi_image_yn, file_name, download_type, limit_count, is_download = true) {
    limit_count = limit_count + 1;
    const config = { headers: { 'content-type': 'application/json;' } };

    // 1. 반드시 return을 붙여서 Promise를 반환하게 합니다.
    return http.post("/rest/shop/cafe24/content/stateChecker", { req_seq, multi_image_yn }, config)
    .then(async res => { // async 추가
        if (res.data.is_done == "D") {
            if (is_download) {
                this.fn_s3FileDownload(res.data.content_code, file_name, download_type);
            } else {
              this.setState({
                final_banner_capture_url: "https://s3.ap-northeast-2.amazonaws.com/banner.img/"+res.data.content_code,
              }, async () => {
                  this.setState({ [download_type]: true });

                  const media_source_id = await this.saveInstagramTemplateMediaSource();

                  if (this.props.onSubmit != null) {
                    this.props.onSubmit(this.state.event_seq, this.state.final_banner_capture_url, media_source_id, {
                      opened_from: this.getOpenedFrom(),
                      is_opened_from_ai_design_starter: this.isOpenedFromAiDesignStarter(),
                    });
                  } else {
                    alert(this.state.final_banner_capture_url);
                  }
                }
              )
            }
            return res; // 완료 시 결과 반환
        } else {
            if (limit_count < 100) {
                // 2. 재귀 호출 앞에도 await와 return을 붙여 흐름을 이어갑니다.
                await new Promise(resolve => setTimeout(resolve, 1000));
                console.log("[재시도] count: " + limit_count);
                
                // 3. 마지막 인자로 is_download를 반드시 전달합니다.
                return this.fn_captureStateChecker(req_seq, multi_image_yn, file_name, download_type, limit_count, is_download);
            } else {
                alert("이미지 캡처 상태조회 실패\n고객센터 : 1599-3518");
                this.setState({ [download_type]: true });
            }
        }
    })
    .catch(error => {
        alert("이미지 캡처 상태조회 오류\n고객센터 : 1599-3518");
        this.setState({ [download_type]: true });
        console.error(error);
    });
}

saveInstagramTemplateMediaSource = async () => {
    if (!this.state.event_seq || !this.state.final_banner_capture_url) {
        return false;
    }

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const body = {
        event_seq: this.state.event_seq,
        source_url: this.state.final_banner_capture_url,
        user_seq: this.state.user_seq,
        shop_no: this.state.shop_no || "1",
    };

    try {
        const res = await http.post("/rest/shop/instagram/template/mediaSource/save", body, config);

        const upper_code_cd =
            Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                ? "03000"
                : "07000";

        this.loadeventHistory(upper_code_cd);

        return res.data.media_source_id;
    } catch (e) {
        console.log("### [ERROR] saveInstagramTemplateMediaSource ###", e);
        return null;
    }
};

  // s3 파일 다운로드
  fn_s3FileDownload(content_code, file_name, download_type) {
      // 파일 확장자 추출
      let file_type = content_code.substring(content_code.lastIndexOf(".")+1, content_code.length);
      const config = {
          headers: {
              'content-type': 'application/json;'
          },
          responseType: 'arraybuffer'
      }
      http.post("/rest/shop/cafe24/content/download",
          {
              "content_code" : content_code
          },
          config
      )
      .then(res => {
          if (res.data != null) {
              if(file_name){
                  // 파일명으로 사용 불가능한 특수문자 제거
                  file_name = file_name.replace(/[`~!@#$%^&*|\\\'\";:\/?]/gi, "");
              } else{
                  // 상품명(제목) 미입력시 '제목없음'로 다운로드
                  file_name = '제목없음';
              }
              file_name = file_name + '.'+file_type;
              var blob = new Blob([res.data], { type: file_type });
              FileDownload(blob, decodeURI(file_name));
          } else {
              alert("s3 이미지 다운로드 요청 실패\n고객센터 : 1599-3518");
          }
          // 다운로드 준비상태 : 완료
          this.setState({[download_type]:true});
      })
      .catch(error => {
          alert("s3 이미지 다운로드 요청 실패\n고객센터 : 1599-3518");
          // 다운로드 준비상태 : 완료
          this.setState({[download_type]:true});
      });
  }

  // s3 이미지 다운로드
  fn_s3ImageFileDownload(capture_code, file_name) {
      // 파일 확장자 추출
      let file_type = capture_code.substring(capture_code.lastIndexOf(".")+1, capture_code.length);
      const config = {
          headers: {
              'content-type': 'application/json;'
          },
          responseType: 'arraybuffer'
      }
      http.post("/rest/shop/cafe24/content/download",
          {
              "capture_code" : capture_code,
              "file_type" : file_type
          },
          config
      )
      .then(res => {
          if (res.data != null) {
              console.log(file_name);
              if(file_name){
                  // 파일명으로 사용 불가능한 특수문자 제거
                  file_name = file_name.replace(/[`~!@#$%^&*|\\\'\";:\/?]/gi, "");
              } else{
                  // 상품명(제목) 미입력시 '제목없음'로 다운로드
                  file_name = '제목없음';
              }
              file_name = file_name + '.'+file_type;
              var blob = new Blob([res.data], { type: 'image/'+file_type });

              // 퍼센트 기호(%)가 포함되어 있으면서 올바른 퍼센트 인코딩이 아닌 경우 찾기
              const invalidPercentEncoding = /%(?![0-9A-Fa-f]{2})/;
              if (!invalidPercentEncoding.test(file_name)) {
                  file_name = decodeURI(file_name);
              }

              FileDownload(blob, file_name);
          } else {
              alert("s3 이미지 다운로드 요청 실패\n고객센터 : 1599-3518");
          }
      })
      .catch(error => {
          alert("s3 이미지 다운로드 요청 실패\n고객센터 : 1599-3518");
      });
  }

  /* ========== RENDER ========== */

  renderHeader() {
    return (
      <header className="header">
        <div className="header-inner">
          <div className="logo">
            <span><i className="fa fa-android"></i></span>
            <span>로보MD</span>
          </div>
        </div>
      </header>
    );
  }

  renderMainIntro() {
    return (
      <div className="container">
        <div className="main-content">
          <h1
            style={{
              fontSize: "28px",
              fontWeight: 700,
              background: "linear-gradient(135deg, #667eea, #764ba2)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              marginBottom: "8px",
            }}
          >
            인스타그램 템플릿 디자인
          </h1>
          <p
            style={{
              color: "#636e72",
              marginBottom: "24px",
            }}
          >
            AI 기능을 활용하여 전문적인 인스타그램 포스트를 만들어보세요
          </p>

          <button
            className="btn btn-primary"
            onClick={this.openTemplateEditor}
          >
            <span><i className="fa fa-paint-brush"></i></span>
            <span>템플릿 편집기 열기</span>
          </button>
        </div>
      </div>
    );
  }

  renderTemplateSelector() {
    const { selectedTemplateType, event_type_cd, event_mobile_type_cd, isTemplatePanelCollapsed, bannerTypeList, mobileBannerTypeList } = this.state;

    const card = (type, label, gradient) => (
      <div
        className={
          "template-card" + (selectedTemplateType === type ? " selected" : "")
        }
        onClick={() => this.selectTemplateCard(type)}
      >
        <div
          style={{
            aspectRatio: "1",
            background: gradient,
            borderRadius: "8px",
            marginBottom: "8px",
          }}
        />
        <div style={{ fontSize: "12px", fontWeight: 600 }}>{label}</div>
      </div>
    );

     const cardReal = (item, label, img_url) => (
      <div
        className={
          "template-card" + ( (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ? event_type_cd : event_mobile_type_cd) == item.code_cd ? " selected" : "") + " " + item.code_cd
        }
        // onClick={() => this.onClickBannerTypeRadioButton(type, "event_type_cd", "event_pc_banner_name")}
        onClick={() => this.onClickBannerTypeRadioButton(item, Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ? "event_type_cd" : "event_mobile_type_cd", Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ? "event_pc_banner_name" : "event_mobile_banner_name")}
      >
        <div
          style={{
            aspectRatio:  Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ? "1.58" : "1 / 1.35",
            backgroundImage: `url(${img_url})`,
            borderRadius: "8px",
            marginBottom: "8px",
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div style={{ fontSize: "12px", fontWeight: 600 }}>{label}</div>
      </div>
    );

    return (
      <>
        <button
          className="template-toggle-btn"
          onClick={this.toggleTemplatePanel}
          title="템플릿 선택"
        >
          <span id="templateToggleIcon">
            {isTemplatePanelCollapsed ? "▶" : "◀"}
          </span>
        </button>

        <div
          className={
            "template-selector" +
            (isTemplatePanelCollapsed ? " collapsed" : "")
          }
          id="templateSelector"
          data-instagram-tutorial="design-template-panel"
        >
          <h3
            style={{
              fontSize: "18px",
              fontWeight: 700,
              color: "#2CADAE",
            }}
          >
            템플릿 선택
          </h3>
          {
            Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
            ?
              <div className={"template_tag_filter"} data-instagram-tutorial="design-template-filter">
                  <button className={"btn_template_filter"} onClick={() => this.handleTemplateFilterBtnClick("03000")}>
                      <img src={icn_filter} alt={"템플릿 태그 필터 아이콘"}/>
                  </button>
                  <div className={"template_tag_list"}>
                      <div 
                          // onMouseLeave={this.handleDragStop}
                      >
                          <ScrollMenu
                              handleMouseOnWheel={(apiObj, ev) => this.handleMouseOnWheel(apiObj, ev)}
                              onMouseDown={(ev) => this.handleDragStart}
                              onMouseUp={(ev) => this.handleDragStop}
                              onMouseMove={this.handleDrag}
                          >
                              <button style={(this.state.w_all_tag_selected || !Object.values(this.state.w_template_all_tag_list)
                                                                                .flat()
                                                                                .some(tag => tag.isSelected === true)) 
                                            ? {backgroundColor:'#00E2E6', border: '1px solid #00E2E6'} : {backgroundColor: '#FFF', border: '1px solid #ACACAC'}}
                                      onClick={() => this.allTagBtnClick("03000", "w")}>{this.state.template_tag_list ? this.state.template_tag_list[0].tag_name : ""}</button>
                              {
                                  Object.keys(this.state.w_template_all_tag_list).map((category, tag_idx) => (
                                      this.state.w_template_all_tag_list[category].map((tag)=>(
                                          <TagButton key={tag.tag_cd} tagCd={tag.tag_cd} tagName={tag.tag_name}
                                                      isSelected={tag.isSelected}
                                                      onClick={(tagCd, isSelected) => this.tagBtnClick(category, tag.tag_cd, isSelected, "03000", "w")}/>
                                      ))
                                  ))
                              }
                          </ScrollMenu>
                      </div>
                  </div>
              </div>
            :
              <div className={"template_tag_filter"} data-instagram-tutorial="design-template-filter">
                  <button className={"btn_template_filter"} onClick={() => this.handleTemplateFilterBtnClick("07000")}>
                      <img src={icn_filter} alt={"템플릿 태그 필터 아이콘"}/>
                  </button>
                  <div className={"template_tag_list"}>
                      <div 
                          // onMouseLeave={this.handleDragStop}
                      >
                          <ScrollMenu
                              handleMouseOnWheel={(apiObj, ev) => this.handleMouseOnWheel(apiObj, ev)}
                              onMouseDown={(ev) => this.handleDragStart}
                              onMouseUp={(ev) => this.handleDragStop}
                              onMouseMove={this.handleDrag}
                          >
                              <button style={(this.state.h_all_tag_selected || !Object.values(this.state.h_template_all_tag_list)
                                                                                .flat()
                                                                                .some(tag => tag.isSelected === true)) 
                                            ? {backgroundColor:'#00E2E6', border: '1px solid #00E2E6'} : {backgroundColor: '#FFF', border: '1px solid #ACACAC'}}
                                      onClick={() => this.allTagBtnClick("07000", "h")}>{this.state.template_tag_list ? this.state.template_tag_list[0].tag_name : ""}</button>
                              {
                                  Object.keys(this.state.h_template_all_tag_list).map((category, tag_idx) => (
                                      this.state.h_template_all_tag_list[category].map((tag)=>(
                                          <TagButton key={tag.tag_cd} tagCd={tag.tag_cd} tagName={tag.tag_name}
                                                      isSelected={tag.isSelected}
                                                      onClick={(tagCd, isSelected) => this.tagBtnClick(category, tag.tag_cd, isSelected, "07000", "h")}/>
                                      ))
                                  ))
                              }
                          </ScrollMenu>
                      </div>
                  </div>
              </div>
          }
          <div className="template-grid" data-instagram-tutorial="design-template-list">
            {
                bannerTypeList.length > 0 &&
                bannerTypeList.map((item) => {
                    return cardReal(item, item.banner_name, item.val2);
                })
            }
            {
              mobileBannerTypeList.length > 0 &&
                mobileBannerTypeList.map((item) => {
                  return cardReal(item, item.banner_name, item.val2);
                })
            }
            {/* {card("single", "싱글 (1개)", "linear-gradient(135deg, #00e2e6, #49BCBD)")}
            {card("double", "더블 (2개)", "linear-gradient(135deg, #f093fb, #f5576c)")}
            {card("triple", "트리플 (3개)", "linear-gradient(135deg, #fa709a, #fee140)")}
            {card("grid", "그리드 (4개)", "linear-gradient(135deg, #30cfd0, #330867)")} */}
          </div>
          <div style={{lineHeight:"60px", width:"100%", textAlign:"center"}}>
            {
              bannerTypeList.length > 0 &&
                <Pagination
                    activePage={this.state.pc_banner_type_paging.activePage}
                    itemsCountPerPage={this.state.pc_banner_type_paging.rowcnt}
                    totalItemsCount={this.state.pc_banner_type_paging.totalCnt}
                    pageRangeDisplayed={10}
                    onChange={this.handleBannerPageChange.bind(this)}
                />
            }
            {
              mobileBannerTypeList.length > 0 &&
                <Pagination
                    activePage={this.state.mobile_banner_type_paging.activePage}
                    itemsCountPerPage={this.state.mobile_banner_type_paging.rowcnt}
                    totalItemsCount={this.state.mobile_banner_type_paging.totalCnt}
                    pageRangeDisplayed={10}
                    onChange={this.handleMobileBannerPageChange.bind(this)}
                />
            }
          </div>
        </div>
      </>
    );
  }


  renderMobileTemplatePopup() {
    const { mobileTemplatePopupOpen, mobile_event_type_cd, selectedTemplateType, mobileBannerTypeList } = this.state;

    const mCard = (type, label, gradient) => (
      <div
        className={
          "mobile-template-card" +
          (selectedTemplateType === type ? " selected" : "")
        }
        onClick={() => this.selectMobileTemplate(type)}
      >
        <div
          className="mobile-template-preview"
          style={{ background: gradient }}
        />
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {label}
        </div>
      </div>
    );
    const mCardReal = (type, label, img_url) => (
      <div
        className={
          "mobile-template-card" +
          (mobile_event_type_cd == type ? " selected" : "")
        }
        onClick={() => this.onClickBannerTypeRadioButton(type, "event_mobile_type_cd", "event_mobile_banner_name")}
      >
        <div
          className="mobile-template-preview"
          style={{ background: `url(${img_url})` }}
        />
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {label}
        </div>
      </div>
    );

    if (!mobileTemplatePopupOpen) return null;

    return (
      <>
        <div
          className="mobile-overlay show"
          onClick={this.closeMobileTemplatePopup}
        />
        <div className="mobile-template-popup show">
          <div className="popup-header">
            <div className="popup-title">템플릿 선택</div>
            <button className="popup-close" onClick={this.closeMobileTemplatePopup}>
              ×
            </button>
          </div>
          <div className="mobile-template-grid">
            {
              mobileBannerTypeList.length > 0 &&
                mobileBannerTypeList.map((item) => {
                  return mCardReal(item.code_cd, item.banner_name, item.val2);
                })
            }
            {/* {mCard("single", "싱글 (1개)", "linear-gradient(135deg, #00e2e6, #49BCBD)")}
            {mCard("double", "더블 (2개)", "linear-gradient(135deg, #f093fb, #f5576c)")}
            {mCard("triple", "트리플 (3개)", "linear-gradient(135deg, #fa709a, #fee140)")}
            {mCard("grid", "그리드 (4개)", "linear-gradient(135deg, #30cfd0, #330867)")} */}
          </div>
        </div>
      </>
    );
  }
  
  renderCanvas() {
    const {
      images,
      selectedImageIndex,
      mainText,
      subText,
      mainPos,
      subPos,
      mainFontFamily,
      subFontFamily,
      mainBold,
      mainItalic,
      mainUnderline,
      subBold,
      subItalic,
      subUnderline,
      mainSizePercent,
      subSizePercent,
      mainColor,
      subColor,
      textUnitMode,

      designTitle,
    } = this.state;

    const mainStyle = {
      position: "absolute",
      color: mainColor,
      fontFamily: mainFontFamily,
      fontWeight: mainBold ? "700" : "400",
      fontStyle: mainItalic ? "italic" : "normal",
      textDecoration: mainUnderline ? "underline" : "none",
      fontSize: `${(36 * mainSizePercent) / 100}px`,
      left:
        textUnitMode === "percent" ? `${mainPos.x}%` : `${mainPos.x}px`,
      bottom:
        textUnitMode === "percent"
          ? `${100 - mainPos.y}%`
          : `${mainPos.y}px`,
      maxWidth:
        textUnitMode === "percent" ? `${mainPos.w}%` : `${mainPos.w}px`,
      maxHeight:
        textUnitMode === "percent" ? `${mainPos.h}%` : `${mainPos.h}px`,
    };

    const subStyle = {
      position: "absolute",
      color: subColor,
      fontFamily: subFontFamily,
      fontWeight: subBold ? "700" : "400",
      fontStyle: subItalic ? "italic" : "normal",
      textDecoration: subUnderline ? "underline" : "none",
      fontSize: `${(18 * subSizePercent) / 100}px`,
      left:
        textUnitMode === "percent" ? `${subPos.x}%` : `${subPos.x}px`,
      bottom:
        textUnitMode === "percent"
          ? `${100 - subPos.y}%`
          : `${subPos.y}px`,
      maxWidth:
        textUnitMode === "percent" ? `${subPos.w}%` : `${subPos.w}px`,
      maxHeight:
        textUnitMode === "percent" ? `${subPos.h}%` : `${subPos.h}px`,
    };

    const linesMain = mainText.split("\n");
    const linesSub = subText.split("\n");

    

    return (
      <div className="editor-canvas">
        <div className="toolbar">
            <div className="toolbar-left">
                <div className="toolbar-brand">
                    <span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="13.5" r="1" fill="#333333"/>
                            <circle cx="15" cy="13.5" r="1" fill="#333333"/>
                            <rect x="4.75" y="7.35156" width="14.5" height="13.5" rx="2.75" stroke="#333333" stroke-width="1.5"/>
                            <path d="M18.5 11H19.1C20.1493 11 21 11.8507 21 12.9V15.1C21 16.1493 20.1493 17 19.1 17H18.5" stroke="#333333"/>
                            <path d="M5.5 17L4.9 17C3.85066 17 3 16.1493 3 15.1L3 12.9C3 11.8507 3.85066 11 4.9 11L5.5 11" stroke="#333333"/>
                            <path d="M11 16C12 16.5 12.5 16.5 13.5 16" stroke="#333333" stroke-linecap="round"/>
                            <rect x="9.09961" y="2.5" width="6" height="2" rx="1" stroke="#333333"/>
                            <rect x="6.5" y="9.5" width="11" height="9" rx="2" stroke="#333333"/>
                            <path d="M12 5V7" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </span>
                    {" "}
                    로보MD 디자인 에디터
                </div>

                {/* <select
                    id="sizePreset"
                    value={sizePreset}
                    onChange={(e) => onChangeCanvasSize && onChangeCanvasSize(e.target.value)}
                    style={{
                    marginLeft: "16px",
                    padding: "6px 12px",
                    border: "1px solid var(--border)",
                    borderRadius: "6px",
                    background: "white",
                    cursor: "pointer",
                    }}
                >
                    <option value="1080x1080">인스타그램 정사각형 (1080x1080)</option>
                    <option value="1080x1350">인스타그램 세로 (1080x1350)</option>
                    <option value="1080x608">인스타그램 가로 (1080x608)</option>
                    <option value="1200x628">페이스북 (1200x628)</option>
                    <option value="1024x512">트위터 (1024x512)</option>
                    <option value="1280x720">유튜브 썸네일 (1280x720)</option>
                    <option value="728x90">배너 광고 (728x90)</option>
                    <option value="300x250">중형 배너 (300x250)</option>
                    <option value="custom">사용자 지정</option>
                </select> */}
            </div>

            <div className="toolbar-actions">
                <div className="toolbar-group">
                  {/* <input
                      type="text"
                      id="designTitle"
                      placeholder="디자인 제목"
                      value={designTitle}
                      onChange={(e) => this.onChangeDesignTitle && this.onChangeDesignTitle(e.target.value)}
                      style={{
                      padding: "6px 12px",
                      border: "1px solid var(--border)",
                      borderRadius: "6px",
                      width: "150px",
                      }}
                  /> */}
                  {
                  window.location.href.indexOf("/instagram") < 0
                  ?
                  <TextInput
                      type="text"
                      id="designTitle"
                      placeholder="디자인 제목"
                      value={this.state.none_title}
                      onChange={(e) => this.onChangeTitle(e, "none_title")}
                      width="150px"
                      padding="6px 12px"
                      background="#fff"
                  />
                  : ""
                  }
                  {/* <button className="btn" type="button" onClick={onUndo}>
                      실행 취소
                  </button>

                  <button className="btn" type="button" onClick={onRedo}>
                      다시 실행
                  </button>

                  <button className="btn" type="button" onClick={onPreview}>
                      미리보기
                  </button> */}
                  <button className="btn btn_download" type="button" data-instagram-tutorial="design-editor-download" onClick={e => {
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                    ? this.downloadOneBannerBtnClick("is_download_w")
                    : this.downloadOneBannerBtnClick("is_download_h")
                  }}>
                      <svg
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      >
                      <path d="M7 10l5 5 5-5M12 15V3M3 17v4h18v-4" strokeWidth="2" />
                      </svg>
                      {" "}
                      다운로드
                  </button>
                  <button
                      className="btn btn-primary btn_save"
                      type="button"
                      data-instagram-tutorial="design-editor-apply"
                      onClick={this.saveEvent}
                      style={{backgroundColor:'#00E2E6', border: '1px solid #00E2E6', color: '#333'}}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.5594 7.5L16.5 3.44063C16.3613 3.30084 16.1962 3.18993 16.0144 3.1143C15.8326 3.03867 15.6376 2.99983 15.4406 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V8.55938C21.0002 8.36244 20.9613 8.16743 20.8857 7.9856C20.8101 7.80376 20.6992 7.63872 20.5594 7.5ZM15.75 19.5H8.25V14.25H15.75V19.5ZM19.5 8.55938V19.5H17.25V14.25C17.25 13.8522 17.092 13.4706 16.8107 13.1893C16.5294 12.908 16.1478 12.75 15.75 12.75H8.25C7.85218 12.75 7.47064 12.908 7.18934 13.1893C6.90804 13.4706 6.75 13.8522 6.75 14.25V19.5H4.5V4.5H15.4406L19.5 8.55938ZM15 6.75C15 6.94891 14.921 7.13968 14.7803 7.28033C14.6397 7.42098 14.4489 7.5 14.25 7.5H9C8.80109 7.5 8.61032 7.42098 8.46967 7.28033C8.32902 7.13968 8.25 6.94891 8.25 6.75C8.25 6.55109 8.32902 6.36032 8.46967 6.21967C8.61032 6.07902 8.80109 6 9 6H14.25C14.4489 6 14.6397 6.07902 14.7803 6.21967C14.921 6.36032 15 6.55109 15 6.75Z" fill="#333333"/>
                    </svg>
                      {
                        window.location.href.indexOf("/instagram") >= 0
                        ? "적용"
                        : "저장"
                      }
                  </button>
                </div>

                <div className="toolbar-group" style={{ justifyContent: "flex-end" }}>
                  <button className="modal-close" onClick={this.closeModal}>
                      ×
                  </button>
                </div>
            </div>
        </div>
        <div
          className="canvas-frame"
          id="canvasFrame"
          style={this.getCanvasBackgroundStyle()}
        >
          {
            Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
            ?
              <object className="robomd_banner_p" type="text/html" 
              data={""}
              style={{display:"block", width:"100%", height:"100%", background: "white"}}/>
            :
              <object className="robomd_banner_m" type="text/html" 
              data={""}
              style={{display:"block", width:"100%", height:"100%", background: "white"}}/>
          }
        </div>
      </div>
    );
  }

  renderImageTab() {
    const {
      images,
      currentUnit,
      contourCorrection,
      faceAuto,
    } = this.state;

    const isPcBanner = Object.keys(this.state.selected_pc_banner_ratio ?? {}).length > 0;
    const imageType = isPcBanner ? "w" : "h";
    const img_position_name = isPcBanner
      ? (this.state.w_img_position_name || [])
      : (this.state.h_img_position_name || []);

    const mapped_img_position_name = img_position_name
      .map((position, index) => ({
        ...position,
        originalIndex: index,
        imageIndex: index + 1,
      }));
    const hasImageUseFlag = [1, 2, 3, 4].some((idx) =>
      ["Y", "N"].includes(this.state[`${imageType}_img${idx}_is_use`])
    );
    const visible_img_position_name = hasImageUseFlag
      ? mapped_img_position_name.filter((position) => this.state[`${imageType}_img${position.imageIndex}_is_use`] === "Y")
      : mapped_img_position_name;

    const firstVisibleImageIndex = visible_img_position_name[0]?.imageIndex || 1;
    const isSelectedImageVisible = visible_img_position_name.some(
      (position) => position.imageIndex === this.state.selectedImageIndex
    );
    const selectedImageIndex = isSelectedImageVisible
      ? this.state.selectedImageIndex
      : firstVisibleImageIndex;

    if (visible_img_position_name.length <= 0) {
      return (
        <div class="image-selector-info" data-instagram-tutorial="design-image-panel">
            {/* <span><i className="fa fa-lightbulb-o"></i></span> */}
            <span>선택하신 템플릿은 이미지 등록이 필요 없는 템플릿입니다.</span>
        </div>
      )
    }

    return (
      <div id="imageTab" className="tab-content" data-instagram-tutorial="design-image-panel">
        {/* 이미지 선택 */}
        <div className="control-section" data-instagram-tutorial="design-image-select">
          {/* <h4 className="control-title">
            <span><i className="fa fa-camera"></i></span>
            <span>이미지 선택</span>
          </h4> */}

          <div class="image-selector-info">
                <span><i className="fa fa-lightbulb-o"></i></span>
                <span>아래 썸네일을 클릭하여 선택한 후 설정을 변경하세요</span>
            </div>

          <div className="carousel-container">
            <div className="carousel-track">
              <div className="carousel-images" id="carouselImages">

                {visible_img_position_name.map((position) => {
                  const index = position.originalIndex;
                  return (
                  <div
                    key={index+1}
                    className={
                      "carousel-item" +
                      ((index+1) === selectedImageIndex ? " active" : "")
                    }
                    // onClick={() => this.showUploadPopup(img.index)}
                     onClick={() =>
                        this.handleSelectCarouselImage(index+1)
                      }
                  >
                    {
                      Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ?
                      this.state.w_user_img_list[index].img_link
                      ?
                      <div
                        style={{
                          aspectRatio: "1",
                          backgroundImage: `url(${
                            this.state.w_user_img_list[index].img_link
                          })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      : 
                      <>
                        <div className="carousel-item-placeholder">
                          <div style={{ fontSize: "20px" }}><i className="fa fa-camera"></i></div>
                          <div style={{ fontSize: "10px" }}>
                            이미지 {window.location.href.indexOf("/instagram") < 0 && " / 동영상 "} {(index+1)}
                          </div>
                        </div>
                        <div className="carousel-item-number">
                          {(index+1)}
                        </div>
                      </>
                      :
                      this.state.h_user_img_list[index].img_link
                      ?
                      <div
                        style={{
                          aspectRatio: "1",
                          backgroundImage: `url(${
                            this.state.h_user_img_list[index].img_link
                          })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      : 
                      <>
                        <div className="carousel-item-placeholder">
                          <div style={{ fontSize: "20px" }}><i className="fa fa-camera"></i></div>
                          <div style={{ fontSize: "10px" }}>
                            이미지 {window.location.href.indexOf("/instagram") < 0 && " / 동영상 "} {(index+1)}
                          </div>
                        </div>
                        <div className="carousel-item-number">
                          {(index+1)}
                        </div>
                      </>
                    }

                    <div className="carousel-item-actions">
                        <button
                            className="carousel-action-btn"
                            onClick={(e) => {
                            e.stopPropagation();
                            this.showUploadPopup((index+1));
                            }}
                            title="변경"
                        >
                            <i className="fa fa-pencil"></i>
                        </button>
                        <button
                            className="carousel-action-btn delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length) {
                                this.setState(prevState => {
                                  const target = prevState.w_user_img_list[index];

                                  if (target?.img_link == null) {
                                    return null; // ❗ state 변경 없음
                                  }


                                  const list = [...prevState.w_user_img_list];
                                  list[index] = {
                                    ...target,
                                    org_img_seq: "",
                                    org_img_name: "",
                                    img_link: "",
                                    video_link: "",
                                    img_link_able: false
                                  };

                                  return {
                                    w_user_img_list: list,
                                    ...this.getTemplateImageClearStatePatch("w", index, prevState)
                                  };
                                }, () => {
                                    this.insertEventTmp('preview', this.getTemplateImageClearPreviewNukkiInfo("w", index));
                                });
                              } else {
                                this.setState(prevState => {
                                  const target = prevState.h_user_img_list[index];

                                  if (target?.img_link == null) {
                                    return null; // ❗ state 변경 없음
                                  }


                                  const list = [...prevState.h_user_img_list];
                                  list[index] = {
                                    ...target,
                                    org_img_seq: "",
                                    org_img_name: "",
                                    img_link: "",
                                    video_link: "",
                                    img_link_able: false
                                  };

                                  return {
                                    h_user_img_list: list,
                                    ...this.getTemplateImageClearStatePatch("h", index, prevState)
                                  };
                                }, () => {
                                    this.insertEventTmp('preview', this.getTemplateImageClearPreviewNukkiInfo("h", index));
                                });
                              }}
                              }
                            title="삭제"
                        >
                            <i className="fa fa-trash"></i>
                        </button>
                    </div>
                  </div>
                  );
                })}
                {/* <div
                  className="carousel-item add-image-btn"
                  onClick={this.addNewImage}
                >
                  <span>+</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* 이미지 설정 + AI 기능 */}
        <div className="control-section" data-instagram-tutorial="design-image-settings">
          <h4 className="control-title">
            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="#49BCBD"/>
                </svg>
            </span>
            <span>이미지 설정</span>
          </h4>

          <div className="ai-feature-box" data-instagram-tutorial="design-image-ai">
            <div className="ai-feature-title"
                style={{display: "flex", alignItems: "center", gap: "6px",}}
            >
              <div style={{marginBottom: "2px", marginRight: "2px"}}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18.5232 12.0994L13.6847 10.3181L11.9035 5.47594C11.798 5.18937 11.6072 4.94206 11.3567 4.76736C11.1063 4.59267 10.8082 4.499 10.5029 4.499C10.1975 4.499 9.89949 4.59267 9.64904 4.76736C9.39858 4.94206 9.20773 5.18937 9.10225 5.47594L7.31912 10.3125L2.47694 12.0938C2.19037 12.1992 1.94305 12.3901 1.76836 12.6405C1.59367 12.891 1.5 13.189 1.5 13.4944C1.5 13.7997 1.59367 14.0978 1.76836 14.3482C1.94305 14.5987 2.19037 14.7895 2.47694 14.895L7.31256 16.6875L9.09381 21.5269C9.1993 21.8134 9.39014 22.0608 9.6406 22.2355C9.89106 22.4101 10.1891 22.5038 10.4944 22.5038C10.7998 22.5038 11.0978 22.4101 11.3483 22.2355C11.5987 22.0608 11.7896 21.8134 11.8951 21.5269L13.6763 16.6884L18.5185 14.9072C18.8051 14.8017 19.0524 14.6109 19.2271 14.3604C19.4018 14.1099 19.4954 13.8119 19.4954 13.5066C19.4954 13.2012 19.4018 12.9032 19.2271 12.6527C19.0524 12.4023 18.8051 12.2114 18.5185 12.1059L18.5232 12.0994ZM13.1616 15.2812C12.9589 15.3556 12.7749 15.4732 12.6222 15.6259C12.4696 15.7786 12.352 15.9626 12.2776 16.1653L10.4963 20.9897L8.71881 16.1616C8.64436 15.96 8.52712 15.7769 8.37516 15.6249C8.22319 15.4729 8.04011 15.3557 7.8385 15.2812L3.01412 13.5L7.8385 11.7188C8.04011 11.6443 8.22319 11.5271 8.37516 11.3751C8.52712 11.2231 8.64436 11.04 8.71881 10.8384L10.5001 6.01406L12.2813 10.8384C12.3557 11.0411 12.4733 11.2252 12.626 11.3778C12.7786 11.5305 12.9627 11.6481 13.1654 11.7225L17.9897 13.5037L13.1616 15.2812ZM13.5001 3.75C13.5001 3.55109 13.5791 3.36032 13.7197 3.21967C13.8604 3.07902 14.0511 3 14.2501 3H15.7501V1.5C15.7501 1.30109 15.8291 1.11032 15.9697 0.96967C16.1104 0.829018 16.3011 0.75 16.5001 0.75C16.699 0.75 16.8897 0.829018 17.0304 0.96967C17.171 1.11032 17.2501 1.30109 17.2501 1.5V3H18.7501C18.949 3 19.1397 3.07902 19.2804 3.21967C19.421 3.36032 19.5001 3.55109 19.5001 3.75C19.5001 3.94891 19.421 4.13968 19.2804 4.28033C19.1397 4.42098 18.949 4.5 18.7501 4.5H17.2501V6C17.2501 6.19891 17.171 6.38968 17.0304 6.53033C16.8897 6.67098 16.699 6.75 16.5001 6.75C16.3011 6.75 16.1104 6.67098 15.9697 6.53033C15.8291 6.38968 15.7501 6.19891 15.7501 6V4.5H14.2501C14.0511 4.5 13.8604 4.42098 13.7197 4.28033C13.5791 4.13968 13.5001 3.94891 13.5001 3.75ZM23.2501 8.25C23.2501 8.44891 23.171 8.63968 23.0304 8.78033C22.8897 8.92098 22.699 9 22.5001 9H21.7501V9.75C21.7501 9.94891 21.671 10.1397 21.5304 10.2803C21.3897 10.421 21.199 10.5 21.0001 10.5C20.8011 10.5 20.6104 10.421 20.4697 10.2803C20.3291 10.1397 20.2501 9.94891 20.2501 9.75V9H19.5001C19.3011 9 19.1104 8.92098 18.9697 8.78033C18.8291 8.63968 18.7501 8.44891 18.7501 8.25C18.7501 8.05109 18.8291 7.86032 18.9697 7.71967C19.1104 7.57902 19.3011 7.5 19.5001 7.5H20.2501V6.75C20.2501 6.55109 20.3291 6.36032 20.4697 6.21967C20.6104 6.07902 20.8011 6 21.0001 6C21.199 6 21.3897 6.07902 21.5304 6.21967C21.671 6.36032 21.7501 6.55109 21.7501 6.75V7.5H22.5001C22.699 7.5 22.8897 7.57902 23.0304 7.71967C23.171 7.86032 23.2501 8.05109 23.2501 8.25Z"
                        fill="#00bfc2"
                        stroke="#00e2e6"
                        stroke-width="0.4"
                        stroke-linejoin="round"
                    />
                </svg>
              </div>
              <div>AI 자동 기능</div>
              <div className="ai-badge">AI</div>
            </div>

            <button
              className="ai-extract-btn"
              // onClick={this.extractColors}
              onClick={() => {
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                ? this.onSelectImgLinkColor("w", selectedImageIndex-1)
                : this.onSelectImgLinkColor("h", selectedImageIndex-1)
              }}
            >
              <i className="fa fa-paint-brush"></i>{" "}<span style={{marginLeft: "6px"}}>AI 색상 자동 추출</span>
            </button>
            {
            (
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                ?
                    this.state.w_essential_img_nukki_yn == "Y"
                    && !(this.state.w_user_img_list[(selectedImageIndex - 1)].link_type == "49002" && this.state.w_user_img_list[(selectedImageIndex - 1)].img_link && !this.state.w_user_img_list[(selectedImageIndex - 1)].img_link_able)
                    && !(this.state.w_user_img_list[(selectedImageIndex - 1)].link_type == "49004" && this.state.w_user_img_list[(selectedImageIndex - 1)].img_link && !this.state.w_user_img_list[(selectedImageIndex - 1)].img_link_able)
                    && !(this.state.w_is_youtube_link_use == "Y" && this.state.w_user_img_list[(selectedImageIndex - 1)].link_type == "49005" && this.state.w_user_img_list[(selectedImageIndex - 1)].video_link)
                : 
                    this.state.h_essential_img_nukki_yn == "Y"
                    && !(this.state.h_user_img_list[(selectedImageIndex - 1)].link_type == "49002" && this.state.h_user_img_list[(selectedImageIndex - 1)].img_link && !this.state.h_user_img_list[(selectedImageIndex - 1)].img_link_able)
                    && !(this.state.h_user_img_list[(selectedImageIndex - 1)].link_type == "49004" && this.state.h_user_img_list[(selectedImageIndex - 1)].img_link && !this.state.h_user_img_list[(selectedImageIndex - 1)].img_link_able)
                    && !(this.state.h_is_youtube_link_use == "Y" && this.state.h_user_img_list[(selectedImageIndex - 1)].link_type == "49005" && this.state.h_user_img_list[(selectedImageIndex - 1)].video_link)
            )
            ?
            <div
              style={{
                padding: "12px",
                background: "white",
                borderRadius: "8px",
                marginBottom: "8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: "13px",
                    }}
                  >
                    AI 배경 제거
                  </div>
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#636e72",
                    }}
                  >
                    자동으로 배경 제거
                  </div>
                </div>
                {/* <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={bgRemoveEnabled}
                    onChange={this.toggleBgRemove}
                  />
                  <span className="toggle-slider"></span>
                </label> */}
                {
                  Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                  ?
                  <ToggleButton
                      id={"w_nukki_yn_" + (selectedImageIndex - 1)}
                      checked={this.state["w_" + img_position_name[(selectedImageIndex - 1)]["position_name"] + "_nukki_yn"] == "Y"}
                      onClickOption={(e) => this.onClickRemoveBackground(e, "w", (selectedImageIndex - 1) + 1)}
                  />
                  :
                  <ToggleButton
                      id={"h_nukki_yn_" + (selectedImageIndex - 1)}
                      checked={this.state["h_" + img_position_name[(selectedImageIndex - 1)]["position_name"] + "_nukki_yn"] == "Y"}
                      onClickOption={(e) => this.onClickRemoveBackground(e, "h", (selectedImageIndex - 1) + 1)}
                  />
                }
              </div>

              {
                (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                ? this.state["w_" + img_position_name[(selectedImageIndex - 1)]["position_name"] + "_nukki_yn"] == "Y" 
                : this.state["h_" + img_position_name[(selectedImageIndex - 1)]["position_name"] + "_nukki_yn"] == "Y")
                && (
                <div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#636e72",
                      marginBottom: "8px",
                    }}
                  >
                    제거 강도
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "8px",
                      marginBottom: "12px",
                    }}
                  >
                    {[1, 2, 3].map((t, idx) => (
                      <button
                        key={t}
                        className="bg-type-btn"
                        style={{
                          padding: "8px",
                          border: 
                            this.state[
                                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                                ? "w_" + "bgRemoveStrength_"+selectedImageIndex
                                : "h_" + "bgRemoveStrength_"+selectedImageIndex
                            ] === t
                            ? "1px solid #00e2e6" : "1px solid #D1D1D1",
                          borderRadius: "8px",
                          fontSize: "12px",
                          cursor: "pointer",
                          background:
                            this.state[
                                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                                ? "w_" + "bgRemoveStrength_"+selectedImageIndex
                                : "h_" + "bgRemoveStrength_"+selectedImageIndex
                            ] === t
                              ? "#00e2e6"
                              : "white",
                          color: "#2d3436",
                        }}
                        // onClick={() => this.setBgType(t)}
                        onClick={() => {
                          Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                          ? this.onChangeVersionSlider(t, "w", (selectedImageIndex - 1) + 1, true)
                          : this.onChangeVersionSlider(t, "h", (selectedImageIndex - 1) + 1, true)
                        }}
                      >
                        {t === 1
                          ? "부드럽게"
                          : t === 2
                          ? "일반"
                          : t === 3
                          && "강하게"}
                      </button>
                    ))}
                  </div>
                {
                  (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                      ? this.state.w_nukki_version_list[(selectedImageIndex - 1)] != "3"
                      : this.state.h_nukki_version_list[(selectedImageIndex - 1)] != "3")
                  &&
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px",
                      background: "#f8f9fa",
                      borderRadius: "6px",
                      marginTop: "8px",
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>
                      윤곽 보정
                    </span>
                    {/* <label
                      className="toggle-switch"
                      style={{ transform: "scale(0.8)" }}
                    >
                      <input
                        type="checkbox"
                        checked={contourCorrection}
                        onChange={() => {this.toggleContourCorrection();}} 
                      />
                      <span className="toggle-slider"></span>
                    </label> */}
                    {
                      Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                      ? 
                        <ToggleButton
                            id={"w_nukki_ppm_state_" + (selectedImageIndex - 1)}
                            checked={this.state.w_nukki_ppm_state[(selectedImageIndex - 1)]}
                            onClickOption={(e) => this.changeNukkiPPMstate(e, "w", (selectedImageIndex - 1) + 1)}
                            disabled={this.state.w_nukki_version_list[(selectedImageIndex - 1)] == "3"}
                        /> 
                      :
                        <ToggleButton
                            id={"h_nukki_ppm_state_" + (selectedImageIndex - 1)}
                            checked={this.state.h_nukki_ppm_state[(selectedImageIndex - 1)]}
                            onClickOption={(e) => this.changeNukkiPPMstate(e, "h", (selectedImageIndex - 1) + 1)}
                            disabled={this.state.h_nukki_version_list[(selectedImageIndex - 1)] == "3"}
                        />
                    }
                  </div>
                }
                </div>
              )}
            </div>
            : <>
            {/* AI로 배경 바꾸기 */}
            <button
            className="ai-extract-btn"
            style={{background: "linear-gradient(to right, #95a8ff, #5164bb)", boxShadow: "0 4px 12px rgb(110 129 216 / 30%)"}}
            onClick={() => {
                this.setState({
                    show_robo_img_popup: true,
                    robo_img_default_tab : "INPAINT",
                    robo_img_default_upload_image_link : 
                        (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                        ? this.state.w_user_img_list[selectedImageIndex - 1].img_link
                        : this.state.h_user_img_list[selectedImageIndex - 1].img_link),
                });
            }}
            >
            <i className="fa fa-refresh"></i>{" "}<span style={{marginLeft: "6px"}}>AI 이미지 배경 교체</span>
            </button>
            </>
          }


            {
              Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
              ?
                !(this.state.w_is_youtube_link_use == "Y" && this.state.w_user_img_list[selectedImageIndex - 1].link_type == "49005" && this.state.w_user_img_list[selectedImageIndex - 1].video_link)
                    ? this.state.w_is_full_background_img_use == "Y"
                        ? <button style={{marginTop: "5px"}}
                            className="ai-extract-btn-secondary"
                            onClick={() => this.modelImageShift("w", selectedImageIndex - 1)}>AI 인물 위치 자동 이동</button>
                        : this.state.w_is_fashionplus_face_banner_use == "Y"
                            ? <button
                                    className="ai-extract-btn-secondary"
                                    onClick={() => this.faceImageShiftForFashionPlus("w", selectedImageIndex - 1, this.state.w_is_nukki_crop_yn)}>AI 얼굴 위치 자동 이동</button>
                            : ""
                    : ""
                : 
                  !(this.state.h_is_youtube_link_use == "Y" && this.state.h_user_img_list[selectedImageIndex - 1].link_type == "49005" && this.state.h_user_img_list[selectedImageIndex - 1].video_link)
                      ? this.state.h_is_full_background_img_use == "Y"
                          ? <button style={{marginTop: "5px"}}
                              className="ai-extract-btn-secondary"
                              onClick={() => this.modelImageShift("h", selectedImageIndex - 1)}>AI 인물 위치 자동 이동</button>
                          : this.state.h_is_fashionplus_face_banner_use == "Y"
                              ? <button
                                      className="ai-extract-btn-secondary"
                                      onClick={() => this.faceImageShiftForFashionPlus("h", selectedImageIndex - 1, this.state.h_is_nukki_crop_yn)}>AI 얼굴 위치 자동 이동</button>
                              : ""
                      : ""
            }
            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px",
                background: "white",
                borderRadius: "8px",
              }}
            >
              <div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                  }}
                >
                  AI 얼굴 자동 감지
                </div>
                <div
                  style={{
                    fontSize: "11px",
                    color: "#636e72",
                  }}
                >
                  모델 얼굴 자동 위치 조정
                </div>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={faceAuto}
                  onChange={this.toggleFaceAuto}
                />
                <span className="toggle-slider"></span>
              </label>
            </div> */}
          </div>

          {/* 이미지 위치 */}
          <div className="main_txt_position_section" style={{marginBottom: "12px" }} data-instagram-tutorial="design-image-position">
              <div
                style={{
                  fontSize: "13px",
                  color: "#636e72",
                  marginBottom: "8px",
                }}
              >
                이미지 위치
              </div>
              {/* {console.log("this.state.pc_banner_ratio_list.length", this.state.pc_banner_ratio_list.length)} */}
              {
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                ?
                <>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                    <div style={{
                            // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>X
                    </div>
                    <div style={{
                        marginLeft: "6px",
                        fontSize: "15px"
                    }}>
                        <input className="numbersOnly input_banner_img_position"
                        type="text"  
                        value={this.state["w_img_position_x_"+selectedImageIndex]}
                        onChange={e => {
                            if (Number(e.target.value) >= 0) {
                              this.setState({
                                ["w_img_position_right_"+selectedImageIndex]: e.target.value,
                                ["w_img_position_x_"+selectedImageIndex]: e.target.value
                              })
                            } else {
                              this.setState({
                                ["w_img_position_left_"+selectedImageIndex]: Math.abs(e.target.value),
                                ["w_img_position_x_"+selectedImageIndex]: e.target.value
                              })
                            }
                        }}
                        onKeyDown={e => {
                                const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                if (isEnterKey) {
                                    e.target.blur();
                                }
                            }
                        }
                        onBlur={e => {
                          if (Number(e.target.value) > 0) {
                            this.movePositionOnBlur(e, "w_img_position_right_"+selectedImageIndex, "w_img_position_left_"+selectedImageIndex)                          
                          } else if (Number(e.target.value < 0)) {
                            this.movePositionOnBlur(e, "w_img_position_left_"+selectedImageIndex, "w_img_position_right_"+selectedImageIndex)
                          } else {
                            isTmp = true;
                            this.setState({
                              ["w_img_position_x_"+selectedImageIndex]: e.target.value,
                              ["w_img_position_right_"+selectedImageIndex]: 0,
                              ["w_img_position_left_"+selectedImageIndex]: 0
                            })
                          }
                        }}
                        style={{
                            width: "70px",
                            height: "25px",
                            paddingTop:"0px",
                            paddingBottom:"0px",
                            backgroundColor: "white",
                        }}
                        autocomplete="off"/>
                    </div>
                    <div style={{
                        // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>%
                    </div>
                    <div style={{marginLeft: "18px", flex: "0.9"}}>
                        <Slider
                            className="slider_w_img_position_x"
                            aria-label="Small steps"
                            defaultValue={this.state["w_img_position_x_"+selectedImageIndex] ? this.state["w_img_position_x_"+selectedImageIndex] : 0}
                            value={this.state["w_img_position_x_"+selectedImageIndex]}
                            step={1}
                            min={this.state["w_img_position_x_"+selectedImageIndex] < -50 ? Number(this.state["w_img_position_x_"+selectedImageIndex]) : -50}
                            max={this.state["w_img_position_x_"+selectedImageIndex] > 50 ?  Number(this.state["w_img_position_x_"+selectedImageIndex]) :50}
                            valueLabelDisplay="auto"
                            sx={{
                                color: "#00e2e6",
                                width: "100px",
                                margin: "0 auto"
                            }}
                            onChange={async (e) => { 
                                if (Number(e.target.value) >= 0) {
                                  this.setState({
                                    ["w_img_position_right_"+selectedImageIndex]: e.target.value,
                                    ["w_img_position_x_"+selectedImageIndex]: e.target.value
                                  })
                                } else {
                                  this.setState({
                                    ["w_img_position_left_"+selectedImageIndex]: Math.abs(e.target.value),
                                    ["w_img_position_x_"+selectedImageIndex]: e.target.value
                                  })
                                }
                            }}
                            onChangeCommitted={(e, newValue) => {
                              if (Number(newValue) >= 0) {
                                this.movePositionOnBlurV2(newValue, "w_img_position_right_"+selectedImageIndex, "w_img_position_left_"+selectedImageIndex)                          
                              } else {
                                this.movePositionOnBlurV2(newValue, "w_img_position_left_"+selectedImageIndex, "w_img_position_right_"+selectedImageIndex)
                              }
                            }}
                        />
                    </div>
                  </div>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                      <div style={{
                              // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>Y
                      </div>
                      <div style={{
                          marginLeft: "6px",
                          fontSize: "15px"
                      }}>
                          <input className="numbersOnly input_banner_img_position"
                          type="text" 
                          value={this.state["w_img_position_y_"+selectedImageIndex]}
                          onChange={e => {
                              if (Number(e.target.value) >= 0) {
                                this.setState({
                                  ["w_img_position_top_"+selectedImageIndex]: e.target.value,
                                  ["w_img_position_y_"+selectedImageIndex]: e.target.value
                                })
                              } else {
                                this.setState({
                                  ["w_img_position_bottom_"+selectedImageIndex]: Math.abs(e.target.value),
                                  ["w_img_position_y_"+selectedImageIndex]: e.target.value
                                })
                              }
                          }}
                          onKeyDown={e => {
                                  const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                  if (isEnterKey) {
                                      e.target.blur();
                                  }
                              }
                          }
                          onBlur={e => {
                            if (Number(e.target.value) > 0) {
                              this.movePositionOnBlur(e, "w_img_position_top_"+selectedImageIndex, "w_img_position_bottom_"+selectedImageIndex)
                            } else if (Number(e.target.value < 0)) {
                              this.movePositionOnBlur(e, "w_img_position_bottom_"+selectedImageIndex, "w_img_position_top_"+selectedImageIndex)                          
                            } else {
                                isTmp = true;
                                this.setState({
                                  ["w_img_position_y_"+selectedImageIndex]: 0,
                                  ["w_img_position_top_"+selectedImageIndex]: 0,
                                  ["w_img_position_bottom_"+selectedImageIndex]: 0
                                })
                            }
                          }}
                          style={{
                                  width: "70px",
                              height: "25px",
                              paddingTop:"0px",
                              paddingBottom:"0px",
                              backgroundColor: "white",
                          }}
                          autocomplete="off"/>
                      </div>
                      <div style={{
                          // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>%
                      </div>
                          <div style={{marginLeft: "18px", flex: "0.9"}}>
                              <Slider
                                  className="slider_w_img_position_y"
                                  aria-label="Small steps"
                                  defaultValue={this.state["w_img_position_y_"+selectedImageIndex] ? this.state["w_img_position_y_"+selectedImageIndex] : 0}
                                  value={this.state["w_img_position_y_"+selectedImageIndex]}
                                  step={1}
                                  min={this.state["w_img_position_y_"+selectedImageIndex] < -50 ? Number(this.state["w_img_position_y_"+selectedImageIndex]) : -50}
                                  max={this.state["w_img_position_y_"+selectedImageIndex] > 50 ?  Number(this.state["w_img_position_y_"+selectedImageIndex]) :50}
                                  valueLabelDisplay="auto"
                                  sx={{
                                      color: "#00e2e6",
                                      width: "100px",
                                      margin: "0 auto"
                                  }}
                                  onChange={async (e) => { 
                                      if (Number(e.target.value) >= 0) {
                                        this.setState({
                                          ["w_img_position_top_"+selectedImageIndex]: e.target.value,
                                          ["w_img_position_y_"+selectedImageIndex]: e.target.value
                                        })
                                      } else {
                                        this.setState({
                                          ["w_img_position_bottom_"+selectedImageIndex]: Math.abs(e.target.value),
                                          ["w_img_position_y_"+selectedImageIndex]: e.target.value
                                        })
                                      }
                                  }}
                                  onChangeCommitted={(e, newValue) => {
                                    if (Number(newValue) >= 0) {
                                      this.movePositionOnBlurV2(newValue, "w_img_position_top_"+selectedImageIndex, "w_img_position_bottom_"+selectedImageIndex)
                                    } else {
                                      this.movePositionOnBlurV2(newValue, "w_img_position_bottom_"+selectedImageIndex, "w_img_position_top_"+selectedImageIndex)                          
                                    }
                                  }}
                              />
                          </div>
                    </div>
                  </>
                  : 
                  <>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                    <div style={{
                            // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>X
                    </div>
                    <div style={{
                        marginLeft: "6px",
                        fontSize: "15px"
                    }}>
                        <input className="numbersOnly input_banner_img_position"
                        type="text" 
                        value={this.state["h_img_position_x_"+selectedImageIndex]}
                        onChange={e => {
                            if (Number(e.target.value) >= 0) {
                              this.setState({
                                ["h_img_position_right_"+selectedImageIndex]: e.target.value,
                                ["h_img_position_x_"+selectedImageIndex]: e.target.value
                              })
                            } else {
                              this.setState({
                                ["h_img_position_left_"+selectedImageIndex]: Math.abs(e.target.value),
                                ["h_img_position_x_"+selectedImageIndex]: e.target.value
                              })
                            }
                        }}
                        onKeyDown={e => {
                                const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                if (isEnterKey) {
                                    e.target.blur();
                                }
                            }
                        }
                        onBlur={e => {
                          if (Number(e.target.value) > 0) {
                            this.movePositionOnBlur(e, "h_img_position_right_"+selectedImageIndex, "h_img_position_left_"+selectedImageIndex)                          
                          } else if (Number(e.target.value < 0)) {
                            this.movePositionOnBlur(e, "h_img_position_left_"+selectedImageIndex, "h_img_position_right_"+selectedImageIndex)
                          } else {
                            isTmp = true;
                            this.setState({
                              ["h_img_position_x_"+selectedImageIndex]: 0,
                              ["h_img_position_left_"+selectedImageIndex]: 0, 
                              ["h_img_position_right_"+selectedImageIndex]: 0,
                            })
                          }
                        }}
                        style={{
                            width: "70px",
                            height: "25px",
                            paddingTop:"0px",
                            paddingBottom:"0px",
                            backgroundColor: "white",
                        }}
                        autocomplete="off"/>
                    </div>
                    <div style={{
                        // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>%
                    </div>
                    <div style={{marginLeft: "18px", flex: "0.9"}}>
                        <Slider
                            className="slider_h_img_position_x"
                            aria-label="Small steps"
                            defaultValue={this.state["h_img_position_x_"+selectedImageIndex] ? this.state["h_img_position_x_"+selectedImageIndex] : 0}
                            value={this.state["h_img_position_x_"+selectedImageIndex]}
                            step={1}
                            min={this.state["h_img_position_x_"+selectedImageIndex] < -50 ? Number(this.state["h_img_position_x_"+selectedImageIndex]) : -50}
                            max={this.state["h_img_position_x_"+selectedImageIndex] > 50 ?  Number(this.state["h_img_position_x_"+selectedImageIndex]) :50}
                            valueLabelDisplay="auto"
                            sx={{
                                color: "#00e2e6",
                                width: "100px",
                                margin: "0 auto"
                            }}
                            onChange={async (e) => { 
                                if (Number(e.target.value) >= 0) {
                                  this.setState({
                                    ["h_img_position_right_"+selectedImageIndex]: e.target.value,
                                    ["h_img_position_x_"+selectedImageIndex]: e.target.value
                                  })
                                } else {
                                  this.setState({
                                    ["h_img_position_left_"+selectedImageIndex]: Math.abs(e.target.value),
                                    ["h_img_position_x_"+selectedImageIndex]: e.target.value
                                  })
                                }
                            }}
                            onChangeCommitted={(e, newValue) => {
                              if (Number(newValue) >= 0) {
                                this.movePositionOnBlurV2(newValue, "h_img_position_right_"+selectedImageIndex, "h_img_position_left_"+selectedImageIndex)                          
                              } else {
                                this.movePositionOnBlurV2(newValue, "h_img_position_left_"+selectedImageIndex, "h_img_position_right_"+selectedImageIndex)
                              }
                            }}
                        />
                    </div>
                  </div>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                      <div style={{
                              // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>Y
                      </div>
                      <div style={{
                          marginLeft: "6px",
                          fontSize: "15px"
                      }}>
                          <input className="numbersOnly input_banner_img_position"
                          type="text" 
                          value={this.state["h_img_position_y_"+selectedImageIndex]}
                          onChange={e => {
                              if (Number(e.target.value) >= 0) {
                                this.setState({
                                  ["h_img_position_top_"+selectedImageIndex]: e.target.value,
                                  ["h_img_position_y_"+selectedImageIndex]: e.target.value
                                })
                              } else {
                                this.setState({
                                  ["h_img_position_bottom_"+selectedImageIndex]: Math.abs(e.target.value),
                                  ["h_img_position_y_"+selectedImageIndex]: e.target.value
                                })
                              }
                          }}
                          onKeyDown={e => {
                                  const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                  if (isEnterKey) {
                                      e.target.blur();
                                  }
                              }
                          }
                          onBlur={e => {
                            if (Number(e.target.value) > 0) {
                              this.movePositionOnBlur(e, "h_img_position_top_"+selectedImageIndex, "h_img_position_bottom_"+selectedImageIndex)
                            } else if (Number(e.target.value < 0)) {
                              this.movePositionOnBlur(e, "h_img_position_bottom_"+selectedImageIndex, "h_img_position_top_"+selectedImageIndex)                          
                            } else {
                                isTmp = true;
                                this.setState({
                                  ["h_img_position_y_"+selectedImageIndex]: 0,
                                  ["h_img_position_top_"+selectedImageIndex]: 0,
                                  ["h_img_position_bottom_"+selectedImageIndex]: 0,
                                })
                            }
                          }}
                          style={{
                                  width: "70px",
                              height: "25px",
                              paddingTop:"0px",
                              paddingBottom:"0px",
                              backgroundColor: "white",
                          }}
                          autocomplete="off"/>
                      </div>
                      <div style={{
                          // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>%
                      </div>
                          <div style={{marginLeft: "18px", flex: "0.9"}}>
                              <Slider
                                  className="slider_h_img_position_y"
                                  aria-label="Small steps"
                                  defaultValue={this.state["h_img_position_y_"+selectedImageIndex] ? this.state["h_img_position_y_"+selectedImageIndex] : 0}
                                  value={this.state["h_img_position_y_"+selectedImageIndex]}
                                  step={1}
                                  min={this.state["h_img_position_y_"+selectedImageIndex] < -50 ? Number(this.state["h_img_position_y_"+selectedImageIndex]) : -50}
                                  max={this.state["h_img_position_y_"+selectedImageIndex] > 50 ?  Number(this.state["h_img_position_y_"+selectedImageIndex]) :50}
                                  valueLabelDisplay="auto"
                                  sx={{
                                      color: "#00e2e6",
                                      width: "100px",
                                      margin: "0 auto"
                                  }}
                                  onChange={async (e) => { 
                                      if (Number(e.target.value) >= 0) {
                                        this.setState({
                                          ["h_img_position_top_"+selectedImageIndex]: e.target.value,
                                          ["h_img_position_y_"+selectedImageIndex]: e.target.value
                                        })
                                      } else {
                                        this.setState({
                                          ["h_img_position_bottom_"+selectedImageIndex]: Math.abs(e.target.value),
                                          ["h_img_position_y_"+selectedImageIndex]: e.target.value
                                        })
                                      }
                                  }}
                                  onChangeCommitted={(e, newValue) => {
                                    if (Number(newValue) >= 0) {
                                      this.movePositionOnBlurV2(newValue, "h_img_position_top_"+selectedImageIndex, "h_img_position_bottom_"+selectedImageIndex)
                                    } else {
                                      this.movePositionOnBlurV2(newValue, "h_img_position_bottom_"+selectedImageIndex, "h_img_position_top_"+selectedImageIndex)                          
                                    }
                                  }}
                              />
                          </div>
                    </div>
                  </>

              }
            </div>

            <div className="slider-group" data-instagram-tutorial="design-image-size">
              <div className="slider-label">
                <span>이미지 크기</span>
                <span>{
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                    ?
                    
                    (this.state["w_img_"+selectedImageIndex+"_scale"] == null || this.state["w_img_"+selectedImageIndex+"_scale"] == undefined || this.state["w_img_"+selectedImageIndex+"_scale"] == 0 ? 1 : this.state["w_img_"+selectedImageIndex+"_scale"] * 100).toFixed(0)
                    :
                    (this.state["h_img_"+selectedImageIndex+"_scale"] == null || this.state["h_img_"+selectedImageIndex+"_scale"] == undefined || this.state["h_img_"+selectedImageIndex+"_scale"] == 0 ? 1 : this.state["h_img_"+selectedImageIndex+"_scale"] * 100).toFixed(0)
                  }%</span>
              </div>
              {/* <input
                type="range"
                className="slider"
                min="50"
                max="200"
                value={mainSizePercent}
                onInput={(e) =>
                  this.resizeText("main", e.target.value)
                }
              /> */}
              {
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ?
                <div className={"text_size_main"}>
                  <Slider
                      className={"w_img_scale_slider"}
                      aria-label="Small steps"
                      defaultValue={this.state["w_img_"+selectedImageIndex+"_scale"] == null || this.state["w_img_"+selectedImageIndex+"_scale"] == undefined || this.state["w_img_"+selectedImageIndex+"_scale"] == 0 ? 1 : this.state["w_img_"+selectedImageIndex+"_scale"]}
                      value={this.state["w_img_"+selectedImageIndex+"_scale"] == null || this.state["w_img_"+selectedImageIndex+"_scale"] == undefined || this.state["w_img_"+selectedImageIndex+"_scale"] == 0 ? 1 : this.state["w_img_"+selectedImageIndex+"_scale"]}
                      // getAriaValueText={(value) => this.getTxtScaleValueText(value)}
                      getAriaValueText={(value) => `${Math.round(value * 100)}%`}
                      valueLabelFormat={(value) => `${Math.round(value * 100)}%`}
                      step={0.01}
                      min={0.1}
                      max={2.0}
                      valueLabelDisplay="auto"
                      sx={{
                          color: "#00e2e6",
                          width: "100%",
                          margin: "0 auto"
                      }}
                      onChange={(e) => this.handleImgScaleOnChange(e, "w", selectedImageIndex)}
                      onChangeCommitted={(e, newValue) => {
                        isTmp = true;
                        this.setState({
                            ['w_img_' + this.state.selectedImageInde + '_scale'] : newValue,
                        });
                      }}
                  />
                </div>
                : <div className={"text_size_main"}>
                  <Slider
                      className={"h_img_scale_slider"}
                      aria-label="Small steps"
                      defaultValue={this.state["h_img_"+selectedImageIndex+"_scale"] == null || this.state["h_img_"+selectedImageIndex+"_scale"] == undefined || this.state["h_img_"+selectedImageIndex+"_scale"] == 0 ? 1 : this.state["h_img_"+selectedImageIndex+"_scale"]}
                      value={this.state["h_img_"+selectedImageIndex+"_scale"] == null || this.state["h_img_"+selectedImageIndex+"_scale"] == undefined || this.state["h_img_"+selectedImageIndex+"_scale"] == 0 ? 1 : this.state["h_img_"+selectedImageIndex+"_scale"]}
                      // getAriaValueText={(value) => this.getTxtScaleValueText(value)}
                      getAriaValueText={(value) => `${Math.round(value * 100)}%`}
                      valueLabelFormat={(value) => `${Math.round(value * 100)}%`}
                      step={0.01}
                      min={0.1}
                      max={2.0}
                      valueLabelDisplay="auto"
                      sx={{
                          color: "#00e2e6",
                          width: "100%",
                          margin: "0 auto"
                      }}
                      onChange={(e) => this.handleImgScaleOnChange(e, "h", selectedImageIndex)}
                      onChangeCommitted={(e, newValue) => {
                        isTmp = true;
                        this.setState({
                            ['h_img_' + this.state.selectedImageInde + '_scale'] : newValue,
                        });
                      }}
                  />
                </div>
              }
            </div>
        </div>
      </div>
    );
  }

  renderTextTab() {
    const {
      mainText,
      mainPos,
      mainSizePercent,
      mainFontFamily,
      mainBold,
      mainItalic,
      mainUnderline,
      textUnitMode,
      mainColor,
    } = this.state;

    return (
      <div id="textTab" className="tab-content" data-instagram-tutorial="design-text-panel">
        <div className="control-section" data-instagram-tutorial="design-text-main">
          <h4 className="control-title">
            <span><i className="fa fa-pencil"></i></span>
            <span>메인 텍스트</span>
          </h4>

          <div className="text-edit-section">
             {
            //  !(
            //   this.isAppleMobile()
            //  ) ?
              <>
                <div className="text-input-wrapper">
                  <ContentEditable className="f-s-15 mobile-width-100 text_editor_title mainTextEditor" id="title" style={{width:"100%", maxWidth:"800px", height:"85px", overflow: "auto", padding: "20px", border: "1.5px solid #DBDDE4", borderRadius: "0 0 13px 13px"}}
                    value={this.state.auto_title} onMouseDown={initSelectionOnMouseDown} onPaste={e => this.handleContentEditablePaste(e, "auto_title")} onChange={e => this.onChangeTitle(e, "auto_title")} onBlur={this.handleTitleBlur} placeholder="메인 텍스트를 입력하세요" html={this.state.title.replace("font-size: 15px;", "")}/>
                  <button
                    type="button"
                    className="ai-text-btn"
                    onClick={() => this.getAIText('main')}
                    title="AI 카피라이터로 메인 텍스트 만들기"
                  >
                    AI
                  </button>
                </div>
                <TextEditor id={"mainTextEditor"} 
                contentEditableId={"title"}
                onBannerTemplateChange={this.state.event_type_cd} 
                onMobileBannerTemplateChange={this.state.event_mobile_type_cd} 
                checkImgLinkUseAble={this.checkImgLinkUseAble} 
                isHorizontal={
                  //가로형 여부
                  Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                }
                w_large_text_color={this.state.w_large_text_color}
                h_large_text_color={this.state.h_large_text_color}
                w_small_text_color={this.state.w_small_text_color}
                h_small_text_color={this.state.h_small_text_color}
                language_code_list={this.state.language_code_list}
                language_code={this.state.language_code}
                handleLanguageChange={this.handleLanguageChange}
                />
              </>
              // :
              // <>
              //   <Editor
              //     editorState={this.state.mainEditorState}
              //     onEditorStateChange={this.onMainEditorStateChange}
              //     toolbarClassName="main_toolbar_wysiwyg"
              //     wrapperClassName="main_wrapper_wysiwyg"
              //     editorClassName="main_editor_wysiwyg"
              //     toolbar={{
              //         options: [
              //             'fontFamily',
              //             'inline',
              //             'list',
              //             'colorPicker',
              //             'image',
              //             'emoji',
              //             'history',
              //             'remove',
              //         ],
              //         fontFamily: {
              //             options: fontArray,
              //         },
              //         inline: {
              //             options: ['bold', 'italic', 'underline', 'strikethrough'],
              //         },
              //         list: {
              //             options: ['unordered', 'ordered'],
              //         },
              //         image: {
              //             urlEnabled: true,
              //             uploadEnabled: true,
              //             alignmentEnabled: false,
              //             uploadCallback: this.uploadCallback,
              //             previewImage: true,
              //             inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
              //             alt: { present: false, mandatory: false },
              //             defaultSize: {
              //                 height: '1em',
              //                 width: 'auto',
              //             },
              //         }
              //     }}
              //     placeholder="메인 텍스트를 입력하세요"
              //     localization={{ locale: "ko" }}
              //     toolbarStyle={{
              //         border: "1px solid #DBE7F2",
              //         background : "#DBE7F2",
              //         width: "100%",
              //         maxWidth: "800px",
              //         borderRadius: "13px 13px 0 0",
              //         padding: "15px 18px 10px",
              //     }}
              //     editorStyle={{
              //         maxWidth: "800px",
              //         minHeight: "200px",
              //         maxHeight: "200px",
              //         width: "100%",
              //         border: "1px solid #DBDDE4",
              //         padding: "10px 20px",
              //         borderRadius: "0 0 13px 13px",
              //     }}
              //     autocomplete={false}
              //     handlePastedText={() => false}
              // />
              // <button style={{width: "100%"}}
              //   className="ai-text-btn"
              //   onClick={() => this.getAutoTitle(this.state.title, "title")}
              // >
              //   AI
              // </button>
              // </>
            }

            {/* 위치 */}
            <div className="main_txt_position_section" style={{ marginTop: "12px", marginBottom: "12px" }}>
              <div
                style={{
                  fontSize: "13px",
                  color: "#636e72",
                  marginBottom: "8px",
                }}
              >
                텍스트 위치
              </div>
              {/* {console.log("this.state.pc_banner_ratio_list.length", this.state.pc_banner_ratio_list.length)} */}
              {
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                ?
                <>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                    <div style={{
                            // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>X
                    </div>
                    <div style={{
                        marginLeft: "6px",
                        fontSize: "15px"
                    }}>
                        <input className="numbersOnly input_banner_img_position"
                        type="text" 
                        value={this.state.w_main_txt_position_x}
                        onChange={e => {
                            if (Number(e.target.value) >= 0) {
                              this.setState({
                                w_main_txt_position_right: e.target.value,
                                w_main_txt_position_x: e.target.value
                              })
                            } else {
                              this.setState({
                                w_main_txt_position_left: Math.abs(e.target.value),
                                w_main_txt_position_x: e.target.value
                              })
                            }
                        }}
                        onKeyDown={e => {
                                const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                if (isEnterKey) {
                                    e.target.blur();
                                }
                            }
                        }
                        onBlur={e => {
                          if (Number(e.target.value) > 0) {
                            this.movePositionOnBlur(e, "w_main_txt_position_right", "w_main_txt_position_left")                          
                          } else if (Number(e.target.value < 0)) {
                            this.movePositionOnBlur(e, "w_main_txt_position_left", "w_main_txt_position_right")
                          } else {
                            isTmp = true;
                            this.setState({
                                w_main_txt_position_x: 0,
                                w_main_txt_position_right: 0,
                                w_main_txt_position_left: 0
                            })
                          }
                        }}
                        style={{
                            width: "70px",
                            height: "25px",
                            paddingTop:"0px",
                            paddingBottom:"0px",
                            backgroundColor: "white",
                        }}
                        autocomplete="off"/>
                    </div>
                    <div style={{
                        // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>%
                    </div>
                    <div style={{marginLeft: "18px", flex: "0.9"}}>
                        <Slider
                            className="slider_w_main_txt_position_x"
                            aria-label="Small steps"
                            defaultValue={this.state.w_main_txt_position_x ? this.state.w_main_txt_position_x : 0}
                            value={this.state.w_main_txt_position_x}
                            step={1}
                            min={this.state.w_main_txt_position_x < -500 ? Number(this.state.w_main_txt_position_x) : -500}
                            max={this.state.w_main_txt_position_x > 500 ?  Number(this.state.w_main_txt_position_x) :500}
                            valueLabelDisplay="auto"
                            sx={{
                                color: "#00e2e6",
                                width: "100px",
                                margin: "0 auto"
                            }}
                            onChange={async (e) => { 
                                if (Number(e.target.value) >= 0) {
                                  this.setState({
                                    w_main_txt_position_right: e.target.value,
                                    w_main_txt_position_x: e.target.value
                                  })
                                } else {
                                  this.setState({
                                    w_main_txt_position_left: Math.abs(e.target.value),
                                    w_main_txt_position_x: e.target.value
                                  })
                                }
                            }}
                            onChangeCommitted={(e, newValue) => {
                              if (Number(newValue) >= 0) {
                                this.movePositionOnBlurV2(newValue, "w_main_txt_position_right", "w_main_txt_position_left")                          
                              } else {
                                this.movePositionOnBlurV2(newValue, "w_main_txt_position_left", "w_main_txt_position_right")
                              }
                            }}
                        />
                    </div>
                  </div>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                      <div style={{
                              // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>Y
                      </div>
                      <div style={{
                          marginLeft: "6px",
                          fontSize: "15px"
                      }}>
                          <input className="numbersOnly input_banner_img_position"
                          type="text" 
                          value={this.state.w_main_txt_position_y}
                          onChange={e => {
                              if (Number(e.target.value) >= 0) {
                                this.setState({
                                  w_main_txt_position_top: e.target.value,
                                  w_main_txt_position_y: e.target.value
                                })
                              } else {
                                this.setState({
                                  w_main_txt_position_bottom: Math.abs(e.target.value),
                                  w_main_txt_position_y: e.target.value
                                })
                              }
                          }}
                          onKeyDown={e => {
                                  const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                  if (isEnterKey) {
                                      e.target.blur();
                                  }
                              }
                          }
                          onBlur={e => {
                            if (Number(e.target.value) > 0) {
                              this.movePositionOnBlur(e, "w_main_txt_position_top", "w_main_txt_position_bottom")
                            } else if (Number(e.target.value < 0)) {
                              this.movePositionOnBlur(e, "w_main_txt_position_bottom", "w_main_txt_position_top")                          
                            } else {
                                isTmp = true;
                                this.setState({
                                  w_main_txt_position_y: 0,
                                  w_main_txt_position_top: 0,
                                  w_main_txt_position_bottom: 0
                                })
                            }
                          }}
                          style={{
                                  width: "70px",
                              height: "25px",
                              paddingTop:"0px",
                              paddingBottom:"0px",
                              backgroundColor: "white",
                          }}
                          autocomplete="off"/>
                      </div>
                      <div style={{
                          // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>%
                      </div>
                          <div style={{marginLeft: "18px", flex: "0.9"}}>
                              <Slider
                                  className="slider_w_main_txt_position_y"
                                  aria-label="Small steps"
                                  defaultValue={this.state.w_main_txt_position_y ? this.state.w_main_txt_position_y : 0}
                                  value={this.state.w_main_txt_position_y}
                                  step={1}
                                  min={this.state.w_main_txt_position_y < -500 ? Number(this.state.w_main_txt_position_y) : -500}
                                  max={this.state.w_main_txt_position_y > 500 ?  Number(this.state.w_main_txt_position_y) :500}
                                  valueLabelDisplay="auto"
                                  sx={{
                                      color: "#00e2e6",
                                      width: "100px",
                                      margin: "0 auto"
                                  }}
                                  onChange={async (e) => { 
                                      if (Number(e.target.value) >= 0) {
                                        this.setState({
                                          w_main_txt_position_top: e.target.value,
                                          w_main_txt_position_y: e.target.value
                                        })
                                      } else {
                                        this.setState({
                                          w_main_txt_position_bottom: Math.abs(e.target.value),
                                          w_main_txt_position_y: e.target.value
                                        })
                                      }
                                  }}
                                  onChangeCommitted={(e, newValue) => {
                                    if (Number(newValue) >= 0) {
                                      this.movePositionOnBlurV2(newValue, "w_main_txt_position_top", "w_main_txt_position_bottom")
                                    } else {
                                      this.movePositionOnBlurV2(newValue, "w_main_txt_position_bottom", "w_main_txt_position_top")                          
                                    }
                                  }}
                              />
                          </div>
                    </div>
                  </>
                  : 
                  <>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                    <div style={{
                            // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>X
                    </div>
                    <div style={{
                        marginLeft: "6px",
                        fontSize: "15px"
                    }}>
                        <input className="numbersOnly input_banner_img_position"
                        type="text" 
                        value={this.state.h_main_txt_position_x}
                        onChange={e => {
                            if (Number(e.target.value) >= 0) {
                              this.setState({
                                h_main_txt_position_right: e.target.value,
                                h_main_txt_position_x: e.target.value
                              })
                            } else {
                              this.setState({
                                h_main_txt_position_left: Math.abs(e.target.value),
                                h_main_txt_position_x: e.target.value
                              })
                            }
                        }}
                        onKeyDown={e => {
                                const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                if (isEnterKey) {
                                    e.target.blur();
                                }
                            }
                        }
                        onBlur={e => {
                          if (Number(e.target.value) > 0) {
                            this.movePositionOnBlur(e, "h_main_txt_position_right", "h_main_txt_position_left")                          
                          } else if (Number(e.target.value < 0)) {
                            this.movePositionOnBlur(e, "h_main_txt_position_left", "h_main_txt_position_right")
                          } else {
                            isTmp = true;
                            this.setState({
                              h_main_txt_position_x: 0,
                              h_main_txt_position_left: 0,
                              h_main_txt_position_right: 0
                            })
                          }
                        }}
                        style={{
                            width: "70px",
                            height: "25px",
                            paddingTop:"0px",
                            paddingBottom:"0px",
                            backgroundColor: "white",
                        }}
                        autocomplete="off"/>
                    </div>
                    <div style={{
                        // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>%
                    </div>
                    <div style={{marginLeft: "18px", flex: "0.9"}}>
                        <Slider
                            className="slider_h_main_txt_position_x"
                            aria-label="Small steps"
                            defaultValue={this.state.h_main_txt_position_x ? this.state.h_main_txt_position_x : 0}
                            value={this.state.h_main_txt_position_x}
                            step={1}
                            min={this.state.h_main_txt_position_x < -500 ? Number(this.state.h_main_txt_position_x) : -500}
                            max={this.state.h_main_txt_position_x > 500 ?  Number(this.state.h_main_txt_position_x) :500}
                            valueLabelDisplay="auto"
                            sx={{
                                color: "#00e2e6",
                                width: "100px",
                                margin: "0 auto"
                            }}
                            onChange={async (e) => { 
                                if (Number(e.target.value) >= 0) {
                                  this.setState({
                                    h_main_txt_position_right: e.target.value,
                                    h_main_txt_position_x: e.target.value
                                  })
                                } else {
                                  this.setState({
                                    h_main_txt_position_left: Math.abs(e.target.value),
                                    h_main_txt_position_x: e.target.value
                                  })
                                }
                            }}
                            onChangeCommitted={(e, newValue) => {
                              if (Number(newValue) >= 0) {
                                this.movePositionOnBlurV2(newValue, "h_main_txt_position_right", "h_main_txt_position_left")                          
                              } else {
                                this.movePositionOnBlurV2(newValue, "h_main_txt_position_left", "h_main_txt_position_right")
                              }
                            }}
                        />
                    </div>
                  </div>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                      <div style={{
                              // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>Y
                      </div>
                      <div style={{
                          marginLeft: "6px",
                          fontSize: "15px"
                      }}>
                          <input className="numbersOnly input_banner_img_position"
                          type="text" 
                          value={this.state.h_main_txt_position_y}
                          onChange={e => {
                              if (Number(e.target.value) >= 0) {
                                this.setState({
                                  h_main_txt_position_top: e.target.value,
                                  h_main_txt_position_y: e.target.value
                                })
                              } else {
                                this.setState({
                                  h_main_txt_position_bottom: Math.abs(e.target.value),
                                  h_main_txt_position_y: e.target.value
                                })
                              }
                          }}
                          onKeyDown={e => {
                                  const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                  if (isEnterKey) {
                                      e.target.blur();
                                  }
                              }
                          }
                          onBlur={e => {
                            if (Number(e.target.value) > 0) {
                              this.movePositionOnBlur(e, "h_main_txt_position_top", "h_main_txt_position_bottom")
                            } else if (Number(e.target.value < 0)) {
                              this.movePositionOnBlur(e, "h_main_txt_position_bottom", "h_main_txt_position_top")                          
                            } else {
                                isTmp = true;
                                this.setState({
                                  h_main_txt_position_y: 0,
                                  h_main_txt_position_top: 0,
                                  h_main_txt_position_bottom: 0
                                })
                            }
                          }}
                          style={{
                                  width: "70px",
                              height: "25px",
                              paddingTop:"0px",
                              paddingBottom:"0px",
                              backgroundColor: "white",
                          }}
                          autocomplete="off"/>
                      </div>
                      <div style={{
                          // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>%
                      </div>
                          <div style={{marginLeft: "18px", flex: "0.9"}}>
                              <Slider
                                  className="slider_h_main_txt_position_y"
                                  aria-label="Small steps"
                                  defaultValue={this.state.h_main_txt_position_y ? this.state.h_main_txt_position_y : 0}
                                  value={this.state.h_main_txt_position_y}
                                  step={1}
                                  min={this.state.h_main_txt_position_y < -500 ? Number(this.state.h_main_txt_position_y) : -500}
                                  max={this.state.h_main_txt_position_y > 500 ?  Number(this.state.h_main_txt_position_y) :500}
                                  valueLabelDisplay="auto"
                                  sx={{
                                      color: "#00e2e6",
                                      width: "100px",
                                      margin: "0 auto"
                                  }}
                                  onChange={async (e) => { 
                                      if (Number(e.target.value) >= 0) {
                                        this.setState({
                                          h_main_txt_position_top: e.target.value,
                                          h_main_txt_position_y: e.target.value
                                        })
                                      } else {
                                        this.setState({
                                          h_main_txt_position_bottom: Math.abs(e.target.value),
                                          h_main_txt_position_y: e.target.value
                                        })
                                      }
                                  }}
                                  onChangeCommitted={(e, newValue) => {
                                    if (Number(newValue) >= 0) {
                                      this.movePositionOnBlurV2(newValue, "h_main_txt_position_top", "h_main_txt_position_bottom")
                                    } else {
                                      this.movePositionOnBlurV2(newValue, "h_main_txt_position_bottom", "h_main_txt_position_top")                          
                                    }
                                  }}
                              />
                          </div>
                    </div>
                  </>

              }
            </div>

            <div className="slider-group">
              <div className="slider-label">
                <span>텍스트 크기</span>
                <span>{
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                    ?
                    (this.state.w_main_txt_scale == null || this.state.w_main_txt_scale == undefined || this.state.w_main_txt_scale == 0 ? 1 : this.state.w_main_txt_scale * 100).toFixed(0)
                    :
                    (this.state.h_main_txt_scale == null || this.state.h_main_txt_scale == undefined || this.state.h_main_txt_scale == 0 ? 1 : this.state.h_main_txt_scale * 100).toFixed(0)
                  }%</span>
              </div>
              {/* <input
                type="range"
                className="slider"
                min="50"
                max="200"
                value={mainSizePercent}
                onInput={(e) =>
                  this.resizeText("main", e.target.value)
                }
              /> */}
              {
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ?
                <div className={"text_size_main"}>
                  <Slider
                      className={"w_main_txt_scale_slider"}
                      aria-label="Small steps"
                      defaultValue={this.state.w_main_txt_scale == null || this.state.w_main_txt_scale == undefined || this.state.w_main_txt_scale == 0 ? 1 : this.state.w_main_txt_scale}
                      value={this.state.w_main_txt_scale == null || this.state.w_main_txt_scale == undefined || this.state.w_main_txt_scale == 0 ? 1 : this.state.w_main_txt_scale}
                      // getAriaValueText={(value) => this.getTxtScaleValueText(value)}
                      getAriaValueText={(value) => `${Math.round(value * 100)}%`}
                      valueLabelFormat={(value) => `${Math.round(value * 100)}%`}
                      step={0.01}
                      min={0.1}
                      max={2.0}
                      valueLabelDisplay="auto"
                      sx={{
                          color: "#00e2e6",
                          width: "100%",
                          margin: "0 auto"
                      }}
                      onChange={(e) => this.handleTxtScaleOnChange(e, "w", "main")}
                      onChangeCommitted={(e, newValue) => {
                        isTmp = true;
                        this.setState({
                            ['w_maiin_txt_scale'] : newValue
                        });
                      }}
                  />
                </div>
                : <div className={"text_size_main"}>
                  <Slider
                      className={"h_main_txt_scale_slider"}
                      aria-label="Small steps"
                      defaultValue={this.state.h_main_txt_scale == null || this.state.h_main_txt_scale == undefined || this.state.h_main_txt_scale == 0 ? 1 : this.state.h_main_txt_scale}
                      value={this.state.h_main_txt_scale == null || this.state.h_main_txt_scale == undefined || this.state.h_main_txt_scale == 0 ? 1 : this.state.h_main_txt_scale}
                      // getAriaValueText={(value) => this.getTxtScaleValueText(value)}
                      getAriaValueText={(value) => `${Math.round(value * 100)}%`}
                      valueLabelFormat={(value) => `${Math.round(value * 100)}%`}
                      step={0.01}
                      min={0.1}
                      max={2.0}
                      valueLabelDisplay="auto"
                      sx={{
                          color: "#00e2e6",
                          width: "100%",
                          margin: "0 auto"
                      }}
                      onChange={(e) => this.handleTxtScaleOnChange(e, "h", "main")}
                      onChangeCommitted={(e, newValue) => {
                        isTmp = true;
                        this.setState({
                            ['h_maiin_txt_scale'] : newValue
                        });
                      }}
                  />
                </div>
              }
            </div>
          </div>
        </div>
        <div className="control-section" data-instagram-tutorial="design-text-sub">
          <h4 className="control-title">
            <span><i className="fa fa-pencil"></i></span>
            <span>서브 텍스트</span>
          </h4>

          <div className="text-edit-section">
            {
            // !(
            //   this.isAppleMobile()
            // ) ?
              <> 
                <div className="text-input-wrapper">
                  <ContentEditable className="f-s-15 mobile-width-100 text_editor_title subTextEditor" id="sub_title" style={{width:"100%", maxWidth:"800px", height:"85px", overflow: "auto", padding: "20px", border: "1.5px solid #DBDDE4", borderRadius: "0 0 13px 13px"}}
                    value={this.state.sub_title ? this.state.sub_title : ""} onPaste={e => this.handleContentEditablePaste(e, "sub_title")} onChange={e => this.onChangeTitle(e, "sub_title")} onBlur={this.handleTitleBlur} placeholder="서브 텍스트를 입력하세요" html={this.state.sub_title ? this.state.sub_title.replace("font-size: 15px;", "") : ""}/>
                  <button
                    type="button"
                    className="ai-text-btn"
                    onClick={() => this.getAIText('sub')}
                    title="AI 카피라이터로 서브 텍스트 만들기"
                  >
                    AI
                  </button>
                </div>
                <TextEditor id={"subTextEditor"}
                contentEditableId={"sub_title"}
                onBannerTemplateChange={this.state.event_type_cd} 
                onMobileBannerTemplateChange={this.state.event_mobile_type_cd} 
                checkImgLinkUseAble={this.checkImgLinkUseAble} 
                isHorizontal={
                  //가로형 여부
                  Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                }
                w_large_text_color={this.state.w_large_text_color}
                h_large_text_color={this.state.h_large_text_color}
                w_small_text_color={this.state.w_small_text_color}
                h_small_text_color={this.state.h_small_text_color}
                language_code_list={this.state.language_code_list}
                language_code={this.state.language_code}
                handleLanguageChange={this.handleLanguageChange}
                />
              </>
              // :
              // <>
              //   <Editor
              //     editorState={this.state.subEditorState}
              //     onEditorStateChange={this.onSubEditorStateChange}
              //     toolbarClassName="sub_toolbar_wysiwyg"
              //     wrapperClassName="sub_wrapper_wysiwyg"
              //     editorClassName="sub_editor_wysiwyg"
              //     toolbar={{
              //         options: [
              //             'fontFamily',
              //             'inline',
              //             'list',
              //             'colorPicker',
              //             'image',
              //             'emoji',
              //             'history',
              //             'remove',
              //         ],
              //         fontFamily: {
              //             options: fontArray,
              //         },
              //         inline: {
              //             options: ['bold', 'italic', 'underline', 'strikethrough'],
              //         },
              //         list: {
              //             options: ['unordered', 'ordered'],
              //         },
              //         image: {
              //             urlEnabled: true,
              //             uploadEnabled: true,
              //             alignmentEnabled: false,
              //             uploadCallback: this.uploadCallback,
              //             previewImage: true,
              //             inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
              //             alt: { present: false, mandatory: false },
              //             defaultSize: {
              //                 height: '1em',
              //                 width: 'auto',
              //             },
              //         }
              //     }}
              //     placeholder="텍스트 내용을 입력하고 드래그를 통해 자유롭게 편집해 보세요."
              //     localization={{ locale: "ko" }}
              //     toolbarStyle={{
              //         border: "1px solid #DBE7F2",
              //         background : "#DBE7F2",
              //         width: "100%",
              //         maxWidth: "800px",
              //         borderRadius: "13px 13px 0 0",
              //         padding: "15px 18px 10px",
              //     }}
              //     editorStyle={{
              //         maxWidth: "800px",
              //         minHeight: "200px",
              //         maxHeight: "200px",
              //         width: "100%",
              //         border: "1px solid #DBDDE4",
              //         padding: "10px 20px",
              //         borderRadius: "0 0 13px 13px",
              //     }}
              //     autocomplete={false}
              //     handlePastedText={() => false}
              // />
              // <button style={{width: "100%"}}
              //   className="ai-text-btn"
              //   onClick={() => this.getAutoTitle(this.state.sub_title, "sub_title")}
              // >
              //   AI
              // </button>
              // </>
            }

            {/* 위치 */}
            <div className="sub_txt_position_section" style={{ marginTop: "12px", marginBottom: "12px" }}>
              <div
                style={{
                  fontSize: "13px",
                  color: "#636e72",
                  marginBottom: "8px",
                }}
              >
                텍스트 위치
              </div>
              {/* {console.log("this.state.pc_banner_ratio_list.length", this.state.pc_banner_ratio_list.length)} */}
              {
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                ?
                <>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                    <div style={{
                            // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>X
                    </div>
                    <div style={{
                        marginLeft: "6px",
                        fontSize: "15px"
                    }}>
                        <input className="numbersOnly input_banner_img_position"
                        type="text" 
                        value={this.state.w_sub_txt_position_x}
                        onChange={e => {
                            if (Number(e.target.value) >= 0) {
                              this.setState({
                                w_sub_txt_position_right: e.target.value,
                                w_sub_txt_position_x: e.target.value
                              })
                            } else {
                              this.setState({
                                w_sub_txt_position_left: Math.abs(e.target.value),
                                w_sub_txt_position_x: e.target.value
                              })
                            }
                        }}
                        onKeyDown={e => {
                                const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                if (isEnterKey) {
                                    e.target.blur();
                                }
                            }
                        }
                        onBlur={e => {
                          if (Number(e.target.value) > 0) {
                            this.movePositionOnBlur(e, "w_sub_txt_position_right", "w_sub_txt_position_left")                          
                          } else if (Number(e.target.value < 0)) {
                            this.movePositionOnBlur(e, "w_sub_txt_position_left", "w_sub_txt_position_right")
                          } else {
                            isTmp = true;
                            this.setState({
                              w_sub_txt_position_x: 0,
                              w_sub_txt_position_left: 0,
                              w_sub_txt_position_right: 0
                            })
                          }
                        }}
                        style={{
                            width: "70px",
                            height: "25px",
                            paddingTop:"0px",
                            paddingBottom:"0px",
                            backgroundColor: "white",
                        }}
                        autocomplete="off"/>
                    </div>
                    <div style={{
                        // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>%
                    </div>
                    <div style={{marginLeft: "18px", flex: "0.9"}}>
                        <Slider
                            className="slider_w_sub_txt_position_x"
                            aria-label="Small steps"
                            defaultValue={this.state.w_sub_txt_position_x ? this.state.w_sub_txt_position_x : 0}
                            value={this.state.w_sub_txt_position_x}
                            step={1}
                            min={this.state.w_sub_txt_position_x < -500 ? Number(this.state.w_sub_txt_position_x) : -500}
                            max={this.state.w_sub_txt_position_x > 500 ?  Number(this.state.w_sub_txt_position_x) :500}
                            valueLabelDisplay="auto"
                            sx={{
                                color: "#00e2e6",
                                width: "100px",
                                margin: "0 auto"
                            }}
                            onChange={async (e) => { 
                                if (Number(e.target.value) >= 0) {
                                  this.setState({
                                    w_sub_txt_position_right: e.target.value,
                                    w_sub_txt_position_x: e.target.value
                                  })
                                } else {
                                  this.setState({
                                    w_sub_txt_position_left: Math.abs(e.target.value),
                                    w_sub_txt_position_x: e.target.value
                                  })
                                }
                            }}
                            onChangeCommitted={(e, newValue) => {
                              if (Number(newValue) >= 0) {
                                this.movePositionOnBlurV2(newValue, "w_sub_txt_position_right", "w_sub_txt_position_left")                          
                              } else {
                                this.movePositionOnBlurV2(newValue, "w_sub_txt_position_left", "w_sub_txt_position_right")
                              }
                            }}
                        />
                    </div>
                  </div>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                      <div style={{
                              // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>Y
                      </div>
                      <div style={{
                          marginLeft: "6px",
                          fontSize: "15px"
                      }}>
                          <input className="numbersOnly input_banner_img_position"
                          type="text" 
                          value={this.state.w_sub_txt_position_y}
                          onChange={e => {
                              if (Number(e.target.value) >= 0) {
                                this.setState({
                                  w_sub_txt_position_top: e.target.value,
                                  w_sub_txt_position_y: e.target.value
                                })
                              } else {
                                this.setState({
                                  w_sub_txt_position_bottom: Math.abs(e.target.value),
                                  w_sub_txt_position_y: e.target.value
                                })
                              }
                          }}
                          onKeyDown={e => {
                                  const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                  if (isEnterKey) {
                                      e.target.blur();
                                  }
                              }
                          }
                          onBlur={e => {
                            if (Number(e.target.value) > 0) {
                              this.movePositionOnBlur(e, "w_sub_txt_position_top", "w_sub_txt_position_bottom")
                            } else if (Number(e.target.value < 0)) {
                              this.movePositionOnBlur(e, "w_sub_txt_position_bottom", "w_sub_txt_position_top")                          
                            } else {
                                isTmp = true;
                                this.setState({
                                    w_sub_txt_position_y: 0,
                                    w_sub_txt_position_top: 0,
                                    w_sub_txt_position_bottom: 0
                                })
                            }
                          }}
                          style={{
                                  width: "70px",
                              height: "25px",
                              paddingTop:"0px",
                              paddingBottom:"0px",
                              backgroundColor: "white",
                          }}
                          autocomplete="off"/>
                      </div>
                      <div style={{
                          // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>%
                      </div>
                          <div style={{marginLeft: "18px", flex: "0.9"}}>
                              <Slider
                                  className="slider_w_sub_txt_position_y"
                                  aria-label="Small steps"
                                  defaultValue={this.state.w_sub_txt_position_y ? this.state.w_sub_txt_position_y : 0}
                                  value={this.state.w_sub_txt_position_y}
                                  step={1}
                                  min={this.state.w_sub_txt_position_y < -500 ? Number(this.state.w_sub_txt_position_y) : -500}
                                  max={this.state.w_sub_txt_position_y > 500 ?  Number(this.state.w_sub_txt_position_y) :500}
                                  valueLabelDisplay="auto"
                                  sx={{
                                      color: "#00e2e6",
                                      width: "100px",
                                      margin: "0 auto"
                                  }}
                                  onChange={async (e) => { 
                                      if (Number(e.target.value) >= 0) {
                                        this.setState({
                                          w_sub_txt_position_top: e.target.value,
                                          w_sub_txt_position_y: e.target.value
                                        })
                                      } else {
                                        this.setState({
                                          w_sub_txt_position_bottom: Math.abs(e.target.value),
                                          w_sub_txt_position_y: e.target.value
                                        })
                                      }
                                  }}
                                  onChangeCommitted={(e, newValue) => {
                                    if (Number(newValue) >= 0) {
                                      this.movePositionOnBlurV2(newValue, "w_sub_txt_position_top", "w_sub_txt_position_bottom")
                                    } else {
                                      this.movePositionOnBlurV2(newValue, "w_sub_txt_position_bottom", "w_sub_txt_position_top")                          
                                    }
                                  }}
                              />
                          </div>
                    </div>
                  </>
                  : 
                  <>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                    <div style={{
                            // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>X
                    </div>
                    <div style={{
                        marginLeft: "6px",
                        fontSize: "15px"
                    }}>
                        <input className="numbersOnly input_banner_img_position"
                        type="text" 
                        value={this.state.h_sub_txt_position_x}
                        onChange={e => {
                            if (Number(e.target.value) >= 0) {
                              this.setState({
                                h_sub_txt_position_right: e.target.value,
                                h_sub_txt_position_x: e.target.value
                              })
                            } else {
                              this.setState({
                                h_sub_txt_position_left: Math.abs(e.target.value),
                                h_sub_txt_position_x: e.target.value
                              })
                            }
                        }}
                        onKeyDown={e => {
                                const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                if (isEnterKey) {
                                    e.target.blur();
                                }
                            }
                        }
                        onBlur={e => {
                          if (Number(e.target.value) > 0) {
                            this.movePositionOnBlur(e, "h_sub_txt_position_right", "h_sub_txt_position_left")                          
                          } else if (Number(e.target.value < 0)) {
                            this.movePositionOnBlur(e, "h_sub_txt_position_left", "h_sub_txt_position_right")
                          } else {
                            isTmp = true;
                            this.setState({
                              h_sub_txt_position_x: 0,
                              h_sub_txt_position_right: 0,
                              h_sub_txt_position_left: 0
                            })
                          }
                        }}
                        style={{
                            width: "70px",
                            height: "25px",
                            paddingTop:"0px",
                            paddingBottom:"0px",
                            backgroundColor: "white",
                        }}
                        autocomplete="off"/>
                    </div>
                    <div style={{
                        // marginLeft: "6px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    }}>%
                    </div>
                    <div style={{marginLeft: "18px", flex: "0.9"}}>
                        <Slider
                            className="slider_h_sub_txt_position_x"
                            aria-label="Small steps"
                            defaultValue={this.state.h_sub_txt_position_x ? this.state.h_sub_txt_position_x : 0}
                            value={this.state.h_sub_txt_position_x}
                            step={1}
                            min={this.state.h_sub_txt_position_x < -500 ? Number(this.state.h_sub_txt_position_x) : -500}
                            max={this.state.h_sub_txt_position_x > 500 ?  Number(this.state.h_sub_txt_position_x) :500}
                            valueLabelDisplay="auto"
                            sx={{
                                color: "#00e2e6",
                                width: "100px",
                                margin: "0 auto"
                            }}
                            onChange={async (e) => { 
                                if (Number(e.target.value) >= 0) {
                                  this.setState({
                                    h_sub_txt_position_right: e.target.value,
                                    h_sub_txt_position_x: e.target.value
                                  })
                                } else {
                                  this.setState({
                                    h_sub_txt_position_left: Math.abs(e.target.value),
                                    h_sub_txt_position_x: e.target.value
                                  })
                                }
                            }}
                            onChangeCommitted={(e, newValue) => {
                              if (Number(newValue) >= 0) {
                                this.movePositionOnBlurV2(newValue, "h_sub_txt_position_right", "h_sub_txt_position_left")                          
                              } else {
                                this.movePositionOnBlurV2(newValue, "h_sub_txt_position_left", "h_sub_txt_position_right")
                              }
                            }}
                        />
                    </div>
                  </div>
                  <div style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      marginTop: "10px"
                  }}>
                      <div style={{
                              // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>Y
                      </div>
                      <div style={{
                          marginLeft: "6px",
                          fontSize: "15px"
                      }}>
                          <input className="numbersOnly input_banner_img_position"
                          type="text" 
                          value={this.state.h_sub_txt_position_y}
                          onChange={e => {
                              if (Number(e.target.value) >= 0) {
                                this.setState({
                                  h_sub_txt_position_top: e.target.value,
                                  h_sub_txt_position_y: e.target.value
                                })
                              } else {
                                this.setState({
                                  h_sub_txt_position_bottom: Math.abs(e.target.value),
                                  h_sub_txt_position_y: e.target.value
                                })
                              }
                          }}
                          onKeyDown={e => {
                                  const isEnterKey = e.key === 'Enter' || e.keyCode === 13;
                                  if (isEnterKey) {
                                      e.target.blur();
                                  }
                              }
                          }
                          onBlur={e => {
                            if (Number(e.target.value) > 0) {
                              this.movePositionOnBlur(e, "h_sub_txt_position_top", "h_sub_txt_position_bottom")
                            } else if (Number(e.target.value < 0)) {
                              this.movePositionOnBlur(e, "h_sub_txt_position_bottom", "h_sub_txt_position_top")                          
                            } else {
                                isTmp = true;
                                this.setState({
                                    h_sub_txt_position_y: 0,
                                    h_sub_txt_position_top: 0,
                                    h_sub_txt_position_bottom: 0
                                })
                            }
                          }}
                          style={{
                                  width: "70px",
                              height: "25px",
                              paddingTop:"0px",
                              paddingBottom:"0px",
                              backgroundColor: "white",
                          }}
                          autocomplete="off"/>
                      </div>
                      <div style={{
                          // marginLeft: "6px",
                          fontSize: "15px",
                          lineHeight: 1.7,
                      }}>%
                      </div>
                          <div style={{marginLeft: "18px", flex: "0.9"}}>
                              <Slider
                                  className="slider_h_sub_txt_position_y"
                                  aria-label="Small steps"
                                  defaultValue={this.state.h_sub_txt_position_y ? this.state.h_sub_txt_position_y : 0}
                                  value={this.state.h_sub_txt_position_y}
                                  step={1}
                                  min={this.state.h_sub_txt_position_y < -500 ? Number(this.state.h_sub_txt_position_y) : -500}
                                  max={this.state.h_sub_txt_position_y > 500 ?  Number(this.state.h_sub_txt_position_y) :500}
                                  valueLabelDisplay="auto"
                                  sx={{
                                      color: "#00e2e6",
                                      width: "100px",
                                      margin: "0 auto"
                                  }}
                                  onChange={async (e) => { 
                                      if (Number(e.target.value) >= 0) {
                                        this.setState({
                                          h_sub_txt_position_top: e.target.value,
                                          h_sub_txt_position_y: e.target.value
                                        })
                                      } else {
                                        this.setState({
                                          h_sub_txt_position_bottom: Math.abs(e.target.value),
                                          h_sub_txt_position_y: e.target.value
                                        })
                                      }
                                  }}
                                  onChangeCommitted={(e, newValue) => {
                                    if (Number(newValue) >= 0) {
                                      this.movePositionOnBlurV2(newValue, "h_sub_txt_position_top", "h_sub_txt_position_bottom")
                                    } else {
                                      this.movePositionOnBlurV2(newValue, "h_sub_txt_position_bottom", "h_sub_txt_position_top")                          
                                    }
                                  }}
                              />
                          </div>
                    </div>
                  </>

              }
            </div>

            <div className="slider-group">
              <div className="slider-label">
                <span>텍스트 크기</span>
                <span>{
                  Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                  ?
                  (this.state.w_sub_txt_scale == null || this.state.w_sub_txt_scale == undefined || this.state.w_sub_txt_scale == 0 ? 1 : this.state.w_sub_txt_scale * 100).toFixed(0)
                  :
                  (this.state.h_sub_txt_scale == null || this.state.h_sub_txt_scale == undefined || this.state.h_sub_txt_scale == 0 ? 1 : this.state.h_sub_txt_scale * 100).toFixed(0)
                  }%</span>
              </div>
              {/* <input
                type="range"
                className="slider"
                min="50"
                max="200"
                value={mainSizePercent}
                onInput={(e) =>
                  this.resizeText("main", e.target.value)
                }
              /> */}
              <div className={"text_size_main"}>
                  {
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ?
                    <Slider
                        className={"w_sub_txt_scale_slider"}
                        aria-label="Small steps"
                        defaultValue={this.state.w_sub_txt_scale == null || this.state.w_sub_txt_scale == undefined || this.state.w_sub_txt_scale == 0 ? 1 : this.state.w_sub_txt_scale}
                        value={this.state.w_sub_txt_scale == null || this.state.w_sub_txt_scale == undefined || this.state.w_sub_txt_scale == 0 ? 1 : this.state.w_sub_txt_scale}
                        // getAriaValueText={(value) => this.getTxtScaleValueText(value)}
                        getAriaValueText={(value) => `${Math.round(value * 100)}%`}
                        valueLabelFormat={(value) => `${Math.round(value * 100)}%`}
                        step={0.01}
                        min={0.1}
                        max={2.0}
                        valueLabelDisplay="auto"
                        sx={{
                            color: "#00e2e6",
                            width: "100%",
                            margin: "0 auto"
                        }}
                        onChange={(e) => this.handleTxtScaleOnChange(e, "w", "sub")}
                        onChangeCommitted={(e, newValue) => {
                            isTmp = true;
                            this.setState({
                                ['w_sub_txt_scale'] : newValue
                            });
                        }}
                    />
                    : <Slider
                        className={"h_sub_txt_scale_slider"}
                        aria-label="Small steps"
                        defaultValue={this.state.h_sub_txt_scale == null || this.state.h_sub_txt_scale == undefined || this.state.h_sub_txt_scale == 0 ? 1 : this.state.h_sub_txt_scale}
                        value={this.state.h_sub_txt_scale == null || this.state.h_sub_txt_scale == undefined || this.state.h_sub_txt_scale == 0 ? 1 : this.state.h_sub_txt_scale}
                        // getAriaValueText={(value) => this.getTxtScaleValueText(value)}
                        getAriaValueText={(value) => `${Math.round(value * 100)}%`}
                        valueLabelFormat={(value) => `${Math.round(value * 100)}%`}
                        step={0.01}
                        min={0.1}
                        max={2.0}
                        valueLabelDisplay="auto"
                        sx={{
                            color: "#00e2e6",
                            width: "100%",
                            margin: "0 auto"
                        }}
                        onChange={(e) => this.handleTxtScaleOnChange(e, "h", "sub")}
                        onChangeCommitted={(e, newValue) => {
                            isTmp = true;
                            this.setState({
                                ['h_sub_txt_scale'] : newValue
                            });
                        }}
                    />
                  }
              </div>
            </div>
          </div>
        </div>
        {this.isPriceAreaUseTemplate() ?
          <>
              <div className="control-section" style={{marginTop:"50px"}} data-instagram-tutorial="design-text-price">
                  <div className="control-title" style={{display:"flex"}}>
                      <span style={{fontSize:"20px", lineHeight:"23px", fontWeight:"700"}}>₩</span>
                      &nbsp;&nbsp;가격 설정
                  </div>
                  <div className="text-edit-section" style={{paddingTop:"3px"}}>
                      <div className={"event_setting_button_list_content"}>
                          <div style={{width: "300px", maxWidth: "600px", marginRight:"20px"}}>
                              <div className="input_text_title_d">가격 문구</div>
                              <input
                                  type="text"
                                  id="input_event_price_text"
                                  className="border_form_radius_b f-s-15 input_width_100 input_height_35px"
                                  value={this.getEventPriceInputValue()}
                                  onChange={this.onChangeEventPrice}
                                  placeholder="가격 문구를 입력해주세요."
                                  maxLength={100}
                              />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="margin-vertical-auto flexBox m-t-15">
                  <div className="icn_warning_round" style={{width:"12px", height:"12px"}}></div>
                  <div style={{marginLeft:"10px", flex:"1", fontSize:"12px"}}>
                      가격 영역을 사용하는 템플릿에서만 가격 문구 입력이 가능합니다.
                  </div>
              </div>
          </> : ""
        }
        {this.isDateAreaUseTemplate() ?
          <>
              <div className="control-section" style={{marginTop:"50px"}} data-instagram-tutorial="design-text-date">
                  <div className="control-title" style={{display:"flex"}}>
                      날짜 설정
                  </div>
                  <div className="text-edit-section" style={{paddingTop:"3px"}}>
                      <div className={"event_setting_button_list_content"} style={{alignItems:"flex-start", gap:"20px", flexWrap:"wrap"}}>
                          <div style={{width:"260px", maxWidth:"600px"}}>
                              <div className="input_text_title_d">시작일</div>
                              <div style={{display:"flex", alignItems:"center", gap:"8px"}}>
                                  <input
                                      type="date"
                                      id="input_template_start_date"
                                      className="border_form_radius_b f-s-15 input_width_100 input_height_35px"
                                      value={this.getTemplateDateInputValue("start")}
                                      max={this.getTemplateDateInputValue("end") || undefined}
                                      onChange={(e) => this.onChangeTemplateDate("start", e)}
                                  />
                                  {this.getTemplateDateInputValue("start") ?
                                      <button
                                          type="button"
                                          onClick={() => this.onClickClearTemplateDate("start")}
                                          style={{height:"35px", padding:"0 12px", border:"1px solid #d1d5db", borderRadius:"6px", background:"#fff", color:"#333", cursor:"pointer", flexShrink:0}}
                                      >
                                          삭제
                                      </button>
                                      : ""
                                  }
                              </div>
                          </div>
                          <div style={{width:"260px", maxWidth:"600px"}}>
                              <div className="input_text_title_d">종료일</div>
                              <div style={{display:"flex", alignItems:"center", gap:"8px"}}>
                                  <input
                                      type="date"
                                      id="input_template_end_date"
                                      className="border_form_radius_b f-s-15 input_width_100 input_height_35px"
                                      value={this.getTemplateDateInputValue("end")}
                                      min={this.getTemplateDateInputValue("start") || undefined}
                                      onChange={(e) => this.onChangeTemplateDate("end", e)}
                                  />
                                  {this.getTemplateDateInputValue("end") ?
                                      <button
                                          type="button"
                                          onClick={() => this.onClickClearTemplateDate("end")}
                                          style={{height:"35px", padding:"0 12px", border:"1px solid #d1d5db", borderRadius:"6px", background:"#fff", color:"#333", cursor:"pointer", flexShrink:0}}
                                      >
                                          삭제
                                      </button>
                                      : ""
                                  }
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="margin-vertical-auto flexBox m-t-15">
                  <div className="icn_warning_round" style={{width:"12px", height:"12px"}}></div>
                  <div style={{marginLeft:"10px", flex:"1", fontSize:"12px"}}>
                      날짜 영역을 사용하는 템플릿에서만 날짜 입력이 가능합니다.
                  </div>
              </div>
          </> : ""
        }
        {(Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_is_button_use == "Y") || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_is_button_use == "Y") ?
          <>
              <div className="control-section" style={{marginTop:"50px"}} data-instagram-tutorial="design-text-button">
                  <div className="control-title" style={{display:"flex"}} ref={scollSettingBtnRef}>
                      <img src={button_list} style={{width:"23px", height:"23px", alignSelf:"center"}}/>
                      &nbsp;&nbsp;버튼 설정
                  </div>
                  <div className="text-edit-section" style={{paddingTop:"3px"}}>
                    {this.state.button_list.map((button, idx) => (
                        <div className={"event_setting_button_list_content"} key={idx}>
                            <div style={{width: "300px", maxWidth: "600px", marginRight:"20px"}}>
                                <div className="input_text_title_d">{(idx+1)+"번 버튼 텍스트"}</div>
                                <input type="text" id={"button_text_input_"+(idx+1)} className="border_form_radius_b f-s-15 input_width_100 input_height_35px" value={button.button_text} onChange={e => this.onChangeButtonSetting(e, idx, "button_text")} placeholder="버튼에 보여질 텍스트를 입력해주세요." maxlength={100}></input>
                            </div>
                            {/* <div style={{flex: 1, maxWidth: "600px", marginRight:"20px"}}>
                                <div className="input_text_title_d">{(idx+1)+"번 버튼 링크"}</div>
                                <input type="text" id={"button_link_input_"+(idx+1)} className="border_form_radius_b f-s-15 input_width_100 input_height_35px" value={button.link} onChange={e => this.onChangeButtonSetting(e, idx, "link")} placeholder="버튼에 연결될 링크를 입력해주세요." maxlength={1024}></input>
                            </div> */}
                            <svg onClick={() => this.onClickDelButton(idx)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.875 4.1665H13.75V3.5415C13.75 3.04422 13.5525 2.56731 13.2008 2.21568C12.8492 1.86405 12.3723 1.6665 11.875 1.6665H8.125C7.62772 1.6665 7.15081 1.86405 6.79917 2.21568C6.44754 2.56731 6.25 3.04422 6.25 3.5415V4.1665H3.125C2.95924 4.1665 2.80027 4.23235 2.68306 4.34956C2.56585 4.46677 2.5 4.62574 2.5 4.7915C2.5 4.95726 2.56585 5.11624 2.68306 5.23345C2.80027 5.35066 2.95924 5.4165 3.125 5.4165H3.75V16.6665C3.75 16.998 3.8817 17.316 4.11612 17.5504C4.35054 17.7848 4.66848 17.9165 5 17.9165H15C15.3315 17.9165 15.6495 17.7848 15.8839 17.5504C16.1183 17.316 16.25 16.998 16.25 16.6665V5.4165H16.875C17.0408 5.4165 17.1997 5.35066 17.3169 5.23345C17.4342 5.11624 17.5 4.95726 17.5 4.7915C17.5 4.62574 17.4342 4.46677 17.3169 4.34956C17.1997 4.23235 17.0408 4.1665 16.875 4.1665ZM7.5 3.5415C7.5 3.37574 7.56585 3.21677 7.68306 3.09956C7.80027 2.98235 7.95924 2.9165 8.125 2.9165H11.875C12.0408 2.9165 12.1997 2.98235 12.3169 3.09956C12.4342 3.21677 12.5 3.37574 12.5 3.5415V4.1665H7.5V3.5415ZM15 16.6665H5V5.4165H15V16.6665ZM8.75 8.5415V13.5415C8.75 13.7073 8.68415 13.8662 8.56694 13.9834C8.44973 14.1007 8.29076 14.1665 8.125 14.1665C7.95924 14.1665 7.80027 14.1007 7.68306 13.9834C7.56585 13.8662 7.5 13.7073 7.5 13.5415V8.5415C7.5 8.37574 7.56585 8.21677 7.68306 8.09956C7.80027 7.98235 7.95924 7.9165 8.125 7.9165C8.29076 7.9165 8.44973 7.98235 8.56694 8.09956C8.68415 8.21677 8.75 8.37574 8.75 8.5415ZM12.5 8.5415V13.5415C12.5 13.7073 12.4342 13.8662 12.3169 13.9834C12.1997 14.1007 12.0408 14.1665 11.875 14.1665C11.7092 14.1665 11.5503 14.1007 11.4331 13.9834C11.3158 13.8662 11.25 13.7073 11.25 13.5415V8.5415C11.25 8.37574 11.3158 8.21677 11.4331 8.09956C11.5503 7.98235 11.7092 7.9165 11.875 7.9165C12.0408 7.9165 12.1997 7.98235 12.3169 8.09956C12.4342 8.21677 12.5 8.37574 12.5 8.5415Z" fill="#878B90"/>
                            </svg>
                        </div>
                    ))}
                    <button className={"event_setting_button_list_add_button"} onClick={() => this.onClickAddButton()}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width: "16px", height : "16px", marginRight : "4px"}}>
                            <path d="M17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625H10.625V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V10.625H3.125C2.95924 10.625 2.80027 10.5592 2.68306 10.4419C2.56585 10.3247 2.5 10.1658 2.5 10C2.5 9.83424 2.56585 9.67527 2.68306 9.55806C2.80027 9.44085 2.95924 9.375 3.125 9.375H9.375V3.125C9.375 2.95924 9.44085 2.80027 9.55806 2.68306C9.67527 2.56585 9.83424 2.5 10 2.5C10.1658 2.5 10.3247 2.56585 10.4419 2.68306C10.5592 2.80027 10.625 2.95924 10.625 3.125V9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10Z" fill="#333333"></path>
                        </svg>
                        버튼 추가
                    </button>
                  </div>
              </div>
              <div className="margin-vertical-auto flexBox m-t-15">
                  <div className="icn_warning_round" style={{width:"12px", height:"12px"}}></div>
                  <div style={{marginLeft:"10px", flex:"1", fontSize:"12px"}}>
                      템플릿 선택에 따라, 배너 이미지 내에 버튼 설정이 가능합니다.
                  </div>
              </div>
          </> : ""
        }
      </div>
    );
  }

  renderColorTab() {
    const {
      canvasMainColor,
      canvasSubColor,
      canvasPointColor,
      canvasBgColor,
      extractedColors,
      background,
      background2,
      background3,
      background4,
    } = this.state;

    color_title_num_p = 0;

    if (
      this.state.w_color1_is_use == "N" && this.state.h_color1_is_use == "N"
      &&  this.state.w_color2_is_use == "N" && this.state.h_color2_is_use == "N"
      &&  this.state.w_color3_is_use == "N" && this.state.h_color3_is_use == "N"
      &&  this.state.w_color4_is_use == "N" && this.state.h_color4_is_use == "N" 
      &&  this.state.w_color_etc_is_use == "N" && this.state.h_color_etc_is_use == "N"
    ) {
      return (
        <div
          style={{
            padding: "16px",
            background: "#ffffff",
            borderRadius: "12px",
          }}
          data-instagram-tutorial="design-color-panel"
        >
          <div class="image-selector-info">
              {/* <span><i className="fa fa-lightbulb-o"></i></span> */}
              <span>선택하신 템플릿은 색상 등록이 필요 없는 템플릿입니다.</span>
          </div>
        </div>
      )
    }

    return (
      <div id="colorTab" className="tab-content" data-instagram-tutorial="design-color-panel">
        <div className="control-section" data-instagram-tutorial="design-color-template">
          <h4 className="control-title">
            <span>
                <svg
                    width={24}
                    height={24}
                    viewBox="0 0 512 512"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    >
                    <g fill={"#49BCBD"}>
                        <path
                        d="M231.137,410.58c-37.33,0-71.105-10.204-96.871-28.027c-25.832-17.955-43.85-43.075-50.826-74.464
                        c-2.002-9.037-2.971-18.214-2.971-27.447c0-30.676,10.785-62.316,30.481-90.672c-8.524-6.136-16.53-13.754-23.571-22.729
                        c-24.669,34.031-39.136,73.36-39.2,113.401c0,11.498,1.227,22.994,3.746,34.359c8.653,39.65,32.095,72.136,63.934,94.09
                        c31.903,21.96,72.073,33.779,115.277,33.779c23.506,0,47.982-3.488,72.588-10.848l-21.31-27.643
                        C264.913,408.58,247.671,410.58,231.137,410.58z"
                        />

                        <path
                        d="M452.068,133.078c-15.824-23.638-38.298-41.852-64.647-54.055c-26.412-12.21-56.637-18.473-88.41-18.536
                        c-24.54,0-50.05,3.746-75.558,11.56c-10.788,3.292-21.184,7.17-31.193,11.686c0.129,0.196,0.258,0.328,0.388,0.517
                        c6.328,8.912,11.431,18.34,15.048,27.838c8.072-3.488,16.467-6.528,25.12-9.17c22.54-6.849,44.885-10.142,66.195-10.142
                        c27.576,0,53.216,5.487,74.785,15.565c21.698,10.009,39.265,24.476,51.406,42.684c4.585,6.849,6.329,12.79,6.329,17.312
                        c-0.063,2.97-0.646,5.424-2.194,8.136c-1.164,2-2.907,4.2-5.62,6.395c-4.005,3.356-10.204,6.906-19.05,9.814
                        c-8.785,2.908-20.15,5.234-34.163,6.458c-16.792,1.425-30.805,7.555-40.558,17.242c-9.75,9.561-14.723,22.414-14.723,34.939
                        c0,13.755,5.812,27.384,16.533,37.329c10.655,10.009,26.091,16.013,43.914,15.95c1.097,0,2.194,0,3.358-0.062h0.129
                        c1.034-0.064,2.132-0.064,3.163-0.064c6.587,0,11.431,0.839,14.855,2c5.102,1.747,7.105,3.746,8.46,5.682
                        c1.29,1.936,2.066,4.522,2.066,7.624c0,2.384-0.451,4.907-1.227,6.969c-0.709,2.132-1.744,3.746-2.132,4.2
                        c-10.525,12.204-22.732,23.574-36.424,33.647l17.889,26.866c16.082-11.623,30.484-24.993,43.012-39.461
                        c3.68-4.326,6.266-9.233,8.202-14.594c1.807-5.423,2.97-11.302,2.97-17.627c0-5.493-0.905-11.371-3.1-17.116
                        c-3.292-8.652-9.946-16.984-19.438-22.344c-9.495-5.487-21.184-8.136-35.134-8.136c-1.486,0-3.034,0.063-4.714,0.126h-1.936
                        c-10.913-0.062-17.63-3.355-21.893-7.296c-4.26-4.006-6.2-8.975-6.263-13.692c0.063-4.326,1.549-8.394,5.165-12.008
                        c3.617-3.557,9.817-7.045,20.667-8.01c28.349-2.522,49.792-8.848,65.483-19.374c7.817-5.297,14.146-11.756,18.472-19.311
                        c4.39-7.492,6.521-15.95,6.521-24.281C463.82,155.744,459.235,143.799,452.068,133.078z"
                        />

                        <path
                        d="M393.485,176.72c5.291-5.298,8.325-12.607,8.325-20.093c0-7.486-3.034-14.802-8.325-20.1
                        c-5.298-5.285-12.608-8.318-20.093-8.318c-7.486,0-14.802,3.033-20.094,8.318c-5.291,5.298-8.324,12.613-8.324,20.1
                        c0,7.486,3.033,14.795,8.324,20.093c5.292,5.291,12.608,8.324,20.094,8.324C380.877,185.045,388.187,182.012,393.485,176.72z"
                        />

                        <path
                        d="M159.79,245.262c4.27-12.859-2.699-26.747-15.565-31.023c-12.859-4.27-26.747,2.692-31.022,15.558
                        c-4.27,12.859,2.699,26.747,15.565,31.029C141.62,265.09,155.514,258.128,159.79,245.262z"
                        />

                        <path
                        d="M160.137,342.631c8.823-9.327,8.413-24.041-0.908-32.864c-9.328-8.829-24.041-8.419-32.864,0.909
                        c-8.83,9.321-8.426,24.035,0.902,32.864C136.587,352.362,151.307,351.952,160.137,342.631z"
                        />

                        <path
                        d="M281.932,162.915c14.877-1.728,25.542-15.193,23.808-30.071c-1.728-14.878-15.193-25.536-30.071-23.808
                        c-14.884,1.728-25.542,15.187-23.808,30.071C253.589,153.985,267.048,164.649,281.932,162.915z"
                        />

                        <path
                        d="M99.435,151.078c15.133,21.096,36.721,35.172,56.348,36.762l0.823,0.075l36.85-26.438l0.195-0.801
                        c4.774-19.103-1.646-44.071-16.772-65.155c-14.357-20.004-31.076-33.728-47.253-47.01c-11.037-9.056-22.459-18.434-33.117-29.78
                        C87.685,9.334,84.715,4.692,84.705,4.68L81.845,0l-2.4,2.826c-11.14,13.156-15.593,36.869-12.238,65.048
                        C70.723,97.464,82.179,127.024,99.435,151.078z M107.649,116.056c12.018,13.598,17.631,4.692,10.4-9.17
                        c-9.079-17.388,0.097-18.012,5.682-12.601c5.566,5.392,12.541,17.476,18.548,14.014c3.61-2.081-0.268-9.568-5.38-20.913
                        c-2.933-6.496-0.4-16.24,14.701-3.236c5.515,5.544,10.747,11.523,15.619,18.309c10.563,14.707,15.564,32.428,13.121,46.329
                        l-31.55,22.642c-13.963-2.132-29.121-12.551-39.697-27.284c-4.049-5.651-7.761-11.768-11.078-18.201
                        c-0.356-0.921-0.763-1.904-1.236-2.946C91.51,111.402,95.632,102.472,107.649,116.056z"
                        />

                        <path
                        d="M215.431,183.86c-7.707-3.147-15.038-2.794-20.266,0.952l-16.993,12.197
                        c-5.235,3.746-7.909,10.589-7.408,18.888c0.511,8.306,4.156,17.363,10.078,25.05l26.851,34.813l52.614-37.746l-24.375-36.579
                        C230.551,193.351,223.137,187.007,215.431,183.86z"
                        />

                        <path
                        d="M268.971,251.026l-51.722,37.103l160.229,207.73c11.109,14.411,27.509,20.182,37.323,13.156l0.116-0.101
                        c9.807-7.032,9.586-24.42-0.501-39.562L268.971,251.026z"
                        />
                    </g>
                </svg>
            </span>
            <span>템플릿 색상</span>
          </h4>
          <div
            style={{
              padding: "16px",
              background: "#ffffff",
              borderRadius: "12px",
            }}
          >
            {/* <div
              style={{
                fontSize: "13px",
                color: "#636e72",
                marginBottom: "12px",
              }}
            >
              네모칸 위의 컬러들
            </div> */}

            <div
              style={{
                display: "flex",
                gap: "8px",
                marginBottom: "16px",
              }}
            >
              {
                (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color1_is_use == "Y") // 가로형 여부
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color1_is_use == "Y") // 세로형 여부
                ?
                  <div className="color-item" style={{ flex: 1, position: "relative" }}>
                    <label
                      style={{
                        fontSize: "11px",
                        color: "#636e72",
                        display: "block",
                        marginBottom: "4px",
                        textAlign: "center",
                      }}
                    >
                    {
                        <>
                          {
                              Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color1_is_use == "Y" // 가로형
                              ? "가로형"
                              : ""
                          }
                          {
                              Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length // 세로형 여부
                              ?   Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color1_is_use == "Y" && this.state.h_color1_is_use == "Y"  // 세로 색상 사용중인데 가로 색상도 사용중인 경우
                                  ?   " / 세로형"
                                  :   this.state.h_color1_is_use == "Y"  // 세로 색상만 사용중인 경우
                                      ?   "세로형"
                                      :   ""
                              :   ""
                          }
                          {
                              " 배너 메인 컬러"+(color_title_num_p = color_title_num_p+1)
                          }
                        </>
                    }
                    </label>
                    <div id="color_picker_1_wrapper" onClick={e => {e.stopPropagation(); this.onClickRactangleColorButton(e, "is_expand_color1")}}>
                    <input
                      type="color"
                      // value={canvasMainColor}
                      value={background}
                      // onChange={(e) =>
                      //   this.updateTemplateColor("1", e.target.value, true)
                      // }
                      style={{
                        width: "100%",
                        height: "50px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        border: "2px solid #D1D1D1",
                        WebkitAppearance: "none",
                        pointerEvents: "none",
                      }}
                    />
                    </div>
                    { this.state.is_expand_color1
                      ?  <div id="color_picker_1" className="color_detail_area_first" style={{position: "absolute", zIndex: "10", WebkitAppearance: "none",}} onMouseDown={(e) => e.stopPropagation()}>
                        <SketchPicker
                            presetColors = {presetColors}
                            color={ this.state.background }
                            onChange={e => this.handleChange(e)}
                            onChangeComplete={e => this.handleChange(e, true)}
                            disableAlpha
                        />
                        </div>
                      : null
                    }
                  </div>
                : null
              }
              {
                (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color2_is_use == "Y") // 가로형 여부
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color2_is_use == "Y") // 세로형 여부
                ?   
                  <div className="color-item" style={{ flex: 1, position: "relative" }}>
                    <label
                      style={{
                        fontSize: "11px",
                        color: "#636e72",
                        display: "block",
                        marginBottom: "4px",
                        textAlign: "center",
                      }}
                    >
                      {
                          <>
                          {
                              Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color2_is_use == "Y" // 가로형
                              ? "가로형"
                              : ""
                          }
                          {
                              Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length // 세로형 여부
                              ?   Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color2_is_use == "Y" && this.state.h_color2_is_use == "Y"  // 세로 색상 사용중인데 가로 색상도 사용중인 경우
                                  ?   " / 세로형"
                                  :   this.state.h_color2_is_use == "Y"  // 세로 색상만 사용중인 경우
                                      ?   "세로형"
                                      :   ""
                              :   ""
                          }
                          {
                              " 배너 메인 컬러"+(color_title_num_p = color_title_num_p+1)
                          }
                          </>
                      }
                    </label>
                    <div id="color_picker_2_wrapper" onClick={e => {e.stopPropagation(); this.onClickRactangleColorButton(e, "is_expand_color2")}}>
                    <input
                      type="color"
                      // value={canvasSubColor}
                      value={background2}
                      // onChange={(e) =>
                      //   this.updateTemplateColor("2", e.target.value, true)
                      // }
                      style={{
                        width: "100%",
                        height: "50px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        border: "2px solid #D1D1D1",
                        WebkitAppearance: "none",
                        pointerEvents: "none",
                      }}
                    />
                    </div>
                    { this.state.is_expand_color2
                      ?  <div id="color_picker_2" className="color_detail_area" style={{position: "absolute", zIndex: "10", WebkitAppearance: "none",}} onMouseDown={(e) => e.stopPropagation()}>
                        <SketchPicker
                            presetColors = {presetColors}
                            color={ this.state.background2 }
                            onChange={e => this.handleChange2(e)}
                            onChangeComplete={e => this.handleChange2(e, true)}
                            disableAlpha
                        />
                        </div>
                      : null
                    }
                  </div>
                : null
              }
              {
                (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color3_is_use == "Y") // 가로형 여부
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color3_is_use == "Y") // 세로형 여부
                ? 
                  <div className="color-item" style={{ flex: 1, position: "relative" }}>
                    <label
                      style={{
                        fontSize: "11px",
                        color: "#636e72",
                        display: "block",
                        marginBottom: "4px",
                        textAlign: "center",
                      }}
                    >
                    {
                        <>
                        {
                            Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color3_is_use == "Y" // 가로형
                            ? "가로형"
                            : ""
                        }
                        {
                            Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length // 세로형 여부
                            ?   Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color3_is_use == "Y" && this.state.h_color3_is_use == "Y"  // 세로 색상 사용중인데 가로 색상도 사용중인 경우
                                ?   " / 세로형"
                                :   this.state.h_color3_is_use == "Y"  // 세로 색상만 사용중인 경우
                                    ?   "세로형"
                                    :   ""
                            :   ""
                        }
                        {
                            " 배너 메인 컬러"+(color_title_num_p = color_title_num_p+1)
                        }
                        </>
                    }
                    </label>
                    <div id="color_picker_3_wrapper" onClick={e => {e.stopPropagation(); this.onClickRactangleColorButton(e, "is_expand_color3")}}>
                    <input
                      type="color"
                      // value={canvasPointColor}
                      value={background3}
                      // onChange={(e) =>
                      //   this.updateTemplateColor("3", e.target.value, true)
                      // }
                      style={{
                        width: "100%",
                        height: "50px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        border: "2px solid #D1D1D1",
                        WebkitAppearance: "none",
                        pointerEvents: "none",
                      }}
                    />
                    </div>
                    {/* <SketchPicker
                        presetColors = {presetColors}
                        color={ this.state.background3 }
                        onChange={e => this.handleChange3(e)}
                        onChangeComplete={e => this.handleChange3(e, true)}
                        disableAlpha
                    /> */}
                    { this.state.is_expand_color3
                      ?  <div id="color_picker_3" className="color_detail_area" style={{position: "absolute", zIndex: "10", WebkitAppearance: "none",}} onMouseDown={(e) => e.stopPropagation()}>
                        <SketchPicker
                            presetColors = {presetColors}
                            color={ this.state.background3 }
                            onChange={e => this.handleChange3(e)}
                            onChangeComplete={e => this.handleChange3(e, true)}
                            disableAlpha
                        />
                        </div>
                      : null
                    }
                  </div>
              : null
              }
              {
                (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color4_is_use == "Y") // 가로형 여부
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color4_is_use == "Y") // 세로형 여부
                ?
                  <div className="color-item" style={{ flex: 1, position: "relative" }}>
                    <label
                      style={{
                        fontSize: "11px",
                        color: "#636e72",
                        display: "block",
                        marginBottom: "4px",
                        textAlign: "center",
                      }}
                    >
                    {
                        <>
                          {
                              Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color4_is_use == "Y" // 가로형
                              ? "가로형"
                              : ""
                          }
                          {
                              Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length // 세로형 여부
                              ?   Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color4_is_use == "Y" && this.state.h_color4_is_use == "Y"  // 세로 색상 사용중인데 가로 색상도 사용중인 경우
                                  ?   " / 세로형"
                                  :   this.state.h_color4_is_use == "Y"  // 세로 색상만 사용중인 경우
                                      ?   "세로형"
                                      :   ""
                              :   ""
                          }
                          {
                              " 배너 메인 컬러"+(color_title_num_p = color_title_num_p+1)
                          }
                        </>
                      }
                    </label>
                    <div id="color_picker_4_wrapper" onClick={e => {e.stopPropagation(); this.onClickRactangleColorButton(e, "is_expand_color4")}}>
                    <input
                      type="color"
                      // value={canvasBgColor}
                      value={background4}
                      // onChange={(e) =>
                      //   this.updateTemplateColor("4", e.target.value, true)
                      // }
                      style={{
                        width: "100%",
                        height: "50px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        border: "2px solid #D1D1D1",
                        WebkitAppearance: "none",
                        pointerEvents: "none",
                      }}
                    />
                    </div>
                    {/* <SketchPicker
                        presetColors = {presetColors}
                        color={ this.state.background4 }
                        onChange={e => this.handleChange4(e)}
                        onChangeComplete={e => this.handleChange4(e, true)}
                        disableAlpha
                    /> */}
                    { this.state.is_expand_color4
                      ?  <div id="color_picker_4" className="color_detail_area" style={{position: "absolute", zIndex: "10", WebkitAppearance: "none",}} onMouseDown={(e) => e.stopPropagation()}>
                        <SketchPicker
                            presetColors = {presetColors}
                            color={ this.state.background4 }
                            onChange={e => this.handleChange4(e)}
                            onChangeComplete={e => this.handleChange4(e, true)}
                            disableAlpha
                        />
                        </div>
                      : null
                    }
                  </div>
                : null
              }
              {
                  Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color_etc_is_use == "Y"
                  ?
                      <div className="color-item" style={{ flex: 1, position: "relative" }}>
                        <label
                          style={{
                            fontSize: "11px",
                            color: "#636e72",
                            display: "block",
                            marginBottom: "4px",
                            textAlign: "center",
                          }}
                        >
                        가로형 배너 서브 컬러
                        </label>
                        <div id="color_picker_w_color_etc_wrapper" onClick={e => this.onClickRactangleColorButton(e, "is_expand_w_color_etc")}>
                        <input
                          type="color"
                          // value={canvasBgColor}
                          value={this.state.w_color_etc}
                          // onChange={(e) =>
                          //   this.updateTemplateColor("4", e.target.value, true)
                          // }
                          style={{
                            width: "100%",
                            height: "50px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            border: "2px solid #D1D1D1",
                            WebkitAppearance: "none",
                            pointerEvents: "none",
                          }}
                        />
                        </div>
                        {/* <SketchPicker
                            presetColors = {presetColors}
                            color={ this.state.w_color_etc }
                            onChange={e => this.w_color_etc(e)}
                            onChangeComplete={e => this.handleChange4(e, true)}
                            disableAlpha
                        /> */}
                        { this.state.is_expand_w_color_etc
                          ?  <div id="color_picker_w_color_etc" className="color_detail_area" style={{position: "absolute", zIndex: "10", WebkitAppearance: "none",}} onMouseDown={(e) => e.stopPropagation()}>
                            <SketchPicker
                                presetColors = {presetColors}
                                color={ this.state.w_color_etc }
                                onChange={ e => this.handleChangeTextColor(e, "w_color_etc") }
                                onChangeComplete={ e => this.handleChangeTextColor(e, "w_color_etc", true) }
                                disableAlpha
                            />
                            </div>
                          : null
                        }
                      </div>
                      // <div className="color_area">
                      //     <div className="color_thumb_area m-l-15">
                      //         <div className="color_title">
                      //             가로형 배너 서브 컬러
                      //         </div>
                      //         <div className="grey_radius_box flexBox width-220px">
                      //             <div className="black_radius_box" style={{flex:"1", height:"33px", background:this.state.w_color_etc}}></div>
                      //             &nbsp;&nbsp;&nbsp;&nbsp;
                      //             {
                      //                 this.state.is_expand_w_color_etc
                      //                 ? <div className="icn_four_ractangle_on cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_w_color_etc")}></div>
                      //                 : <div className="icn_four_ractangle cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_w_color_etc")}></div>
                      //             }
                      //         </div>   
                      //     </div>
                      //     {   this.state.is_expand_w_color_etc
                      //         ?   <div className="color_detail_area">
                      //             <SketchPicker
                      //                 presetColors = {presetColors}
                      //                 color={ this.state.w_color_etc}
                      //                 onChange={ e => this.handleChangeTextColor(e, "w_color_etc") }
                      //                 onChangeComplete={ e => this.handleChangeTextColor(e, "w_color_etc", true) }
                      //                 disableAlpha
                      //             />
                      //             </div>
                      //         : ""
                      //     }      
                      // </div>
                    : ""
                }
                {
                    Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color_etc_is_use == "Y"
                    ?
                        <div className="color-item" style={{ flex: 1, position: "relative" }}>
                          <label
                            style={{
                              fontSize: "11px",
                              color: "#636e72",
                              display: "block",
                              marginBottom: "4px",
                              textAlign: "center",
                            }}
                          >
                          세로형 배너 서브 컬러
                          </label>
                          <div id="color_picker_h_color_etc_wrapper" onClick={e => this.onClickRactangleColorButton(e, "is_expand_h_color_etc")}>
                          <input
                            type="color"
                            // value={canvasBgColor}
                            value={this.state.h_color_etc}
                            // onChange={(e) =>
                            //   this.updateTemplateColor("4", e.target.value, true)
                            // }
                            style={{
                              width: "100%",
                              height: "50px",
                              borderRadius: "8px",
                              cursor: "pointer",
                              border: "2px solid #D1D1D1",
                              WebkitAppearance: "none",
                              pointerEvents: "none",
                            }}
                          />
                          </div>
                          {/* <SketchPicker
                              presetColors = {presetColors}
                              color={ this.state.h_color_etc }
                              onChange={e => this.h_color_etc(e)}
                              onChangeComplete={e => this.handleChange4(e, true)}
                              disableAlpha
                          /> */}
                          { this.state.is_expand_h_color_etc
                            ?  <div id="color_picker_h_color_etc" className="color_detail_area" style={{position: "absolute", zIndex: "10", WebkitAppearance: "none",}} onMouseDown={(e) => e.stopPropagation()}>
                              <SketchPicker
                                  presetColors = {presetColors}
                                  color={ this.state.h_color_etc }
                                  onChange={ e => this.handleChangeTextColor(e, "h_color_etc") }
                                  onChangeComplete={ e => this.handleChangeTextColor(e, "h_color_etc", true) }
                                  disableAlpha
                              />
                              </div>
                            : null
                          }
                        </div>
                        // <div className="color_area">
                        //     <div className="color_thumb_area m-l-15">
                        //         <div className="color_title">
                        //             세로형 배너 서브 컬러
                        //         </div>
                        //         <div className="grey_radius_box flexBox width-220px">
                        //             <div className="black_radius_box" style={{flex:"1", height:"33px", background:this.state.h_color_etc}}></div>
                        //             &nbsp;&nbsp;&nbsp;&nbsp;
                        //             {
                        //                 this.state.is_expand_h_color_etc
                        //                 ? <div className="icn_four_ractangle_on cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_h_color_etc")}></div>
                        //                 : <div className="icn_four_ractangle cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_h_color_etc")}></div>
                        //             }
                        //         </div>   
                        //     </div>
                        //     {   this.state.is_expand_h_color_etc
                        //         ?   <div className="color_detail_area">
                        //             <SketchPicker
                        //                 presetColors = {presetColors}
                        //                 color={ this.state.h_color_etc}
                        //                 onChange={ e => this.handleChangeTextColor(e, "h_color_etc") }
                        //                 onChangeComplete={ e => this.handleChangeTextColor(e, "h_color_etc", true) }
                        //                 disableAlpha
                        //             />
                        //             </div>
                        //         : ""
                        //     }      
                        // </div>
                    : ""
                }
            </div>
            
            {/* <div
              style={{
                display: "flex",
                gap: "8px",
                marginBottom: "16px",
              }}
            >
              <div className="m-t-43 m-l-29">
                <div className="flexBox"> 
                    <div className="icn_round_blue_small"></div>
                    &nbsp;&nbsp;
                    <div className="form_title" style={{marginTop: "auto", marginBottom: "auto"}}>배너에 들어갈 색상을 선택해 주세요.</div>
                </div>
                <div className="margin-vertical-auto flexBox m-l-34" style={{width:"98%", height:"auto" }}>
                {
                    
                    this.state.w_color1_is_use == "N" && this.state.h_color1_is_use == "N"
                        &&  this.state.w_color2_is_use == "N" && this.state.h_color2_is_use == "N"
                        &&  this.state.w_color3_is_use == "N" && this.state.h_color3_is_use == "N"
                        &&  this.state.w_color4_is_use == "N" && this.state.h_color4_is_use == "N" 
                        &&  this.state.w_color_etc_is_use == "N" && this.state.h_color_etc_is_use == "N"
                    ? <div className="m-t-32" style={{color:"#10CFC9", fontSize:"15px"}}><b>* 색상을 선택하지 않아도 됩니다.</b></div> 
                    : this.state.w_color1_is_use != "Y" && this.state.h_color1_is_use != "Y"
                        &&  this.state.w_color2_is_use != "Y" && this.state.h_color2_is_use != "Y"
                        &&  this.state.w_color3_is_use != "Y" && this.state.h_color3_is_use != "Y"
                        &&  this.state.w_color4_is_use != "Y" && this.state.h_color4_is_use != "Y"
                        &&  this.state.w_color_etc_is_use != "Y" && this.state.h_color_etc_is_use != "Y"
                        ?   <div className="m-t-32" style={{color:"#FF7B7B", fontSize:"15px"}}><b>* 디자인 설정 - 배너 디자인을 먼저 선택 해주세요.</b></div>   
                        :   "" 
                }    

                {
                    (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color1_is_use == "Y") // 가로형 여부
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color1_is_use == "Y") // 세로형 여부
                    ?   <div className="color_area">
                            <div className="color_thumb_area">
                                <div className="color_thumb_area color_title">
                                    {
                                        Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color1_is_use == "Y" // 가로형
                                        ? "가로형"
                                        : ""
                                    }
                                    {
                                        Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length // 세로형 여부
                                        ?   Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color1_is_use == "Y" && this.state.h_color1_is_use == "Y"  // 세로 색상 사용중인데 가로 색상도 사용중인 경우
                                            ?   " / 세로형"
                                            :   this.state.h_color1_is_use == "Y"  // 세로 색상만 사용중인 경우
                                                ?   "세로형"
                                                :   ""
                                        :   ""
                                    }
                                    {
                                        " 배너 메인 컬러"+(color_title_num_p = color_title_num_p+1)
                                    }
                                </div>
                                <div className="grey_radius_box flexBox width-220px">
                                    <div className="black_radius_box" style={{flex:"1", height:"33px", background:this.state.background}}></div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        this.state.is_expand_color1 == true
                                        ? <div className="icn_four_ractangle_on cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_color1")}></div>
                                        : <div className="icn_four_ractangle cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_color1")}></div>
                                    }
                                </div>   
                            </div>
                            {   this.state.is_expand_color1
                                ?   <div className="color_detail_area_first">
                                    <SketchPicker
                                        presetColors = {presetColors}
                                        color={ this.state.background }
                                        onChange={e => this.handleChange(e)}
                                        onChangeComplete={e => this.handleChange(e, true)}
                                        disableAlpha
                                    />
                                    </div>
                                : ""
                            }       
                        </div>
                    : ""
                }
                {
                    (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color2_is_use == "Y") // 가로형 여부
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color2_is_use == "Y") // 세로형 여부
                    ?   <div className="color_area">
                            <div className="color_thumb_area m-l-15">
                                <div className="color_title">
                                    {
                                        Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color2_is_use == "Y" // 가로형
                                        ? "가로형"
                                        : ""
                                    }
                                    {
                                        Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length // 세로형 여부
                                        ?   Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color2_is_use == "Y" && this.state.h_color2_is_use == "Y"  // 세로 색상 사용중인데 가로 색상도 사용중인 경우
                                            ?   " / 세로형"
                                            :   this.state.h_color2_is_use == "Y"  // 세로 색상만 사용중인 경우
                                                ?   "세로형"
                                                :   ""
                                        :   ""
                                    }
                                    {
                                        " 배너 메인 컬러"+(color_title_num_p = color_title_num_p+1)
                                    }
                                </div>
                                <div className="grey_radius_box flexBox width-220px">
                                    <div className="black_radius_box" style={{flex:"1", height:"33px", background:this.state.background2}}></div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        this.state.is_expand_color2
                                        ? <div className="icn_four_ractangle_on cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_color2")}></div>
                                        : <div className="icn_four_ractangle cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_color2")}></div>
                                    }
                                </div>
                            </div>
                            {   this.state.is_expand_color2
                                ?   <div className="color_detail_area">
                                    <SketchPicker
                                        presetColors = {presetColors}
                                        color={ this.state.background2 }
                                        onChange={e => this.handleChange2(e)}
                                        onChangeComplete={e => this.handleChange2(e, true)}
                                        disableAlpha
                                    />
                                    </div>
                                : ""    
                            }
                        </div>
                    :   ""
                }
                {
                    (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color3_is_use == "Y") // 가로형 여부
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color3_is_use == "Y") // 세로형 여부
                    ?   <div className="color_area">
                            <div className="color_thumb_area m-l-15">
                                <div className="color_title">
                                    {
                                        Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color3_is_use == "Y" // 가로형
                                        ? "가로형"
                                        : ""
                                    }
                                    {
                                        Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length // 세로형 여부
                                        ?   Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color3_is_use == "Y" && this.state.h_color3_is_use == "Y"  // 세로 색상 사용중인데 가로 색상도 사용중인 경우
                                            ?   " / 세로형"
                                            :   this.state.h_color3_is_use == "Y"  // 세로 색상만 사용중인 경우
                                                ?   "세로형"
                                                :   ""
                                        :   ""
                                    }
                                    {
                                        " 배너 메인 컬러"+(color_title_num_p = color_title_num_p+1)
                                    }
                                </div>
                                <div className="grey_radius_box flexBox width-220px">
                                    <div className="black_radius_box" style={{flex:"1", height:"33px", background:this.state.background3}}></div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        this.state.is_expand_color3
                                        ? <div className="icn_four_ractangle_on cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_color3")}></div>
                                        : <div className="icn_four_ractangle cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_color3")}></div>
                                    }
                                </div>   
                            </div>
                            {   this.state.is_expand_color3
                                ?   <div className="color_detail_area">
                                    <SketchPicker
                                        presetColors = {presetColors}
                                        color={ this.state.background3 }
                                        onChange={e => this.handleChange3(e)}
                                        onChangeComplete={e => this.handleChange3(e, true)}
                                        disableAlpha
                                    />
                                    </div>
                                : ""
                            }        
                        </div>
                    :   ""
                }
                {
                    (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color4_is_use == "Y") // 가로형 여부
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color4_is_use == "Y") // 세로형 여부
                    ?   <div className="color_area">
                            <div className="color_thumb_area m-l-15">
                                <div className="color_title">
                                    {
                                        Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color4_is_use == "Y" // 가로형
                                        ? "가로형"
                                        : ""
                                    }
                                    {
                                        Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length // 세로형 여부
                                        ?   Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color4_is_use == "Y" && this.state.h_color4_is_use == "Y"  // 세로 색상 사용중인데 가로 색상도 사용중인 경우
                                            ?   " / 세로형"
                                            :   this.state.h_color4_is_use == "Y"  // 세로 색상만 사용중인 경우
                                                ?   "세로형"
                                                :   ""
                                        :   ""
                                    }
                                    {
                                        " 배너 메인 컬러"+(color_title_num_p = color_title_num_p+1)
                                    }
                                </div>
                                <div className="grey_radius_box flexBox width-220px">
                                    <div className="black_radius_box" style={{flex:"1", height:"33px", background:this.state.background4}}></div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        this.state.is_expand_color4
                                        ? <div className="icn_four_ractangle_on cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_color4")}></div>
                                        : <div className="icn_four_ractangle cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_color4")}></div>
                                    }
                                </div>   
                            </div>
                            {   this.state.is_expand_color4
                                ?   <div className="color_detail_area">
                                    <SketchPicker
                                        presetColors = {presetColors}
                                        color={ this.state.background4 }
                                        onChange={e => this.handleChange4(e)}
                                        onChangeComplete={e => this.handleChange4(e, true)}
                                        disableAlpha
                                    />
                                    </div>
                                : ""
                            }      
                        </div>
                    :   ""
                }
                {
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length && this.state.w_color_etc_is_use == "Y"
                    ?
                        <div className="color_area">
                            <div className="color_thumb_area m-l-15">
                                <div className="color_title">
                                    가로형 배너 서브 컬러
                                </div>
                                <div className="grey_radius_box flexBox width-220px">
                                    <div className="black_radius_box" style={{flex:"1", height:"33px", background:this.state.w_color_etc}}></div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        this.state.is_expand_w_color_etc
                                        ? <div className="icn_four_ractangle_on cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_w_color_etc")}></div>
                                        : <div className="icn_four_ractangle cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_w_color_etc")}></div>
                                    }
                                </div>   
                            </div>
                            {   this.state.is_expand_w_color_etc
                                ?   <div className="color_detail_area">
                                    <SketchPicker
                                        presetColors = {presetColors}
                                        color={ this.state.w_color_etc}
                                        onChange={ e => this.handleChangeTextColor(e, "w_color_etc") }
                                        onChangeComplete={ e => this.handleChangeTextColor(e, "w_color_etc", true) }
                                        disableAlpha
                                    />
                                    </div>
                                : ""
                            }      
                        </div>
                    : ""
                }
                {
                    Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length && this.state.h_color_etc_is_use == "Y"
                    ?
                        <div className="color_area">
                            <div className="color_thumb_area m-l-15">
                                <div className="color_title">
                                    세로형 배너 서브 컬러
                                </div>
                                <div className="grey_radius_box flexBox width-220px">
                                    <div className="black_radius_box" style={{flex:"1", height:"33px", background:this.state.h_color_etc}}></div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        this.state.is_expand_h_color_etc
                                        ? <div className="icn_four_ractangle_on cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_h_color_etc")}></div>
                                        : <div className="icn_four_ractangle cursor-pointer" onClick={e => this.onClickRactangleColorButton(e, "is_expand_h_color_etc")}></div>
                                    }
                                </div>   
                            </div>
                            {   this.state.is_expand_h_color_etc
                                ?   <div className="color_detail_area">
                                    <SketchPicker
                                        presetColors = {presetColors}
                                        color={ this.state.h_color_etc}
                                        onChange={ e => this.handleChangeTextColor(e, "h_color_etc") }
                                        onChangeComplete={ e => this.handleChangeTextColor(e, "h_color_etc", true) }
                                        disableAlpha
                                    />
                                    </div>
                                : ""
                            }      
                        </div>
                    : ""
                }
                </div>
                <div style={{marginTop:"20px"}}>
                    <div className="margin-vertical-auto flexBox m-l-34 m-t-21">
                        <div className="icn_warning_round"></div>
                        <div style={{marginLeft:"10px", flex:"1"}}>서브 컬러 요소로는 기간, 가격, 선 등이 있습니다.</div>
                    </div>
                    <div className="margin-vertical-auto flexBox m-l-34 m-t-21">
                        <div className="icn_warning_round"></div>
                        <div style={{marginLeft:"10px", flex:"1"}}>서브 컬러 색상은 배너 디자인을 선택할 때마다 해당 디자인의 기본 색상으로 변경됩니다. 디자인을 최종 선택하신 뒤에 색상을 선택해 주세요.</div>
                    </div>
                </div>
            </div> 
            </div> */}

            <button
              className="ai-extract-btn"
              data-instagram-tutorial="design-color-ai"
              // onClick={this.aiExtractColors}
              onClick={() => 
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                ?
                this.onSelectImgLinkColor("w", 0)
                :
                this.onSelectImgLinkColor("h", 0)
              }
              style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "6px",}}
            >
              <div style={{marginBottom: "2px"}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18.5232 12.0994L13.6847 10.3181L11.9035 5.47594C11.798 5.18937 11.6072 4.94206 11.3567 4.76736C11.1063 4.59267 10.8082 4.499 10.5029 4.499C10.1975 4.499 9.89949 4.59267 9.64904 4.76736C9.39858 4.94206 9.20773 5.18937 9.10225 5.47594L7.31912 10.3125L2.47694 12.0938C2.19037 12.1992 1.94305 12.3901 1.76836 12.6405C1.59367 12.891 1.5 13.189 1.5 13.4944C1.5 13.7997 1.59367 14.0978 1.76836 14.3482C1.94305 14.5987 2.19037 14.7895 2.47694 14.895L7.31256 16.6875L9.09381 21.5269C9.1993 21.8134 9.39014 22.0608 9.6406 22.2355C9.89106 22.4101 10.1891 22.5038 10.4944 22.5038C10.7998 22.5038 11.0978 22.4101 11.3483 22.2355C11.5987 22.0608 11.7896 21.8134 11.8951 21.5269L13.6763 16.6884L18.5185 14.9072C18.8051 14.8017 19.0524 14.6109 19.2271 14.3604C19.4018 14.1099 19.4954 13.8119 19.4954 13.5066C19.4954 13.2012 19.4018 12.9032 19.2271 12.6527C19.0524 12.4023 18.8051 12.2114 18.5185 12.1059L18.5232 12.0994ZM13.1616 15.2812C12.9589 15.3556 12.7749 15.4732 12.6222 15.6259C12.4696 15.7786 12.352 15.9626 12.2776 16.1653L10.4963 20.9897L8.71881 16.1616C8.64436 15.96 8.52712 15.7769 8.37516 15.6249C8.22319 15.4729 8.04011 15.3557 7.8385 15.2812L3.01412 13.5L7.8385 11.7188C8.04011 11.6443 8.22319 11.5271 8.37516 11.3751C8.52712 11.2231 8.64436 11.04 8.71881 10.8384L10.5001 6.01406L12.2813 10.8384C12.3557 11.0411 12.4733 11.2252 12.626 11.3778C12.7786 11.5305 12.9627 11.6481 13.1654 11.7225L17.9897 13.5037L13.1616 15.2812ZM13.5001 3.75C13.5001 3.55109 13.5791 3.36032 13.7197 3.21967C13.8604 3.07902 14.0511 3 14.2501 3H15.7501V1.5C15.7501 1.30109 15.8291 1.11032 15.9697 0.96967C16.1104 0.829018 16.3011 0.75 16.5001 0.75C16.699 0.75 16.8897 0.829018 17.0304 0.96967C17.171 1.11032 17.2501 1.30109 17.2501 1.5V3H18.7501C18.949 3 19.1397 3.07902 19.2804 3.21967C19.421 3.36032 19.5001 3.55109 19.5001 3.75C19.5001 3.94891 19.421 4.13968 19.2804 4.28033C19.1397 4.42098 18.949 4.5 18.7501 4.5H17.2501V6C17.2501 6.19891 17.171 6.38968 17.0304 6.53033C16.8897 6.67098 16.699 6.75 16.5001 6.75C16.3011 6.75 16.1104 6.67098 15.9697 6.53033C15.8291 6.38968 15.7501 6.19891 15.7501 6V4.5H14.2501C14.0511 4.5 13.8604 4.42098 13.7197 4.28033C13.5791 4.13968 13.5001 3.94891 13.5001 3.75ZM23.2501 8.25C23.2501 8.44891 23.171 8.63968 23.0304 8.78033C22.8897 8.92098 22.699 9 22.5001 9H21.7501V9.75C21.7501 9.94891 21.671 10.1397 21.5304 10.2803C21.3897 10.421 21.199 10.5 21.0001 10.5C20.8011 10.5 20.6104 10.421 20.4697 10.2803C20.3291 10.1397 20.2501 9.94891 20.2501 9.75V9H19.5001C19.3011 9 19.1104 8.92098 18.9697 8.78033C18.8291 8.63968 18.7501 8.44891 18.7501 8.25C18.7501 8.05109 18.8291 7.86032 18.9697 7.71967C19.1104 7.57902 19.3011 7.5 19.5001 7.5H20.2501V6.75C20.2501 6.55109 20.3291 6.36032 20.4697 6.21967C20.6104 6.07902 20.8011 6 21.0001 6C21.199 6 21.3897 6.07902 21.5304 6.21967C21.671 6.36032 21.7501 6.55109 21.7501 6.75V7.5H22.5001C22.699 7.5 22.8897 7.57902 23.0304 7.71967C23.171 7.86032 23.2501 8.05109 23.2501 8.25Z"
                        fill="white"
                        stroke="white"
                        stroke-width="0.4"
                        stroke-linejoin="round"
                    />
                </svg>
              </div>
              <div>AI 색상 추천</div>
            </button>

            {/* <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
              <button
                style={{
                  flex: 1,
                  padding: "10px",
                  border: "1px solid #D1D1D1",
                  background: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
                onClick={() => this.applyColorPreset("warm")}
              >
                따뜻한
              </button>
              <button
                style={{
                  flex: 1,
                  padding: "10px",
                  border: "1px solid #D1D1D1",
                  background: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
                onClick={() => this.applyColorPreset("cool")}
              >
                차가운
              </button>
              <button
                style={{
                  flex: 1,
                  padding: "10px",
                  border: "1px solid #D1D1D1",
                  background: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
                onClick={() => this.applyColorPreset("pastel")}
              >
                파스텔
              </button>
              <button
                style={{
                  flex: 1,
                  padding: "10px",
                  border: "1px solid #D1D1D1",
                  background: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
                onClick={() => this.applyColorPreset("mono")}
              >
                모노톤
              </button>
            </div> */}
          </div>
        </div>

        {/* 추출된 색상 */}
        <div className="control-section" data-instagram-tutorial="design-color-extracted">
          <h4 className="control-title">
            {/* <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#49BCBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <g transform="rotate(45 12 12)">
                        <path d="M8.5 5.5 C8.5 1.5, 15.5 1.5, 15.5 5.5" />
                        <rect x="7.5" y="5.5" width="9" height="2.5" rx="1" />
                        <path d="M9.5 8 V14.5 C9.5 16.5, 10.5 17.5, 10.5 18.5 H13.5 C13.5 17.5, 14.5 16.5, 14.5 14.5 V8" />
                        <path d="M9.5 11.5 Q12 13.5 14.5 11.5" />
                    </g>
                    <path d="M6.3 18.5 C7.8 21.5, 7.8 23.5, 6.3 23.5 C4.8 23.5, 4.8 21.5, 6.3 18.5 Z" />
                </svg>
            </span> */}
            <span>
                <i class="fa fa-eyedropper" aria-hidden="true"></i>
            </span>
            <span>추출된 색상</span>
          </h4>

          <div
            style={{
              padding: "16px",
              background: "#ffffff",
              borderRadius: "12px",
            }}
          >
            <div
              id="extractedColorPalette"
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                marginBottom: "12px",
              }}
            >
              {extractedColors.length === 0
                ? Array.from({ length: 4 }).map((_, i) => (
                    <div
                      key={i}
                      style={{
                        flex: 1,
                        height: "55px",
                        background: "#e0e0e0",
                        borderRadius: "8px",
                        border: "2px solid #D1D1D1",
                      }}
                    />
                  ))
                : extractedColors.map((c, i) => (
                    <div
                      key={i}
                      style={{
                        flex: 1,
                        height: "55px",
                        background: c,
                        borderRadius: "8px",
                        border: "2px solid #D1D1D1",
                        cursor: "pointer",
                      }}
                      onClick={() => this.handleCopyExtractedColor(c)}
                    />
                  ))}
            </div>

            <div
              style={{
                padding: "12px",
                background:
                  "linear-gradient(135deg, rgba(0, 226, 230, 0.05), rgba(0, 191, 194, 0.05))",
                border: "1px solid rgba(0, 226, 230, 0.3)",
                borderRadius: "8px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  color: "#00bfc2"
                }}
              >
                <i className="fa fa-lightbulb-o"></i>{" "}AI가 이미지에서 자동으로 색상을 추출하여 템플릿에
                적용합니다
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 색상 팔레트 확장 여부
  onClickRactangleColorButton = (e, name) => {
      var boolean = false;

      if(!this.state[name]){
          boolean = true;
      }
      
      if (boolean) {
          this.setState({[name] : true});
          $("#palleteBack").show();
      } else {
          this.setState({[name] : false});
          $("#palleteBack").hide();
      }
  }

  onCloseRactangleColorButton = (name) => {
    if (this.state[name]) {
      this.setState({[name] : false});
    }
  };

  renderRightControls() {
    const { activePanel } = this.state;
    if (!this.state.activePanel) return null;
    return (
      <div className="editor-controls">
          {
              activePanel === "image" 
              ? 
                  <h3
                  style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#2CADAE",
                      marginBottom: "1rem",
                  }}
                  >
                  이미지 {window.location.href.indexOf("/instagram") < 0 && " / 동영상 "} 선택
                  </h3> 
              :
              activePanel === "text" ? 
                  <h3
                  style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#2CADAE",
                      marginBottom: "1rem",
                  }}
                  >
                  문구 입력
                  </h3> 
              :
              activePanel === "color" 
              ? 
                  <h3
                  style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#2CADAE",
                      marginBottom: "1rem",
                  }}
                  >
                  색상 선택
                  </h3>  
              :
                  null
          }
          {
              activePanel === "image" ? this.renderImageTab()
              : activePanel === "text" ? this.renderTextTab()
              : activePanel === "color" ? this.renderColorTab()
              : null
          }
      </div>
    );
  }

  renderModal() {
    const { isModalOpen, activePanel } = this.state;
    if (!isModalOpen) return null;

    return (
      <div id="templateModal" className="modal show">
        <div className="modal-content">
          {/* 모바일 플로팅 버튼 */}
          {/* <div
            className="mobile-floating-btn"
            onClick={this.openMobileTemplatePopup}
          >
            <i className="fa fa-paint-brush"></i>
          </div> */}

          <div className="sidebar-icons">
            {this.sidebarButtons.map(this.renderSidebarButton)}
          </div>
          {/* {this.renderMobileTemplatePopup()}  */}
          {activePanel === "template" && this.renderTemplateSelector()}
          {(activePanel !== "template" && activePanel !== "history") && this.renderRightControls()}
          {activePanel === "history" && this.renderHistorySelector()}
          {this.renderCanvas()}
        </div>
      </div>
    );
  }

  renderUploadPopup() {
    const { isUploadPopupOpen } = this.state;
    if (!isUploadPopupOpen) return null;

    return (
      <div id="uploadPopup" className="upload-popup show" data-instagram-tutorial="design-image-source-popup">
        <div className="upload-popup-header">
          <div className="upload-popup-title">추가 방법 선택</div>
          <button
            className="upload-popup-close"
            onClick={this.closeUploadPopup}
          >
            ×
          </button>
        </div>
        <div className="upload-popup-options">
          <div
            className="upload-popup-option"
            onClick={() => this.uploadOption("file")}
          >
            <div style={{ fontSize: "32px" }}>
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2 20.5V4.5C2 3.67157 2.67157 3 3.5 3H8.25L10.5 6H19.5C20.3284 6 21 6.67157 21 7.5V11.25"
                        stroke="#333333"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />

                    <path
                        d="M2.25 20.5L5.4 12.9C5.74944 12.0576 6.57153 11.5 7.48352 11.5H21.0986C22.4542 11.5 23.3246 12.9384 22.7044 14.1439L19.3978 20.5714C19.1397 21.0732 18.6227 21.3889 18.0584 21.3889H3.1724C2.5197 21.3889 2.00008 20.8483 2.02591 20.1961C2.03008 20.0908 2.05297 19.9871 2.09342 19.8898L2.25 20.5Z"
                        stroke="#333333"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>
              파일 선택
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#636e72",
              }}
            >
              기기에서 이미지 업로드
            </div>
          </div>
          <div
            className="upload-popup-option"
            onClick={() => this.uploadOption("url")}
          >
            <div style={{ fontSize: "32px" }}>
                {/* <i className="fa fa-paperclip"></i> */}
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.8942 17.4713C13.0347 17.6119 13.1137 17.8026 13.1137 18.0014C13.1137 18.2002 13.0347 18.3909 12.8942 18.5316L11.9623 19.4691C10.9768 20.4539 9.64045 21.007 8.2472 21.0065C6.85395 21.0061 5.51794 20.4522 4.53308 19.4667C3.54821 18.4812 2.99517 17.1449 2.99561 15.7516C2.99605 14.3584 3.54993 13.0224 4.53542 12.0375L6.79667 9.77626C7.74325 8.82892 9.01608 8.27914 10.3547 8.2394C11.6933 8.19967 12.9965 8.67299 13.9976 9.56251C14.0715 9.62801 14.1317 9.70741 14.1749 9.79619C14.2181 9.88497 14.2434 9.98139 14.2493 10.0799C14.2552 10.1785 14.2416 10.2772 14.2094 10.3705C14.1772 10.4638 14.1269 10.5499 14.0614 10.6238C13.9959 10.6976 13.9165 10.7579 13.8277 10.8011C13.7389 10.8442 13.6425 10.8695 13.5439 10.8754C13.4454 10.8813 13.3466 10.8678 13.2533 10.8356C13.16 10.8033 13.074 10.753 13.0001 10.6875C12.2851 10.0525 11.3545 9.71473 10.3987 9.74313C9.44284 9.77153 8.53397 10.164 7.85792 10.8403L5.59667 13.0988C4.89327 13.8022 4.4981 14.7562 4.4981 15.7509C4.4981 16.7457 4.89327 17.6997 5.59667 18.4031C6.30007 19.1065 7.25409 19.5017 8.24886 19.5017C9.24362 19.5017 10.1976 19.1065 10.901 18.4031L11.8329 17.4713C11.9026 17.4015 11.9853 17.3462 12.0763 17.3085C12.1674 17.2707 12.265 17.2513 12.3635 17.2513C12.4621 17.2513 12.5597 17.2707 12.6507 17.3085C12.7418 17.3462 12.8245 17.4015 12.8942 17.4713ZM19.4642 4.53376C18.4785 3.55034 17.1431 2.99805 15.7507 2.99805C14.3584 2.99805 13.0229 3.55034 12.0373 4.53376L11.1054 5.46657C10.9648 5.6073 10.8859 5.79813 10.886 5.99706C10.886 6.196 10.9652 6.38675 11.1059 6.52736C11.2466 6.66796 11.4374 6.7469 11.6364 6.74682C11.8353 6.74673 12.0261 6.66762 12.1667 6.52689L13.0985 5.59501C13.8019 4.89161 14.756 4.49644 15.7507 4.49644C16.7455 4.49644 17.6995 4.89161 18.4029 5.59501C19.1063 6.29842 19.5015 7.25244 19.5015 8.2472C19.5015 9.24196 19.1063 10.196 18.4029 10.8994L16.1417 13.1625C15.4653 13.8384 14.5562 14.2304 13.6004 14.2583C12.6445 14.2862 11.7141 13.9478 10.9995 13.3125C10.8503 13.1802 10.6547 13.1126 10.4557 13.1246C10.2566 13.1365 10.0705 13.2271 9.93823 13.3763C9.80595 13.5254 9.73836 13.7211 9.75031 13.9201C9.76227 14.1191 9.8528 14.3052 10.002 14.4375C11.0029 15.3273 12.3059 15.8009 13.6445 15.7615C14.9831 15.7222 16.2561 15.1727 17.2029 14.2256L19.4642 11.9644C20.4482 10.9787 21.0008 9.6428 21.0008 8.25001C21.0008 6.85722 20.4482 5.52134 19.4642 4.53564V4.53376Z" fill="#333333"/>
                </svg>
            </div>
            <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>
              이미지 주소
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#636e72",
              }}
            >
              이미지 URL로 불러오기
            </div>
          </div>
          <div
            className="upload-popup-option"
            onClick={() => this.uploadOption("product")}
          >
            <div style={{ fontSize: "32px" }}>
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.25 6H16.5C16.5 4.80653 16.0259 3.66193 15.182 2.81802C14.3381 1.97411 13.1935 1.5 12 1.5C10.8065 1.5 9.66193 1.97411 8.81802 2.81802C7.97411 3.66193 7.5 4.80653 7.5 6H3.75C3.35218 6 2.97064 6.15804 2.68934 6.43934C2.40804 6.72064 2.25 7.10218 2.25 7.5V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V7.5C21.75 7.10218 21.592 6.72064 21.3107 6.43934C21.0294 6.15804 20.6478 6 20.25 6ZM12 3C12.7956 3 13.5587 3.31607 14.1213 3.87868C14.6839 4.44129 15 5.20435 15 6H9C9 5.20435 9.31607 4.44129 9.87868 3.87868C10.4413 3.31607 11.2044 3 12 3ZM20.25 18.75H3.75V7.5H7.5V9C7.5 9.19891 7.57902 9.38968 7.71967 9.53033C7.86032 9.67098 8.05109 9.75 8.25 9.75C8.44891 9.75 8.63968 9.67098 8.78033 9.53033C8.92098 9.38968 9 9.19891 9 9V7.5H15V9C15 9.19891 15.079 9.38968 15.2197 9.53033C15.3603 9.67098 15.5511 9.75 15.75 9.75C15.9489 9.75 16.1397 9.67098 16.2803 9.53033C16.421 9.38968 16.5 9.19891 16.5 9V7.5H20.25V18.75Z" fill="#333333"/>
                </svg>
            </div>
            <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>
              상품 선택
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#636e72",
              }}
            >
              등록된 상품 이미지 사용
            </div>
          </div>
          <div
            className="upload-popup-option"
            onClick={() => this.uploadOption("crop")}
          >
            <div style={{ fontSize: "32px" }}>
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="7" cy="7" r="2.75" stroke="#333333" stroke-width="1.5"></circle>
                    <circle cx="7" cy="17" r="2.75" stroke="#333333" stroke-width="1.5"></circle>

                    <path
                        d="M9.2 8.8L14 12L19 7"
                        stroke="#333333"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                    </path>

                    <path
                        d="M9.2 15.2L14 12L19 17"
                        stroke="#333333"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                    </path>
                </svg>
            </div>
            <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>
              상세페이지 자르기
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#636e72",
              }}
            >
              상세페이지 이미지 업로드 후<br/>자르기
            </div>
          </div>
          <div
            className="upload-popup-option"
            onClick={() => this.uploadOption("ai")}
          >
            <div style={{ fontSize: "32px" }}>
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2803_100)">
                    <path d="M10.5254 18.9337C11.0404 18.9337 11.458 18.5135 11.458 17.9953C11.458 17.477 11.0404 17.0569 10.5254 17.0569C10.0103 17.0569 9.59277 17.477 9.59277 17.9953C9.59277 18.5135 10.0103 18.9337 10.5254 18.9337Z" fill="#333333"/>
                    <path d="M16.5674 18.9337C17.0824 18.9337 17.5 18.5135 17.5 17.9953C17.5 17.477 17.0824 17.0569 16.5674 17.0569C16.0523 17.0569 15.6348 17.477 15.6348 17.9953C15.6348 18.5135 16.0523 18.9337 16.5674 18.9337Z" fill="#333333"/>
                    <path d="M16.8785 23H10.2386C7.90312 23 5.99805 21.0831 5.99805 18.7331V17.9231C5.99805 15.5731 7.90312 13.6562 10.2386 13.6562H16.8785C19.214 13.6562 21.1191 15.5731 21.1191 17.9231V18.7331C21.1191 21.0831 19.214 23 16.8785 23ZM10.2386 15.172C8.73211 15.172 7.51254 16.4072 7.51254 17.915V18.7251C7.51254 20.241 8.73211 21.4681 10.2386 21.4681H16.8785C18.385 21.4681 19.6046 20.241 19.6046 18.7251V17.915C19.6046 16.3992 18.377 15.172 16.8785 15.172H10.2386Z" fill="#333333"/>
                    <path d="M14.1203 12.1243H13.0044V14.0813H14.1203V12.1243Z" fill="#333333"/>
                    <path d="M13.5625 20.658C12.9408 20.658 12.3589 20.4094 12.2951 20.3773C12.056 20.273 11.9444 19.9923 12.048 19.7437C12.1516 19.5031 12.4386 19.3908 12.6777 19.4951C12.6777 19.4951 13.14 19.6956 13.5705 19.6956C14.0009 19.6956 14.4553 19.5031 14.4632 19.4951C14.7024 19.3908 14.9893 19.4951 15.0929 19.7437C15.1966 19.9843 15.0929 20.273 14.8458 20.3773C14.7821 20.4094 14.1922 20.658 13.5785 20.658H13.5625Z" fill="#333333"/>
                    <path d="M13.5622 12.7178C14.3282 12.7178 14.9492 12.093 14.9492 11.3222C14.9492 10.5515 14.3282 9.9267 13.5622 9.9267C12.7963 9.9267 12.1753 10.5515 12.1753 11.3222C12.1753 12.093 12.7963 12.7178 13.5622 12.7178Z" fill="#333333"/>
                    <path d="M21.5494 20.7142C21.3502 20.7142 21.1589 20.6981 20.9835 20.6821L20.2422 20.634V15.934H20.8002C21.4618 15.934 23.0002 15.934 23.0002 17.2494V19.5673C23.0002 19.9763 22.8168 20.2249 22.6733 20.3613C22.3704 20.642 21.956 20.7062 21.5494 20.7062V20.7142ZM21.3581 19.5833C21.5813 19.5994 21.8364 19.5913 21.9241 19.5432L21.8922 17.2574C21.8284 17.1611 21.6052 17.113 21.3661 17.089V19.5913L21.3581 19.5833Z" fill="#333333"/>
                    <path d="M5.76664 20.7142C5.36012 20.7142 4.94563 20.65 4.64273 20.3693C4.49128 20.2329 4.31592 19.9763 4.31592 19.5753V17.2574C4.31592 15.942 5.85432 15.942 6.51592 15.942H7.07389V20.634L6.33258 20.6821C6.15722 20.6981 5.96592 20.7142 5.76664 20.7142ZM5.95795 17.0809C5.71882 17.097 5.49563 17.1371 5.43983 17.2092V19.5753C5.49563 19.6073 5.74273 19.5993 5.95795 19.5833V17.0809Z" fill="#333333"/>
                    <path d="M6.76285 5.87641C6.97806 6.09297 7.27299 6.21327 7.57589 6.21327C7.87879 6.21327 8.16575 6.09297 8.38096 5.87641C8.59618 5.65986 8.71575 5.37113 8.71575 5.06635C8.71575 4.76158 8.59618 4.47284 8.38096 4.25629C8.16575 4.03974 7.87879 3.91943 7.57589 3.91943C7.27299 3.91943 6.98603 4.03974 6.77082 4.25629C6.5556 4.47284 6.43604 4.76158 6.43604 5.06635C6.43604 5.21874 6.46792 5.37113 6.52372 5.50748C6.57951 5.64382 6.66719 5.77215 6.77082 5.88444L6.76285 5.87641Z" fill="#333333"/>
                    <path d="M2.52246 17.8589V11.4987L5.56739 8.43493L7.53623 10.416C7.82319 10.6967 8.2058 10.8571 8.61232 10.8571C9.01884 10.8571 9.40145 10.6967 9.68841 10.416L13.9449 6.13307L17.7551 9.96682V12.8542C17.7551 13.6081 19.2775 13.6482 19.2775 12.8782V2.5319C19.2775 2.12286 19.1181 1.73788 18.8312 1.44914C18.5442 1.16041 18.1616 1 17.7551 1H2.52246C2.11594 1 1.73333 1.16041 1.44638 1.44914C1.15942 1.73788 1 2.12286 1 2.5319V17.8589C1 18.268 1.15942 18.6529 1.44638 18.9417C1.73333 19.2304 2.11594 19.3908 2.52246 19.3908H2.92101C3.86159 19.3908 3.82971 17.8669 2.96884 17.8669C2.79348 17.8669 2.52246 17.8669 2.52246 17.8669V17.8589ZM2.52246 2.5319H17.7551V7.80131L15.021 5.05031C14.7341 4.7696 14.3514 4.60919 13.9449 4.60919C13.5384 4.60919 13.1558 4.7696 12.8688 5.05031L8.61232 9.33321L6.64348 7.35217C6.35652 7.07145 5.97391 6.91105 5.56739 6.91105C5.16087 6.91105 4.77826 7.07145 4.4913 7.35217L2.52246 9.33321V2.5319Z" fill="#333333"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_2803_100">
                    <rect width="22" height="22" fill="white" transform="translate(1 1)"/>
                    </clipPath>
                    </defs>
                </svg>
            </div>
            <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>
              AI 스튜디오
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#636e72",
              }}
            >
              AI로 새 이미지 생성
            </div>
          </div>
          {
            window.location.href.indexOf("/instagram") < 0 &&
            <div
                className="upload-popup-option"
                onClick={() => this.uploadOption("youtube")}
                style={{
                    opacity: (
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                    ?
                        this.state.w_is_youtube_link_use == "Y"
                        ? 1
                        : 0.5
                    : this.state.h_is_youtube_link_use == "Y"
                        ? 1
                        : 0.5
                    )
                    , pointerEvents: (
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                    ?
                        this.state.w_is_youtube_link_use == "Y"
                        ? "auto"
                        : "none"
                    : this.state.h_is_youtube_link_use == "Y"
                        ? "auto"
                        : "none"
                    )
                    , backgroundColor: (
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                    ?
                        this.state.w_is_youtube_link_use == "Y"
                        ? ""
                        : "#f7f7f7"
                    : this.state.h_is_youtube_link_use == "Y"
                    ? ""
                    : "#f7f7f7"
                    )
                }}
                >
                <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"48px", paddingTop: "10px"}}>
                    <div style={{ width:"32px", height:"32px", margin: "auto" }}>
                    <svg width="100%" height="100%" viewBox="0 0 100 70" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0" y="0" width="100" height="70" rx="16" ry="16" fill="#FF0000"/>
                        <polygon points="38,22 38,48 66,35" fill="#FFFFFF"/>
                    </svg>
                    </div>
                </div>
                <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>
                    유튜브
                </div>
                <div
                    style={{
                    fontSize: "12px",
                    color: "#636e72",
                    }}
                >
                    유튜브 동영상 불러오기
                </div>

                { (Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                    &&  this.state.w_is_youtube_link_use != "Y")
                    || (Object.keys(this.state.selected_mobile_banner_ratio ?? {}).length
                    &&  this.state.h_is_youtube_link_use != "Y")
                &&
                <div className="youtube-notice"
                    style={{
                    fontSize: "10px",
                    color: "#343434",    
                }}>
                    동영상 템플릿을 선택하면 사용 가능합니다.
                </div>
                }
            </div>
          }
        </div>
      </div>
    );
  }

  togglePanel = (panel) => {
    this.setState({
      activePanel: this.state.activePanel === panel ? null : panel
    });
  };

  sidebarButtons = [
    {
      id: "template",
      title: "템플릿",
      label: "템플릿",
      icon: (
        <>
            {/* <rect x="3" y="3" width="7" height="7" strokeWidth="2" />
            <rect x="14" y="3" width="7" height="7" strokeWidth="2" />
            <rect x="3" y="14" width="7" height="7" strokeWidth="2" />
            <rect x="14" y="14" width="7" height="7" strokeWidth="2" /> */}
            {/* <path d="M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM20.25 5.25V9H3.75V5.25H20.25ZM3.75 10.5H9V18.75H3.75V10.5ZM20.25 18.75H10.5V10.5H20.25V18.75Z" fill="currentColor"/> */}
            <g transform="translate(2.25 3.75)">
            <path d="M18 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5V15C0 15.3978 0.158035 15.7794 0.43934 16.0607C0.720644 16.342 1.10218 16.5 1.5 16.5H18C18.3978 16.5 18.7794 16.342 19.0607 16.0607C19.342 15.7794 19.5 15.3978 19.5 15V1.5C19.5 1.10218 19.342 0.720644 19.0607 0.43934C18.7794 0.158035 18.3978 0 18 0ZM18 1.5V5.25H1.5V1.5H18ZM1.5 6.75H6.75V15H1.5V6.75ZM18 15H8.25V6.75H18V15Z" fill="currentColor"/>
            </g>

        </>
      ),
    },
    {
      id: "image",
      title: "이미지"+(window.location.href.indexOf("/instagram") < 0 ? " / 동영상" : ""),
      label: "이미지"+(window.location.href.indexOf("/instagram") < 0 ? "<br/>/ 동영상" : ""),
      icon: (
        <>
            {/* <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2" />
            <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
            <path d="M21 15l-5-5L5 21" strokeWidth="2" /> */}
            {/* <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="currentColor"/> */}
            <g transform="translate(3 3)">
            <path d="M18 12V1.5C18 1.10218 17.842 0.720644 17.5607 0.43934C17.2794 0.158035 16.8978 0 16.5 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H16.5C16.8978 18 17.2794 17.842 17.5607 17.5607C17.842 17.2794 18 16.8978 18 16.5V12ZM16.5 1.5V10.1906L13.8094 7.5C13.527 7.22175 13.1464 7.06577 12.75 7.06577C12.3536 7.06577 11.973 7.22175 11.6906 7.5L7.5 11.6906L5.55938 9.75C5.27698 9.47175 4.89645 9.31577 4.5 9.31577C4.10355 9.31577 3.72302 9.47175 3.44062 9.75L1.5 11.6906V1.5H16.5ZM16.5 16.5H1.5V13.8094L4.5 10.8094L6.44062 12.75C6.72302 13.0283 7.10355 13.1842 7.5 13.1842C7.89645 13.1842 8.27698 13.0283 8.55938 12.75L12.75 8.55938L16.5 12.3094V16.5ZM5.57812 6.42188C5.47332 6.31744 5.39034 6.19321 5.33401 6.0564C5.27768 5.91959 5.24912 5.77295 5.25 5.625C5.25 5.32663 5.36853 5.04048 5.5795 4.8295C5.79048 4.61853 6.07663 4.5 6.375 4.5C6.67337 4.5 6.95952 4.61853 7.1705 4.8295C7.38147 5.04048 7.5 5.32663 7.5 5.625C7.5 5.92337 7.38147 6.20952 7.1705 6.4205C6.95952 6.63147 6.67337 6.75 6.375 6.75C6.07695 6.74772 5.79136 6.63013 5.57812 6.42188Z" fill="currentColor"/>
            </g>
        </>
      ),
    },
    {
      id: "text",
      title: "텍스트",
      label: "텍스트",
      icon: (
        // <path
        //   d="M4 7V4h16v3M9 20h6M12 4v16"
        //   strokeWidth="2"
        //   strokeLinecap="round"
        // />
        <g transform="translate(3.75 4.5)">
        <path d="M16.5 0.75V3.75C16.5 3.94891 16.421 4.13968 16.2803 4.28033C16.1397 4.42098 15.9489 4.5 15.75 4.5C15.5511 4.5 15.3603 4.42098 15.2197 4.28033C15.079 4.13968 15 3.94891 15 3.75V1.5H9V13.5H11.25C11.4489 13.5 11.6397 13.579 11.7803 13.7197C11.921 13.8603 12 14.0511 12 14.25C12 14.4489 11.921 14.6397 11.7803 14.7803C11.6397 14.921 11.4489 15 11.25 15H5.25C5.05109 15 4.86032 14.921 4.71967 14.7803C4.57902 14.6397 4.5 14.4489 4.5 14.25C4.5 14.0511 4.57902 13.8603 4.71967 13.7197C4.86032 13.579 5.05109 13.5 5.25 13.5H7.5V1.5H1.5V3.75C1.5 3.94891 1.42098 4.13968 1.28033 4.28033C1.13968 4.42098 0.948912 4.5 0.75 4.5C0.551088 4.5 0.360322 4.42098 0.21967 4.28033C0.0790178 4.13968 0 3.94891 0 3.75V0.75C0 0.551088 0.0790178 0.360322 0.21967 0.21967C0.360322 0.0790178 0.551088 0 0.75 0H15.75C15.9489 0 16.1397 0.0790178 16.2803 0.21967C16.421 0.360322 16.5 0.551088 16.5 0.75Z" fill="currentColor"/>
        </g>
      ),
    },
    // { divider: true },
    {
      id: "color",
      title: "색상",
      label: "색상",
      icon: (
        <>
            {/* <circle cx="12" cy="12" r="9" strokeWidth="2" />
            <path d="M12 3v6l5.2 3-5.2 3v6" strokeWidth="2" /> */}
            <g transform="translate(2.5 3.5)">
            <path d="M19 0.68C19 0.499653 18.9285 0.326692 18.8012 0.199167C18.674 0.0716426 18.5014 0 18.3214 0C14.5824 0 10.7458 4.22535 8.61499 7.02355C7.85401 6.79001 7.04897 6.73856 6.26455 6.87334C5.48012 7.00811 4.73818 7.32536 4.0983 7.79959C3.45842 8.27382 2.93844 8.89182 2.58014 9.60394C2.22183 10.3161 2.03519 11.1025 2.03519 11.9C2.03519 14.5248 0.377726 15.7021 0.29884 15.7564C0.178465 15.8379 0.0873471 15.9559 0.038885 16.0931C-0.00957695 16.2303 -0.0128259 16.3795 0.0296161 16.5187C0.072058 16.6579 0.157951 16.7798 0.274665 16.8664C0.391379 16.9531 0.532755 16.9999 0.678003 17H7.12463C7.9205 17 8.70528 16.813 9.41594 16.4539C10.1266 16.0949 10.7433 15.5738 11.2166 14.9326C11.6898 14.2914 12.0064 13.5479 12.1409 12.7619C12.2754 11.9758 12.224 11.1691 11.991 10.4065C14.7842 8.27135 19 4.4268 19 0.68ZM7.12463 15.64H2.25828C2.83084 14.8249 3.39237 13.5932 3.39237 11.9C3.39237 11.1603 3.61127 10.4372 4.02137 9.82217C4.43148 9.20713 5.01438 8.72776 5.69636 8.44469C6.37834 8.16162 7.12877 8.08755 7.85276 8.23186C8.57675 8.37617 9.24177 8.73237 9.76374 9.25542C10.2857 9.77847 10.6412 10.4449 10.7852 11.1704C10.9292 11.8959 10.8553 12.6478 10.5728 13.3312C10.2903 14.0146 9.81193 14.5987 9.19816 15.0097C8.5844 15.4207 7.8628 15.64 7.12463 15.64ZM9.87463 7.61175C10.1653 7.23435 10.4506 6.87877 10.7305 6.545C11.4156 7.00885 12.0057 7.60008 12.4685 8.28665C12.1349 8.56658 11.7801 8.85247 11.404 9.1443C11.0086 8.53044 10.4872 8.00801 9.87463 7.61175ZM13.4966 7.38395C12.9843 6.65958 12.3534 6.02732 11.6305 5.51395C14.3262 2.5789 16.3594 1.68895 17.5597 1.4416C17.3179 2.6452 16.4256 4.68265 13.4966 7.38395Z" fill="currentColor"/>
            </g>
        </>
      ),
    },
    {
      id: "history",
      title: "작업물",
      label: "작업물",
      icon: (
        <>
            {/* <circle cx="12" cy="12" r="9" strokeWidth="2" />
            <path d="M12 3v6l5.2 3-5.2 3v6" strokeWidth="2" /> */}
            <g transform="translate(3 3)">
            <path d="M17.5594 4.5L13.5 0.440626C13.3613 0.300843 13.1962 0.189933 13.0144 0.114303C12.8326 0.0386743 12.6376 -0.000174814 12.4406 5.91327e-07H1.5C1.10218 5.91327e-07 0.720644 0.158036 0.43934 0.43934C0.158035 0.720645 0 1.10218 0 1.5V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H16.5C16.8978 18 17.2794 17.842 17.5607 17.5607C17.842 17.2794 18 16.8978 18 16.5V5.55938C18.0002 5.36244 17.9613 5.16743 17.8857 4.9856C17.8101 4.80376 17.6992 4.63872 17.5594 4.5ZM12.75 16.5H5.25V11.25H12.75V16.5ZM16.5 5.55938V16.5H14.25V11.25C14.25 10.8522 14.092 10.4706 13.8107 10.1893C13.5294 9.90804 13.1478 9.75 12.75 9.75H5.25C4.85218 9.75 4.47064 9.90804 4.18934 10.1893C3.90804 10.4706 3.75 10.8522 3.75 11.25V16.5H1.5V1.5H12.4406L16.5 5.55938ZM12 3.75C12 3.94891 11.921 4.13968 11.7803 4.28033C11.6397 4.42098 11.4489 4.5 11.25 4.5H6C5.80109 4.5 5.61032 4.42098 5.46967 4.28033C5.32902 4.13968 5.25 3.94891 5.25 3.75C5.25 3.55109 5.32902 3.36032 5.46967 3.21967C5.61032 3.07902 5.80109 3 6 3H11.25C11.4489 3 11.6397 3.07902 11.7803 3.21967C11.921 3.36032 12 3.55109 12 3.75Z" fill="currentColor"/>
            </g>
        </>
      ),
    },
    // {
    //   id: "ai",
    //   title: "AI",
    //   label: "AI",
    //   icon: (
    //     <path
    //       d="
    //         M9.813 15.904
    //         L9 18.75
    //         l-.813-2.846
    //         a4.5 4.5 0 00-3.09-3.09
    //         L2.25 12
    //         l2.846-.813
    //         a4.5 4.5 0 003.09-3.09
    //         L9 5.25
    //         l.813 2.846
    //         a4.5 4.5 0 003.09 3.09
    //         L15.75 12
    //         l-2.846.813
    //         a4.5 4.5 0 00-3.09 3.09
    //         z
    //       "
    //       strokeWidth="2"
    //     />
    //   ),
    // },
  ];

  // 버튼 하나 렌더 전담 함수
  renderSidebarButton = (btn, idx) => {
    if (btn.divider) {
      return <div key={`divider-${idx}`} className="sidebar-divider" />;
    }

    const { activePanel } = this.state;

    return (
      <button
        key={btn.id}
        className={`sidebar-icon ${activePanel === btn.id ? "active" : ""}`}
        title={btn.title}
        data-instagram-tutorial={`design-tab-${btn.id}`}
        onClick={() => this.togglePanel(btn.id)}
      >
        {/* <svg fill="none" stroke={btn.id == "text" ? "currentColor" : ""} viewBox="0 0 24 24"> */}
        <svg fill="none" stroke="none" viewBox="0 0 24 24">
          {btn.icon}
        </svg>
        <span dangerouslySetInnerHTML={{ __html: btn.label }}></span>
      </button>
    );
  };

  openConfirmDialog(props) {
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const close = (result) => {
        resolve(result);
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      ReactDOM.render(
        <TitleContentDialogV2
          {...props}
          popup_close={() => close(false)}
          button_list={[
            {
              title: "확인",
              event_method: () => close(true),
            },
            {
              title: "취소",
              event_method: () => close(false),
            },
          ]}
        />,
        container
      );
    });
  }
  openBasicDialog(props) {
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const close = (result) => {
        resolve(result);
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      ReactDOM.render(
        <BasicDialogV2
          {...props}
          popup_close={() => close(false)}
          button_list={[
            {
              title: "확인",
              event_method: () => close(true),
            }
          ]}
        />,
        container
      );
    });
  }

  renderHistorySelector() {
    const { isHistoryPanelCollapsed, event_history_list } = this.state;

    const cardReal = (item, img_url) => (
        <div
        key={item.event_seq}
        className={"template-card" + (this.state.selected_history_seq == item.event_seq ? " selected" : "")}
        onClick={() => this.onClickHistoryItem(item)}
        syle={{ 
            padding: "8px",
        }}
        >
        <div
            style={{
            aspectRatio: (
                Object.keys(this.state.selected_pc_banner_ratio ?? {}).length 
                ? "1.58" 
                : 
                    this.state.selected_mobile_banner_ratio.banner_height / this.state.selected_mobile_banner_ratio.banner_width == 1
                    ? "1 / 1"
                    : "4 / 5"
            ),
            backgroundImage: `url(${img_url})`,
            borderRadius: "8px",
            // marginBottom: "8px",
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            }}
        />
        </div>
    );

    return (
        <>
        <button
            className="template-toggle-btn"
            onClick={this.toggleHistoryPanel}
            title="작업물 선택"
        >
            <span id="templateSelectorToggleIcon">
            {isHistoryPanelCollapsed ? "◀" : "▶"}
            </span>
        </button>

        <div
            className={
            "template-selector" +
            (isHistoryPanelCollapsed ? " collapsed" : "")
            }
            id="templateSelector"
            data-instagram-tutorial="design-history-panel"
        >
            <h3
            style={{
                fontSize: "18px",
                fontWeight: 700,
                color: "#2CADAE",
            }}
            >
            작업물 선택
            </h3>

            <div className="template-grid" data-instagram-tutorial="design-history-list">
            {
                event_history_list && event_history_list.length > 0
                ? event_history_list.map((item) => cardReal(item, item.source_url))
                : <div style={{ fontSize: "13px", color: "#999" }}>작업물이 없습니다.</div>
            }
            </div>

            <div style={{ lineHeight: "60px", width: "100%", textAlign: "center" }}>
            {
                event_history_list && event_history_list.length > 0 &&
                <Pagination
                    activePage={
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                        ? this.state.pc_history_paging.activePage
                        : this.state.mobile_history_paging.activePage
                    }
                    itemsCountPerPage={
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                        ? this.state.pc_history_paging.rowcnt
                        : this.state.mobile_history_paging.rowcnt
                    }
                    totalItemsCount={
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                        ? this.state.pc_history_paging.totalCnt
                        : this.state.mobile_history_paging.totalCnt
                    }
                    pageRangeDisplayed={10}
                    onChange={
                    Object.keys(this.state.selected_pc_banner_ratio ?? {}).length
                        ? this.handleHistoryPageChange.bind(this)
                        : this.handleMobileHistoryPageChange.bind(this)
                    }
                />
            }
            </div>
        </div>
        </>
    );
  }

  onClickHistoryItem = async (item) => {
    if (!item || !item.event_seq) {
        return false;
    }

    const result = await this.openConfirmDialog({
        title: "기존 작업물을 불러오시겠습니까?",
        content: "현재 편집 중인 내용은 선택한 작업물 내용으로 변경됩니다.",
    });

    if (!result) {
        return false;
    }

    this.setState({
        selected_history_seq: item.event_seq,
    });

    this.loadEventDetail(item.event_seq);
 };

  render() {
    const bannerType = Object.keys(this.state.selected_pc_banner_ratio ?? {}).length ? "w" : "h";
    return (
      <div
        id="instagram-template-editor-page"
        className="page-container"
        data-instagram-tutorial-popup={this.props.onClose ? "POPUP_AI_DESIGN" : undefined}
      >
        <style>
            {
                `
                 #instagram-template-editor-page .fa {
                    font-family: FontAwesome !important;
                    font-style: normal;
                    font-weight: normal;
                 }
                 #instagram-template-editor-page {
                    .modal-content {
                        border-width: 0px !important;
                    }
                    .toolbar {
                        border-radius: 0px !important;
                    }
                    .sidebar-icon {
                        color: white; !important;
                    }
                    .sidebar-icon span {
                        font-weight: 600;
                    }
                    .modal-close {
                        border: 0px !important;
                        box-shadow: none !important;
                    }

                    .history-selector {
                        width: 280px;
                        height: 100%;
                        background: #fff;
                        border-left: 1px solid #e5e5e5;
                        padding: 20px;
                        overflow-y: auto;
                        transition: width 0.25s ease, padding 0.25s ease;
                    }

                    .history-selector.collapsed {
                        width: 0;
                        padding: 0;
                        overflow: hidden;
                        border-left: 0;
                    }

                    .history-toggle-btn {
                        position: absolute;
                        right: 280px;
                        top: 50%;
                        transform: translateY(-50%);
                        z-index: 10;
                    }

                    .history-selector.collapsed + .history-toggle-btn {
                        right: 0;
                    }

                    .btn {
                        height: 42px;
                        padding: 12px 24px;
                        border-radius: 12px;
                        font-size: 14px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.3s;
                        border: none;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        grid-gap: 8px;
                        gap: 8px;
                    }
                 }
                `
            }
        </style>
        {/* {this.renderHeader()} */}
        {/* {this.renderMainIntro()} */}
        {this.renderModal()}
        {this.renderUploadPopup()}

        {/* 템플릿 태그 필터 팝업 */
          this.state.show_template_filter_popup &&
          <PopupFrameV2
              className={"template_filter_popup"}
              maxWidth={"950px"}
              onClose={this.closeTemplateFilterPopupBtnClick.bind(this)}
          >
              <div className={"template_filter_popup_container"}>
                  <h4>템플릿 필터</h4>
                  {this.state.show_template_filter_popup_type == "03000"
                      ?
                      Object.keys(this.state.w_template_all_tag_list).map((category, tag_idx) => (
                          <section key={category}>
                              <h5>{this.state.template_ctg_list.at(tag_idx).tag_name}</h5>
                              <div>
                                  <button style={this.state.w_all_selected[category] ? {backgroundColor:'#00E2E6', border: '1px solid #00E2E6'} : {backgroundColor: '#FFF', border: '1px solid #ACACAC'}}
                                          onClick={() => this.handleAllTagBtnClick(category, "w")}>{this.state.template_tag_list ? this.state.template_tag_list[0].tag_name : ""}</button>
                                  {this.state.w_template_all_tag_list[category].map((tag)=>(
                                      <TagButton key={tag.tag_cd} tagCd={tag.tag_cd} tagName={tag.tag_name}
                                                  isSelected={tag.isSelected}
                                                  onClick={(tagCd, isSelected) => this.handleTagBtnClick(category, tag.tag_cd, isSelected, "w")}/>
                                  ))}
                              </div>
                          </section>
                      ))
                      :
                      Object.keys(this.state.h_template_all_tag_list).map((category, tag_idx) => (
                          <section key={category}>
                              <h5>{this.state.template_ctg_list.at(tag_idx).tag_name}</h5>
                              <div>
                                  <button style={this.state.h_all_selected[category] ? {backgroundColor:'#00E2E6', border: '1px solid #00E2E6'} : {backgroundColor: '#FFF', border: '1px solid #ACACAC'}}
                                          onClick={() => this.handleAllTagBtnClick(category, "h")}>{this.state.template_tag_list ? this.state.template_tag_list[0].tag_name : ""}</button>
                                  {this.state.h_template_all_tag_list[category].map((tag)=>(
                                      <TagButton key={tag.tag_cd} tagCd={tag.tag_cd} tagName={tag.tag_name}
                                                  isSelected={tag.isSelected}
                                                  onClick={(tagCd, isSelected) => this.handleTagBtnClick(category, tag.tag_cd, isSelected, "h")}/>
                                  ))}
                              </div>
                          </section>
                      ))
                  }
              </div>
              <div className={"template_filter_popup_footer"}>
                  {this.state.show_template_filter_popup_type == "03000"
                      ? <button onClick={() => this.resetTemplateFilterBtnClick("03000", "w")}>초기화</button>
                      : <button onClick={() => this.resetTemplateFilterBtnClick("07000", "h")}>초기화</button>
                  }
                  {this.state.show_template_filter_popup_type == "03000"
                      ? <button onClick={() => this.applyTemplateFilterBtnClick("03000", "w")}>필터적용</button>
                      : <button onClick={() => this.applyTemplateFilterBtnClick("07000", "h")}>필터적용</button>
                  }
              </div>
          </PopupFrameV2>
      }
      {/* 배경제거, 이미지 업로드 등 로딩 상태표시 */
          (this.state.save_dialog_show_state === true)
          ? <SaveDialogV2
              content={this.state.save_dialog_content}
              button_list={this.state.save_dialog_button_list}
          />
          : ''
      }
      {/** 상품 추가 팝업 */
        this.state.show_add_product_popup
        ? <SearchProductPopup
            title = {"상품 추가"}
            select_type = {"radio"}
            selected_product_list = {this.state.selected_rp_product_list || []}
            image_type_cd = {this.state.image_type_cd || ""}
            onClose = {() => {this.setState({show_add_product_popup:false})}}
            onSubmit = {this.onClickAddProductbtn.bind(this)}
            submit_btn_name = {"선택 상품 추가"}
        />
        : ""
      }
      {/** 분할된 상세 이미지 선택 팝업 */
        this.state.select_detail_crop_img_popup_show == true
        &&  <DetailImgCropPopup
                onClose={() => {
                    this.setState({
                        select_detail_crop_img_popup_show : false,
                    });
                }}
                crop_img_info = {this.state[bannerType+"_crop_img_info_list"][(this.state.selectedImageIndex-1)]}
                selectImgUpload={(crop_img_info) => {
                    let crop_img_info_list = this.state[bannerType+"_crop_img_info_list"];
                    crop_img_info_list[(this.state.selectedImageIndex-1)] = crop_img_info;
                    let user_img_list = this.state[bannerType+"_user_img_list"];
                    user_img_list[(this.state.selectedImageIndex-1)].link_type = "49003";
                    user_img_list[(this.state.selectedImageIndex-1)].img_link = crop_img_info.crop_img_link_list[crop_img_info.crop_img_seleted_no];
                    user_img_list[(this.state.selectedImageIndex-1)].org_img_name = crop_img_info.crop_img_link_list[crop_img_info.crop_img_seleted_no];
                    user_img_list[(this.state.selectedImageIndex-1)].org_img_seq = "";
                    user_img_list[(this.state.selectedImageIndex-1)].video_link = "";
                    this.setState({
                        select_detail_crop_img_popup_show : false,
                        [bannerType+"_user_img_list"] : user_img_list,
                        [bannerType+"_crop_img_info_list"] : crop_img_info_list,
                    }, () => {
                        this.eventChangeOneProductImageOfNukki(bannerType, this.state.selectedImageIndex-1);
                    });
                }}
            />}
      {/** 로보 이미지 팝업 */
        //   this.state.show_robo_img_popup
        //   ?
        //   <RoboImageStudioTabs
        //       onClose={() => {
        //         this.setState({
        //             show_robo_img_popup : false,
        //             robo_img_default_tab : "GENERATE",
        //             robo_img_default_upload_image_link : "",    
        //         })
        //       }}
        //       sendRoboImg={(img) => {
        //           let type = bannerType;
        //           let idx = (this.state.selectedImageIndex-1);
        //           let user_img_list = this.state[type+"_user_img_list"];
        //           user_img_list[idx].link_type = "49004";
        //           user_img_list[idx].img_link = img;
        //           user_img_list[idx].org_img_name = img;
        //           user_img_list[idx].org_img_seq = "";
        //           user_img_list[idx].video_link = "";
        //           this.setState({
        //               [type+"_user_img_list"] : user_img_list,
        //               show_robo_img_popup : false,
        //               robo_img_default_tab : "GENERATE",
        //               robo_img_default_upload_image_link : "",
        //           }, () => {
        //               this.eventChangeOneProductImageOfNukki(type, idx);
        //           });
        //       }}
        //       eventSeq={this.state.event_seq}
        //       imgPosition={Number((this.state.selectedImageIndex-1))+1}
        //       bannerCd={bannerType == "w" ? this.state.event_type_cd : this.state.event_mobile_type_cd}
        //       bannerDirection={bannerType == "w" ? "03000" : "07000"}
        //       defaultTab={this.state.robo_img_default_tab}
        //       defaultImageLink={this.state.robo_img_default_upload_image_link}
        //       service_type={this.props.service_type}
        //   />
        //   :""
      }
        {/** 로보 이미지 팝업 */}
        {this.state.show_robo_img_popup ? (
            <AiImageStudioWorkflowClass
                view_mode="popup"
                ai_response_type="IMAGE"
                onClose={() => {
                    this.setState({
                        show_robo_img_popup: false,
                        robo_img_default_tab: "GENERATE",
                        robo_img_default_upload_image_link: "",
                    });
                }}
                onApplyRule={(result) => {
                    const img = result.appliedImage || result.appliedValue || "";

                    if (!img) {
                        window.alert("적용할 이미지가 없습니다.");
                        return;
                    }

                    let type = bannerType;
                    let idx = (this.state.selectedImageIndex - 1);
                    let user_img_list = this.state[type + "_user_img_list"];

                    user_img_list[idx].link_type = "49004";
                    user_img_list[idx].img_link = img;
                    user_img_list[idx].org_img_name = img;
                    user_img_list[idx].org_img_seq = "";
                    user_img_list[idx].video_link = "";

                    this.setState({
                        [type + "_user_img_list"]: user_img_list,
                        show_robo_img_popup: false,
                        robo_img_default_tab: "GENERATE",
                        robo_img_default_upload_image_link: "",
                    }, () => {
                        this.eventChangeOneProductImageOfNukki(type, idx);
                    });
                }}
                eventSeq={this.state.event_seq}
                imgPosition={Number((this.state.selectedImageIndex - 1)) + 1}
                bannerCd={bannerType == "w" ? this.state.event_type_cd : this.state.event_mobile_type_cd}
                bannerDirection={bannerType == "w" ? "03000" : "07000"}
                defaultImageLink={this.state.robo_img_default_upload_image_link}
                service_type={this.props.service_type}
            />
        ) : ""}
      {/* 메인/서브 텍스트 AI 카피라이터 팝업 */}
      {this.state.isCopywriterModalOpen ? (
        <RoboMDAICopywriterModal
          isOpen={this.state.isCopywriterModalOpen}
          onClose={this.closeCopywriterModal}
          onApply={this.applyCopywriterText}
          getGenerationContext={this.getCopywriterGenerationContext}
          initialCommand={this.getCopywriterInitialCommand()}
          generationInstruction={this.getCopywriterGenerationInstruction()}
          modalTitle={
            this.state.copywriterApplyTarget === 'sub'
              ? '서브 텍스트 AI 카피라이터'
              : '메인 텍스트 AI 카피라이터'
          }
          commandPlaceholder={
            this.state.copywriterApplyTarget === 'sub'
              ? '메인 문구를 보완할 혜택, 기간, 특징 등을 입력해 주세요.'
              : '강조할 상품명, 혜택, 이벤트 핵심 내용을 입력해 주세요.'
          }
          applyTargetLabel={
            this.state.copywriterApplyTarget === 'sub'
              ? '서브 텍스트'
              : '메인 텍스트'
          }
          applyButtonLabel={
            this.state.copywriterApplyTarget === 'sub'
              ? '서브 텍스트에 적용'
              : '메인 텍스트에 적용'
          }
          closeOnApply={true}
        />
      ) : null}

      {/* 이미지 링크 작성 다이얼로그 */
          (this.state.input_dialog_show_state === true)
          ? <InputDialogV2
              title={this.state.input_dialog_title}
              content={this.state.input_dialog_content}
              input_value={this.state.input_dialog_input_value}
              input_placeholder={this.state.input_dialog_input_placeholder}
              button_list={this.state.input_dialog_button_list}
              popup_close={() => {
                  this.setState({input_dialog_show_state: false});
              }}
          />
          : ''
      }
      {/* 유튜브 링크 업로드 팝업 */
          this.state.showUploadYoutubeLinkPopup
          && <UploadYoutubeLinkPopup
              onClose={() => {
                  this.setState({showUploadYoutubeLinkPopup: false});
              }}
              link={this.state[bannerType+"_user_img_list"][this.state.selectedImageIndex-1].video_link}
              getVideoInfo={(items, link) => {
                  const type = bannerType;
                  const idx = (this.state.selectedImageIndex-1);
                  let thumbnails = items[0].snippet.thumbnails;
                  let user_img_list = this.state[type+"_user_img_list"];
                  user_img_list[idx].link_type = "49005";
                  // 썸네일 이미지가 큰것을 우선으로 사용
                  user_img_list[idx].img_link = thumbnails.maxres ? thumbnails.maxres.url : thumbnails.standard ? thumbnails.standard.url : thumbnails.high ? thumbnails.high.url : thumbnails.medium ? thumbnails.medium.url : thumbnails.default && thumbnails.default.url;
                  user_img_list[idx].org_img_name = link;
                  user_img_list[idx].org_img_seq = "";
                  user_img_list[idx].video_link = link;
                  this.setState({
                      [type+"_user_img_list"]: user_img_list,
                      showUploadYoutubeLinkPopup: false,
                  }, () => {
                      this.eventChangeOneProductImageOfNukki(type, idx);
                  })
              }}
          />
      }
      {/* 기본 다이얼로그 */
          this.state.is_open_basic_dialog
          ? <BasicDialogV2
            content={this.state.basic_dialog_content}
            button_list={[{
                title : "확인",
                event_method : () => { this.basicDialog(false,"") }
            }]}
          />
          : ""
        }
      {/* 저장시 기본배너 세팅 관련 다이얼로그 */
          this.state.title_content_dialog_show_state &&
          <TitleContentDialogV2
              title={this.state.title_content_dialog_title}
              content={this.state.title_content_dialog_content}
              button_list={this.state.title_content_dialog_button_list}
              popup_close={this.state.title_content_popup_close}
          />
      }
      {
        this.state.showToast &&
        <div style={styles.toast}>
          {this.state.toastMsg}
        </div>
      }
      <div style={{display: "none"}}>
        <DownloadManager></DownloadManager>
      </div>
      </div>
    );
  }
}

const styles = {
  toast: {
    position: "fixed",
    left: "50%",
    bottom: "40px",
    transform: "translateX(-50%)",
    backgroundColor: "rgba(0,0,0,0.85)",
    color: "#fff",
    padding: "10px 16px",
    borderRadius: "8px",
    fontSize: "14px",
    zIndex: 9999,
    boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
  }
};

export default InstagramTemplateEditor;
